import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
export class CardDefinitions {
  get descriptor() {
    return CardDefinitions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardDefinitions = [];
    this._hasPowerIndexParameters = false;
    this._powerIndexParameters = null;
    this._cardTags = [];
  }
  isEmpty() {
    if (this._cardDefinitions.length > 0) return false;
    if (this._hasPowerIndexParameters && !this._powerIndexParameters.isEmpty()) return false;
    if (this._cardTags.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardDefinitions) {
      return value;
    }
    return CardDefinitions.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardDefinitions();
    result._cardDefinitions = JsonToList(json.cardDefinitions, CardDefinition);
    if (json.powerIndexParameters != null) {
      result._hasPowerIndexParameters = true;
      result._powerIndexParameters = PowerIndexParameters.fromJson(json.powerIndexParameters);
    }
    result._cardTags = JsonToList(json.cardTags, CardTag);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardDefinitions.length > 0) {
      result.cardDefinitions = ArrayToJson(this._cardDefinitions, CardDefinition);
    }
    if (this._hasPowerIndexParameters && !this._powerIndexParameters.isEmpty()) {
      result.powerIndexParameters = PowerIndexParameters.toJson(this._powerIndexParameters);
    }
    if (this._cardTags.length > 0) {
      result.cardTags = ArrayToJson(this._cardTags, CardTag);
    }
    return result;
  }
  /**
   * @returns {CardDefinition[]}
   */
  get cardDefinitions() {
    return this._cardDefinitions;
  }
  addCardDefinitions_(path, value) {
    return {type: 'ADD', path: path.concat(['cardDefinitions']), value: value.toJson()};
  }
  setCardDefinitions_(path, value) {
    return {type: 'SET', path: path.concat(['cardDefinitions']), value: ArrayToJson(value, CardDefinition)};
  }
  setCardDefinitions_ByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardDefinitions', key]), value: value.toJson()};
  }
  deleteCardDefinitions_(path) {
    return {type: 'DELETE', path: path.concat(['cardDefinitions'])};
  }
  deleteCardDefinitions_ByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardDefinitions', key])};
  }
  /**
   * @returns {PowerIndexParameters}
   */
  get powerIndexParameters() {
    return this._hasPowerIndexParameters ? this._powerIndexParameters : PowerIndexParameters.default;
  }
  get hasPowerIndexParameters() {
    return this._hasPowerIndexParameters;
  }
  setPowerIndexParameters(path, value) {
    return {type: 'SET', path: path.concat(['powerIndexParameters']), value: value.toJson()};
  }
  deletePowerIndexParameters(path) {
    return {type: 'DELETE', path: path.concat(['powerIndexParameters'])};
  }
  /**
   * @returns {CardTag[]}
   */
  get cardTags() {
    return this._cardTags;
  }
  addCardTags(path, value) {
    return {type: 'ADD', path: path.concat(['cardTags']), value: value.toJson()};
  }
  setCardTags(path, value) {
    return {type: 'SET', path: path.concat(['cardTags']), value: ArrayToJson(value, CardTag)};
  }
  setCardTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardTags', key]), value: value.toJson()};
  }
  deleteCardTags(path) {
    return {type: 'DELETE', path: path.concat(['cardTags'])};
  }
  deleteCardTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardTags', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinitions(this);
              copy._cardDefinitions = [];        for (let i of value) {
                copy._cardDefinitions.push(CardDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinitions(this);
              copy._cardDefinitions = copy._cardDefinitions.concat([CardDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardDefinitions.length === 0) {
                return this;
              }
              const copy = new CardDefinitions(this);
              copy._cardDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinitions(this);
              copy._cardDefinitions = copy._cardDefinitions.slice();
              copy._cardDefinitions[path[1]] = CardDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinitions(this);
              copy._cardDefinitions = copy._cardDefinitions.slice(0, path[1]).concat(copy._cardDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardDefinitions.length) {
            return this;
          }
          const oldValue = this._cardDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinitions(this);
          copy._cardDefinitions = copy._cardDefinitions.slice();
          copy._cardDefinitions[key] = newValue;
          return copy;
        }
      }
      case "powerIndexParameters": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinitions(this);
              copy._hasPowerIndexParameters = true;
              copy._powerIndexParameters = PowerIndexParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPowerIndexParameters) {
                return this;
              }
              const copy = new CardDefinitions(this);
              copy._hasPowerIndexParameters = false;
              copy._powerIndexParameters = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPowerIndexParameters) {
            const copy = new CardDefinitions(this);
            copy._hasPowerIndexParameters = true;
            copy._powerIndexParameters = PowerIndexParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._powerIndexParameters.apply(type, path.slice(1), value);
          if (newValue === this._powerIndexParameters) {
            return this;
          }
          const copy = new CardDefinitions(this);
          copy._powerIndexParameters = copy._powerIndexParameters.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "cardTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinitions(this);
              copy._cardTags = [];        for (let i of value) {
                copy._cardTags.push(CardTag.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinitions(this);
              copy._cardTags = copy._cardTags.concat([CardTag.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTags.length === 0) {
                return this;
              }
              const copy = new CardDefinitions(this);
              copy._cardTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinitions(this);
              copy._cardTags = copy._cardTags.slice();
              copy._cardTags[path[1]] = CardTag.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinitions(this);
              copy._cardTags = copy._cardTags.slice(0, path[1]).concat(copy._cardTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardTags.length) {
            return this;
          }
          const oldValue = this._cardTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinitions(this);
          copy._cardTags = copy._cardTags.slice();
          copy._cardTags[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardDefinitions} other
   * @returns {CardDefinitions}
   */
  merge(other) {
    const copy = new CardDefinitions(this);
    copy._cardDefinitions = this._cardDefinitions.concat(other._cardDefinitions);
    if (other._hasPowerIndexParameters) {
      if (copy._hasPowerIndexParameters) {
        copy._powerIndexParameters = copy.powerIndexParameters.merge(other.powerIndexParameters);
      } else {
        copy._powerIndexParameters = other._powerIndexParameters;
      }
      copy._hasPowerIndexParameters = true;
    }
    copy._cardTags = this._cardTags.concat(other._cardTags);
    return copy;
  }
}
CardDefinitions.default = new CardDefinitions();
class CardDefinitions_Builder {
  constructor(value) {
    this._value = new CardDefinitions(value);
  }
  build() {
    return new CardDefinitions(this._value);
  }
  addAllCardDefinitions_(values) {
    this._value._cardDefinitions = this._value._cardDefinitions.concat(values);
    return this;
  }
  addCardDefinitions_(value) {
    this._value._cardDefinitions = this._value._cardDefinitions.concat([value]);
    return this;
  }
  setCardDefinitions_(index, value) {
    this._value._cardDefinitions = this._value._cardDefinitions.concat();
    this._value._cardDefinitions[index] = value;
    return this;
  }
  clearCardDefinitions_() {
    this._value._cardDefinitions = [];
    return this;
  }
  setPowerIndexParameters(value) {
    this._value._hasPowerIndexParameters = true;
    this._value._powerIndexParameters = value;
    return this;
  }
  deletePowerIndexParameters() {
    this._value._hasPowerIndexParameters = false;
    this._value._powerIndexParameters = null;
    return this;
  }
  addAllCardTags(values) {
    this._value._cardTags = this._value._cardTags.concat(values);
    return this;
  }
  addCardTags(value) {
    this._value._cardTags = this._value._cardTags.concat([value]);
    return this;
  }
  setCardTags(index, value) {
    this._value._cardTags = this._value._cardTags.concat();
    this._value._cardTags[index] = value;
    return this;
  }
  clearCardTags() {
    this._value._cardTags = [];
    return this;
  }
}
CardDefinitions.Builder = CardDefinitions_Builder;
class CardDefinitions_WithParent {
  /**
   * @param {CardDefinitions} value
   * @param {CardDefinitions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardDefinitions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardDefinitions_() {
    if (!this._selfCardDefinitions_) {
      this._selfCardDefinitions_ = [];
      for (let i of this._value.cardDefinitions) {
        this._selfCardDefinitions_.push(new CardDefinition.WithParent(i, null));
      }
    }
    return this._selfCardDefinitions_;
  }
  get inherentCardDefinitions_() {
    if (!this._inherentCardDefinitions_) {
      this._inherentCardDefinitions_ = this._parent ? this._parent.cardDefinitions : [];
    }
    return this._inherentCardDefinitions_;
  }
  get cardDefinitions() {
    if (!this._allCardDefinitions_) {
      this._allCardDefinitions_ = this._parent ? this._parent.cardDefinitions.concat(this.selfCardDefinitions_) : this.selfCardDefinitions_;
    }
    return this._allCardDefinitions_;
  }
  get hasPowerIndexParameters() {
    if (this._cachedHasPowerIndexParameters === undefined) {
      if (this._value.hasPowerIndexParameters) {
        this._cachedHasPowerIndexParameters = true;
      } else {
        this._cachedHasPowerIndexParameters = this._parent ? this._parent.hasPowerIndexParameters : false;
      }
    }
    return this._cachedHasPowerIndexParameters;
  }
  get powerIndexParameters() {
    if (!this._cachedPowerIndexParameters) {
      if (this._value.hasPowerIndexParameters) {
        this._cachedPowerIndexParameters = new PowerIndexParameters.WithParent(this._value.powerIndexParameters, this._parent && this._parent.hasPowerIndexParameters ? this._parent.powerIndexParameters : null);
      } else {
        this._cachedPowerIndexParameters = this._parent ? new PowerIndexParameters.WithParent(PowerIndexParameters.default, this._parent.powerIndexParameters) : PowerIndexParameters.WithParent.default;
      }
    }
    return this._cachedPowerIndexParameters;
  }
  get selfCardTags() {
    if (!this._selfCardTags) {
      this._selfCardTags = [];
      for (let i of this._value.cardTags) {
        this._selfCardTags.push(new CardTag.WithParent(i, null));
      }
    }
    return this._selfCardTags;
  }
  get inherentCardTags() {
    if (!this._inherentCardTags) {
      this._inherentCardTags = this._parent ? this._parent.cardTags : [];
    }
    return this._inherentCardTags;
  }
  get cardTags() {
    if (!this._allCardTags) {
      this._allCardTags = this._parent ? this._parent.cardTags.concat(this.selfCardTags) : this.selfCardTags;
    }
    return this._allCardTags;
  }
  update(current, parent) {
    const result = new CardDefinitions_WithParent(current, parent);
    if (this._selfCardDefinitions_) {
      if (this._value.cardDefinitions === current.cardDefinitions) {
        result._selfCardDefinitions_ = this._selfCardDefinitions_;
      } else {
        result._selfCardDefinitions_ = [];
        for (let i = 0; i < current.cardDefinitions.length; i++) {
          const oldValue = this._value.cardDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfCardDefinitions_[i];
            if (oldValue === current.cardDefinitions[i]) {
              result._selfCardDefinitions_[i] = oldCache;
            } else {
              result._selfCardDefinitions_[i] = oldCache.update(current.cardDefinitions[i], null);
            }
          } else {
            result._selfCardDefinitions_[i] = new CardDefinition.WithParent(current.cardDefinitions[i], null);
          }
        }
      }
    }
    if (this._cachedPowerIndexParameters && this._value.hasPowerIndexParameters && current.hasPowerIndexParameters) {
      if (this._value.powerIndexParameters === current.powerIndexParameters && this._parent === parent) {
        result._cachedPowerIndexParameters = this._cachedPowerIndexParameters;
      } else {
        result._cachedPowerIndexParameters = this._cachedPowerIndexParameters.update(current.powerIndexParameters, parent && parent.hasPowerIndexParameters ? parent.powerIndexParameters : null);
      }
    }
    if (this._selfCardTags) {
      if (this._value.cardTags === current.cardTags) {
        result._selfCardTags = this._selfCardTags;
      } else {
        result._selfCardTags = [];
        for (let i = 0; i < current.cardTags.length; i++) {
          const oldValue = this._value.cardTags[i];
          if (oldValue) {
            const oldCache = this._selfCardTags[i];
            if (oldValue === current.cardTags[i]) {
              result._selfCardTags[i] = oldCache;
            } else {
              result._selfCardTags[i] = oldCache.update(current.cardTags[i], null);
            }
          } else {
            result._selfCardTags[i] = new CardTag.WithParent(current.cardTags[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardDefinitions_WithParent.default = new CardDefinitions_WithParent(CardDefinitions.default, null);
CardDefinitions.WithParent = CardDefinitions_WithParent;
class CardDefinitions_Descriptor {
  get cardDefinitions() {
    if (!this._cardDefinitions) {
      this._cardDefinitions = {
        name: "cardDefinitions",
        Name: "CardDefinitions_",
        number: 1,
        protoType: 11,
        protoName: "card_definitions",
        type: CardDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardDefinitions;
  }
  get powerIndexParameters() {
    if (!this._powerIndexParameters) {
      this._powerIndexParameters = {
        name: "powerIndexParameters",
        Name: "PowerIndexParameters",
        number: 2,
        protoType: 11,
        protoName: "power_index_parameters",
        type: PowerIndexParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._powerIndexParameters;
  }
  get cardTags() {
    if (!this._cardTags) {
      this._cardTags = {
        name: "cardTags",
        Name: "CardTags",
        number: 3,
        protoType: 11,
        protoName: "card_tags",
        type: CardTag,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardTags;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardDefinitions,
        this.powerIndexParameters,
        this.cardTags,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPowerIndexParameters",
        Name: "DummyOneofForPowerIndexParameters",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardDefinitions.descriptor = new CardDefinitions_Descriptor();
export class PowerIndexParameters {
  get descriptor() {
    return PowerIndexParameters.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCardLevelFactor = false;
    this._cardLevelFactor = null;
    this._promotionFactors = [];
    this._skillLevelFactors = [];
    this._awakenFactors = [];
  }
  isEmpty() {
    if (this._hasCardLevelFactor) return false;
    if (this._promotionFactors.length > 0) return false;
    if (this._skillLevelFactors.length > 0) return false;
    if (this._awakenFactors.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PowerIndexParameters) {
      return value;
    }
    return PowerIndexParameters.fromJson(value);
  }
  static fromJson(json) {
    const result = new PowerIndexParameters();
    if (json.cardLevelFactor != null) {
      result._hasCardLevelFactor = true;
      result._cardLevelFactor = JsonToDouble.fromJson(json.cardLevelFactor);
    }
    result._promotionFactors = JsonToList(json.promotionFactors, JsonToDouble);
    result._skillLevelFactors = JsonToList(json.skillLevelFactors, JsonToDouble);
    result._awakenFactors = JsonToList(json.awakenFactors, JsonToDouble);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCardLevelFactor) {
      result.cardLevelFactor = JsonToDouble.toJson(this._cardLevelFactor);
    }
    if (this._promotionFactors.length > 0) {
      result.promotionFactors = ArrayToJson(this._promotionFactors, JsonToDouble);
    }
    if (this._skillLevelFactors.length > 0) {
      result.skillLevelFactors = ArrayToJson(this._skillLevelFactors, JsonToDouble);
    }
    if (this._awakenFactors.length > 0) {
      result.awakenFactors = ArrayToJson(this._awakenFactors, JsonToDouble);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get cardLevelFactor() {
    return this._hasCardLevelFactor ? this._cardLevelFactor : JsonToDouble.default;
  }
  get hasCardLevelFactor() {
    return this._hasCardLevelFactor;
  }
  setCardLevelFactor(path, value) {
    return {type: 'SET', path: path.concat(['cardLevelFactor']), value};
  }
  deleteCardLevelFactor(path) {
    return {type: 'DELETE', path: path.concat(['cardLevelFactor'])};
  }
  /**
   * @returns {number[]}
   */
  get promotionFactors() {
    return this._promotionFactors;
  }
  addPromotionFactors(path, value) {
    return {type: 'ADD', path: path.concat(['promotionFactors']), value};
  }
  setPromotionFactors(path, value) {
    return {type: 'SET', path: path.concat(['promotionFactors']), value: ArrayToJson(value, JsonToDouble)};
  }
  setPromotionFactorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['promotionFactors', key]), value};
  }
  deletePromotionFactors(path) {
    return {type: 'DELETE', path: path.concat(['promotionFactors'])};
  }
  deletePromotionFactorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['promotionFactors', key])};
  }
  /**
   * @returns {number[]}
   */
  get skillLevelFactors() {
    return this._skillLevelFactors;
  }
  addSkillLevelFactors(path, value) {
    return {type: 'ADD', path: path.concat(['skillLevelFactors']), value};
  }
  setSkillLevelFactors(path, value) {
    return {type: 'SET', path: path.concat(['skillLevelFactors']), value: ArrayToJson(value, JsonToDouble)};
  }
  setSkillLevelFactorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skillLevelFactors', key]), value};
  }
  deleteSkillLevelFactors(path) {
    return {type: 'DELETE', path: path.concat(['skillLevelFactors'])};
  }
  deleteSkillLevelFactorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skillLevelFactors', key])};
  }
  /**
   * @returns {number[]}
   */
  get awakenFactors() {
    return this._awakenFactors;
  }
  addAwakenFactors(path, value) {
    return {type: 'ADD', path: path.concat(['awakenFactors']), value};
  }
  setAwakenFactors(path, value) {
    return {type: 'SET', path: path.concat(['awakenFactors']), value: ArrayToJson(value, JsonToDouble)};
  }
  setAwakenFactorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['awakenFactors', key]), value};
  }
  deleteAwakenFactors(path) {
    return {type: 'DELETE', path: path.concat(['awakenFactors'])};
  }
  deleteAwakenFactorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['awakenFactors', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardLevelFactor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._hasCardLevelFactor = true;
              copy._cardLevelFactor = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardLevelFactor) {
                return this;
              }
              const copy = new PowerIndexParameters(this);
              copy._hasCardLevelFactor = false;
              copy._cardLevelFactor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "promotionFactors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._promotionFactors = [];        for (let i of value) {
                copy._promotionFactors.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PowerIndexParameters(this);
              copy._promotionFactors = copy._promotionFactors.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._promotionFactors.length === 0) {
                return this;
              }
              const copy = new PowerIndexParameters(this);
              copy._promotionFactors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._promotionFactors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._promotionFactors = copy._promotionFactors.slice();
              copy._promotionFactors[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PowerIndexParameters(this);
              copy._promotionFactors = copy._promotionFactors.slice(0, path[1]).concat(copy._promotionFactors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._promotionFactors.length) {
            return this;
          }
          const oldValue = this._promotionFactors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PowerIndexParameters(this);
          copy._promotionFactors = copy._promotionFactors.slice();
          copy._promotionFactors[key] = newValue;
          return copy;
        }
      }
      case "skillLevelFactors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._skillLevelFactors = [];        for (let i of value) {
                copy._skillLevelFactors.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PowerIndexParameters(this);
              copy._skillLevelFactors = copy._skillLevelFactors.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skillLevelFactors.length === 0) {
                return this;
              }
              const copy = new PowerIndexParameters(this);
              copy._skillLevelFactors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skillLevelFactors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._skillLevelFactors = copy._skillLevelFactors.slice();
              copy._skillLevelFactors[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PowerIndexParameters(this);
              copy._skillLevelFactors = copy._skillLevelFactors.slice(0, path[1]).concat(copy._skillLevelFactors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skillLevelFactors.length) {
            return this;
          }
          const oldValue = this._skillLevelFactors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PowerIndexParameters(this);
          copy._skillLevelFactors = copy._skillLevelFactors.slice();
          copy._skillLevelFactors[key] = newValue;
          return copy;
        }
      }
      case "awakenFactors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._awakenFactors = [];        for (let i of value) {
                copy._awakenFactors.push(JsonToDouble.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PowerIndexParameters(this);
              copy._awakenFactors = copy._awakenFactors.concat([JsonToDouble.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._awakenFactors.length === 0) {
                return this;
              }
              const copy = new PowerIndexParameters(this);
              copy._awakenFactors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._awakenFactors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PowerIndexParameters(this);
              copy._awakenFactors = copy._awakenFactors.slice();
              copy._awakenFactors[path[1]] = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PowerIndexParameters(this);
              copy._awakenFactors = copy._awakenFactors.slice(0, path[1]).concat(copy._awakenFactors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._awakenFactors.length) {
            return this;
          }
          const oldValue = this._awakenFactors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PowerIndexParameters(this);
          copy._awakenFactors = copy._awakenFactors.slice();
          copy._awakenFactors[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PowerIndexParameters} other
   * @returns {PowerIndexParameters}
   */
  merge(other) {
    const copy = new PowerIndexParameters(this);
    if (other._hasCardLevelFactor) {
      copy._hasCardLevelFactor = true;
      copy._cardLevelFactor = other._cardLevelFactor;
    }
    copy._promotionFactors = this._promotionFactors.concat(other._promotionFactors);
    copy._skillLevelFactors = this._skillLevelFactors.concat(other._skillLevelFactors);
    copy._awakenFactors = this._awakenFactors.concat(other._awakenFactors);
    return copy;
  }
}
PowerIndexParameters.default = new PowerIndexParameters();
class PowerIndexParameters_Builder {
  constructor(value) {
    this._value = new PowerIndexParameters(value);
  }
  build() {
    return new PowerIndexParameters(this._value);
  }
  setCardLevelFactor(value) {
    this._value._hasCardLevelFactor = true;
    this._value._cardLevelFactor = value;
    return this;
  }
  deleteCardLevelFactor() {
    this._value._hasCardLevelFactor = false;
    this._value._cardLevelFactor = null;
    return this;
  }
  addAllPromotionFactors(values) {
    this._value._promotionFactors = this._value._promotionFactors.concat(values);
    return this;
  }
  addPromotionFactors(value) {
    this._value._promotionFactors = this._value._promotionFactors.concat([value]);
    return this;
  }
  setPromotionFactors(index, value) {
    this._value._promotionFactors = this._value._promotionFactors.concat();
    this._value._promotionFactors[index] = value;
    return this;
  }
  clearPromotionFactors() {
    this._value._promotionFactors = [];
    return this;
  }
  addAllSkillLevelFactors(values) {
    this._value._skillLevelFactors = this._value._skillLevelFactors.concat(values);
    return this;
  }
  addSkillLevelFactors(value) {
    this._value._skillLevelFactors = this._value._skillLevelFactors.concat([value]);
    return this;
  }
  setSkillLevelFactors(index, value) {
    this._value._skillLevelFactors = this._value._skillLevelFactors.concat();
    this._value._skillLevelFactors[index] = value;
    return this;
  }
  clearSkillLevelFactors() {
    this._value._skillLevelFactors = [];
    return this;
  }
  addAllAwakenFactors(values) {
    this._value._awakenFactors = this._value._awakenFactors.concat(values);
    return this;
  }
  addAwakenFactors(value) {
    this._value._awakenFactors = this._value._awakenFactors.concat([value]);
    return this;
  }
  setAwakenFactors(index, value) {
    this._value._awakenFactors = this._value._awakenFactors.concat();
    this._value._awakenFactors[index] = value;
    return this;
  }
  clearAwakenFactors() {
    this._value._awakenFactors = [];
    return this;
  }
}
PowerIndexParameters.Builder = PowerIndexParameters_Builder;
class PowerIndexParameters_WithParent {
  /**
   * @param {PowerIndexParameters} value
   * @param {PowerIndexParameters_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PowerIndexParameters.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCardLevelFactor() {
    if (this._cachedHasCardLevelFactor === undefined) {
      if (this._value.hasCardLevelFactor) {
        this._cachedHasCardLevelFactor = true;
      } else {
        this._cachedHasCardLevelFactor = this._parent ? this._parent.hasCardLevelFactor : false;
      }
    }
    return this._cachedHasCardLevelFactor;
  }
  get cardLevelFactor() {
    if (this._cachedCardLevelFactor === undefined) {
      if (this._value.hasCardLevelFactor) {
        this._cachedCardLevelFactor = this._value.cardLevelFactor;
      } else {
        this._cachedCardLevelFactor = this._parent ? this._parent.cardLevelFactor : this._value.cardLevelFactor;
      }
    }
    return this._cachedCardLevelFactor;
  }
  get selfPromotionFactors() {
    return this._value.promotionFactors;
  }
  get inherentPromotionFactors() {
    if (!this._inherentPromotionFactors) {
      this._inherentPromotionFactors = this._parent ? this._parent.promotionFactors : [];
    }
    return this._inherentPromotionFactors;
  }
  get promotionFactors() {
    if (!this._allPromotionFactors) {
      this._allPromotionFactors = this._parent ? this._parent.promotionFactors.concat(this.selfPromotionFactors) : this.selfPromotionFactors;
    }
    return this._allPromotionFactors;
  }
  get selfSkillLevelFactors() {
    return this._value.skillLevelFactors;
  }
  get inherentSkillLevelFactors() {
    if (!this._inherentSkillLevelFactors) {
      this._inherentSkillLevelFactors = this._parent ? this._parent.skillLevelFactors : [];
    }
    return this._inherentSkillLevelFactors;
  }
  get skillLevelFactors() {
    if (!this._allSkillLevelFactors) {
      this._allSkillLevelFactors = this._parent ? this._parent.skillLevelFactors.concat(this.selfSkillLevelFactors) : this.selfSkillLevelFactors;
    }
    return this._allSkillLevelFactors;
  }
  get selfAwakenFactors() {
    return this._value.awakenFactors;
  }
  get inherentAwakenFactors() {
    if (!this._inherentAwakenFactors) {
      this._inherentAwakenFactors = this._parent ? this._parent.awakenFactors : [];
    }
    return this._inherentAwakenFactors;
  }
  get awakenFactors() {
    if (!this._allAwakenFactors) {
      this._allAwakenFactors = this._parent ? this._parent.awakenFactors.concat(this.selfAwakenFactors) : this.selfAwakenFactors;
    }
    return this._allAwakenFactors;
  }
  update(current, parent) {
    const result = new PowerIndexParameters_WithParent(current, parent);
    return result;
  }
}
PowerIndexParameters_WithParent.default = new PowerIndexParameters_WithParent(PowerIndexParameters.default, null);
PowerIndexParameters.WithParent = PowerIndexParameters_WithParent;
class PowerIndexParameters_Descriptor {
  get cardLevelFactor() {
    if (!this._cardLevelFactor) {
      this._cardLevelFactor = {
        name: "cardLevelFactor",
        Name: "CardLevelFactor",
        number: 1,
        protoType: 1,
        protoName: "card_level_factor",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardLevelFactor;
  }
  get promotionFactors() {
    if (!this._promotionFactors) {
      this._promotionFactors = {
        name: "promotionFactors",
        Name: "PromotionFactors",
        number: 2,
        protoType: 1,
        protoName: "promotion_factors",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._promotionFactors;
  }
  get skillLevelFactors() {
    if (!this._skillLevelFactors) {
      this._skillLevelFactors = {
        name: "skillLevelFactors",
        Name: "SkillLevelFactors",
        number: 3,
        protoType: 1,
        protoName: "skill_level_factors",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillLevelFactors;
  }
  get awakenFactors() {
    if (!this._awakenFactors) {
      this._awakenFactors = {
        name: "awakenFactors",
        Name: "AwakenFactors",
        number: 4,
        protoType: 1,
        protoName: "awaken_factors",
        type: JsonToDouble,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awakenFactors;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardLevelFactor,
        this.promotionFactors,
        this.skillLevelFactors,
        this.awakenFactors,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCardLevelFactor",
        Name: "DummyOneofForCardLevelFactor",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
PowerIndexParameters.descriptor = new PowerIndexParameters_Descriptor();
class CardDefinition_HeroCard {
  get descriptor() {
    return CardDefinition_HeroCard.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSubtitle = false;
    this._subtitle = null;
    this._hasHeroUnit = false;
    this._heroUnit = null;
    this._petUnits = [];
  }
  isEmpty() {
    if (this._hasSubtitle) return false;
    if (this._hasHeroUnit) return false;
    if (this._petUnits.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardDefinition_HeroCard) {
      return value;
    }
    return CardDefinition_HeroCard.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardDefinition_HeroCard();
    if (json.subtitle != null) {
      result._hasSubtitle = true;
      result._subtitle = JsonToString.fromJson(json.subtitle);
    }
    if (json.heroUnit != null) {
      result._hasHeroUnit = true;
      result._heroUnit = JsonToString.fromJson(json.heroUnit);
    }
    result._petUnits = JsonToList(json.petUnits, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSubtitle) {
      result.subtitle = JsonToString.toJson(this._subtitle);
    }
    if (this._hasHeroUnit) {
      result.heroUnit = JsonToString.toJson(this._heroUnit);
    }
    if (this._petUnits.length > 0) {
      result.petUnits = ArrayToJson(this._petUnits, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get subtitle() {
    return this._hasSubtitle ? this._subtitle : JsonToString.default;
  }
  get hasSubtitle() {
    return this._hasSubtitle;
  }
  setSubtitle(path, value) {
    return {type: 'SET', path: path.concat(['subtitle']), value};
  }
  deleteSubtitle(path) {
    return {type: 'DELETE', path: path.concat(['subtitle'])};
  }
  /**
   * @returns {string}
   */
  get heroUnit() {
    return this._hasHeroUnit ? this._heroUnit : JsonToString.default;
  }
  get hasHeroUnit() {
    return this._hasHeroUnit;
  }
  setHeroUnit(path, value) {
    return {type: 'SET', path: path.concat(['heroUnit']), value};
  }
  deleteHeroUnit(path) {
    return {type: 'DELETE', path: path.concat(['heroUnit'])};
  }
  /**
   * @returns {string[]}
   */
  get petUnits() {
    return this._petUnits;
  }
  addPetUnits(path, value) {
    return {type: 'ADD', path: path.concat(['petUnits']), value};
  }
  setPetUnits(path, value) {
    return {type: 'SET', path: path.concat(['petUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setPetUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['petUnits', key]), value};
  }
  deletePetUnits(path) {
    return {type: 'DELETE', path: path.concat(['petUnits'])};
  }
  deletePetUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['petUnits', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "subtitle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_HeroCard(this);
              copy._hasSubtitle = true;
              copy._subtitle = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSubtitle) {
                return this;
              }
              const copy = new CardDefinition_HeroCard(this);
              copy._hasSubtitle = false;
              copy._subtitle = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "heroUnit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_HeroCard(this);
              copy._hasHeroUnit = true;
              copy._heroUnit = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeroUnit) {
                return this;
              }
              const copy = new CardDefinition_HeroCard(this);
              copy._hasHeroUnit = false;
              copy._heroUnit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "petUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_HeroCard(this);
              copy._petUnits = [];        for (let i of value) {
                copy._petUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition_HeroCard(this);
              copy._petUnits = copy._petUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._petUnits.length === 0) {
                return this;
              }
              const copy = new CardDefinition_HeroCard(this);
              copy._petUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._petUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_HeroCard(this);
              copy._petUnits = copy._petUnits.slice();
              copy._petUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition_HeroCard(this);
              copy._petUnits = copy._petUnits.slice(0, path[1]).concat(copy._petUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._petUnits.length) {
            return this;
          }
          const oldValue = this._petUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition_HeroCard(this);
          copy._petUnits = copy._petUnits.slice();
          copy._petUnits[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardDefinition_HeroCard} other
   * @returns {CardDefinition_HeroCard}
   */
  merge(other) {
    const copy = new CardDefinition_HeroCard(this);
    if (other._hasSubtitle) {
      copy._hasSubtitle = true;
      copy._subtitle = other._subtitle;
    }
    if (other._hasHeroUnit) {
      copy._hasHeroUnit = true;
      copy._heroUnit = other._heroUnit;
    }
    copy._petUnits = this._petUnits.concat(other._petUnits);
    return copy;
  }
}
CardDefinition_HeroCard.default = new CardDefinition_HeroCard();
class CardDefinition_HeroCard_Builder {
  constructor(value) {
    this._value = new CardDefinition_HeroCard(value);
  }
  build() {
    return new CardDefinition_HeroCard(this._value);
  }
  setSubtitle(value) {
    this._value._hasSubtitle = true;
    this._value._subtitle = value;
    return this;
  }
  deleteSubtitle() {
    this._value._hasSubtitle = false;
    this._value._subtitle = null;
    return this;
  }
  setHeroUnit(value) {
    this._value._hasHeroUnit = true;
    this._value._heroUnit = value;
    return this;
  }
  deleteHeroUnit() {
    this._value._hasHeroUnit = false;
    this._value._heroUnit = null;
    return this;
  }
  addAllPetUnits(values) {
    this._value._petUnits = this._value._petUnits.concat(values);
    return this;
  }
  addPetUnits(value) {
    this._value._petUnits = this._value._petUnits.concat([value]);
    return this;
  }
  setPetUnits(index, value) {
    this._value._petUnits = this._value._petUnits.concat();
    this._value._petUnits[index] = value;
    return this;
  }
  clearPetUnits() {
    this._value._petUnits = [];
    return this;
  }
}
CardDefinition_HeroCard.Builder = CardDefinition_HeroCard_Builder;
class CardDefinition_HeroCard_WithParent {
  /**
   * @param {CardDefinition_HeroCard} value
   * @param {CardDefinition_HeroCard_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardDefinition_HeroCard.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSubtitle() {
    if (this._cachedHasSubtitle === undefined) {
      if (this._value.hasSubtitle) {
        this._cachedHasSubtitle = true;
      } else {
        this._cachedHasSubtitle = this._parent ? this._parent.hasSubtitle : false;
      }
    }
    return this._cachedHasSubtitle;
  }
  get subtitle() {
    if (this._cachedSubtitle === undefined) {
      if (this._value.hasSubtitle) {
        this._cachedSubtitle = this._value.subtitle;
      } else {
        this._cachedSubtitle = this._parent ? this._parent.subtitle : this._value.subtitle;
      }
    }
    return this._cachedSubtitle;
  }
  get hasHeroUnit() {
    if (this._cachedHasHeroUnit === undefined) {
      if (this._value.hasHeroUnit) {
        this._cachedHasHeroUnit = true;
      } else {
        this._cachedHasHeroUnit = this._parent ? this._parent.hasHeroUnit : false;
      }
    }
    return this._cachedHasHeroUnit;
  }
  get heroUnit() {
    if (this._cachedHeroUnit === undefined) {
      if (this._value.hasHeroUnit) {
        this._cachedHeroUnit = this._value.heroUnit;
      } else {
        this._cachedHeroUnit = this._parent ? this._parent.heroUnit : this._value.heroUnit;
      }
    }
    return this._cachedHeroUnit;
  }
  get selfPetUnits() {
    return this._value.petUnits;
  }
  get inherentPetUnits() {
    if (!this._inherentPetUnits) {
      this._inherentPetUnits = this._parent ? this._parent.petUnits : [];
    }
    return this._inherentPetUnits;
  }
  get petUnits() {
    if (!this._allPetUnits) {
      this._allPetUnits = this._parent ? this._parent.petUnits.concat(this.selfPetUnits) : this.selfPetUnits;
    }
    return this._allPetUnits;
  }
  update(current, parent) {
    const result = new CardDefinition_HeroCard_WithParent(current, parent);
    return result;
  }
}
CardDefinition_HeroCard_WithParent.default = new CardDefinition_HeroCard_WithParent(CardDefinition_HeroCard.default, null);
CardDefinition_HeroCard.WithParent = CardDefinition_HeroCard_WithParent;
class CardDefinition_HeroCard_Descriptor {
  get subtitle() {
    if (!this._subtitle) {
      this._subtitle = {
        name: "subtitle",
        Name: "Subtitle",
        number: 1,
        protoType: 9,
        protoName: "subtitle",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._subtitle;
  }
  get heroUnit() {
    if (!this._heroUnit) {
      this._heroUnit = {
        name: "heroUnit",
        Name: "HeroUnit",
        number: 2,
        protoType: 9,
        protoName: "hero_unit",
        type: JsonToString,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heroUnit;
  }
  get petUnits() {
    if (!this._petUnits) {
      this._petUnits = {
        name: "petUnits",
        Name: "PetUnits",
        number: 4,
        protoType: 9,
        protoName: "pet_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._petUnits;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.subtitle,
        this.heroUnit,
        this.petUnits,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSubtitle",
        Name: "DummyOneofForSubtitle",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHeroUnit",
        Name: "DummyOneofForHeroUnit",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardDefinition_HeroCard.descriptor = new CardDefinition_HeroCard_Descriptor();
class CardDefinition_TowerCard {
  get descriptor() {
    return CardDefinition_TowerCard.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTowerSlotAbility = false;
    this._towerSlotAbility = null;
    this._towerUnits = [];
    this._buildLimits = [];
  }
  isEmpty() {
    if (this._hasTowerSlotAbility) return false;
    if (this._towerUnits.length > 0) return false;
    if (this._buildLimits.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardDefinition_TowerCard) {
      return value;
    }
    return CardDefinition_TowerCard.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardDefinition_TowerCard();
    if (json.towerSlotAbility != null) {
      result._hasTowerSlotAbility = true;
      result._towerSlotAbility = JsonToString.fromJson(json.towerSlotAbility);
    }
    result._towerUnits = JsonToList(json.towerUnits, JsonToString);
    result._buildLimits = JsonToList(json.buildLimits, JsonToInt32);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTowerSlotAbility) {
      result.towerSlotAbility = JsonToString.toJson(this._towerSlotAbility);
    }
    if (this._towerUnits.length > 0) {
      result.towerUnits = ArrayToJson(this._towerUnits, JsonToString);
    }
    if (this._buildLimits.length > 0) {
      result.buildLimits = ArrayToJson(this._buildLimits, JsonToInt32);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get towerSlotAbility() {
    return this._hasTowerSlotAbility ? this._towerSlotAbility : JsonToString.default;
  }
  get hasTowerSlotAbility() {
    return this._hasTowerSlotAbility;
  }
  setTowerSlotAbility(path, value) {
    return {type: 'SET', path: path.concat(['towerSlotAbility']), value};
  }
  deleteTowerSlotAbility(path) {
    return {type: 'DELETE', path: path.concat(['towerSlotAbility'])};
  }
  /**
   * @returns {string[]}
   */
  get towerUnits() {
    return this._towerUnits;
  }
  addTowerUnits(path, value) {
    return {type: 'ADD', path: path.concat(['towerUnits']), value};
  }
  setTowerUnits(path, value) {
    return {type: 'SET', path: path.concat(['towerUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setTowerUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['towerUnits', key]), value};
  }
  deleteTowerUnits(path) {
    return {type: 'DELETE', path: path.concat(['towerUnits'])};
  }
  deleteTowerUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['towerUnits', key])};
  }
  /**
   * @returns {number[]}
   */
  get buildLimits() {
    return this._buildLimits;
  }
  addBuildLimits(path, value) {
    return {type: 'ADD', path: path.concat(['buildLimits']), value};
  }
  setBuildLimits(path, value) {
    return {type: 'SET', path: path.concat(['buildLimits']), value: ArrayToJson(value, JsonToInt32)};
  }
  setBuildLimitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['buildLimits', key]), value};
  }
  deleteBuildLimits(path) {
    return {type: 'DELETE', path: path.concat(['buildLimits'])};
  }
  deleteBuildLimitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['buildLimits', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "towerSlotAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_TowerCard(this);
              copy._hasTowerSlotAbility = true;
              copy._towerSlotAbility = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTowerSlotAbility) {
                return this;
              }
              const copy = new CardDefinition_TowerCard(this);
              copy._hasTowerSlotAbility = false;
              copy._towerSlotAbility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "towerUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_TowerCard(this);
              copy._towerUnits = [];        for (let i of value) {
                copy._towerUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition_TowerCard(this);
              copy._towerUnits = copy._towerUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._towerUnits.length === 0) {
                return this;
              }
              const copy = new CardDefinition_TowerCard(this);
              copy._towerUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._towerUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_TowerCard(this);
              copy._towerUnits = copy._towerUnits.slice();
              copy._towerUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition_TowerCard(this);
              copy._towerUnits = copy._towerUnits.slice(0, path[1]).concat(copy._towerUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._towerUnits.length) {
            return this;
          }
          const oldValue = this._towerUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition_TowerCard(this);
          copy._towerUnits = copy._towerUnits.slice();
          copy._towerUnits[key] = newValue;
          return copy;
        }
      }
      case "buildLimits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_TowerCard(this);
              copy._buildLimits = [];        for (let i of value) {
                copy._buildLimits.push(JsonToInt32.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition_TowerCard(this);
              copy._buildLimits = copy._buildLimits.concat([JsonToInt32.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._buildLimits.length === 0) {
                return this;
              }
              const copy = new CardDefinition_TowerCard(this);
              copy._buildLimits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._buildLimits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_TowerCard(this);
              copy._buildLimits = copy._buildLimits.slice();
              copy._buildLimits[path[1]] = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition_TowerCard(this);
              copy._buildLimits = copy._buildLimits.slice(0, path[1]).concat(copy._buildLimits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._buildLimits.length) {
            return this;
          }
          const oldValue = this._buildLimits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition_TowerCard(this);
          copy._buildLimits = copy._buildLimits.slice();
          copy._buildLimits[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardDefinition_TowerCard} other
   * @returns {CardDefinition_TowerCard}
   */
  merge(other) {
    const copy = new CardDefinition_TowerCard(this);
    if (other._hasTowerSlotAbility) {
      copy._hasTowerSlotAbility = true;
      copy._towerSlotAbility = other._towerSlotAbility;
    }
    copy._towerUnits = this._towerUnits.concat(other._towerUnits);
    copy._buildLimits = this._buildLimits.concat(other._buildLimits);
    return copy;
  }
}
CardDefinition_TowerCard.default = new CardDefinition_TowerCard();
class CardDefinition_TowerCard_Builder {
  constructor(value) {
    this._value = new CardDefinition_TowerCard(value);
  }
  build() {
    return new CardDefinition_TowerCard(this._value);
  }
  setTowerSlotAbility(value) {
    this._value._hasTowerSlotAbility = true;
    this._value._towerSlotAbility = value;
    return this;
  }
  deleteTowerSlotAbility() {
    this._value._hasTowerSlotAbility = false;
    this._value._towerSlotAbility = null;
    return this;
  }
  addAllTowerUnits(values) {
    this._value._towerUnits = this._value._towerUnits.concat(values);
    return this;
  }
  addTowerUnits(value) {
    this._value._towerUnits = this._value._towerUnits.concat([value]);
    return this;
  }
  setTowerUnits(index, value) {
    this._value._towerUnits = this._value._towerUnits.concat();
    this._value._towerUnits[index] = value;
    return this;
  }
  clearTowerUnits() {
    this._value._towerUnits = [];
    return this;
  }
  addAllBuildLimits(values) {
    this._value._buildLimits = this._value._buildLimits.concat(values);
    return this;
  }
  addBuildLimits(value) {
    this._value._buildLimits = this._value._buildLimits.concat([value]);
    return this;
  }
  setBuildLimits(index, value) {
    this._value._buildLimits = this._value._buildLimits.concat();
    this._value._buildLimits[index] = value;
    return this;
  }
  clearBuildLimits() {
    this._value._buildLimits = [];
    return this;
  }
}
CardDefinition_TowerCard.Builder = CardDefinition_TowerCard_Builder;
class CardDefinition_TowerCard_WithParent {
  /**
   * @param {CardDefinition_TowerCard} value
   * @param {CardDefinition_TowerCard_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardDefinition_TowerCard.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTowerSlotAbility() {
    if (this._cachedHasTowerSlotAbility === undefined) {
      if (this._value.hasTowerSlotAbility) {
        this._cachedHasTowerSlotAbility = true;
      } else {
        this._cachedHasTowerSlotAbility = this._parent ? this._parent.hasTowerSlotAbility : false;
      }
    }
    return this._cachedHasTowerSlotAbility;
  }
  get towerSlotAbility() {
    if (this._cachedTowerSlotAbility === undefined) {
      if (this._value.hasTowerSlotAbility) {
        this._cachedTowerSlotAbility = this._value.towerSlotAbility;
      } else {
        this._cachedTowerSlotAbility = this._parent ? this._parent.towerSlotAbility : this._value.towerSlotAbility;
      }
    }
    return this._cachedTowerSlotAbility;
  }
  get selfTowerUnits() {
    return this._value.towerUnits;
  }
  get inherentTowerUnits() {
    if (!this._inherentTowerUnits) {
      this._inherentTowerUnits = this._parent ? this._parent.towerUnits : [];
    }
    return this._inherentTowerUnits;
  }
  get towerUnits() {
    if (!this._allTowerUnits) {
      this._allTowerUnits = this._parent ? this._parent.towerUnits.concat(this.selfTowerUnits) : this.selfTowerUnits;
    }
    return this._allTowerUnits;
  }
  get selfBuildLimits() {
    return this._value.buildLimits;
  }
  get inherentBuildLimits() {
    if (!this._inherentBuildLimits) {
      this._inherentBuildLimits = this._parent ? this._parent.buildLimits : [];
    }
    return this._inherentBuildLimits;
  }
  get buildLimits() {
    if (!this._allBuildLimits) {
      this._allBuildLimits = this._parent ? this._parent.buildLimits.concat(this.selfBuildLimits) : this.selfBuildLimits;
    }
    return this._allBuildLimits;
  }
  update(current, parent) {
    const result = new CardDefinition_TowerCard_WithParent(current, parent);
    return result;
  }
}
CardDefinition_TowerCard_WithParent.default = new CardDefinition_TowerCard_WithParent(CardDefinition_TowerCard.default, null);
CardDefinition_TowerCard.WithParent = CardDefinition_TowerCard_WithParent;
class CardDefinition_TowerCard_Descriptor {
  get towerSlotAbility() {
    if (!this._towerSlotAbility) {
      this._towerSlotAbility = {
        name: "towerSlotAbility",
        Name: "TowerSlotAbility",
        number: 1,
        protoType: 9,
        protoName: "tower_slot_ability",
        type: JsonToString,
        options: {
          valueDropdown: "AbilityNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerSlotAbility;
  }
  get towerUnits() {
    if (!this._towerUnits) {
      this._towerUnits = {
        name: "towerUnits",
        Name: "TowerUnits",
        number: 2,
        protoType: 9,
        protoName: "tower_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerUnits;
  }
  get buildLimits() {
    if (!this._buildLimits) {
      this._buildLimits = {
        name: "buildLimits",
        Name: "BuildLimits",
        number: 4,
        protoType: 5,
        protoName: "build_limits",
        type: JsonToInt32,
        isRepeated: true,
        options: {
          comments: "[0]:awaken 0, [1]:awaken 1, ...",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._buildLimits;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.towerSlotAbility,
        this.towerUnits,
        this.buildLimits,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTowerSlotAbility",
        Name: "DummyOneofForTowerSlotAbility",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CardDefinition_TowerCard.descriptor = new CardDefinition_TowerCard_Descriptor();
class CardDefinition_SpellCard {
  get descriptor() {
    return CardDefinition_SpellCard.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasSpellAbility = false;
    this._spellAbility = null;
    this._spellUnits = [];
  }
  isEmpty() {
    if (this._hasSpellAbility) return false;
    if (this._spellUnits.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardDefinition_SpellCard) {
      return value;
    }
    return CardDefinition_SpellCard.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardDefinition_SpellCard();
    if (json.spellAbility != null) {
      result._hasSpellAbility = true;
      result._spellAbility = JsonToString.fromJson(json.spellAbility);
    }
    result._spellUnits = JsonToList(json.spellUnits, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasSpellAbility) {
      result.spellAbility = JsonToString.toJson(this._spellAbility);
    }
    if (this._spellUnits.length > 0) {
      result.spellUnits = ArrayToJson(this._spellUnits, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get spellAbility() {
    return this._hasSpellAbility ? this._spellAbility : JsonToString.default;
  }
  get hasSpellAbility() {
    return this._hasSpellAbility;
  }
  setSpellAbility(path, value) {
    return {type: 'SET', path: path.concat(['spellAbility']), value};
  }
  deleteSpellAbility(path) {
    return {type: 'DELETE', path: path.concat(['spellAbility'])};
  }
  /**
   * @returns {string[]}
   */
  get spellUnits() {
    return this._spellUnits;
  }
  addSpellUnits(path, value) {
    return {type: 'ADD', path: path.concat(['spellUnits']), value};
  }
  setSpellUnits(path, value) {
    return {type: 'SET', path: path.concat(['spellUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setSpellUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['spellUnits', key]), value};
  }
  deleteSpellUnits(path) {
    return {type: 'DELETE', path: path.concat(['spellUnits'])};
  }
  deleteSpellUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['spellUnits', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "spellAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_SpellCard(this);
              copy._hasSpellAbility = true;
              copy._spellAbility = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpellAbility) {
                return this;
              }
              const copy = new CardDefinition_SpellCard(this);
              copy._hasSpellAbility = false;
              copy._spellAbility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spellUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_SpellCard(this);
              copy._spellUnits = [];        for (let i of value) {
                copy._spellUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition_SpellCard(this);
              copy._spellUnits = copy._spellUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._spellUnits.length === 0) {
                return this;
              }
              const copy = new CardDefinition_SpellCard(this);
              copy._spellUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._spellUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition_SpellCard(this);
              copy._spellUnits = copy._spellUnits.slice();
              copy._spellUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition_SpellCard(this);
              copy._spellUnits = copy._spellUnits.slice(0, path[1]).concat(copy._spellUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._spellUnits.length) {
            return this;
          }
          const oldValue = this._spellUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition_SpellCard(this);
          copy._spellUnits = copy._spellUnits.slice();
          copy._spellUnits[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardDefinition_SpellCard} other
   * @returns {CardDefinition_SpellCard}
   */
  merge(other) {
    const copy = new CardDefinition_SpellCard(this);
    if (other._hasSpellAbility) {
      copy._hasSpellAbility = true;
      copy._spellAbility = other._spellAbility;
    }
    copy._spellUnits = this._spellUnits.concat(other._spellUnits);
    return copy;
  }
}
CardDefinition_SpellCard.default = new CardDefinition_SpellCard();
class CardDefinition_SpellCard_Builder {
  constructor(value) {
    this._value = new CardDefinition_SpellCard(value);
  }
  build() {
    return new CardDefinition_SpellCard(this._value);
  }
  setSpellAbility(value) {
    this._value._hasSpellAbility = true;
    this._value._spellAbility = value;
    return this;
  }
  deleteSpellAbility() {
    this._value._hasSpellAbility = false;
    this._value._spellAbility = null;
    return this;
  }
  addAllSpellUnits(values) {
    this._value._spellUnits = this._value._spellUnits.concat(values);
    return this;
  }
  addSpellUnits(value) {
    this._value._spellUnits = this._value._spellUnits.concat([value]);
    return this;
  }
  setSpellUnits(index, value) {
    this._value._spellUnits = this._value._spellUnits.concat();
    this._value._spellUnits[index] = value;
    return this;
  }
  clearSpellUnits() {
    this._value._spellUnits = [];
    return this;
  }
}
CardDefinition_SpellCard.Builder = CardDefinition_SpellCard_Builder;
class CardDefinition_SpellCard_WithParent {
  /**
   * @param {CardDefinition_SpellCard} value
   * @param {CardDefinition_SpellCard_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardDefinition_SpellCard.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasSpellAbility() {
    if (this._cachedHasSpellAbility === undefined) {
      if (this._value.hasSpellAbility) {
        this._cachedHasSpellAbility = true;
      } else {
        this._cachedHasSpellAbility = this._parent ? this._parent.hasSpellAbility : false;
      }
    }
    return this._cachedHasSpellAbility;
  }
  get spellAbility() {
    if (this._cachedSpellAbility === undefined) {
      if (this._value.hasSpellAbility) {
        this._cachedSpellAbility = this._value.spellAbility;
      } else {
        this._cachedSpellAbility = this._parent ? this._parent.spellAbility : this._value.spellAbility;
      }
    }
    return this._cachedSpellAbility;
  }
  get selfSpellUnits() {
    return this._value.spellUnits;
  }
  get inherentSpellUnits() {
    if (!this._inherentSpellUnits) {
      this._inherentSpellUnits = this._parent ? this._parent.spellUnits : [];
    }
    return this._inherentSpellUnits;
  }
  get spellUnits() {
    if (!this._allSpellUnits) {
      this._allSpellUnits = this._parent ? this._parent.spellUnits.concat(this.selfSpellUnits) : this.selfSpellUnits;
    }
    return this._allSpellUnits;
  }
  update(current, parent) {
    const result = new CardDefinition_SpellCard_WithParent(current, parent);
    return result;
  }
}
CardDefinition_SpellCard_WithParent.default = new CardDefinition_SpellCard_WithParent(CardDefinition_SpellCard.default, null);
CardDefinition_SpellCard.WithParent = CardDefinition_SpellCard_WithParent;
class CardDefinition_SpellCard_Descriptor {
  get spellAbility() {
    if (!this._spellAbility) {
      this._spellAbility = {
        name: "spellAbility",
        Name: "SpellAbility",
        number: 1,
        protoType: 9,
        protoName: "spell_ability",
        type: JsonToString,
        options: {
          valueDropdown: "AbilityNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellAbility;
  }
  get spellUnits() {
    if (!this._spellUnits) {
      this._spellUnits = {
        name: "spellUnits",
        Name: "SpellUnits",
        number: 2,
        protoType: 9,
        protoName: "spell_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellUnits;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.spellAbility,
        this.spellUnits,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSpellAbility",
        Name: "DummyOneofForSpellAbility",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CardDefinition_SpellCard.descriptor = new CardDefinition_SpellCard_Descriptor();
class CardDefinition_Affinity {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "PHYSICAL": return 0;
        case "FIRE": return 1;
        case "WATER": return 2;
        case "NATURE": return 3;
        case "LIGHT": return 4;
        case "DARK": return 5;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return CardDefinition_Affinity.fromJson(value);
  }
  static fromReact(e) {
    return CardDefinition_Affinity.fromJson(e);
  }
}
CardDefinition_Affinity.PHYSICAL = 0;
CardDefinition_Affinity.FIRE = 1;
CardDefinition_Affinity.WATER = 2;
CardDefinition_Affinity.NATURE = 3;
CardDefinition_Affinity.LIGHT = 4;
CardDefinition_Affinity.DARK = 5;
CardDefinition_Affinity.default = 0;
CardDefinition_Affinity.values = {
  PHYSICAL: 0,
  FIRE: 1,
  WATER: 2,
  NATURE: 3,
  LIGHT: 4,
  DARK: 5,
};
CardDefinition_Affinity.names = {
  0: "PHYSICAL",
  1: "FIRE",
  2: "WATER",
  3: "NATURE",
  4: "LIGHT",
  5: "DARK",
};
export class CardDefinition {
  get descriptor() {
    return CardDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasLoadoutIcon = false;
    this._loadoutIcon = null;
    this._hasCardIcon = false;
    this._cardIcon = null;
    this._hasPortraitImage = false;
    this._portraitImage = null;
    this._hasAffinity = false;
    this._affinity = null;
    this._cardSkills = [];
    this._unitUpgrades = [];
    this._cardAwaken = [];
    this._hasCardInfo = false;
    this._cardInfo = null;
    this._hasShardId = false;
    this._shardId = null;
    this._hasLevelUpPopupMsg = false;
    this._levelUpPopupMsg = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._voPaths = [];
    this._hasBasePowerIndex = false;
    this._basePowerIndex = null;
    this._hasModulePath = false;
    this._modulePath = null;
    this._hasHide = false;
    this._hide = null;
    this._cardTypeCase = 0;
    this._cardTypeValue = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasLoadoutIcon) return false;
    if (this._hasCardIcon) return false;
    if (this._hasPortraitImage) return false;
    if (this._hasAffinity) return false;
    if (this._cardSkills.length > 0) return false;
    if (this._unitUpgrades.length > 0) return false;
    if (this._cardAwaken.length > 0) return false;
    if (this._hasCardInfo && !this._cardInfo.isEmpty()) return false;
    if (this._hasShardId) return false;
    if (this._hasLevelUpPopupMsg) return false;
    if (this._hasDisplayName) return false;
    if (this._voPaths.length > 0) return false;
    if (this._hasBasePowerIndex) return false;
    if (this._hasModulePath) return false;
    if (this._hasHide) return false;
    if (this._cardTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardDefinition) {
      return value;
    }
    return CardDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardDefinition();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.loadoutIcon != null) {
      result._hasLoadoutIcon = true;
      result._loadoutIcon = JsonToString.fromJson(json.loadoutIcon);
    }
    if (json.cardIcon != null) {
      result._hasCardIcon = true;
      result._cardIcon = JsonToString.fromJson(json.cardIcon);
    }
    if (json.portraitImage != null) {
      result._hasPortraitImage = true;
      result._portraitImage = JsonToString.fromJson(json.portraitImage);
    }
    if (json.affinity != null) {
      result._hasAffinity = true;
      result._affinity = CardDefinition_Affinity.fromJson(json.affinity);
    }
    result._cardSkills = JsonToList(json.cardSkills, CardSkill);
    result._unitUpgrades = JsonToList(json.unitUpgrades, JsonToString);
    result._cardAwaken = JsonToList(json.cardAwaken, CardAwaken);
    if (json.cardInfo != null) {
      result._hasCardInfo = true;
      result._cardInfo = CardInfo.fromJson(json.cardInfo);
    }
    if (json.shardId != null) {
      result._hasShardId = true;
      result._shardId = JsonToString.fromJson(json.shardId);
    }
    if (json.levelUpPopupMsg != null) {
      result._hasLevelUpPopupMsg = true;
      result._levelUpPopupMsg = JsonToString.fromJson(json.levelUpPopupMsg);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    result._voPaths = JsonToList(json.voPaths, JsonToString);
    if (json.basePowerIndex != null) {
      result._hasBasePowerIndex = true;
      result._basePowerIndex = JsonToInt32.fromJson(json.basePowerIndex);
    }
    if (json.modulePath != null) {
      result._hasModulePath = true;
      result._modulePath = JsonToString.fromJson(json.modulePath);
    }
    if (json.hide != null) {
      result._hasHide = true;
      result._hide = JsonToBoolean.fromJson(json.hide);
    }
    if (json.hero != null) {
      result._cardTypeCase = 11;
      result._cardTypeValue = CardDefinition_HeroCard.fromJson(json.hero);
    }
    if (json.tower != null) {
      result._cardTypeCase = 12;
      result._cardTypeValue = CardDefinition_TowerCard.fromJson(json.tower);
    }
    if (json.spell != null) {
      result._cardTypeCase = 13;
      result._cardTypeValue = CardDefinition_SpellCard.fromJson(json.spell);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasLoadoutIcon) {
      result.loadoutIcon = JsonToString.toJson(this._loadoutIcon);
    }
    if (this._hasCardIcon) {
      result.cardIcon = JsonToString.toJson(this._cardIcon);
    }
    if (this._hasPortraitImage) {
      result.portraitImage = JsonToString.toJson(this._portraitImage);
    }
    if (this._hasAffinity) {
      result.affinity = CardDefinition_Affinity.toJson(this._affinity);
    }
    if (this._cardSkills.length > 0) {
      result.cardSkills = ArrayToJson(this._cardSkills, CardSkill);
    }
    if (this._unitUpgrades.length > 0) {
      result.unitUpgrades = ArrayToJson(this._unitUpgrades, JsonToString);
    }
    if (this._cardAwaken.length > 0) {
      result.cardAwaken = ArrayToJson(this._cardAwaken, CardAwaken);
    }
    if (this._hasCardInfo && !this._cardInfo.isEmpty()) {
      result.cardInfo = CardInfo.toJson(this._cardInfo);
    }
    if (this._hasShardId) {
      result.shardId = JsonToString.toJson(this._shardId);
    }
    if (this._hasLevelUpPopupMsg) {
      result.levelUpPopupMsg = JsonToString.toJson(this._levelUpPopupMsg);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._voPaths.length > 0) {
      result.voPaths = ArrayToJson(this._voPaths, JsonToString);
    }
    if (this._hasBasePowerIndex) {
      result.basePowerIndex = JsonToInt32.toJson(this._basePowerIndex);
    }
    if (this._hasModulePath) {
      result.modulePath = JsonToString.toJson(this._modulePath);
    }
    if (this._hasHide) {
      result.hide = JsonToBoolean.toJson(this._hide);
    }
    switch (this._cardTypeCase) {
      case 11:
        result.hero = CardDefinition_HeroCard.toJson(this._cardTypeValue);
        break;
      case 12:
        result.tower = CardDefinition_TowerCard.toJson(this._cardTypeValue);
        break;
      case 13:
        result.spell = CardDefinition_SpellCard.toJson(this._cardTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get loadoutIcon() {
    return this._hasLoadoutIcon ? this._loadoutIcon : JsonToString.default;
  }
  get hasLoadoutIcon() {
    return this._hasLoadoutIcon;
  }
  setLoadoutIcon(path, value) {
    return {type: 'SET', path: path.concat(['loadoutIcon']), value};
  }
  deleteLoadoutIcon(path) {
    return {type: 'DELETE', path: path.concat(['loadoutIcon'])};
  }
  /**
   * @returns {string}
   */
  get cardIcon() {
    return this._hasCardIcon ? this._cardIcon : JsonToString.default;
  }
  get hasCardIcon() {
    return this._hasCardIcon;
  }
  setCardIcon(path, value) {
    return {type: 'SET', path: path.concat(['cardIcon']), value};
  }
  deleteCardIcon(path) {
    return {type: 'DELETE', path: path.concat(['cardIcon'])};
  }
  /**
   * @returns {string}
   */
  get portraitImage() {
    return this._hasPortraitImage ? this._portraitImage : JsonToString.default;
  }
  get hasPortraitImage() {
    return this._hasPortraitImage;
  }
  setPortraitImage(path, value) {
    return {type: 'SET', path: path.concat(['portraitImage']), value};
  }
  deletePortraitImage(path) {
    return {type: 'DELETE', path: path.concat(['portraitImage'])};
  }
  /**
   * @returns {number}
   */
  get affinity() {
    return this._hasAffinity ? this._affinity : CardDefinition_Affinity.default;
  }
  get hasAffinity() {
    return this._hasAffinity;
  }
  setAffinity(path, value) {
    return {type: 'SET', path: path.concat(['affinity']), value};
  }
  deleteAffinity(path) {
    return {type: 'DELETE', path: path.concat(['affinity'])};
  }
  /**
   * @returns {CardSkill[]}
   */
  get cardSkills() {
    return this._cardSkills;
  }
  addCardSkills(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkills']), value: value.toJson()};
  }
  setCardSkills(path, value) {
    return {type: 'SET', path: path.concat(['cardSkills']), value: ArrayToJson(value, CardSkill)};
  }
  setCardSkillsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkills', key]), value: value.toJson()};
  }
  deleteCardSkills(path) {
    return {type: 'DELETE', path: path.concat(['cardSkills'])};
  }
  deleteCardSkillsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkills', key])};
  }
  /**
   * @returns {string[]}
   */
  get unitUpgrades() {
    return this._unitUpgrades;
  }
  addUnitUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['unitUpgrades']), value};
  }
  setUnitUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['unitUpgrades']), value: ArrayToJson(value, JsonToString)};
  }
  setUnitUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unitUpgrades', key]), value};
  }
  deleteUnitUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['unitUpgrades'])};
  }
  deleteUnitUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unitUpgrades', key])};
  }
  /**
   * @returns {CardAwaken[]}
   */
  get cardAwaken() {
    return this._cardAwaken;
  }
  addCardAwaken(path, value) {
    return {type: 'ADD', path: path.concat(['cardAwaken']), value: value.toJson()};
  }
  setCardAwaken(path, value) {
    return {type: 'SET', path: path.concat(['cardAwaken']), value: ArrayToJson(value, CardAwaken)};
  }
  setCardAwakenByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardAwaken', key]), value: value.toJson()};
  }
  deleteCardAwaken(path) {
    return {type: 'DELETE', path: path.concat(['cardAwaken'])};
  }
  deleteCardAwakenByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardAwaken', key])};
  }
  /**
   * @returns {CardInfo}
   */
  get cardInfo() {
    return this._hasCardInfo ? this._cardInfo : CardInfo.default;
  }
  get hasCardInfo() {
    return this._hasCardInfo;
  }
  setCardInfo(path, value) {
    return {type: 'SET', path: path.concat(['cardInfo']), value: value.toJson()};
  }
  deleteCardInfo(path) {
    return {type: 'DELETE', path: path.concat(['cardInfo'])};
  }
  /**
   * @returns {string}
   */
  get shardId() {
    return this._hasShardId ? this._shardId : JsonToString.default;
  }
  get hasShardId() {
    return this._hasShardId;
  }
  setShardId(path, value) {
    return {type: 'SET', path: path.concat(['shardId']), value};
  }
  deleteShardId(path) {
    return {type: 'DELETE', path: path.concat(['shardId'])};
  }
  /**
   * @returns {string}
   */
  get levelUpPopupMsg() {
    return this._hasLevelUpPopupMsg ? this._levelUpPopupMsg : JsonToString.default;
  }
  get hasLevelUpPopupMsg() {
    return this._hasLevelUpPopupMsg;
  }
  setLevelUpPopupMsg(path, value) {
    return {type: 'SET', path: path.concat(['levelUpPopupMsg']), value};
  }
  deleteLevelUpPopupMsg(path) {
    return {type: 'DELETE', path: path.concat(['levelUpPopupMsg'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string[]}
   */
  get voPaths() {
    return this._voPaths;
  }
  addVoPaths(path, value) {
    return {type: 'ADD', path: path.concat(['voPaths']), value};
  }
  setVoPaths(path, value) {
    return {type: 'SET', path: path.concat(['voPaths']), value: ArrayToJson(value, JsonToString)};
  }
  setVoPathsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['voPaths', key]), value};
  }
  deleteVoPaths(path) {
    return {type: 'DELETE', path: path.concat(['voPaths'])};
  }
  deleteVoPathsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['voPaths', key])};
  }
  /**
   * @returns {number}
   */
  get basePowerIndex() {
    return this._hasBasePowerIndex ? this._basePowerIndex : JsonToInt32.default;
  }
  get hasBasePowerIndex() {
    return this._hasBasePowerIndex;
  }
  setBasePowerIndex(path, value) {
    return {type: 'SET', path: path.concat(['basePowerIndex']), value};
  }
  deleteBasePowerIndex(path) {
    return {type: 'DELETE', path: path.concat(['basePowerIndex'])};
  }
  /**
   * @returns {string}
   */
  get modulePath() {
    return this._hasModulePath ? this._modulePath : JsonToString.default;
  }
  get hasModulePath() {
    return this._hasModulePath;
  }
  setModulePath(path, value) {
    return {type: 'SET', path: path.concat(['modulePath']), value};
  }
  deleteModulePath(path) {
    return {type: 'DELETE', path: path.concat(['modulePath'])};
  }
  /**
   * @returns {boolean}
   */
  get hide() {
    return this._hasHide ? this._hide : JsonToBoolean.default;
  }
  get hasHide() {
    return this._hasHide;
  }
  setHide(path, value) {
    return {type: 'SET', path: path.concat(['hide']), value};
  }
  deleteHide(path) {
    return {type: 'DELETE', path: path.concat(['hide'])};
  }
  get cardTypeCase() {
    return this._cardTypeCase;
  }
  deleteCardType(path) {
    switch (this._cardTypeCase) {
      default:
      case 11: {
        return {type: 'DELETE', path: path.concat(['hero'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['tower'])};
      }
      case 13: {
        return {type: 'DELETE', path: path.concat(['spell'])};
      }
    }
  }
  /**
   * @returns {CardDefinition_HeroCard}
   */
  get hero() {
    return this._cardTypeCase === 11 ? this._cardTypeValue : CardDefinition_HeroCard.default;
  }
  setHero(path, value) {
    return {type: 'SET', path: path.concat(['hero']), value: value.toJson()};
  }
  deleteHero(path) {
    return {type: 'DELETE', path: path.concat(['hero'])};
  }
  /**
   * @returns {CardDefinition_TowerCard}
   */
  get tower() {
    return this._cardTypeCase === 12 ? this._cardTypeValue : CardDefinition_TowerCard.default;
  }
  setTower(path, value) {
    return {type: 'SET', path: path.concat(['tower']), value: value.toJson()};
  }
  deleteTower(path) {
    return {type: 'DELETE', path: path.concat(['tower'])};
  }
  /**
   * @returns {CardDefinition_SpellCard}
   */
  get spell() {
    return this._cardTypeCase === 13 ? this._cardTypeValue : CardDefinition_SpellCard.default;
  }
  setSpell(path, value) {
    return {type: 'SET', path: path.concat(['spell']), value: value.toJson()};
  }
  deleteSpell(path) {
    return {type: 'DELETE', path: path.concat(['spell'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "loadoutIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasLoadoutIcon = true;
              copy._loadoutIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLoadoutIcon) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasLoadoutIcon = false;
              copy._loadoutIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasCardIcon = true;
              copy._cardIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardIcon) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasCardIcon = false;
              copy._cardIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "portraitImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasPortraitImage = true;
              copy._portraitImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPortraitImage) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasPortraitImage = false;
              copy._portraitImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasAffinity = true;
              copy._affinity = CardDefinition_Affinity.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinity) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasAffinity = false;
              copy._affinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardSkills": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardSkills = [];        for (let i of value) {
                copy._cardSkills.push(CardSkill.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition(this);
              copy._cardSkills = copy._cardSkills.concat([CardSkill.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkills.length === 0) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._cardSkills = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkills.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardSkills = copy._cardSkills.slice();
              copy._cardSkills[path[1]] = CardSkill.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition(this);
              copy._cardSkills = copy._cardSkills.slice(0, path[1]).concat(copy._cardSkills.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkills.length) {
            return this;
          }
          const oldValue = this._cardSkills[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardSkills = copy._cardSkills.slice();
          copy._cardSkills[key] = newValue;
          return copy;
        }
      }
      case "unitUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._unitUpgrades = [];        for (let i of value) {
                copy._unitUpgrades.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition(this);
              copy._unitUpgrades = copy._unitUpgrades.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unitUpgrades.length === 0) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._unitUpgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unitUpgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._unitUpgrades = copy._unitUpgrades.slice();
              copy._unitUpgrades[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition(this);
              copy._unitUpgrades = copy._unitUpgrades.slice(0, path[1]).concat(copy._unitUpgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unitUpgrades.length) {
            return this;
          }
          const oldValue = this._unitUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._unitUpgrades = copy._unitUpgrades.slice();
          copy._unitUpgrades[key] = newValue;
          return copy;
        }
      }
      case "cardAwaken": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardAwaken = [];        for (let i of value) {
                copy._cardAwaken.push(CardAwaken.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition(this);
              copy._cardAwaken = copy._cardAwaken.concat([CardAwaken.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardAwaken.length === 0) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._cardAwaken = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardAwaken.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardAwaken = copy._cardAwaken.slice();
              copy._cardAwaken[path[1]] = CardAwaken.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition(this);
              copy._cardAwaken = copy._cardAwaken.slice(0, path[1]).concat(copy._cardAwaken.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardAwaken.length) {
            return this;
          }
          const oldValue = this._cardAwaken[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardAwaken = copy._cardAwaken.slice();
          copy._cardAwaken[key] = newValue;
          return copy;
        }
      }
      case "cardInfo": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasCardInfo = true;
              copy._cardInfo = CardInfo.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardInfo) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasCardInfo = false;
              copy._cardInfo = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCardInfo) {
            const copy = new CardDefinition(this);
            copy._hasCardInfo = true;
            copy._cardInfo = CardInfo.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cardInfo.apply(type, path.slice(1), value);
          if (newValue === this._cardInfo) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardInfo = copy._cardInfo.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "shardId": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasShardId = true;
              copy._shardId = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShardId) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasShardId = false;
              copy._shardId = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelUpPopupMsg": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasLevelUpPopupMsg = true;
              copy._levelUpPopupMsg = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelUpPopupMsg) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasLevelUpPopupMsg = false;
              copy._levelUpPopupMsg = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "voPaths": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._voPaths = [];        for (let i of value) {
                copy._voPaths.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardDefinition(this);
              copy._voPaths = copy._voPaths.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._voPaths.length === 0) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._voPaths = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._voPaths.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._voPaths = copy._voPaths.slice();
              copy._voPaths[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardDefinition(this);
              copy._voPaths = copy._voPaths.slice(0, path[1]).concat(copy._voPaths.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._voPaths.length) {
            return this;
          }
          const oldValue = this._voPaths[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._voPaths = copy._voPaths.slice();
          copy._voPaths[key] = newValue;
          return copy;
        }
      }
      case "basePowerIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasBasePowerIndex = true;
              copy._basePowerIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBasePowerIndex) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasBasePowerIndex = false;
              copy._basePowerIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "modulePath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasModulePath = true;
              copy._modulePath = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasModulePath) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasModulePath = false;
              copy._modulePath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._hasHide = true;
              copy._hide = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHide) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._hasHide = false;
              copy._hide = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hero": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 11;
              copy._cardTypeValue = CardDefinition_HeroCard.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 11) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 11) {
            const copy = new CardDefinition(this);
            copy._cardTypeCase = 11;
            copy._cardTypeValue = CardDefinition_HeroCard.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.hero.apply(type, path.slice(1), value);
          if (newValue === this.hero) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardTypeCase = 11;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "tower": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 12;
              copy._cardTypeValue = CardDefinition_TowerCard.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 12) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 12) {
            const copy = new CardDefinition(this);
            copy._cardTypeCase = 12;
            copy._cardTypeValue = CardDefinition_TowerCard.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tower.apply(type, path.slice(1), value);
          if (newValue === this.tower) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardTypeCase = 12;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "spell": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 13;
              copy._cardTypeValue = CardDefinition_SpellCard.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 13) {
                return this;
              }
              const copy = new CardDefinition(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 13) {
            const copy = new CardDefinition(this);
            copy._cardTypeCase = 13;
            copy._cardTypeValue = CardDefinition_SpellCard.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.spell.apply(type, path.slice(1), value);
          if (newValue === this.spell) {
            return this;
          }
          const copy = new CardDefinition(this);
          copy._cardTypeCase = 13;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardDefinition} other
   * @returns {CardDefinition}
   */
  merge(other) {
    const copy = new CardDefinition(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasLoadoutIcon) {
      copy._hasLoadoutIcon = true;
      copy._loadoutIcon = other._loadoutIcon;
    }
    if (other._hasCardIcon) {
      copy._hasCardIcon = true;
      copy._cardIcon = other._cardIcon;
    }
    if (other._hasPortraitImage) {
      copy._hasPortraitImage = true;
      copy._portraitImage = other._portraitImage;
    }
    if (other._hasAffinity) {
      copy._hasAffinity = true;
      copy._affinity = other._affinity;
    }
    copy._cardSkills = this._cardSkills.concat(other._cardSkills);
    copy._unitUpgrades = this._unitUpgrades.concat(other._unitUpgrades);
    copy._cardAwaken = this._cardAwaken.concat(other._cardAwaken);
    if (other._hasCardInfo) {
      if (copy._hasCardInfo) {
        copy._cardInfo = copy.cardInfo.merge(other.cardInfo);
      } else {
        copy._cardInfo = other._cardInfo;
      }
      copy._hasCardInfo = true;
    }
    if (other._hasShardId) {
      copy._hasShardId = true;
      copy._shardId = other._shardId;
    }
    if (other._hasLevelUpPopupMsg) {
      copy._hasLevelUpPopupMsg = true;
      copy._levelUpPopupMsg = other._levelUpPopupMsg;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    copy._voPaths = this._voPaths.concat(other._voPaths);
    if (other._hasBasePowerIndex) {
      copy._hasBasePowerIndex = true;
      copy._basePowerIndex = other._basePowerIndex;
    }
    if (other._hasModulePath) {
      copy._hasModulePath = true;
      copy._modulePath = other._modulePath;
    }
    if (other._hasHide) {
      copy._hasHide = true;
      copy._hide = other._hide;
    }
    if (other._cardTypeCase === 11) {
      if (this._cardTypeCase === 11) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 11;
    }
    if (other._cardTypeCase === 11) {
      if (this._cardTypeCase === 11) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 11;
    }
    if (other._cardTypeCase === 11) {
      if (this._cardTypeCase === 11) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 11;
    }
    return copy;
  }
}
CardDefinition.default = new CardDefinition();
CardDefinition.HeroCard = CardDefinition_HeroCard;
CardDefinition.TowerCard = CardDefinition_TowerCard;
CardDefinition.SpellCard = CardDefinition_SpellCard;
CardDefinition.Affinity = CardDefinition_Affinity;
class CardDefinition_Builder {
  constructor(value) {
    this._value = new CardDefinition(value);
  }
  build() {
    return new CardDefinition(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setLoadoutIcon(value) {
    this._value._hasLoadoutIcon = true;
    this._value._loadoutIcon = value;
    return this;
  }
  deleteLoadoutIcon() {
    this._value._hasLoadoutIcon = false;
    this._value._loadoutIcon = null;
    return this;
  }
  setCardIcon(value) {
    this._value._hasCardIcon = true;
    this._value._cardIcon = value;
    return this;
  }
  deleteCardIcon() {
    this._value._hasCardIcon = false;
    this._value._cardIcon = null;
    return this;
  }
  setPortraitImage(value) {
    this._value._hasPortraitImage = true;
    this._value._portraitImage = value;
    return this;
  }
  deletePortraitImage() {
    this._value._hasPortraitImage = false;
    this._value._portraitImage = null;
    return this;
  }
  setAffinity(value) {
    this._value._hasAffinity = true;
    this._value._affinity = value;
    return this;
  }
  deleteAffinity() {
    this._value._hasAffinity = false;
    this._value._affinity = null;
    return this;
  }
  addAllCardSkills(values) {
    this._value._cardSkills = this._value._cardSkills.concat(values);
    return this;
  }
  addCardSkills(value) {
    this._value._cardSkills = this._value._cardSkills.concat([value]);
    return this;
  }
  setCardSkills(index, value) {
    this._value._cardSkills = this._value._cardSkills.concat();
    this._value._cardSkills[index] = value;
    return this;
  }
  clearCardSkills() {
    this._value._cardSkills = [];
    return this;
  }
  addAllUnitUpgrades(values) {
    this._value._unitUpgrades = this._value._unitUpgrades.concat(values);
    return this;
  }
  addUnitUpgrades(value) {
    this._value._unitUpgrades = this._value._unitUpgrades.concat([value]);
    return this;
  }
  setUnitUpgrades(index, value) {
    this._value._unitUpgrades = this._value._unitUpgrades.concat();
    this._value._unitUpgrades[index] = value;
    return this;
  }
  clearUnitUpgrades() {
    this._value._unitUpgrades = [];
    return this;
  }
  addAllCardAwaken(values) {
    this._value._cardAwaken = this._value._cardAwaken.concat(values);
    return this;
  }
  addCardAwaken(value) {
    this._value._cardAwaken = this._value._cardAwaken.concat([value]);
    return this;
  }
  setCardAwaken(index, value) {
    this._value._cardAwaken = this._value._cardAwaken.concat();
    this._value._cardAwaken[index] = value;
    return this;
  }
  clearCardAwaken() {
    this._value._cardAwaken = [];
    return this;
  }
  setCardInfo(value) {
    this._value._hasCardInfo = true;
    this._value._cardInfo = value;
    return this;
  }
  deleteCardInfo() {
    this._value._hasCardInfo = false;
    this._value._cardInfo = null;
    return this;
  }
  setShardId(value) {
    this._value._hasShardId = true;
    this._value._shardId = value;
    return this;
  }
  deleteShardId() {
    this._value._hasShardId = false;
    this._value._shardId = null;
    return this;
  }
  setLevelUpPopupMsg(value) {
    this._value._hasLevelUpPopupMsg = true;
    this._value._levelUpPopupMsg = value;
    return this;
  }
  deleteLevelUpPopupMsg() {
    this._value._hasLevelUpPopupMsg = false;
    this._value._levelUpPopupMsg = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  addAllVoPaths(values) {
    this._value._voPaths = this._value._voPaths.concat(values);
    return this;
  }
  addVoPaths(value) {
    this._value._voPaths = this._value._voPaths.concat([value]);
    return this;
  }
  setVoPaths(index, value) {
    this._value._voPaths = this._value._voPaths.concat();
    this._value._voPaths[index] = value;
    return this;
  }
  clearVoPaths() {
    this._value._voPaths = [];
    return this;
  }
  setBasePowerIndex(value) {
    this._value._hasBasePowerIndex = true;
    this._value._basePowerIndex = value;
    return this;
  }
  deleteBasePowerIndex() {
    this._value._hasBasePowerIndex = false;
    this._value._basePowerIndex = null;
    return this;
  }
  setModulePath(value) {
    this._value._hasModulePath = true;
    this._value._modulePath = value;
    return this;
  }
  deleteModulePath() {
    this._value._hasModulePath = false;
    this._value._modulePath = null;
    return this;
  }
  setHide(value) {
    this._value._hasHide = true;
    this._value._hide = value;
    return this;
  }
  deleteHide() {
    this._value._hasHide = false;
    this._value._hide = null;
    return this;
  }
  clearcardType() {
    this._value._cardTypeCase = 0;
    this._value._cardTypeValue = null;
    return this;
  }
  setHero(value) {
    this._value._cardTypeCase = 11;
    this._value._cardTypeValue = value;
    return this;
  }
  setTower(value) {
    this._value._cardTypeCase = 12;
    this._value._cardTypeValue = value;
    return this;
  }
  setSpell(value) {
    this._value._cardTypeCase = 13;
    this._value._cardTypeValue = value;
    return this;
  }
}
CardDefinition.Builder = CardDefinition_Builder;
class CardDefinition_WithParent {
  /**
   * @param {CardDefinition} value
   * @param {CardDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasLoadoutIcon() {
    if (this._cachedHasLoadoutIcon === undefined) {
      if (this._value.hasLoadoutIcon) {
        this._cachedHasLoadoutIcon = true;
      } else {
        this._cachedHasLoadoutIcon = this._parent ? this._parent.hasLoadoutIcon : false;
      }
    }
    return this._cachedHasLoadoutIcon;
  }
  get loadoutIcon() {
    if (this._cachedLoadoutIcon === undefined) {
      if (this._value.hasLoadoutIcon) {
        this._cachedLoadoutIcon = this._value.loadoutIcon;
      } else {
        this._cachedLoadoutIcon = this._parent ? this._parent.loadoutIcon : this._value.loadoutIcon;
      }
    }
    return this._cachedLoadoutIcon;
  }
  get hasCardIcon() {
    if (this._cachedHasCardIcon === undefined) {
      if (this._value.hasCardIcon) {
        this._cachedHasCardIcon = true;
      } else {
        this._cachedHasCardIcon = this._parent ? this._parent.hasCardIcon : false;
      }
    }
    return this._cachedHasCardIcon;
  }
  get cardIcon() {
    if (this._cachedCardIcon === undefined) {
      if (this._value.hasCardIcon) {
        this._cachedCardIcon = this._value.cardIcon;
      } else {
        this._cachedCardIcon = this._parent ? this._parent.cardIcon : this._value.cardIcon;
      }
    }
    return this._cachedCardIcon;
  }
  get hasPortraitImage() {
    if (this._cachedHasPortraitImage === undefined) {
      if (this._value.hasPortraitImage) {
        this._cachedHasPortraitImage = true;
      } else {
        this._cachedHasPortraitImage = this._parent ? this._parent.hasPortraitImage : false;
      }
    }
    return this._cachedHasPortraitImage;
  }
  get portraitImage() {
    if (this._cachedPortraitImage === undefined) {
      if (this._value.hasPortraitImage) {
        this._cachedPortraitImage = this._value.portraitImage;
      } else {
        this._cachedPortraitImage = this._parent ? this._parent.portraitImage : this._value.portraitImage;
      }
    }
    return this._cachedPortraitImage;
  }
  get hasAffinity() {
    if (this._cachedHasAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedHasAffinity = true;
      } else {
        this._cachedHasAffinity = this._parent ? this._parent.hasAffinity : false;
      }
    }
    return this._cachedHasAffinity;
  }
  get affinity() {
    if (this._cachedAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedAffinity = this._value.affinity;
      } else {
        this._cachedAffinity = this._parent ? this._parent.affinity : this._value.affinity;
      }
    }
    return this._cachedAffinity;
  }
  get selfCardSkills() {
    if (!this._selfCardSkills) {
      this._selfCardSkills = [];
      for (let i of this._value.cardSkills) {
        this._selfCardSkills.push(new CardSkill.WithParent(i, null));
      }
    }
    return this._selfCardSkills;
  }
  get inherentCardSkills() {
    if (!this._inherentCardSkills) {
      this._inherentCardSkills = this._parent ? this._parent.cardSkills : [];
    }
    return this._inherentCardSkills;
  }
  get cardSkills() {
    if (!this._allCardSkills) {
      this._allCardSkills = this._parent ? this._parent.cardSkills.concat(this.selfCardSkills) : this.selfCardSkills;
    }
    return this._allCardSkills;
  }
  get selfUnitUpgrades() {
    return this._value.unitUpgrades;
  }
  get inherentUnitUpgrades() {
    if (!this._inherentUnitUpgrades) {
      this._inherentUnitUpgrades = this._parent ? this._parent.unitUpgrades : [];
    }
    return this._inherentUnitUpgrades;
  }
  get unitUpgrades() {
    if (!this._allUnitUpgrades) {
      this._allUnitUpgrades = this._parent ? this._parent.unitUpgrades.concat(this.selfUnitUpgrades) : this.selfUnitUpgrades;
    }
    return this._allUnitUpgrades;
  }
  get selfCardAwaken() {
    if (!this._selfCardAwaken) {
      this._selfCardAwaken = [];
      for (let i of this._value.cardAwaken) {
        this._selfCardAwaken.push(new CardAwaken.WithParent(i, null));
      }
    }
    return this._selfCardAwaken;
  }
  get inherentCardAwaken() {
    if (!this._inherentCardAwaken) {
      this._inherentCardAwaken = this._parent ? this._parent.cardAwaken : [];
    }
    return this._inherentCardAwaken;
  }
  get cardAwaken() {
    if (!this._allCardAwaken) {
      this._allCardAwaken = this._parent ? this._parent.cardAwaken.concat(this.selfCardAwaken) : this.selfCardAwaken;
    }
    return this._allCardAwaken;
  }
  get hasCardInfo() {
    if (this._cachedHasCardInfo === undefined) {
      if (this._value.hasCardInfo) {
        this._cachedHasCardInfo = true;
      } else {
        this._cachedHasCardInfo = this._parent ? this._parent.hasCardInfo : false;
      }
    }
    return this._cachedHasCardInfo;
  }
  get cardInfo() {
    if (!this._cachedCardInfo) {
      if (this._value.hasCardInfo) {
        this._cachedCardInfo = new CardInfo.WithParent(this._value.cardInfo, this._parent && this._parent.hasCardInfo ? this._parent.cardInfo : null);
      } else {
        this._cachedCardInfo = this._parent ? new CardInfo.WithParent(CardInfo.default, this._parent.cardInfo) : CardInfo.WithParent.default;
      }
    }
    return this._cachedCardInfo;
  }
  get hasShardId() {
    if (this._cachedHasShardId === undefined) {
      if (this._value.hasShardId) {
        this._cachedHasShardId = true;
      } else {
        this._cachedHasShardId = this._parent ? this._parent.hasShardId : false;
      }
    }
    return this._cachedHasShardId;
  }
  get shardId() {
    if (this._cachedShardId === undefined) {
      if (this._value.hasShardId) {
        this._cachedShardId = this._value.shardId;
      } else {
        this._cachedShardId = this._parent ? this._parent.shardId : this._value.shardId;
      }
    }
    return this._cachedShardId;
  }
  get hasLevelUpPopupMsg() {
    if (this._cachedHasLevelUpPopupMsg === undefined) {
      if (this._value.hasLevelUpPopupMsg) {
        this._cachedHasLevelUpPopupMsg = true;
      } else {
        this._cachedHasLevelUpPopupMsg = this._parent ? this._parent.hasLevelUpPopupMsg : false;
      }
    }
    return this._cachedHasLevelUpPopupMsg;
  }
  get levelUpPopupMsg() {
    if (this._cachedLevelUpPopupMsg === undefined) {
      if (this._value.hasLevelUpPopupMsg) {
        this._cachedLevelUpPopupMsg = this._value.levelUpPopupMsg;
      } else {
        this._cachedLevelUpPopupMsg = this._parent ? this._parent.levelUpPopupMsg : this._value.levelUpPopupMsg;
      }
    }
    return this._cachedLevelUpPopupMsg;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get selfVoPaths() {
    return this._value.voPaths;
  }
  get inherentVoPaths() {
    if (!this._inherentVoPaths) {
      this._inherentVoPaths = this._parent ? this._parent.voPaths : [];
    }
    return this._inherentVoPaths;
  }
  get voPaths() {
    if (!this._allVoPaths) {
      this._allVoPaths = this._parent ? this._parent.voPaths.concat(this.selfVoPaths) : this.selfVoPaths;
    }
    return this._allVoPaths;
  }
  get hasBasePowerIndex() {
    if (this._cachedHasBasePowerIndex === undefined) {
      if (this._value.hasBasePowerIndex) {
        this._cachedHasBasePowerIndex = true;
      } else {
        this._cachedHasBasePowerIndex = this._parent ? this._parent.hasBasePowerIndex : false;
      }
    }
    return this._cachedHasBasePowerIndex;
  }
  get basePowerIndex() {
    if (this._cachedBasePowerIndex === undefined) {
      if (this._value.hasBasePowerIndex) {
        this._cachedBasePowerIndex = this._value.basePowerIndex;
      } else {
        this._cachedBasePowerIndex = this._parent ? this._parent.basePowerIndex : this._value.basePowerIndex;
      }
    }
    return this._cachedBasePowerIndex;
  }
  get hasModulePath() {
    if (this._cachedHasModulePath === undefined) {
      if (this._value.hasModulePath) {
        this._cachedHasModulePath = true;
      } else {
        this._cachedHasModulePath = this._parent ? this._parent.hasModulePath : false;
      }
    }
    return this._cachedHasModulePath;
  }
  get modulePath() {
    if (this._cachedModulePath === undefined) {
      if (this._value.hasModulePath) {
        this._cachedModulePath = this._value.modulePath;
      } else {
        this._cachedModulePath = this._parent ? this._parent.modulePath : this._value.modulePath;
      }
    }
    return this._cachedModulePath;
  }
  get hasHide() {
    if (this._cachedHasHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHasHide = true;
      } else {
        this._cachedHasHide = this._parent ? this._parent.hasHide : false;
      }
    }
    return this._cachedHasHide;
  }
  get hide() {
    if (this._cachedHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHide = this._value.hide;
      } else {
        this._cachedHide = this._parent ? this._parent.hide : this._value.hide;
      }
    }
    return this._cachedHide;
  }
  get cardTypeCase() {
    if (this._cachedcardTypeCase === undefined) {
      if (this._value._cardTypeCase === 0) {
        this._cachedcardTypeCase = this._parent ? this._parent.cardTypeCase : 0;
      } else {
        this._cachedcardTypeCase = this._value._cardTypeCase;
      }
    }
    return this._cachedcardTypeCase;
  }
  get hero() {
    if (!this._cachedHero) {
      if (this._value._cardTypeCase === 0) {
        this._cachedHero = this._parent ? new CardDefinition_HeroCard.WithParent(CardDefinition_HeroCard.default, this._parent.hero) : this._value.hero;
      } else if (this._value._cardTypeCase === 11) {
        this._cachedHero = new CardDefinition_HeroCard.WithParent(this._value.hero, this._parent && this._parent.cardTypeCase === 11 ? this._parent.hero : null);
      } else {
        this._cachedHero = CardDefinition_HeroCard.WithParent.default;
      }
    }
    return this._cachedHero;
  }
  get tower() {
    if (!this._cachedTower) {
      if (this._value._cardTypeCase === 0) {
        this._cachedTower = this._parent ? new CardDefinition_TowerCard.WithParent(CardDefinition_TowerCard.default, this._parent.tower) : this._value.tower;
      } else if (this._value._cardTypeCase === 12) {
        this._cachedTower = new CardDefinition_TowerCard.WithParent(this._value.tower, this._parent && this._parent.cardTypeCase === 12 ? this._parent.tower : null);
      } else {
        this._cachedTower = CardDefinition_TowerCard.WithParent.default;
      }
    }
    return this._cachedTower;
  }
  get spell() {
    if (!this._cachedSpell) {
      if (this._value._cardTypeCase === 0) {
        this._cachedSpell = this._parent ? new CardDefinition_SpellCard.WithParent(CardDefinition_SpellCard.default, this._parent.spell) : this._value.spell;
      } else if (this._value._cardTypeCase === 13) {
        this._cachedSpell = new CardDefinition_SpellCard.WithParent(this._value.spell, this._parent && this._parent.cardTypeCase === 13 ? this._parent.spell : null);
      } else {
        this._cachedSpell = CardDefinition_SpellCard.WithParent.default;
      }
    }
    return this._cachedSpell;
  }
  update(current, parent) {
    const result = new CardDefinition_WithParent(current, parent);
    if (this._selfCardSkills) {
      if (this._value.cardSkills === current.cardSkills) {
        result._selfCardSkills = this._selfCardSkills;
      } else {
        result._selfCardSkills = [];
        for (let i = 0; i < current.cardSkills.length; i++) {
          const oldValue = this._value.cardSkills[i];
          if (oldValue) {
            const oldCache = this._selfCardSkills[i];
            if (oldValue === current.cardSkills[i]) {
              result._selfCardSkills[i] = oldCache;
            } else {
              result._selfCardSkills[i] = oldCache.update(current.cardSkills[i], null);
            }
          } else {
            result._selfCardSkills[i] = new CardSkill.WithParent(current.cardSkills[i], null);
          }
        }
      }
    }
    if (this._selfCardAwaken) {
      if (this._value.cardAwaken === current.cardAwaken) {
        result._selfCardAwaken = this._selfCardAwaken;
      } else {
        result._selfCardAwaken = [];
        for (let i = 0; i < current.cardAwaken.length; i++) {
          const oldValue = this._value.cardAwaken[i];
          if (oldValue) {
            const oldCache = this._selfCardAwaken[i];
            if (oldValue === current.cardAwaken[i]) {
              result._selfCardAwaken[i] = oldCache;
            } else {
              result._selfCardAwaken[i] = oldCache.update(current.cardAwaken[i], null);
            }
          } else {
            result._selfCardAwaken[i] = new CardAwaken.WithParent(current.cardAwaken[i], null);
          }
        }
      }
    }
    if (this._cachedCardInfo && this._value.hasCardInfo && current.hasCardInfo) {
      if (this._value.cardInfo === current.cardInfo && this._parent === parent) {
        result._cachedCardInfo = this._cachedCardInfo;
      } else {
        result._cachedCardInfo = this._cachedCardInfo.update(current.cardInfo, parent && parent.hasCardInfo ? parent.cardInfo : null);
      }
    }
    if (this._cachedHero && this._value._cardTypeCase === 11 && current._cardTypeCase === 11) {
      if (this._value.hero === current.hero && this._parent === parent) {
        result._cachedHero = this._cachedHero;
      } else {
        result._cachedHero = this._cachedHero.update(current.hero, parent && parent.cardTypeCase === 11 ? parent.hero : null);
      }
    }
    if (this._cachedTower && this._value._cardTypeCase === 12 && current._cardTypeCase === 12) {
      if (this._value.tower === current.tower && this._parent === parent) {
        result._cachedTower = this._cachedTower;
      } else {
        result._cachedTower = this._cachedTower.update(current.tower, parent && parent.cardTypeCase === 12 ? parent.tower : null);
      }
    }
    if (this._cachedSpell && this._value._cardTypeCase === 13 && current._cardTypeCase === 13) {
      if (this._value.spell === current.spell && this._parent === parent) {
        result._cachedSpell = this._cachedSpell;
      } else {
        result._cachedSpell = this._cachedSpell.update(current.spell, parent && parent.cardTypeCase === 13 ? parent.spell : null);
      }
    }
    return result;
  }
}
CardDefinition_WithParent.default = new CardDefinition_WithParent(CardDefinition.default, null);
CardDefinition.WithParent = CardDefinition_WithParent;
class CardDefinition_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get loadoutIcon() {
    if (!this._loadoutIcon) {
      this._loadoutIcon = {
        name: "loadoutIcon",
        Name: "LoadoutIcon",
        number: 2,
        protoType: 9,
        protoName: "loadout_icon",
        type: JsonToString,
        options: {
          comments: "Small icon.",
          valueDropdown: "LoadoutIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._loadoutIcon;
  }
  get cardIcon() {
    if (!this._cardIcon) {
      this._cardIcon = {
        name: "cardIcon",
        Name: "CardIcon",
        number: 3,
        protoType: 9,
        protoName: "card_icon",
        type: JsonToString,
        options: {
          comments: "Large icon used in card detail page.",
          valueDropdown: "CardIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardIcon;
  }
  get portraitImage() {
    if (!this._portraitImage) {
      this._portraitImage = {
        name: "portraitImage",
        Name: "PortraitImage",
        number: 7,
        protoType: 9,
        protoName: "portrait_image",
        type: JsonToString,
        options: {
          valueDropdown: "CardPortraits",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._portraitImage;
  }
  get affinity() {
    if (!this._affinity) {
      this._affinity = {
        name: "affinity",
        Name: "Affinity",
        number: 4,
        protoType: 14,
        protoName: "affinity",
        type: CardDefinition_Affinity,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinity;
  }
  get cardSkills() {
    if (!this._cardSkills) {
      this._cardSkills = {
        name: "cardSkills",
        Name: "CardSkills",
        number: 5,
        protoType: 11,
        protoName: "card_skills",
        type: CardSkill,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkills;
  }
  get unitUpgrades() {
    if (!this._unitUpgrades) {
      this._unitUpgrades = {
        name: "unitUpgrades",
        Name: "UnitUpgrades",
        number: 6,
        protoType: 9,
        protoName: "unit_upgrades",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitUpgrades;
  }
  get cardAwaken() {
    if (!this._cardAwaken) {
      this._cardAwaken = {
        name: "cardAwaken",
        Name: "CardAwaken",
        number: 14,
        protoType: 11,
        protoName: "card_awaken",
        type: CardAwaken,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardAwaken;
  }
  get cardInfo() {
    if (!this._cardInfo) {
      this._cardInfo = {
        name: "cardInfo",
        Name: "CardInfo",
        number: 15,
        protoType: 11,
        protoName: "card_info",
        type: CardInfo,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardInfo;
  }
  get shardId() {
    if (!this._shardId) {
      this._shardId = {
        name: "shardId",
        Name: "ShardId",
        number: 8,
        protoType: 9,
        protoName: "shard_id",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._shardId;
  }
  get levelUpPopupMsg() {
    if (!this._levelUpPopupMsg) {
      this._levelUpPopupMsg = {
        name: "levelUpPopupMsg",
        Name: "LevelUpPopupMsg",
        number: 9,
        protoType: 9,
        protoName: "level_up_popup_msg",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelUpPopupMsg;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 10,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get voPaths() {
    if (!this._voPaths) {
      this._voPaths = {
        name: "voPaths",
        Name: "VoPaths",
        number: 20,
        protoType: 9,
        protoName: "vo_paths",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._voPaths;
  }
  get basePowerIndex() {
    if (!this._basePowerIndex) {
      this._basePowerIndex = {
        name: "basePowerIndex",
        Name: "BasePowerIndex",
        number: 30,
        protoType: 5,
        protoName: "base_power_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._basePowerIndex;
  }
  get modulePath() {
    if (!this._modulePath) {
      this._modulePath = {
        name: "modulePath",
        Name: "ModulePath",
        number: 40,
        protoType: 9,
        protoName: "module_path",
        type: JsonToString,
        options: {
          comments: "The mod to load when this card is in loadout.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._modulePath;
  }
  get hide() {
    if (!this._hide) {
      this._hide = {
        name: "hide",
        Name: "Hide",
        number: 99,
        protoType: 8,
        protoName: "hide",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hide;
  }
  get hero() {
    if (!this._hero) {
      this._hero = {
        name: "hero",
        Name: "Hero",
        number: 11,
        protoType: 11,
        protoName: "hero",
        oneofIndex: 12,
        type: CardDefinition_HeroCard,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hero;
  }
  get tower() {
    if (!this._tower) {
      this._tower = {
        name: "tower",
        Name: "Tower",
        number: 12,
        protoType: 11,
        protoName: "tower",
        oneofIndex: 12,
        type: CardDefinition_TowerCard,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tower;
  }
  get spell() {
    if (!this._spell) {
      this._spell = {
        name: "spell",
        Name: "Spell",
        number: 13,
        protoType: 11,
        protoName: "spell",
        oneofIndex: 12,
        type: CardDefinition_SpellCard,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spell;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.loadoutIcon,
        this.cardIcon,
        this.portraitImage,
        this.affinity,
        this.cardSkills,
        this.unitUpgrades,
        this.cardAwaken,
        this.cardInfo,
        this.shardId,
        this.levelUpPopupMsg,
        this.displayName,
        this.voPaths,
        this.basePowerIndex,
        this.modulePath,
        this.hide,
        this.hero,
        this.tower,
        this.spell,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLoadoutIcon",
        Name: "DummyOneofForLoadoutIcon",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardIcon",
        Name: "DummyOneofForCardIcon",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPortraitImage",
        Name: "DummyOneofForPortraitImage",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinity",
        Name: "DummyOneofForAffinity",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardInfo",
        Name: "DummyOneofForCardInfo",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShardId",
        Name: "DummyOneofForShardId",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelUpPopupMsg",
        Name: "DummyOneofForLevelUpPopupMsg",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBasePowerIndex",
        Name: "DummyOneofForBasePowerIndex",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForModulePath",
        Name: "DummyOneofForModulePath",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHide",
        Name: "DummyOneofForHide",
        fields: [
          this.fields[15],
        ],
      });
      this._oneofs.push({
        name: "cardType",
        Name: "CardType",
        fields: [
          this.fields[16],
          this.fields[17],
          this.fields[18],
        ],
      });
    }
    return this._oneofs;
  }
}
CardDefinition.descriptor = new CardDefinition_Descriptor();
class ScalingSettings_ScalingParameters {
  get descriptor() {
    return ScalingSettings_ScalingParameters.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStar1 = false;
    this._star1 = null;
    this._hasStar2 = false;
    this._star2 = null;
    this._hasStar3 = false;
    this._star3 = null;
    this._hasStar4 = false;
    this._star4 = null;
    this._hasStar5 = false;
    this._star5 = null;
  }
  isEmpty() {
    if (this._hasStar1) return false;
    if (this._hasStar2) return false;
    if (this._hasStar3) return false;
    if (this._hasStar4) return false;
    if (this._hasStar5) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ScalingSettings_ScalingParameters) {
      return value;
    }
    return ScalingSettings_ScalingParameters.fromJson(value);
  }
  static fromJson(json) {
    const result = new ScalingSettings_ScalingParameters();
    if (json.star1 != null) {
      result._hasStar1 = true;
      result._star1 = JsonToDouble.fromJson(json.star1);
    }
    if (json.star2 != null) {
      result._hasStar2 = true;
      result._star2 = JsonToDouble.fromJson(json.star2);
    }
    if (json.star3 != null) {
      result._hasStar3 = true;
      result._star3 = JsonToDouble.fromJson(json.star3);
    }
    if (json.star4 != null) {
      result._hasStar4 = true;
      result._star4 = JsonToDouble.fromJson(json.star4);
    }
    if (json.star5 != null) {
      result._hasStar5 = true;
      result._star5 = JsonToDouble.fromJson(json.star5);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStar1) {
      result.star1 = JsonToDouble.toJson(this._star1);
    }
    if (this._hasStar2) {
      result.star2 = JsonToDouble.toJson(this._star2);
    }
    if (this._hasStar3) {
      result.star3 = JsonToDouble.toJson(this._star3);
    }
    if (this._hasStar4) {
      result.star4 = JsonToDouble.toJson(this._star4);
    }
    if (this._hasStar5) {
      result.star5 = JsonToDouble.toJson(this._star5);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get star1() {
    return this._hasStar1 ? this._star1 : JsonToDouble.default;
  }
  get hasStar1() {
    return this._hasStar1;
  }
  setStar1(path, value) {
    return {type: 'SET', path: path.concat(['star1']), value};
  }
  deleteStar1(path) {
    return {type: 'DELETE', path: path.concat(['star1'])};
  }
  /**
   * @returns {number}
   */
  get star2() {
    return this._hasStar2 ? this._star2 : JsonToDouble.default;
  }
  get hasStar2() {
    return this._hasStar2;
  }
  setStar2(path, value) {
    return {type: 'SET', path: path.concat(['star2']), value};
  }
  deleteStar2(path) {
    return {type: 'DELETE', path: path.concat(['star2'])};
  }
  /**
   * @returns {number}
   */
  get star3() {
    return this._hasStar3 ? this._star3 : JsonToDouble.default;
  }
  get hasStar3() {
    return this._hasStar3;
  }
  setStar3(path, value) {
    return {type: 'SET', path: path.concat(['star3']), value};
  }
  deleteStar3(path) {
    return {type: 'DELETE', path: path.concat(['star3'])};
  }
  /**
   * @returns {number}
   */
  get star4() {
    return this._hasStar4 ? this._star4 : JsonToDouble.default;
  }
  get hasStar4() {
    return this._hasStar4;
  }
  setStar4(path, value) {
    return {type: 'SET', path: path.concat(['star4']), value};
  }
  deleteStar4(path) {
    return {type: 'DELETE', path: path.concat(['star4'])};
  }
  /**
   * @returns {number}
   */
  get star5() {
    return this._hasStar5 ? this._star5 : JsonToDouble.default;
  }
  get hasStar5() {
    return this._hasStar5;
  }
  setStar5(path, value) {
    return {type: 'SET', path: path.concat(['star5']), value};
  }
  deleteStar5(path) {
    return {type: 'DELETE', path: path.concat(['star5'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "star1": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar1 = true;
              copy._star1 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar1) {
                return this;
              }
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar1 = false;
              copy._star1 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star2": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar2 = true;
              copy._star2 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar2) {
                return this;
              }
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar2 = false;
              copy._star2 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star3": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar3 = true;
              copy._star3 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar3) {
                return this;
              }
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar3 = false;
              copy._star3 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star4": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar4 = true;
              copy._star4 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar4) {
                return this;
              }
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar4 = false;
              copy._star4 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star5": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar5 = true;
              copy._star5 = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar5) {
                return this;
              }
              const copy = new ScalingSettings_ScalingParameters(this);
              copy._hasStar5 = false;
              copy._star5 = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ScalingSettings_ScalingParameters} other
   * @returns {ScalingSettings_ScalingParameters}
   */
  merge(other) {
    const copy = new ScalingSettings_ScalingParameters(this);
    if (other._hasStar1) {
      copy._hasStar1 = true;
      copy._star1 = other._star1;
    }
    if (other._hasStar2) {
      copy._hasStar2 = true;
      copy._star2 = other._star2;
    }
    if (other._hasStar3) {
      copy._hasStar3 = true;
      copy._star3 = other._star3;
    }
    if (other._hasStar4) {
      copy._hasStar4 = true;
      copy._star4 = other._star4;
    }
    if (other._hasStar5) {
      copy._hasStar5 = true;
      copy._star5 = other._star5;
    }
    return copy;
  }
}
ScalingSettings_ScalingParameters.default = new ScalingSettings_ScalingParameters();
class ScalingSettings_ScalingParameters_Builder {
  constructor(value) {
    this._value = new ScalingSettings_ScalingParameters(value);
  }
  build() {
    return new ScalingSettings_ScalingParameters(this._value);
  }
  setStar1(value) {
    this._value._hasStar1 = true;
    this._value._star1 = value;
    return this;
  }
  deleteStar1() {
    this._value._hasStar1 = false;
    this._value._star1 = null;
    return this;
  }
  setStar2(value) {
    this._value._hasStar2 = true;
    this._value._star2 = value;
    return this;
  }
  deleteStar2() {
    this._value._hasStar2 = false;
    this._value._star2 = null;
    return this;
  }
  setStar3(value) {
    this._value._hasStar3 = true;
    this._value._star3 = value;
    return this;
  }
  deleteStar3() {
    this._value._hasStar3 = false;
    this._value._star3 = null;
    return this;
  }
  setStar4(value) {
    this._value._hasStar4 = true;
    this._value._star4 = value;
    return this;
  }
  deleteStar4() {
    this._value._hasStar4 = false;
    this._value._star4 = null;
    return this;
  }
  setStar5(value) {
    this._value._hasStar5 = true;
    this._value._star5 = value;
    return this;
  }
  deleteStar5() {
    this._value._hasStar5 = false;
    this._value._star5 = null;
    return this;
  }
}
ScalingSettings_ScalingParameters.Builder = ScalingSettings_ScalingParameters_Builder;
class ScalingSettings_ScalingParameters_WithParent {
  /**
   * @param {ScalingSettings_ScalingParameters} value
   * @param {ScalingSettings_ScalingParameters_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ScalingSettings_ScalingParameters.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStar1() {
    if (this._cachedHasStar1 === undefined) {
      if (this._value.hasStar1) {
        this._cachedHasStar1 = true;
      } else {
        this._cachedHasStar1 = this._parent ? this._parent.hasStar1 : false;
      }
    }
    return this._cachedHasStar1;
  }
  get star1() {
    if (this._cachedStar1 === undefined) {
      if (this._value.hasStar1) {
        this._cachedStar1 = this._value.star1;
      } else {
        this._cachedStar1 = this._parent ? this._parent.star1 : this._value.star1;
      }
    }
    return this._cachedStar1;
  }
  get hasStar2() {
    if (this._cachedHasStar2 === undefined) {
      if (this._value.hasStar2) {
        this._cachedHasStar2 = true;
      } else {
        this._cachedHasStar2 = this._parent ? this._parent.hasStar2 : false;
      }
    }
    return this._cachedHasStar2;
  }
  get star2() {
    if (this._cachedStar2 === undefined) {
      if (this._value.hasStar2) {
        this._cachedStar2 = this._value.star2;
      } else {
        this._cachedStar2 = this._parent ? this._parent.star2 : this._value.star2;
      }
    }
    return this._cachedStar2;
  }
  get hasStar3() {
    if (this._cachedHasStar3 === undefined) {
      if (this._value.hasStar3) {
        this._cachedHasStar3 = true;
      } else {
        this._cachedHasStar3 = this._parent ? this._parent.hasStar3 : false;
      }
    }
    return this._cachedHasStar3;
  }
  get star3() {
    if (this._cachedStar3 === undefined) {
      if (this._value.hasStar3) {
        this._cachedStar3 = this._value.star3;
      } else {
        this._cachedStar3 = this._parent ? this._parent.star3 : this._value.star3;
      }
    }
    return this._cachedStar3;
  }
  get hasStar4() {
    if (this._cachedHasStar4 === undefined) {
      if (this._value.hasStar4) {
        this._cachedHasStar4 = true;
      } else {
        this._cachedHasStar4 = this._parent ? this._parent.hasStar4 : false;
      }
    }
    return this._cachedHasStar4;
  }
  get star4() {
    if (this._cachedStar4 === undefined) {
      if (this._value.hasStar4) {
        this._cachedStar4 = this._value.star4;
      } else {
        this._cachedStar4 = this._parent ? this._parent.star4 : this._value.star4;
      }
    }
    return this._cachedStar4;
  }
  get hasStar5() {
    if (this._cachedHasStar5 === undefined) {
      if (this._value.hasStar5) {
        this._cachedHasStar5 = true;
      } else {
        this._cachedHasStar5 = this._parent ? this._parent.hasStar5 : false;
      }
    }
    return this._cachedHasStar5;
  }
  get star5() {
    if (this._cachedStar5 === undefined) {
      if (this._value.hasStar5) {
        this._cachedStar5 = this._value.star5;
      } else {
        this._cachedStar5 = this._parent ? this._parent.star5 : this._value.star5;
      }
    }
    return this._cachedStar5;
  }
  update(current, parent) {
    const result = new ScalingSettings_ScalingParameters_WithParent(current, parent);
    return result;
  }
}
ScalingSettings_ScalingParameters_WithParent.default = new ScalingSettings_ScalingParameters_WithParent(ScalingSettings_ScalingParameters.default, null);
ScalingSettings_ScalingParameters.WithParent = ScalingSettings_ScalingParameters_WithParent;
class ScalingSettings_ScalingParameters_Descriptor {
  get star1() {
    if (!this._star1) {
      this._star1 = {
        name: "star1",
        Name: "Star1",
        number: 1,
        protoType: 1,
        protoName: "star1",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star1;
  }
  get star2() {
    if (!this._star2) {
      this._star2 = {
        name: "star2",
        Name: "Star2",
        number: 2,
        protoType: 1,
        protoName: "star2",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star2;
  }
  get star3() {
    if (!this._star3) {
      this._star3 = {
        name: "star3",
        Name: "Star3",
        number: 3,
        protoType: 1,
        protoName: "star3",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star3;
  }
  get star4() {
    if (!this._star4) {
      this._star4 = {
        name: "star4",
        Name: "Star4",
        number: 4,
        protoType: 1,
        protoName: "star4",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star4;
  }
  get star5() {
    if (!this._star5) {
      this._star5 = {
        name: "star5",
        Name: "Star5",
        number: 5,
        protoType: 1,
        protoName: "star5",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star5;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.star1,
        this.star2,
        this.star3,
        this.star4,
        this.star5,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStar1",
        Name: "DummyOneofForStar1",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar2",
        Name: "DummyOneofForStar2",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar3",
        Name: "DummyOneofForStar3",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar4",
        Name: "DummyOneofForStar4",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar5",
        Name: "DummyOneofForStar5",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
ScalingSettings_ScalingParameters.descriptor = new ScalingSettings_ScalingParameters_Descriptor();
export class ScalingSettings {
  get descriptor() {
    return ScalingSettings.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHero = false;
    this._hero = null;
    this._hasTower = false;
    this._tower = null;
    this._hasSpell = false;
    this._spell = null;
    this._hasCreep = false;
    this._creep = null;
  }
  isEmpty() {
    if (this._hasHero && !this._hero.isEmpty()) return false;
    if (this._hasTower && !this._tower.isEmpty()) return false;
    if (this._hasSpell && !this._spell.isEmpty()) return false;
    if (this._hasCreep && !this._creep.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ScalingSettings) {
      return value;
    }
    return ScalingSettings.fromJson(value);
  }
  static fromJson(json) {
    const result = new ScalingSettings();
    if (json.hero != null) {
      result._hasHero = true;
      result._hero = ScalingSettings_ScalingParameters.fromJson(json.hero);
    }
    if (json.tower != null) {
      result._hasTower = true;
      result._tower = ScalingSettings_ScalingParameters.fromJson(json.tower);
    }
    if (json.spell != null) {
      result._hasSpell = true;
      result._spell = ScalingSettings_ScalingParameters.fromJson(json.spell);
    }
    if (json.creep != null) {
      result._hasCreep = true;
      result._creep = ScalingSettings_ScalingParameters.fromJson(json.creep);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHero && !this._hero.isEmpty()) {
      result.hero = ScalingSettings_ScalingParameters.toJson(this._hero);
    }
    if (this._hasTower && !this._tower.isEmpty()) {
      result.tower = ScalingSettings_ScalingParameters.toJson(this._tower);
    }
    if (this._hasSpell && !this._spell.isEmpty()) {
      result.spell = ScalingSettings_ScalingParameters.toJson(this._spell);
    }
    if (this._hasCreep && !this._creep.isEmpty()) {
      result.creep = ScalingSettings_ScalingParameters.toJson(this._creep);
    }
    return result;
  }
  /**
   * @returns {ScalingSettings_ScalingParameters}
   */
  get hero() {
    return this._hasHero ? this._hero : ScalingSettings_ScalingParameters.default;
  }
  get hasHero() {
    return this._hasHero;
  }
  setHero(path, value) {
    return {type: 'SET', path: path.concat(['hero']), value: value.toJson()};
  }
  deleteHero(path) {
    return {type: 'DELETE', path: path.concat(['hero'])};
  }
  /**
   * @returns {ScalingSettings_ScalingParameters}
   */
  get tower() {
    return this._hasTower ? this._tower : ScalingSettings_ScalingParameters.default;
  }
  get hasTower() {
    return this._hasTower;
  }
  setTower(path, value) {
    return {type: 'SET', path: path.concat(['tower']), value: value.toJson()};
  }
  deleteTower(path) {
    return {type: 'DELETE', path: path.concat(['tower'])};
  }
  /**
   * @returns {ScalingSettings_ScalingParameters}
   */
  get spell() {
    return this._hasSpell ? this._spell : ScalingSettings_ScalingParameters.default;
  }
  get hasSpell() {
    return this._hasSpell;
  }
  setSpell(path, value) {
    return {type: 'SET', path: path.concat(['spell']), value: value.toJson()};
  }
  deleteSpell(path) {
    return {type: 'DELETE', path: path.concat(['spell'])};
  }
  /**
   * @returns {ScalingSettings_ScalingParameters}
   */
  get creep() {
    return this._hasCreep ? this._creep : ScalingSettings_ScalingParameters.default;
  }
  get hasCreep() {
    return this._hasCreep;
  }
  setCreep(path, value) {
    return {type: 'SET', path: path.concat(['creep']), value: value.toJson()};
  }
  deleteCreep(path) {
    return {type: 'DELETE', path: path.concat(['creep'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "hero": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings(this);
              copy._hasHero = true;
              copy._hero = ScalingSettings_ScalingParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHero) {
                return this;
              }
              const copy = new ScalingSettings(this);
              copy._hasHero = false;
              copy._hero = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasHero) {
            const copy = new ScalingSettings(this);
            copy._hasHero = true;
            copy._hero = ScalingSettings_ScalingParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._hero.apply(type, path.slice(1), value);
          if (newValue === this._hero) {
            return this;
          }
          const copy = new ScalingSettings(this);
          copy._hero = copy._hero.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "tower": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings(this);
              copy._hasTower = true;
              copy._tower = ScalingSettings_ScalingParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTower) {
                return this;
              }
              const copy = new ScalingSettings(this);
              copy._hasTower = false;
              copy._tower = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTower) {
            const copy = new ScalingSettings(this);
            copy._hasTower = true;
            copy._tower = ScalingSettings_ScalingParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._tower.apply(type, path.slice(1), value);
          if (newValue === this._tower) {
            return this;
          }
          const copy = new ScalingSettings(this);
          copy._tower = copy._tower.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "spell": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings(this);
              copy._hasSpell = true;
              copy._spell = ScalingSettings_ScalingParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpell) {
                return this;
              }
              const copy = new ScalingSettings(this);
              copy._hasSpell = false;
              copy._spell = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSpell) {
            const copy = new ScalingSettings(this);
            copy._hasSpell = true;
            copy._spell = ScalingSettings_ScalingParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._spell.apply(type, path.slice(1), value);
          if (newValue === this._spell) {
            return this;
          }
          const copy = new ScalingSettings(this);
          copy._spell = copy._spell.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "creep": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ScalingSettings(this);
              copy._hasCreep = true;
              copy._creep = ScalingSettings_ScalingParameters.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreep) {
                return this;
              }
              const copy = new ScalingSettings(this);
              copy._hasCreep = false;
              copy._creep = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCreep) {
            const copy = new ScalingSettings(this);
            copy._hasCreep = true;
            copy._creep = ScalingSettings_ScalingParameters.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._creep.apply(type, path.slice(1), value);
          if (newValue === this._creep) {
            return this;
          }
          const copy = new ScalingSettings(this);
          copy._creep = copy._creep.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ScalingSettings} other
   * @returns {ScalingSettings}
   */
  merge(other) {
    const copy = new ScalingSettings(this);
    if (other._hasHero) {
      if (copy._hasHero) {
        copy._hero = copy.hero.merge(other.hero);
      } else {
        copy._hero = other._hero;
      }
      copy._hasHero = true;
    }
    if (other._hasTower) {
      if (copy._hasTower) {
        copy._tower = copy.tower.merge(other.tower);
      } else {
        copy._tower = other._tower;
      }
      copy._hasTower = true;
    }
    if (other._hasSpell) {
      if (copy._hasSpell) {
        copy._spell = copy.spell.merge(other.spell);
      } else {
        copy._spell = other._spell;
      }
      copy._hasSpell = true;
    }
    if (other._hasCreep) {
      if (copy._hasCreep) {
        copy._creep = copy.creep.merge(other.creep);
      } else {
        copy._creep = other._creep;
      }
      copy._hasCreep = true;
    }
    return copy;
  }
}
ScalingSettings.default = new ScalingSettings();
ScalingSettings.ScalingParameters = ScalingSettings_ScalingParameters;
class ScalingSettings_Builder {
  constructor(value) {
    this._value = new ScalingSettings(value);
  }
  build() {
    return new ScalingSettings(this._value);
  }
  setHero(value) {
    this._value._hasHero = true;
    this._value._hero = value;
    return this;
  }
  deleteHero() {
    this._value._hasHero = false;
    this._value._hero = null;
    return this;
  }
  setTower(value) {
    this._value._hasTower = true;
    this._value._tower = value;
    return this;
  }
  deleteTower() {
    this._value._hasTower = false;
    this._value._tower = null;
    return this;
  }
  setSpell(value) {
    this._value._hasSpell = true;
    this._value._spell = value;
    return this;
  }
  deleteSpell() {
    this._value._hasSpell = false;
    this._value._spell = null;
    return this;
  }
  setCreep(value) {
    this._value._hasCreep = true;
    this._value._creep = value;
    return this;
  }
  deleteCreep() {
    this._value._hasCreep = false;
    this._value._creep = null;
    return this;
  }
}
ScalingSettings.Builder = ScalingSettings_Builder;
class ScalingSettings_WithParent {
  /**
   * @param {ScalingSettings} value
   * @param {ScalingSettings_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ScalingSettings.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHero() {
    if (this._cachedHasHero === undefined) {
      if (this._value.hasHero) {
        this._cachedHasHero = true;
      } else {
        this._cachedHasHero = this._parent ? this._parent.hasHero : false;
      }
    }
    return this._cachedHasHero;
  }
  get hero() {
    if (!this._cachedHero) {
      if (this._value.hasHero) {
        this._cachedHero = new ScalingSettings_ScalingParameters.WithParent(this._value.hero, this._parent && this._parent.hasHero ? this._parent.hero : null);
      } else {
        this._cachedHero = this._parent ? new ScalingSettings_ScalingParameters.WithParent(ScalingSettings_ScalingParameters.default, this._parent.hero) : ScalingSettings_ScalingParameters.WithParent.default;
      }
    }
    return this._cachedHero;
  }
  get hasTower() {
    if (this._cachedHasTower === undefined) {
      if (this._value.hasTower) {
        this._cachedHasTower = true;
      } else {
        this._cachedHasTower = this._parent ? this._parent.hasTower : false;
      }
    }
    return this._cachedHasTower;
  }
  get tower() {
    if (!this._cachedTower) {
      if (this._value.hasTower) {
        this._cachedTower = new ScalingSettings_ScalingParameters.WithParent(this._value.tower, this._parent && this._parent.hasTower ? this._parent.tower : null);
      } else {
        this._cachedTower = this._parent ? new ScalingSettings_ScalingParameters.WithParent(ScalingSettings_ScalingParameters.default, this._parent.tower) : ScalingSettings_ScalingParameters.WithParent.default;
      }
    }
    return this._cachedTower;
  }
  get hasSpell() {
    if (this._cachedHasSpell === undefined) {
      if (this._value.hasSpell) {
        this._cachedHasSpell = true;
      } else {
        this._cachedHasSpell = this._parent ? this._parent.hasSpell : false;
      }
    }
    return this._cachedHasSpell;
  }
  get spell() {
    if (!this._cachedSpell) {
      if (this._value.hasSpell) {
        this._cachedSpell = new ScalingSettings_ScalingParameters.WithParent(this._value.spell, this._parent && this._parent.hasSpell ? this._parent.spell : null);
      } else {
        this._cachedSpell = this._parent ? new ScalingSettings_ScalingParameters.WithParent(ScalingSettings_ScalingParameters.default, this._parent.spell) : ScalingSettings_ScalingParameters.WithParent.default;
      }
    }
    return this._cachedSpell;
  }
  get hasCreep() {
    if (this._cachedHasCreep === undefined) {
      if (this._value.hasCreep) {
        this._cachedHasCreep = true;
      } else {
        this._cachedHasCreep = this._parent ? this._parent.hasCreep : false;
      }
    }
    return this._cachedHasCreep;
  }
  get creep() {
    if (!this._cachedCreep) {
      if (this._value.hasCreep) {
        this._cachedCreep = new ScalingSettings_ScalingParameters.WithParent(this._value.creep, this._parent && this._parent.hasCreep ? this._parent.creep : null);
      } else {
        this._cachedCreep = this._parent ? new ScalingSettings_ScalingParameters.WithParent(ScalingSettings_ScalingParameters.default, this._parent.creep) : ScalingSettings_ScalingParameters.WithParent.default;
      }
    }
    return this._cachedCreep;
  }
  update(current, parent) {
    const result = new ScalingSettings_WithParent(current, parent);
    if (this._cachedHero && this._value.hasHero && current.hasHero) {
      if (this._value.hero === current.hero && this._parent === parent) {
        result._cachedHero = this._cachedHero;
      } else {
        result._cachedHero = this._cachedHero.update(current.hero, parent && parent.hasHero ? parent.hero : null);
      }
    }
    if (this._cachedTower && this._value.hasTower && current.hasTower) {
      if (this._value.tower === current.tower && this._parent === parent) {
        result._cachedTower = this._cachedTower;
      } else {
        result._cachedTower = this._cachedTower.update(current.tower, parent && parent.hasTower ? parent.tower : null);
      }
    }
    if (this._cachedSpell && this._value.hasSpell && current.hasSpell) {
      if (this._value.spell === current.spell && this._parent === parent) {
        result._cachedSpell = this._cachedSpell;
      } else {
        result._cachedSpell = this._cachedSpell.update(current.spell, parent && parent.hasSpell ? parent.spell : null);
      }
    }
    if (this._cachedCreep && this._value.hasCreep && current.hasCreep) {
      if (this._value.creep === current.creep && this._parent === parent) {
        result._cachedCreep = this._cachedCreep;
      } else {
        result._cachedCreep = this._cachedCreep.update(current.creep, parent && parent.hasCreep ? parent.creep : null);
      }
    }
    return result;
  }
}
ScalingSettings_WithParent.default = new ScalingSettings_WithParent(ScalingSettings.default, null);
ScalingSettings.WithParent = ScalingSettings_WithParent;
class ScalingSettings_Descriptor {
  get hero() {
    if (!this._hero) {
      this._hero = {
        name: "hero",
        Name: "Hero",
        number: 1,
        protoType: 11,
        protoName: "hero",
        type: ScalingSettings_ScalingParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hero;
  }
  get tower() {
    if (!this._tower) {
      this._tower = {
        name: "tower",
        Name: "Tower",
        number: 2,
        protoType: 11,
        protoName: "tower",
        type: ScalingSettings_ScalingParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tower;
  }
  get spell() {
    if (!this._spell) {
      this._spell = {
        name: "spell",
        Name: "Spell",
        number: 3,
        protoType: 11,
        protoName: "spell",
        type: ScalingSettings_ScalingParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spell;
  }
  get creep() {
    if (!this._creep) {
      this._creep = {
        name: "creep",
        Name: "Creep",
        number: 4,
        protoType: 11,
        protoName: "creep",
        type: ScalingSettings_ScalingParameters,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creep;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.hero,
        this.tower,
        this.spell,
        this.creep,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHero",
        Name: "DummyOneofForHero",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTower",
        Name: "DummyOneofForTower",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpell",
        Name: "DummyOneofForSpell",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreep",
        Name: "DummyOneofForCreep",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ScalingSettings.descriptor = new ScalingSettings_Descriptor();
export class PlayerLoadout {
  get descriptor() {
    return PlayerLoadout.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._heros = [];
    this._towers = [];
    this._spells = [];
    this._hasName = false;
    this._name = null;
    this._hasHerosLimit = false;
    this._herosLimit = null;
    this._hasTowersLimit = false;
    this._towersLimit = null;
    this._hasSpellsLimit = false;
    this._spellsLimit = null;
  }
  isEmpty() {
    if (this._heros.length > 0) return false;
    if (this._towers.length > 0) return false;
    if (this._spells.length > 0) return false;
    if (this._hasName) return false;
    if (this._hasHerosLimit) return false;
    if (this._hasTowersLimit) return false;
    if (this._hasSpellsLimit) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerLoadout) {
      return value;
    }
    return PlayerLoadout.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerLoadout();
    result._heros = JsonToList(json.heros, JsonToString);
    result._towers = JsonToList(json.towers, JsonToString);
    result._spells = JsonToList(json.spells, JsonToString);
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.herosLimit != null) {
      result._hasHerosLimit = true;
      result._herosLimit = JsonToInt32.fromJson(json.herosLimit);
    }
    if (json.towersLimit != null) {
      result._hasTowersLimit = true;
      result._towersLimit = JsonToInt32.fromJson(json.towersLimit);
    }
    if (json.spellsLimit != null) {
      result._hasSpellsLimit = true;
      result._spellsLimit = JsonToInt32.fromJson(json.spellsLimit);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._heros.length > 0) {
      result.heros = ArrayToJson(this._heros, JsonToString);
    }
    if (this._towers.length > 0) {
      result.towers = ArrayToJson(this._towers, JsonToString);
    }
    if (this._spells.length > 0) {
      result.spells = ArrayToJson(this._spells, JsonToString);
    }
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasHerosLimit) {
      result.herosLimit = JsonToInt32.toJson(this._herosLimit);
    }
    if (this._hasTowersLimit) {
      result.towersLimit = JsonToInt32.toJson(this._towersLimit);
    }
    if (this._hasSpellsLimit) {
      result.spellsLimit = JsonToInt32.toJson(this._spellsLimit);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get heros() {
    return this._heros;
  }
  addHeros(path, value) {
    return {type: 'ADD', path: path.concat(['heros']), value};
  }
  setHeros(path, value) {
    return {type: 'SET', path: path.concat(['heros']), value: ArrayToJson(value, JsonToString)};
  }
  setHerosByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['heros', key]), value};
  }
  deleteHeros(path) {
    return {type: 'DELETE', path: path.concat(['heros'])};
  }
  deleteHerosByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['heros', key])};
  }
  /**
   * @returns {string[]}
   */
  get towers() {
    return this._towers;
  }
  addTowers(path, value) {
    return {type: 'ADD', path: path.concat(['towers']), value};
  }
  setTowers(path, value) {
    return {type: 'SET', path: path.concat(['towers']), value: ArrayToJson(value, JsonToString)};
  }
  setTowersByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['towers', key]), value};
  }
  deleteTowers(path) {
    return {type: 'DELETE', path: path.concat(['towers'])};
  }
  deleteTowersByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['towers', key])};
  }
  /**
   * @returns {string[]}
   */
  get spells() {
    return this._spells;
  }
  addSpells(path, value) {
    return {type: 'ADD', path: path.concat(['spells']), value};
  }
  setSpells(path, value) {
    return {type: 'SET', path: path.concat(['spells']), value: ArrayToJson(value, JsonToString)};
  }
  setSpellsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['spells', key]), value};
  }
  deleteSpells(path) {
    return {type: 'DELETE', path: path.concat(['spells'])};
  }
  deleteSpellsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['spells', key])};
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get herosLimit() {
    return this._hasHerosLimit ? this._herosLimit : JsonToInt32.default;
  }
  get hasHerosLimit() {
    return this._hasHerosLimit;
  }
  setHerosLimit(path, value) {
    return {type: 'SET', path: path.concat(['herosLimit']), value};
  }
  deleteHerosLimit(path) {
    return {type: 'DELETE', path: path.concat(['herosLimit'])};
  }
  /**
   * @returns {number}
   */
  get towersLimit() {
    return this._hasTowersLimit ? this._towersLimit : JsonToInt32.default;
  }
  get hasTowersLimit() {
    return this._hasTowersLimit;
  }
  setTowersLimit(path, value) {
    return {type: 'SET', path: path.concat(['towersLimit']), value};
  }
  deleteTowersLimit(path) {
    return {type: 'DELETE', path: path.concat(['towersLimit'])};
  }
  /**
   * @returns {number}
   */
  get spellsLimit() {
    return this._hasSpellsLimit ? this._spellsLimit : JsonToInt32.default;
  }
  get hasSpellsLimit() {
    return this._hasSpellsLimit;
  }
  setSpellsLimit(path, value) {
    return {type: 'SET', path: path.concat(['spellsLimit']), value};
  }
  deleteSpellsLimit(path) {
    return {type: 'DELETE', path: path.concat(['spellsLimit'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "heros": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._heros = [];        for (let i of value) {
                copy._heros.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerLoadout(this);
              copy._heros = copy._heros.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._heros.length === 0) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._heros = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._heros.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._heros = copy._heros.slice();
              copy._heros[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerLoadout(this);
              copy._heros = copy._heros.slice(0, path[1]).concat(copy._heros.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._heros.length) {
            return this;
          }
          const oldValue = this._heros[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerLoadout(this);
          copy._heros = copy._heros.slice();
          copy._heros[key] = newValue;
          return copy;
        }
      }
      case "towers": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._towers = [];        for (let i of value) {
                copy._towers.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerLoadout(this);
              copy._towers = copy._towers.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._towers.length === 0) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._towers = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._towers.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._towers = copy._towers.slice();
              copy._towers[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerLoadout(this);
              copy._towers = copy._towers.slice(0, path[1]).concat(copy._towers.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._towers.length) {
            return this;
          }
          const oldValue = this._towers[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerLoadout(this);
          copy._towers = copy._towers.slice();
          copy._towers[key] = newValue;
          return copy;
        }
      }
      case "spells": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._spells = [];        for (let i of value) {
                copy._spells.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerLoadout(this);
              copy._spells = copy._spells.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._spells.length === 0) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._spells = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._spells.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._spells = copy._spells.slice();
              copy._spells[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerLoadout(this);
              copy._spells = copy._spells.slice(0, path[1]).concat(copy._spells.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._spells.length) {
            return this;
          }
          const oldValue = this._spells[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerLoadout(this);
          copy._spells = copy._spells.slice();
          copy._spells[key] = newValue;
          return copy;
        }
      }
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "herosLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._hasHerosLimit = true;
              copy._herosLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHerosLimit) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._hasHerosLimit = false;
              copy._herosLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "towersLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._hasTowersLimit = true;
              copy._towersLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTowersLimit) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._hasTowersLimit = false;
              copy._towersLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spellsLimit": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerLoadout(this);
              copy._hasSpellsLimit = true;
              copy._spellsLimit = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpellsLimit) {
                return this;
              }
              const copy = new PlayerLoadout(this);
              copy._hasSpellsLimit = false;
              copy._spellsLimit = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerLoadout} other
   * @returns {PlayerLoadout}
   */
  merge(other) {
    const copy = new PlayerLoadout(this);
    copy._heros = this._heros.concat(other._heros);
    copy._towers = this._towers.concat(other._towers);
    copy._spells = this._spells.concat(other._spells);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasHerosLimit) {
      copy._hasHerosLimit = true;
      copy._herosLimit = other._herosLimit;
    }
    if (other._hasTowersLimit) {
      copy._hasTowersLimit = true;
      copy._towersLimit = other._towersLimit;
    }
    if (other._hasSpellsLimit) {
      copy._hasSpellsLimit = true;
      copy._spellsLimit = other._spellsLimit;
    }
    return copy;
  }
}
PlayerLoadout.default = new PlayerLoadout();
class PlayerLoadout_Builder {
  constructor(value) {
    this._value = new PlayerLoadout(value);
  }
  build() {
    return new PlayerLoadout(this._value);
  }
  addAllHeros(values) {
    this._value._heros = this._value._heros.concat(values);
    return this;
  }
  addHeros(value) {
    this._value._heros = this._value._heros.concat([value]);
    return this;
  }
  setHeros(index, value) {
    this._value._heros = this._value._heros.concat();
    this._value._heros[index] = value;
    return this;
  }
  clearHeros() {
    this._value._heros = [];
    return this;
  }
  addAllTowers(values) {
    this._value._towers = this._value._towers.concat(values);
    return this;
  }
  addTowers(value) {
    this._value._towers = this._value._towers.concat([value]);
    return this;
  }
  setTowers(index, value) {
    this._value._towers = this._value._towers.concat();
    this._value._towers[index] = value;
    return this;
  }
  clearTowers() {
    this._value._towers = [];
    return this;
  }
  addAllSpells(values) {
    this._value._spells = this._value._spells.concat(values);
    return this;
  }
  addSpells(value) {
    this._value._spells = this._value._spells.concat([value]);
    return this;
  }
  setSpells(index, value) {
    this._value._spells = this._value._spells.concat();
    this._value._spells[index] = value;
    return this;
  }
  clearSpells() {
    this._value._spells = [];
    return this;
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setHerosLimit(value) {
    this._value._hasHerosLimit = true;
    this._value._herosLimit = value;
    return this;
  }
  deleteHerosLimit() {
    this._value._hasHerosLimit = false;
    this._value._herosLimit = null;
    return this;
  }
  setTowersLimit(value) {
    this._value._hasTowersLimit = true;
    this._value._towersLimit = value;
    return this;
  }
  deleteTowersLimit() {
    this._value._hasTowersLimit = false;
    this._value._towersLimit = null;
    return this;
  }
  setSpellsLimit(value) {
    this._value._hasSpellsLimit = true;
    this._value._spellsLimit = value;
    return this;
  }
  deleteSpellsLimit() {
    this._value._hasSpellsLimit = false;
    this._value._spellsLimit = null;
    return this;
  }
}
PlayerLoadout.Builder = PlayerLoadout_Builder;
class PlayerLoadout_WithParent {
  /**
   * @param {PlayerLoadout} value
   * @param {PlayerLoadout_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerLoadout.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfHeros() {
    return this._value.heros;
  }
  get inherentHeros() {
    if (!this._inherentHeros) {
      this._inherentHeros = this._parent ? this._parent.heros : [];
    }
    return this._inherentHeros;
  }
  get heros() {
    if (!this._allHeros) {
      this._allHeros = this._parent ? this._parent.heros.concat(this.selfHeros) : this.selfHeros;
    }
    return this._allHeros;
  }
  get selfTowers() {
    return this._value.towers;
  }
  get inherentTowers() {
    if (!this._inherentTowers) {
      this._inherentTowers = this._parent ? this._parent.towers : [];
    }
    return this._inherentTowers;
  }
  get towers() {
    if (!this._allTowers) {
      this._allTowers = this._parent ? this._parent.towers.concat(this.selfTowers) : this.selfTowers;
    }
    return this._allTowers;
  }
  get selfSpells() {
    return this._value.spells;
  }
  get inherentSpells() {
    if (!this._inherentSpells) {
      this._inherentSpells = this._parent ? this._parent.spells : [];
    }
    return this._inherentSpells;
  }
  get spells() {
    if (!this._allSpells) {
      this._allSpells = this._parent ? this._parent.spells.concat(this.selfSpells) : this.selfSpells;
    }
    return this._allSpells;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasHerosLimit() {
    if (this._cachedHasHerosLimit === undefined) {
      if (this._value.hasHerosLimit) {
        this._cachedHasHerosLimit = true;
      } else {
        this._cachedHasHerosLimit = this._parent ? this._parent.hasHerosLimit : false;
      }
    }
    return this._cachedHasHerosLimit;
  }
  get herosLimit() {
    if (this._cachedHerosLimit === undefined) {
      if (this._value.hasHerosLimit) {
        this._cachedHerosLimit = this._value.herosLimit;
      } else {
        this._cachedHerosLimit = this._parent ? this._parent.herosLimit : this._value.herosLimit;
      }
    }
    return this._cachedHerosLimit;
  }
  get hasTowersLimit() {
    if (this._cachedHasTowersLimit === undefined) {
      if (this._value.hasTowersLimit) {
        this._cachedHasTowersLimit = true;
      } else {
        this._cachedHasTowersLimit = this._parent ? this._parent.hasTowersLimit : false;
      }
    }
    return this._cachedHasTowersLimit;
  }
  get towersLimit() {
    if (this._cachedTowersLimit === undefined) {
      if (this._value.hasTowersLimit) {
        this._cachedTowersLimit = this._value.towersLimit;
      } else {
        this._cachedTowersLimit = this._parent ? this._parent.towersLimit : this._value.towersLimit;
      }
    }
    return this._cachedTowersLimit;
  }
  get hasSpellsLimit() {
    if (this._cachedHasSpellsLimit === undefined) {
      if (this._value.hasSpellsLimit) {
        this._cachedHasSpellsLimit = true;
      } else {
        this._cachedHasSpellsLimit = this._parent ? this._parent.hasSpellsLimit : false;
      }
    }
    return this._cachedHasSpellsLimit;
  }
  get spellsLimit() {
    if (this._cachedSpellsLimit === undefined) {
      if (this._value.hasSpellsLimit) {
        this._cachedSpellsLimit = this._value.spellsLimit;
      } else {
        this._cachedSpellsLimit = this._parent ? this._parent.spellsLimit : this._value.spellsLimit;
      }
    }
    return this._cachedSpellsLimit;
  }
  update(current, parent) {
    const result = new PlayerLoadout_WithParent(current, parent);
    return result;
  }
}
PlayerLoadout_WithParent.default = new PlayerLoadout_WithParent(PlayerLoadout.default, null);
PlayerLoadout.WithParent = PlayerLoadout_WithParent;
class PlayerLoadout_Descriptor {
  get heros() {
    if (!this._heros) {
      this._heros = {
        name: "heros",
        Name: "Heros",
        number: 1,
        protoType: 9,
        protoName: "heros",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heros;
  }
  get towers() {
    if (!this._towers) {
      this._towers = {
        name: "towers",
        Name: "Towers",
        number: 2,
        protoType: 9,
        protoName: "towers",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towers;
  }
  get spells() {
    if (!this._spells) {
      this._spells = {
        name: "spells",
        Name: "Spells",
        number: 3,
        protoType: 9,
        protoName: "spells",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spells;
  }
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 4,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get herosLimit() {
    if (!this._herosLimit) {
      this._herosLimit = {
        name: "herosLimit",
        Name: "HerosLimit",
        number: 5,
        protoType: 5,
        protoName: "heros_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._herosLimit;
  }
  get towersLimit() {
    if (!this._towersLimit) {
      this._towersLimit = {
        name: "towersLimit",
        Name: "TowersLimit",
        number: 6,
        protoType: 5,
        protoName: "towers_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towersLimit;
  }
  get spellsLimit() {
    if (!this._spellsLimit) {
      this._spellsLimit = {
        name: "spellsLimit",
        Name: "SpellsLimit",
        number: 7,
        protoType: 5,
        protoName: "spells_limit",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellsLimit;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.heros,
        this.towers,
        this.spells,
        this.name,
        this.herosLimit,
        this.towersLimit,
        this.spellsLimit,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHerosLimit",
        Name: "DummyOneofForHerosLimit",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTowersLimit",
        Name: "DummyOneofForTowersLimit",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpellsLimit",
        Name: "DummyOneofForSpellsLimit",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerLoadout.descriptor = new PlayerLoadout_Descriptor();
class CardProgression_SkillProgression {
  get descriptor() {
    return CardProgression_SkillProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasLevel = false;
    this._level = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardProgression_SkillProgression) {
      return value;
    }
    return CardProgression_SkillProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardProgression_SkillProgression();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression_SkillProgression(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardProgression_SkillProgression(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression_SkillProgression(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new CardProgression_SkillProgression(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardProgression_SkillProgression} other
   * @returns {CardProgression_SkillProgression}
   */
  merge(other) {
    const copy = new CardProgression_SkillProgression(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    return copy;
  }
}
CardProgression_SkillProgression.default = new CardProgression_SkillProgression();
class CardProgression_SkillProgression_Builder {
  constructor(value) {
    this._value = new CardProgression_SkillProgression(value);
  }
  build() {
    return new CardProgression_SkillProgression(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
}
CardProgression_SkillProgression.Builder = CardProgression_SkillProgression_Builder;
class CardProgression_SkillProgression_WithParent {
  /**
   * @param {CardProgression_SkillProgression} value
   * @param {CardProgression_SkillProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardProgression_SkillProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  update(current, parent) {
    const result = new CardProgression_SkillProgression_WithParent(current, parent);
    return result;
  }
}
CardProgression_SkillProgression_WithParent.default = new CardProgression_SkillProgression_WithParent(CardProgression_SkillProgression.default, null);
CardProgression_SkillProgression.WithParent = CardProgression_SkillProgression_WithParent;
class CardProgression_SkillProgression_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 2,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.level,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardProgression_SkillProgression.descriptor = new CardProgression_SkillProgression_Descriptor();
class CardProgression_CardStatus {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE": return 0;
        case "LOCKED": return 1;
        case "UNLOCKED": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return CardProgression_CardStatus.fromJson(value);
  }
  static fromReact(e) {
    return CardProgression_CardStatus.fromJson(e);
  }
}
CardProgression_CardStatus.NONE = 0;
CardProgression_CardStatus.LOCKED = 1;
CardProgression_CardStatus.UNLOCKED = 2;
CardProgression_CardStatus.default = 0;
CardProgression_CardStatus.values = {
  NONE: 0,
  LOCKED: 1,
  UNLOCKED: 2,
};
CardProgression_CardStatus.names = {
  0: "NONE",
  1: "LOCKED",
  2: "UNLOCKED",
};
export class CardProgression {
  get descriptor() {
    return CardProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasLevel = false;
    this._level = null;
    this._hasStar = false;
    this._star = null;
    this._skills = [];
    this._hasAwaken = false;
    this._awaken = null;
    this._hasAmount = false;
    this._amount = null;
    this._hasXp = false;
    this._xp = null;
    this._hasCardStatus = false;
    this._cardStatus = null;
    this._hasCurrentSkin = false;
    this._currentSkin = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasLevel) return false;
    if (this._hasStar) return false;
    if (this._skills.length > 0) return false;
    if (this._hasAwaken) return false;
    if (this._hasAmount) return false;
    if (this._hasXp) return false;
    if (this._hasCardStatus) return false;
    if (this._hasCurrentSkin) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardProgression) {
      return value;
    }
    return CardProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardProgression();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.star != null) {
      result._hasStar = true;
      result._star = JsonToInt32.fromJson(json.star);
    }
    result._skills = JsonToList(json.skills, CardProgression_SkillProgression);
    if (json.awaken != null) {
      result._hasAwaken = true;
      result._awaken = JsonToInt32.fromJson(json.awaken);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    if (json.xp != null) {
      result._hasXp = true;
      result._xp = JsonToInt32.fromJson(json.xp);
    }
    if (json.cardStatus != null) {
      result._hasCardStatus = true;
      result._cardStatus = CardProgression_CardStatus.fromJson(json.cardStatus);
    }
    if (json.currentSkin != null) {
      result._hasCurrentSkin = true;
      result._currentSkin = JsonToString.fromJson(json.currentSkin);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasStar) {
      result.star = JsonToInt32.toJson(this._star);
    }
    if (this._skills.length > 0) {
      result.skills = ArrayToJson(this._skills, CardProgression_SkillProgression);
    }
    if (this._hasAwaken) {
      result.awaken = JsonToInt32.toJson(this._awaken);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    if (this._hasXp) {
      result.xp = JsonToInt32.toJson(this._xp);
    }
    if (this._hasCardStatus) {
      result.cardStatus = CardProgression_CardStatus.toJson(this._cardStatus);
    }
    if (this._hasCurrentSkin) {
      result.currentSkin = JsonToString.toJson(this._currentSkin);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {number}
   */
  get star() {
    return this._hasStar ? this._star : JsonToInt32.default;
  }
  get hasStar() {
    return this._hasStar;
  }
  setStar(path, value) {
    return {type: 'SET', path: path.concat(['star']), value};
  }
  deleteStar(path) {
    return {type: 'DELETE', path: path.concat(['star'])};
  }
  /**
   * @returns {CardProgression_SkillProgression[]}
   */
  get skills() {
    return this._skills;
  }
  addSkills(path, value) {
    return {type: 'ADD', path: path.concat(['skills']), value: value.toJson()};
  }
  setSkills(path, value) {
    return {type: 'SET', path: path.concat(['skills']), value: ArrayToJson(value, CardProgression_SkillProgression)};
  }
  setSkillsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skills', key]), value: value.toJson()};
  }
  deleteSkills(path) {
    return {type: 'DELETE', path: path.concat(['skills'])};
  }
  deleteSkillsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skills', key])};
  }
  /**
   * @returns {number}
   */
  get awaken() {
    return this._hasAwaken ? this._awaken : JsonToInt32.default;
  }
  get hasAwaken() {
    return this._hasAwaken;
  }
  setAwaken(path, value) {
    return {type: 'SET', path: path.concat(['awaken']), value};
  }
  deleteAwaken(path) {
    return {type: 'DELETE', path: path.concat(['awaken'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  /**
   * @returns {number}
   */
  get xp() {
    return this._hasXp ? this._xp : JsonToInt32.default;
  }
  get hasXp() {
    return this._hasXp;
  }
  setXp(path, value) {
    return {type: 'SET', path: path.concat(['xp']), value};
  }
  deleteXp(path) {
    return {type: 'DELETE', path: path.concat(['xp'])};
  }
  /**
   * @returns {number}
   */
  get cardStatus() {
    return this._hasCardStatus ? this._cardStatus : CardProgression_CardStatus.default;
  }
  get hasCardStatus() {
    return this._hasCardStatus;
  }
  setCardStatus(path, value) {
    return {type: 'SET', path: path.concat(['cardStatus']), value};
  }
  deleteCardStatus(path) {
    return {type: 'DELETE', path: path.concat(['cardStatus'])};
  }
  /**
   * @returns {string}
   */
  get currentSkin() {
    return this._hasCurrentSkin ? this._currentSkin : JsonToString.default;
  }
  get hasCurrentSkin() {
    return this._hasCurrentSkin;
  }
  setCurrentSkin(path, value) {
    return {type: 'SET', path: path.concat(['currentSkin']), value};
  }
  deleteCurrentSkin(path) {
    return {type: 'DELETE', path: path.concat(['currentSkin'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasStar = true;
              copy._star = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasStar = false;
              copy._star = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skills": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._skills = [];        for (let i of value) {
                copy._skills.push(CardProgression_SkillProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardProgression(this);
              copy._skills = copy._skills.concat([CardProgression_SkillProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skills.length === 0) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._skills = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skills.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._skills = copy._skills.slice();
              copy._skills[path[1]] = CardProgression_SkillProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardProgression(this);
              copy._skills = copy._skills.slice(0, path[1]).concat(copy._skills.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skills.length) {
            return this;
          }
          const oldValue = this._skills[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardProgression(this);
          copy._skills = copy._skills.slice();
          copy._skills[key] = newValue;
          return copy;
        }
      }
      case "awaken": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasAwaken = true;
              copy._awaken = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwaken) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasAwaken = false;
              copy._awaken = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasXp = true;
              copy._xp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXp) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasXp = false;
              copy._xp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasCardStatus = true;
              copy._cardStatus = CardProgression_CardStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardStatus) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasCardStatus = false;
              copy._cardStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "currentSkin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardProgression(this);
              copy._hasCurrentSkin = true;
              copy._currentSkin = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrentSkin) {
                return this;
              }
              const copy = new CardProgression(this);
              copy._hasCurrentSkin = false;
              copy._currentSkin = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardProgression} other
   * @returns {CardProgression}
   */
  merge(other) {
    const copy = new CardProgression(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasStar) {
      copy._hasStar = true;
      copy._star = other._star;
    }
    copy._skills = this._skills.concat(other._skills);
    if (other._hasAwaken) {
      copy._hasAwaken = true;
      copy._awaken = other._awaken;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    if (other._hasXp) {
      copy._hasXp = true;
      copy._xp = other._xp;
    }
    if (other._hasCardStatus) {
      copy._hasCardStatus = true;
      copy._cardStatus = other._cardStatus;
    }
    if (other._hasCurrentSkin) {
      copy._hasCurrentSkin = true;
      copy._currentSkin = other._currentSkin;
    }
    return copy;
  }
}
CardProgression.default = new CardProgression();
CardProgression.SkillProgression = CardProgression_SkillProgression;
CardProgression.CardStatus = CardProgression_CardStatus;
class CardProgression_Builder {
  constructor(value) {
    this._value = new CardProgression(value);
  }
  build() {
    return new CardProgression(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setStar(value) {
    this._value._hasStar = true;
    this._value._star = value;
    return this;
  }
  deleteStar() {
    this._value._hasStar = false;
    this._value._star = null;
    return this;
  }
  addAllSkills(values) {
    this._value._skills = this._value._skills.concat(values);
    return this;
  }
  addSkills(value) {
    this._value._skills = this._value._skills.concat([value]);
    return this;
  }
  setSkills(index, value) {
    this._value._skills = this._value._skills.concat();
    this._value._skills[index] = value;
    return this;
  }
  clearSkills() {
    this._value._skills = [];
    return this;
  }
  setAwaken(value) {
    this._value._hasAwaken = true;
    this._value._awaken = value;
    return this;
  }
  deleteAwaken() {
    this._value._hasAwaken = false;
    this._value._awaken = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
  setXp(value) {
    this._value._hasXp = true;
    this._value._xp = value;
    return this;
  }
  deleteXp() {
    this._value._hasXp = false;
    this._value._xp = null;
    return this;
  }
  setCardStatus(value) {
    this._value._hasCardStatus = true;
    this._value._cardStatus = value;
    return this;
  }
  deleteCardStatus() {
    this._value._hasCardStatus = false;
    this._value._cardStatus = null;
    return this;
  }
  setCurrentSkin(value) {
    this._value._hasCurrentSkin = true;
    this._value._currentSkin = value;
    return this;
  }
  deleteCurrentSkin() {
    this._value._hasCurrentSkin = false;
    this._value._currentSkin = null;
    return this;
  }
}
CardProgression.Builder = CardProgression_Builder;
class CardProgression_WithParent {
  /**
   * @param {CardProgression} value
   * @param {CardProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasStar() {
    if (this._cachedHasStar === undefined) {
      if (this._value.hasStar) {
        this._cachedHasStar = true;
      } else {
        this._cachedHasStar = this._parent ? this._parent.hasStar : false;
      }
    }
    return this._cachedHasStar;
  }
  get star() {
    if (this._cachedStar === undefined) {
      if (this._value.hasStar) {
        this._cachedStar = this._value.star;
      } else {
        this._cachedStar = this._parent ? this._parent.star : this._value.star;
      }
    }
    return this._cachedStar;
  }
  get selfSkills() {
    if (!this._selfSkills) {
      this._selfSkills = [];
      for (let i of this._value.skills) {
        this._selfSkills.push(new CardProgression_SkillProgression.WithParent(i, null));
      }
    }
    return this._selfSkills;
  }
  get inherentSkills() {
    if (!this._inherentSkills) {
      this._inherentSkills = this._parent ? this._parent.skills : [];
    }
    return this._inherentSkills;
  }
  get skills() {
    if (!this._allSkills) {
      this._allSkills = this._parent ? this._parent.skills.concat(this.selfSkills) : this.selfSkills;
    }
    return this._allSkills;
  }
  get hasAwaken() {
    if (this._cachedHasAwaken === undefined) {
      if (this._value.hasAwaken) {
        this._cachedHasAwaken = true;
      } else {
        this._cachedHasAwaken = this._parent ? this._parent.hasAwaken : false;
      }
    }
    return this._cachedHasAwaken;
  }
  get awaken() {
    if (this._cachedAwaken === undefined) {
      if (this._value.hasAwaken) {
        this._cachedAwaken = this._value.awaken;
      } else {
        this._cachedAwaken = this._parent ? this._parent.awaken : this._value.awaken;
      }
    }
    return this._cachedAwaken;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  get hasXp() {
    if (this._cachedHasXp === undefined) {
      if (this._value.hasXp) {
        this._cachedHasXp = true;
      } else {
        this._cachedHasXp = this._parent ? this._parent.hasXp : false;
      }
    }
    return this._cachedHasXp;
  }
  get xp() {
    if (this._cachedXp === undefined) {
      if (this._value.hasXp) {
        this._cachedXp = this._value.xp;
      } else {
        this._cachedXp = this._parent ? this._parent.xp : this._value.xp;
      }
    }
    return this._cachedXp;
  }
  get hasCardStatus() {
    if (this._cachedHasCardStatus === undefined) {
      if (this._value.hasCardStatus) {
        this._cachedHasCardStatus = true;
      } else {
        this._cachedHasCardStatus = this._parent ? this._parent.hasCardStatus : false;
      }
    }
    return this._cachedHasCardStatus;
  }
  get cardStatus() {
    if (this._cachedCardStatus === undefined) {
      if (this._value.hasCardStatus) {
        this._cachedCardStatus = this._value.cardStatus;
      } else {
        this._cachedCardStatus = this._parent ? this._parent.cardStatus : this._value.cardStatus;
      }
    }
    return this._cachedCardStatus;
  }
  get hasCurrentSkin() {
    if (this._cachedHasCurrentSkin === undefined) {
      if (this._value.hasCurrentSkin) {
        this._cachedHasCurrentSkin = true;
      } else {
        this._cachedHasCurrentSkin = this._parent ? this._parent.hasCurrentSkin : false;
      }
    }
    return this._cachedHasCurrentSkin;
  }
  get currentSkin() {
    if (this._cachedCurrentSkin === undefined) {
      if (this._value.hasCurrentSkin) {
        this._cachedCurrentSkin = this._value.currentSkin;
      } else {
        this._cachedCurrentSkin = this._parent ? this._parent.currentSkin : this._value.currentSkin;
      }
    }
    return this._cachedCurrentSkin;
  }
  update(current, parent) {
    const result = new CardProgression_WithParent(current, parent);
    if (this._selfSkills) {
      if (this._value.skills === current.skills) {
        result._selfSkills = this._selfSkills;
      } else {
        result._selfSkills = [];
        for (let i = 0; i < current.skills.length; i++) {
          const oldValue = this._value.skills[i];
          if (oldValue) {
            const oldCache = this._selfSkills[i];
            if (oldValue === current.skills[i]) {
              result._selfSkills[i] = oldCache;
            } else {
              result._selfSkills[i] = oldCache.update(current.skills[i], null);
            }
          } else {
            result._selfSkills[i] = new CardProgression_SkillProgression.WithParent(current.skills[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardProgression_WithParent.default = new CardProgression_WithParent(CardProgression.default, null);
CardProgression.WithParent = CardProgression_WithParent;
class CardProgression_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 2,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get star() {
    if (!this._star) {
      this._star = {
        name: "star",
        Name: "Star",
        number: 3,
        protoType: 5,
        protoName: "star",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star;
  }
  get skills() {
    if (!this._skills) {
      this._skills = {
        name: "skills",
        Name: "Skills",
        number: 4,
        protoType: 11,
        protoName: "skills",
        type: CardProgression_SkillProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skills;
  }
  get awaken() {
    if (!this._awaken) {
      this._awaken = {
        name: "awaken",
        Name: "Awaken",
        number: 5,
        protoType: 5,
        protoName: "awaken",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awaken;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 6,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get xp() {
    if (!this._xp) {
      this._xp = {
        name: "xp",
        Name: "Xp",
        number: 7,
        protoType: 5,
        protoName: "xp",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xp;
  }
  get cardStatus() {
    if (!this._cardStatus) {
      this._cardStatus = {
        name: "cardStatus",
        Name: "CardStatus",
        number: 8,
        protoType: 14,
        protoName: "card_status",
        type: CardProgression_CardStatus,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardStatus;
  }
  get currentSkin() {
    if (!this._currentSkin) {
      this._currentSkin = {
        name: "currentSkin",
        Name: "CurrentSkin",
        number: 9,
        protoType: 9,
        protoName: "current_skin",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currentSkin;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.level,
        this.star,
        this.skills,
        this.awaken,
        this.amount,
        this.xp,
        this.cardStatus,
        this.currentSkin,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar",
        Name: "DummyOneofForStar",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwaken",
        Name: "DummyOneofForAwaken",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXp",
        Name: "DummyOneofForXp",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardStatus",
        Name: "DummyOneofForCardStatus",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCurrentSkin",
        Name: "DummyOneofForCurrentSkin",
        fields: [
          this.fields[8],
        ],
      });
    }
    return this._oneofs;
  }
}
CardProgression.descriptor = new CardProgression_Descriptor();
export class PlayerProgression {
  get descriptor() {
    return PlayerProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardProgressions = [];
    this._hasSkillPoints = false;
    this._skillPoints = null;
    this._hasAwakenToken = false;
    this._awakenToken = null;
    this._hasTowerCardXp = false;
    this._towerCardXp = null;
    this._hasSpellCardXp = false;
    this._spellCardXp = null;
    this._hasHeroCardXp = false;
    this._heroCardXp = null;
    this._cardSkinProgressions = [];
  }
  isEmpty() {
    if (this._cardProgressions.length > 0) return false;
    if (this._hasSkillPoints) return false;
    if (this._hasAwakenToken) return false;
    if (this._hasTowerCardXp) return false;
    if (this._hasSpellCardXp) return false;
    if (this._hasHeroCardXp) return false;
    if (this._cardSkinProgressions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerProgression) {
      return value;
    }
    return PlayerProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerProgression();
    result._cardProgressions = JsonToList(json.cardProgressions, CardProgression);
    if (json.skillPoints != null) {
      result._hasSkillPoints = true;
      result._skillPoints = JsonToInt32.fromJson(json.skillPoints);
    }
    if (json.awakenToken != null) {
      result._hasAwakenToken = true;
      result._awakenToken = JsonToInt32.fromJson(json.awakenToken);
    }
    if (json.towerCardXp != null) {
      result._hasTowerCardXp = true;
      result._towerCardXp = JsonToInt32.fromJson(json.towerCardXp);
    }
    if (json.spellCardXp != null) {
      result._hasSpellCardXp = true;
      result._spellCardXp = JsonToInt32.fromJson(json.spellCardXp);
    }
    if (json.heroCardXp != null) {
      result._hasHeroCardXp = true;
      result._heroCardXp = JsonToInt32.fromJson(json.heroCardXp);
    }
    result._cardSkinProgressions = JsonToList(json.cardSkinProgressions, CardSkinProgression);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardProgressions.length > 0) {
      result.cardProgressions = ArrayToJson(this._cardProgressions, CardProgression);
    }
    if (this._hasSkillPoints) {
      result.skillPoints = JsonToInt32.toJson(this._skillPoints);
    }
    if (this._hasAwakenToken) {
      result.awakenToken = JsonToInt32.toJson(this._awakenToken);
    }
    if (this._hasTowerCardXp) {
      result.towerCardXp = JsonToInt32.toJson(this._towerCardXp);
    }
    if (this._hasSpellCardXp) {
      result.spellCardXp = JsonToInt32.toJson(this._spellCardXp);
    }
    if (this._hasHeroCardXp) {
      result.heroCardXp = JsonToInt32.toJson(this._heroCardXp);
    }
    if (this._cardSkinProgressions.length > 0) {
      result.cardSkinProgressions = ArrayToJson(this._cardSkinProgressions, CardSkinProgression);
    }
    return result;
  }
  /**
   * @returns {CardProgression[]}
   */
  get cardProgressions() {
    return this._cardProgressions;
  }
  addCardProgressions(path, value) {
    return {type: 'ADD', path: path.concat(['cardProgressions']), value: value.toJson()};
  }
  setCardProgressions(path, value) {
    return {type: 'SET', path: path.concat(['cardProgressions']), value: ArrayToJson(value, CardProgression)};
  }
  setCardProgressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardProgressions', key]), value: value.toJson()};
  }
  deleteCardProgressions(path) {
    return {type: 'DELETE', path: path.concat(['cardProgressions'])};
  }
  deleteCardProgressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardProgressions', key])};
  }
  /**
   * @returns {number}
   */
  get skillPoints() {
    return this._hasSkillPoints ? this._skillPoints : JsonToInt32.default;
  }
  get hasSkillPoints() {
    return this._hasSkillPoints;
  }
  setSkillPoints(path, value) {
    return {type: 'SET', path: path.concat(['skillPoints']), value};
  }
  deleteSkillPoints(path) {
    return {type: 'DELETE', path: path.concat(['skillPoints'])};
  }
  /**
   * @returns {number}
   */
  get awakenToken() {
    return this._hasAwakenToken ? this._awakenToken : JsonToInt32.default;
  }
  get hasAwakenToken() {
    return this._hasAwakenToken;
  }
  setAwakenToken(path, value) {
    return {type: 'SET', path: path.concat(['awakenToken']), value};
  }
  deleteAwakenToken(path) {
    return {type: 'DELETE', path: path.concat(['awakenToken'])};
  }
  /**
   * @returns {number}
   */
  get towerCardXp() {
    return this._hasTowerCardXp ? this._towerCardXp : JsonToInt32.default;
  }
  get hasTowerCardXp() {
    return this._hasTowerCardXp;
  }
  setTowerCardXp(path, value) {
    return {type: 'SET', path: path.concat(['towerCardXp']), value};
  }
  deleteTowerCardXp(path) {
    return {type: 'DELETE', path: path.concat(['towerCardXp'])};
  }
  /**
   * @returns {number}
   */
  get spellCardXp() {
    return this._hasSpellCardXp ? this._spellCardXp : JsonToInt32.default;
  }
  get hasSpellCardXp() {
    return this._hasSpellCardXp;
  }
  setSpellCardXp(path, value) {
    return {type: 'SET', path: path.concat(['spellCardXp']), value};
  }
  deleteSpellCardXp(path) {
    return {type: 'DELETE', path: path.concat(['spellCardXp'])};
  }
  /**
   * @returns {number}
   */
  get heroCardXp() {
    return this._hasHeroCardXp ? this._heroCardXp : JsonToInt32.default;
  }
  get hasHeroCardXp() {
    return this._hasHeroCardXp;
  }
  setHeroCardXp(path, value) {
    return {type: 'SET', path: path.concat(['heroCardXp']), value};
  }
  deleteHeroCardXp(path) {
    return {type: 'DELETE', path: path.concat(['heroCardXp'])};
  }
  /**
   * @returns {CardSkinProgression[]}
   */
  get cardSkinProgressions() {
    return this._cardSkinProgressions;
  }
  addCardSkinProgressions(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkinProgressions']), value: value.toJson()};
  }
  setCardSkinProgressions(path, value) {
    return {type: 'SET', path: path.concat(['cardSkinProgressions']), value: ArrayToJson(value, CardSkinProgression)};
  }
  setCardSkinProgressionsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkinProgressions', key]), value: value.toJson()};
  }
  deleteCardSkinProgressions(path) {
    return {type: 'DELETE', path: path.concat(['cardSkinProgressions'])};
  }
  deleteCardSkinProgressionsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkinProgressions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardProgressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._cardProgressions = [];        for (let i of value) {
                copy._cardProgressions.push(CardProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerProgression(this);
              copy._cardProgressions = copy._cardProgressions.concat([CardProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardProgressions.length === 0) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._cardProgressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardProgressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._cardProgressions = copy._cardProgressions.slice();
              copy._cardProgressions[path[1]] = CardProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerProgression(this);
              copy._cardProgressions = copy._cardProgressions.slice(0, path[1]).concat(copy._cardProgressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardProgressions.length) {
            return this;
          }
          const oldValue = this._cardProgressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerProgression(this);
          copy._cardProgressions = copy._cardProgressions.slice();
          copy._cardProgressions[key] = newValue;
          return copy;
        }
      }
      case "skillPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._hasSkillPoints = true;
              copy._skillPoints = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkillPoints) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._hasSkillPoints = false;
              copy._skillPoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awakenToken": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._hasAwakenToken = true;
              copy._awakenToken = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwakenToken) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._hasAwakenToken = false;
              copy._awakenToken = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "towerCardXp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._hasTowerCardXp = true;
              copy._towerCardXp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTowerCardXp) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._hasTowerCardXp = false;
              copy._towerCardXp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "spellCardXp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._hasSpellCardXp = true;
              copy._spellCardXp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpellCardXp) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._hasSpellCardXp = false;
              copy._spellCardXp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "heroCardXp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._hasHeroCardXp = true;
              copy._heroCardXp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHeroCardXp) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._hasHeroCardXp = false;
              copy._heroCardXp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardSkinProgressions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._cardSkinProgressions = [];        for (let i of value) {
                copy._cardSkinProgressions.push(CardSkinProgression.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new PlayerProgression(this);
              copy._cardSkinProgressions = copy._cardSkinProgressions.concat([CardSkinProgression.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkinProgressions.length === 0) {
                return this;
              }
              const copy = new PlayerProgression(this);
              copy._cardSkinProgressions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkinProgressions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new PlayerProgression(this);
              copy._cardSkinProgressions = copy._cardSkinProgressions.slice();
              copy._cardSkinProgressions[path[1]] = CardSkinProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new PlayerProgression(this);
              copy._cardSkinProgressions = copy._cardSkinProgressions.slice(0, path[1]).concat(copy._cardSkinProgressions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkinProgressions.length) {
            return this;
          }
          const oldValue = this._cardSkinProgressions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new PlayerProgression(this);
          copy._cardSkinProgressions = copy._cardSkinProgressions.slice();
          copy._cardSkinProgressions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerProgression} other
   * @returns {PlayerProgression}
   */
  merge(other) {
    const copy = new PlayerProgression(this);
    copy._cardProgressions = this._cardProgressions.concat(other._cardProgressions);
    if (other._hasSkillPoints) {
      copy._hasSkillPoints = true;
      copy._skillPoints = other._skillPoints;
    }
    if (other._hasAwakenToken) {
      copy._hasAwakenToken = true;
      copy._awakenToken = other._awakenToken;
    }
    if (other._hasTowerCardXp) {
      copy._hasTowerCardXp = true;
      copy._towerCardXp = other._towerCardXp;
    }
    if (other._hasSpellCardXp) {
      copy._hasSpellCardXp = true;
      copy._spellCardXp = other._spellCardXp;
    }
    if (other._hasHeroCardXp) {
      copy._hasHeroCardXp = true;
      copy._heroCardXp = other._heroCardXp;
    }
    copy._cardSkinProgressions = this._cardSkinProgressions.concat(other._cardSkinProgressions);
    return copy;
  }
}
PlayerProgression.default = new PlayerProgression();
class PlayerProgression_Builder {
  constructor(value) {
    this._value = new PlayerProgression(value);
  }
  build() {
    return new PlayerProgression(this._value);
  }
  addAllCardProgressions(values) {
    this._value._cardProgressions = this._value._cardProgressions.concat(values);
    return this;
  }
  addCardProgressions(value) {
    this._value._cardProgressions = this._value._cardProgressions.concat([value]);
    return this;
  }
  setCardProgressions(index, value) {
    this._value._cardProgressions = this._value._cardProgressions.concat();
    this._value._cardProgressions[index] = value;
    return this;
  }
  clearCardProgressions() {
    this._value._cardProgressions = [];
    return this;
  }
  setSkillPoints(value) {
    this._value._hasSkillPoints = true;
    this._value._skillPoints = value;
    return this;
  }
  deleteSkillPoints() {
    this._value._hasSkillPoints = false;
    this._value._skillPoints = null;
    return this;
  }
  setAwakenToken(value) {
    this._value._hasAwakenToken = true;
    this._value._awakenToken = value;
    return this;
  }
  deleteAwakenToken() {
    this._value._hasAwakenToken = false;
    this._value._awakenToken = null;
    return this;
  }
  setTowerCardXp(value) {
    this._value._hasTowerCardXp = true;
    this._value._towerCardXp = value;
    return this;
  }
  deleteTowerCardXp() {
    this._value._hasTowerCardXp = false;
    this._value._towerCardXp = null;
    return this;
  }
  setSpellCardXp(value) {
    this._value._hasSpellCardXp = true;
    this._value._spellCardXp = value;
    return this;
  }
  deleteSpellCardXp() {
    this._value._hasSpellCardXp = false;
    this._value._spellCardXp = null;
    return this;
  }
  setHeroCardXp(value) {
    this._value._hasHeroCardXp = true;
    this._value._heroCardXp = value;
    return this;
  }
  deleteHeroCardXp() {
    this._value._hasHeroCardXp = false;
    this._value._heroCardXp = null;
    return this;
  }
  addAllCardSkinProgressions(values) {
    this._value._cardSkinProgressions = this._value._cardSkinProgressions.concat(values);
    return this;
  }
  addCardSkinProgressions(value) {
    this._value._cardSkinProgressions = this._value._cardSkinProgressions.concat([value]);
    return this;
  }
  setCardSkinProgressions(index, value) {
    this._value._cardSkinProgressions = this._value._cardSkinProgressions.concat();
    this._value._cardSkinProgressions[index] = value;
    return this;
  }
  clearCardSkinProgressions() {
    this._value._cardSkinProgressions = [];
    return this;
  }
}
PlayerProgression.Builder = PlayerProgression_Builder;
class PlayerProgression_WithParent {
  /**
   * @param {PlayerProgression} value
   * @param {PlayerProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardProgressions() {
    if (!this._selfCardProgressions) {
      this._selfCardProgressions = [];
      for (let i of this._value.cardProgressions) {
        this._selfCardProgressions.push(new CardProgression.WithParent(i, null));
      }
    }
    return this._selfCardProgressions;
  }
  get inherentCardProgressions() {
    if (!this._inherentCardProgressions) {
      this._inherentCardProgressions = this._parent ? this._parent.cardProgressions : [];
    }
    return this._inherentCardProgressions;
  }
  get cardProgressions() {
    if (!this._allCardProgressions) {
      this._allCardProgressions = this._parent ? this._parent.cardProgressions.concat(this.selfCardProgressions) : this.selfCardProgressions;
    }
    return this._allCardProgressions;
  }
  get hasSkillPoints() {
    if (this._cachedHasSkillPoints === undefined) {
      if (this._value.hasSkillPoints) {
        this._cachedHasSkillPoints = true;
      } else {
        this._cachedHasSkillPoints = this._parent ? this._parent.hasSkillPoints : false;
      }
    }
    return this._cachedHasSkillPoints;
  }
  get skillPoints() {
    if (this._cachedSkillPoints === undefined) {
      if (this._value.hasSkillPoints) {
        this._cachedSkillPoints = this._value.skillPoints;
      } else {
        this._cachedSkillPoints = this._parent ? this._parent.skillPoints : this._value.skillPoints;
      }
    }
    return this._cachedSkillPoints;
  }
  get hasAwakenToken() {
    if (this._cachedHasAwakenToken === undefined) {
      if (this._value.hasAwakenToken) {
        this._cachedHasAwakenToken = true;
      } else {
        this._cachedHasAwakenToken = this._parent ? this._parent.hasAwakenToken : false;
      }
    }
    return this._cachedHasAwakenToken;
  }
  get awakenToken() {
    if (this._cachedAwakenToken === undefined) {
      if (this._value.hasAwakenToken) {
        this._cachedAwakenToken = this._value.awakenToken;
      } else {
        this._cachedAwakenToken = this._parent ? this._parent.awakenToken : this._value.awakenToken;
      }
    }
    return this._cachedAwakenToken;
  }
  get hasTowerCardXp() {
    if (this._cachedHasTowerCardXp === undefined) {
      if (this._value.hasTowerCardXp) {
        this._cachedHasTowerCardXp = true;
      } else {
        this._cachedHasTowerCardXp = this._parent ? this._parent.hasTowerCardXp : false;
      }
    }
    return this._cachedHasTowerCardXp;
  }
  get towerCardXp() {
    if (this._cachedTowerCardXp === undefined) {
      if (this._value.hasTowerCardXp) {
        this._cachedTowerCardXp = this._value.towerCardXp;
      } else {
        this._cachedTowerCardXp = this._parent ? this._parent.towerCardXp : this._value.towerCardXp;
      }
    }
    return this._cachedTowerCardXp;
  }
  get hasSpellCardXp() {
    if (this._cachedHasSpellCardXp === undefined) {
      if (this._value.hasSpellCardXp) {
        this._cachedHasSpellCardXp = true;
      } else {
        this._cachedHasSpellCardXp = this._parent ? this._parent.hasSpellCardXp : false;
      }
    }
    return this._cachedHasSpellCardXp;
  }
  get spellCardXp() {
    if (this._cachedSpellCardXp === undefined) {
      if (this._value.hasSpellCardXp) {
        this._cachedSpellCardXp = this._value.spellCardXp;
      } else {
        this._cachedSpellCardXp = this._parent ? this._parent.spellCardXp : this._value.spellCardXp;
      }
    }
    return this._cachedSpellCardXp;
  }
  get hasHeroCardXp() {
    if (this._cachedHasHeroCardXp === undefined) {
      if (this._value.hasHeroCardXp) {
        this._cachedHasHeroCardXp = true;
      } else {
        this._cachedHasHeroCardXp = this._parent ? this._parent.hasHeroCardXp : false;
      }
    }
    return this._cachedHasHeroCardXp;
  }
  get heroCardXp() {
    if (this._cachedHeroCardXp === undefined) {
      if (this._value.hasHeroCardXp) {
        this._cachedHeroCardXp = this._value.heroCardXp;
      } else {
        this._cachedHeroCardXp = this._parent ? this._parent.heroCardXp : this._value.heroCardXp;
      }
    }
    return this._cachedHeroCardXp;
  }
  get selfCardSkinProgressions() {
    if (!this._selfCardSkinProgressions) {
      this._selfCardSkinProgressions = [];
      for (let i of this._value.cardSkinProgressions) {
        this._selfCardSkinProgressions.push(new CardSkinProgression.WithParent(i, null));
      }
    }
    return this._selfCardSkinProgressions;
  }
  get inherentCardSkinProgressions() {
    if (!this._inherentCardSkinProgressions) {
      this._inherentCardSkinProgressions = this._parent ? this._parent.cardSkinProgressions : [];
    }
    return this._inherentCardSkinProgressions;
  }
  get cardSkinProgressions() {
    if (!this._allCardSkinProgressions) {
      this._allCardSkinProgressions = this._parent ? this._parent.cardSkinProgressions.concat(this.selfCardSkinProgressions) : this.selfCardSkinProgressions;
    }
    return this._allCardSkinProgressions;
  }
  update(current, parent) {
    const result = new PlayerProgression_WithParent(current, parent);
    if (this._selfCardProgressions) {
      if (this._value.cardProgressions === current.cardProgressions) {
        result._selfCardProgressions = this._selfCardProgressions;
      } else {
        result._selfCardProgressions = [];
        for (let i = 0; i < current.cardProgressions.length; i++) {
          const oldValue = this._value.cardProgressions[i];
          if (oldValue) {
            const oldCache = this._selfCardProgressions[i];
            if (oldValue === current.cardProgressions[i]) {
              result._selfCardProgressions[i] = oldCache;
            } else {
              result._selfCardProgressions[i] = oldCache.update(current.cardProgressions[i], null);
            }
          } else {
            result._selfCardProgressions[i] = new CardProgression.WithParent(current.cardProgressions[i], null);
          }
        }
      }
    }
    if (this._selfCardSkinProgressions) {
      if (this._value.cardSkinProgressions === current.cardSkinProgressions) {
        result._selfCardSkinProgressions = this._selfCardSkinProgressions;
      } else {
        result._selfCardSkinProgressions = [];
        for (let i = 0; i < current.cardSkinProgressions.length; i++) {
          const oldValue = this._value.cardSkinProgressions[i];
          if (oldValue) {
            const oldCache = this._selfCardSkinProgressions[i];
            if (oldValue === current.cardSkinProgressions[i]) {
              result._selfCardSkinProgressions[i] = oldCache;
            } else {
              result._selfCardSkinProgressions[i] = oldCache.update(current.cardSkinProgressions[i], null);
            }
          } else {
            result._selfCardSkinProgressions[i] = new CardSkinProgression.WithParent(current.cardSkinProgressions[i], null);
          }
        }
      }
    }
    return result;
  }
}
PlayerProgression_WithParent.default = new PlayerProgression_WithParent(PlayerProgression.default, null);
PlayerProgression.WithParent = PlayerProgression_WithParent;
class PlayerProgression_Descriptor {
  get cardProgressions() {
    if (!this._cardProgressions) {
      this._cardProgressions = {
        name: "cardProgressions",
        Name: "CardProgressions",
        number: 2,
        protoType: 11,
        protoName: "card_progressions",
        type: CardProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardProgressions;
  }
  get skillPoints() {
    if (!this._skillPoints) {
      this._skillPoints = {
        name: "skillPoints",
        Name: "SkillPoints",
        number: 3,
        protoType: 5,
        protoName: "skill_points",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillPoints;
  }
  get awakenToken() {
    if (!this._awakenToken) {
      this._awakenToken = {
        name: "awakenToken",
        Name: "AwakenToken",
        number: 4,
        protoType: 5,
        protoName: "awaken_token",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awakenToken;
  }
  get towerCardXp() {
    if (!this._towerCardXp) {
      this._towerCardXp = {
        name: "towerCardXp",
        Name: "TowerCardXp",
        number: 5,
        protoType: 5,
        protoName: "tower_card_xp",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerCardXp;
  }
  get spellCardXp() {
    if (!this._spellCardXp) {
      this._spellCardXp = {
        name: "spellCardXp",
        Name: "SpellCardXp",
        number: 6,
        protoType: 5,
        protoName: "spell_card_xp",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellCardXp;
  }
  get heroCardXp() {
    if (!this._heroCardXp) {
      this._heroCardXp = {
        name: "heroCardXp",
        Name: "HeroCardXp",
        number: 7,
        protoType: 5,
        protoName: "hero_card_xp",
        type: JsonToInt32,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heroCardXp;
  }
  get cardSkinProgressions() {
    if (!this._cardSkinProgressions) {
      this._cardSkinProgressions = {
        name: "cardSkinProgressions",
        Name: "CardSkinProgressions",
        number: 10,
        protoType: 11,
        protoName: "card_skin_progressions",
        type: CardSkinProgression,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkinProgressions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardProgressions,
        this.skillPoints,
        this.awakenToken,
        this.towerCardXp,
        this.spellCardXp,
        this.heroCardXp,
        this.cardSkinProgressions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForSkillPoints",
        Name: "DummyOneofForSkillPoints",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwakenToken",
        Name: "DummyOneofForAwakenToken",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTowerCardXp",
        Name: "DummyOneofForTowerCardXp",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpellCardXp",
        Name: "DummyOneofForSpellCardXp",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHeroCardXp",
        Name: "DummyOneofForHeroCardXp",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerProgression.descriptor = new PlayerProgression_Descriptor();
export class PlayerSettingsBundle {
  get descriptor() {
    return PlayerSettingsBundle.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCreepLevel = false;
    this._creepLevel = null;
    this._hasPlayerProgression = false;
    this._playerProgression = null;
    this._hasPlayerLoadout = false;
    this._playerLoadout = null;
    this._hasScalingSettings = false;
    this._scalingSettings = null;
  }
  isEmpty() {
    if (this._hasCreepLevel) return false;
    if (this._hasPlayerProgression && !this._playerProgression.isEmpty()) return false;
    if (this._hasPlayerLoadout && !this._playerLoadout.isEmpty()) return false;
    if (this._hasScalingSettings && !this._scalingSettings.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerSettingsBundle) {
      return value;
    }
    return PlayerSettingsBundle.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerSettingsBundle();
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    if (json.playerProgression != null) {
      result._hasPlayerProgression = true;
      result._playerProgression = PlayerProgression.fromJson(json.playerProgression);
    }
    if (json.playerLoadout != null) {
      result._hasPlayerLoadout = true;
      result._playerLoadout = PlayerLoadout.fromJson(json.playerLoadout);
    }
    if (json.scalingSettings != null) {
      result._hasScalingSettings = true;
      result._scalingSettings = ScalingSettings.fromJson(json.scalingSettings);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    if (this._hasPlayerProgression && !this._playerProgression.isEmpty()) {
      result.playerProgression = PlayerProgression.toJson(this._playerProgression);
    }
    if (this._hasPlayerLoadout && !this._playerLoadout.isEmpty()) {
      result.playerLoadout = PlayerLoadout.toJson(this._playerLoadout);
    }
    if (this._hasScalingSettings && !this._scalingSettings.isEmpty()) {
      result.scalingSettings = ScalingSettings.toJson(this._scalingSettings);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  /**
   * @returns {PlayerProgression}
   */
  get playerProgression() {
    return this._hasPlayerProgression ? this._playerProgression : PlayerProgression.default;
  }
  get hasPlayerProgression() {
    return this._hasPlayerProgression;
  }
  setPlayerProgression(path, value) {
    return {type: 'SET', path: path.concat(['playerProgression']), value: value.toJson()};
  }
  deletePlayerProgression(path) {
    return {type: 'DELETE', path: path.concat(['playerProgression'])};
  }
  /**
   * @returns {PlayerLoadout}
   */
  get playerLoadout() {
    return this._hasPlayerLoadout ? this._playerLoadout : PlayerLoadout.default;
  }
  get hasPlayerLoadout() {
    return this._hasPlayerLoadout;
  }
  setPlayerLoadout(path, value) {
    return {type: 'SET', path: path.concat(['playerLoadout']), value: value.toJson()};
  }
  deletePlayerLoadout(path) {
    return {type: 'DELETE', path: path.concat(['playerLoadout'])};
  }
  /**
   * @returns {ScalingSettings}
   */
  get scalingSettings() {
    return this._hasScalingSettings ? this._scalingSettings : ScalingSettings.default;
  }
  get hasScalingSettings() {
    return this._hasScalingSettings;
  }
  setScalingSettings(path, value) {
    return {type: 'SET', path: path.concat(['scalingSettings']), value: value.toJson()};
  }
  deleteScalingSettings(path) {
    return {type: 'DELETE', path: path.concat(['scalingSettings'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerSettingsBundle(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new PlayerSettingsBundle(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerProgression": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerSettingsBundle(this);
              copy._hasPlayerProgression = true;
              copy._playerProgression = PlayerProgression.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerProgression) {
                return this;
              }
              const copy = new PlayerSettingsBundle(this);
              copy._hasPlayerProgression = false;
              copy._playerProgression = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerProgression) {
            const copy = new PlayerSettingsBundle(this);
            copy._hasPlayerProgression = true;
            copy._playerProgression = PlayerProgression.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerProgression.apply(type, path.slice(1), value);
          if (newValue === this._playerProgression) {
            return this;
          }
          const copy = new PlayerSettingsBundle(this);
          copy._playerProgression = copy._playerProgression.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "playerLoadout": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerSettingsBundle(this);
              copy._hasPlayerLoadout = true;
              copy._playerLoadout = PlayerLoadout.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLoadout) {
                return this;
              }
              const copy = new PlayerSettingsBundle(this);
              copy._hasPlayerLoadout = false;
              copy._playerLoadout = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasPlayerLoadout) {
            const copy = new PlayerSettingsBundle(this);
            copy._hasPlayerLoadout = true;
            copy._playerLoadout = PlayerLoadout.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._playerLoadout.apply(type, path.slice(1), value);
          if (newValue === this._playerLoadout) {
            return this;
          }
          const copy = new PlayerSettingsBundle(this);
          copy._playerLoadout = copy._playerLoadout.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "scalingSettings": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerSettingsBundle(this);
              copy._hasScalingSettings = true;
              copy._scalingSettings = ScalingSettings.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasScalingSettings) {
                return this;
              }
              const copy = new PlayerSettingsBundle(this);
              copy._hasScalingSettings = false;
              copy._scalingSettings = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasScalingSettings) {
            const copy = new PlayerSettingsBundle(this);
            copy._hasScalingSettings = true;
            copy._scalingSettings = ScalingSettings.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._scalingSettings.apply(type, path.slice(1), value);
          if (newValue === this._scalingSettings) {
            return this;
          }
          const copy = new PlayerSettingsBundle(this);
          copy._scalingSettings = copy._scalingSettings.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerSettingsBundle} other
   * @returns {PlayerSettingsBundle}
   */
  merge(other) {
    const copy = new PlayerSettingsBundle(this);
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    if (other._hasPlayerProgression) {
      if (copy._hasPlayerProgression) {
        copy._playerProgression = copy.playerProgression.merge(other.playerProgression);
      } else {
        copy._playerProgression = other._playerProgression;
      }
      copy._hasPlayerProgression = true;
    }
    if (other._hasPlayerLoadout) {
      if (copy._hasPlayerLoadout) {
        copy._playerLoadout = copy.playerLoadout.merge(other.playerLoadout);
      } else {
        copy._playerLoadout = other._playerLoadout;
      }
      copy._hasPlayerLoadout = true;
    }
    if (other._hasScalingSettings) {
      if (copy._hasScalingSettings) {
        copy._scalingSettings = copy.scalingSettings.merge(other.scalingSettings);
      } else {
        copy._scalingSettings = other._scalingSettings;
      }
      copy._hasScalingSettings = true;
    }
    return copy;
  }
}
PlayerSettingsBundle.default = new PlayerSettingsBundle();
class PlayerSettingsBundle_Builder {
  constructor(value) {
    this._value = new PlayerSettingsBundle(value);
  }
  build() {
    return new PlayerSettingsBundle(this._value);
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
  setPlayerProgression(value) {
    this._value._hasPlayerProgression = true;
    this._value._playerProgression = value;
    return this;
  }
  deletePlayerProgression() {
    this._value._hasPlayerProgression = false;
    this._value._playerProgression = null;
    return this;
  }
  setPlayerLoadout(value) {
    this._value._hasPlayerLoadout = true;
    this._value._playerLoadout = value;
    return this;
  }
  deletePlayerLoadout() {
    this._value._hasPlayerLoadout = false;
    this._value._playerLoadout = null;
    return this;
  }
  setScalingSettings(value) {
    this._value._hasScalingSettings = true;
    this._value._scalingSettings = value;
    return this;
  }
  deleteScalingSettings() {
    this._value._hasScalingSettings = false;
    this._value._scalingSettings = null;
    return this;
  }
}
PlayerSettingsBundle.Builder = PlayerSettingsBundle_Builder;
class PlayerSettingsBundle_WithParent {
  /**
   * @param {PlayerSettingsBundle} value
   * @param {PlayerSettingsBundle_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerSettingsBundle.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  get hasPlayerProgression() {
    if (this._cachedHasPlayerProgression === undefined) {
      if (this._value.hasPlayerProgression) {
        this._cachedHasPlayerProgression = true;
      } else {
        this._cachedHasPlayerProgression = this._parent ? this._parent.hasPlayerProgression : false;
      }
    }
    return this._cachedHasPlayerProgression;
  }
  get playerProgression() {
    if (!this._cachedPlayerProgression) {
      if (this._value.hasPlayerProgression) {
        this._cachedPlayerProgression = new PlayerProgression.WithParent(this._value.playerProgression, this._parent && this._parent.hasPlayerProgression ? this._parent.playerProgression : null);
      } else {
        this._cachedPlayerProgression = this._parent ? new PlayerProgression.WithParent(PlayerProgression.default, this._parent.playerProgression) : PlayerProgression.WithParent.default;
      }
    }
    return this._cachedPlayerProgression;
  }
  get hasPlayerLoadout() {
    if (this._cachedHasPlayerLoadout === undefined) {
      if (this._value.hasPlayerLoadout) {
        this._cachedHasPlayerLoadout = true;
      } else {
        this._cachedHasPlayerLoadout = this._parent ? this._parent.hasPlayerLoadout : false;
      }
    }
    return this._cachedHasPlayerLoadout;
  }
  get playerLoadout() {
    if (!this._cachedPlayerLoadout) {
      if (this._value.hasPlayerLoadout) {
        this._cachedPlayerLoadout = new PlayerLoadout.WithParent(this._value.playerLoadout, this._parent && this._parent.hasPlayerLoadout ? this._parent.playerLoadout : null);
      } else {
        this._cachedPlayerLoadout = this._parent ? new PlayerLoadout.WithParent(PlayerLoadout.default, this._parent.playerLoadout) : PlayerLoadout.WithParent.default;
      }
    }
    return this._cachedPlayerLoadout;
  }
  get hasScalingSettings() {
    if (this._cachedHasScalingSettings === undefined) {
      if (this._value.hasScalingSettings) {
        this._cachedHasScalingSettings = true;
      } else {
        this._cachedHasScalingSettings = this._parent ? this._parent.hasScalingSettings : false;
      }
    }
    return this._cachedHasScalingSettings;
  }
  get scalingSettings() {
    if (!this._cachedScalingSettings) {
      if (this._value.hasScalingSettings) {
        this._cachedScalingSettings = new ScalingSettings.WithParent(this._value.scalingSettings, this._parent && this._parent.hasScalingSettings ? this._parent.scalingSettings : null);
      } else {
        this._cachedScalingSettings = this._parent ? new ScalingSettings.WithParent(ScalingSettings.default, this._parent.scalingSettings) : ScalingSettings.WithParent.default;
      }
    }
    return this._cachedScalingSettings;
  }
  update(current, parent) {
    const result = new PlayerSettingsBundle_WithParent(current, parent);
    if (this._cachedPlayerProgression && this._value.hasPlayerProgression && current.hasPlayerProgression) {
      if (this._value.playerProgression === current.playerProgression && this._parent === parent) {
        result._cachedPlayerProgression = this._cachedPlayerProgression;
      } else {
        result._cachedPlayerProgression = this._cachedPlayerProgression.update(current.playerProgression, parent && parent.hasPlayerProgression ? parent.playerProgression : null);
      }
    }
    if (this._cachedPlayerLoadout && this._value.hasPlayerLoadout && current.hasPlayerLoadout) {
      if (this._value.playerLoadout === current.playerLoadout && this._parent === parent) {
        result._cachedPlayerLoadout = this._cachedPlayerLoadout;
      } else {
        result._cachedPlayerLoadout = this._cachedPlayerLoadout.update(current.playerLoadout, parent && parent.hasPlayerLoadout ? parent.playerLoadout : null);
      }
    }
    if (this._cachedScalingSettings && this._value.hasScalingSettings && current.hasScalingSettings) {
      if (this._value.scalingSettings === current.scalingSettings && this._parent === parent) {
        result._cachedScalingSettings = this._cachedScalingSettings;
      } else {
        result._cachedScalingSettings = this._cachedScalingSettings.update(current.scalingSettings, parent && parent.hasScalingSettings ? parent.scalingSettings : null);
      }
    }
    return result;
  }
}
PlayerSettingsBundle_WithParent.default = new PlayerSettingsBundle_WithParent(PlayerSettingsBundle.default, null);
PlayerSettingsBundle.WithParent = PlayerSettingsBundle_WithParent;
class PlayerSettingsBundle_Descriptor {
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 1,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get playerProgression() {
    if (!this._playerProgression) {
      this._playerProgression = {
        name: "playerProgression",
        Name: "PlayerProgression",
        number: 2,
        protoType: 11,
        protoName: "player_progression",
        type: PlayerProgression,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerProgression;
  }
  get playerLoadout() {
    if (!this._playerLoadout) {
      this._playerLoadout = {
        name: "playerLoadout",
        Name: "PlayerLoadout",
        number: 3,
        protoType: 11,
        protoName: "player_loadout",
        type: PlayerLoadout,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLoadout;
  }
  get scalingSettings() {
    if (!this._scalingSettings) {
      this._scalingSettings = {
        name: "scalingSettings",
        Name: "ScalingSettings",
        number: 4,
        protoType: 11,
        protoName: "scaling_settings",
        type: ScalingSettings,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._scalingSettings;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.creepLevel,
        this.playerProgression,
        this.playerLoadout,
        this.scalingSettings,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerProgression",
        Name: "DummyOneofForPlayerProgression",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerLoadout",
        Name: "DummyOneofForPlayerLoadout",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForScalingSettings",
        Name: "DummyOneofForScalingSettings",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerSettingsBundle.descriptor = new PlayerSettingsBundle_Descriptor();
export class CardLevelUpCost {
  get descriptor() {
    return CardLevelUpCost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLevel = false;
    this._level = null;
    this._hasXp = false;
    this._xp = null;
  }
  isEmpty() {
    if (this._hasLevel) return false;
    if (this._hasXp) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardLevelUpCost) {
      return value;
    }
    return CardLevelUpCost.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardLevelUpCost();
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.xp != null) {
      result._hasXp = true;
      result._xp = JsonToInt32.fromJson(json.xp);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasXp) {
      result.xp = JsonToInt32.toJson(this._xp);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {number}
   */
  get xp() {
    return this._hasXp ? this._xp : JsonToInt32.default;
  }
  get hasXp() {
    return this._hasXp;
  }
  setXp(path, value) {
    return {type: 'SET', path: path.concat(['xp']), value};
  }
  deleteXp(path) {
    return {type: 'DELETE', path: path.concat(['xp'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardLevelUpCost(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new CardLevelUpCost(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardLevelUpCost(this);
              copy._hasXp = true;
              copy._xp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXp) {
                return this;
              }
              const copy = new CardLevelUpCost(this);
              copy._hasXp = false;
              copy._xp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardLevelUpCost} other
   * @returns {CardLevelUpCost}
   */
  merge(other) {
    const copy = new CardLevelUpCost(this);
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasXp) {
      copy._hasXp = true;
      copy._xp = other._xp;
    }
    return copy;
  }
}
CardLevelUpCost.default = new CardLevelUpCost();
class CardLevelUpCost_Builder {
  constructor(value) {
    this._value = new CardLevelUpCost(value);
  }
  build() {
    return new CardLevelUpCost(this._value);
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setXp(value) {
    this._value._hasXp = true;
    this._value._xp = value;
    return this;
  }
  deleteXp() {
    this._value._hasXp = false;
    this._value._xp = null;
    return this;
  }
}
CardLevelUpCost.Builder = CardLevelUpCost_Builder;
class CardLevelUpCost_WithParent {
  /**
   * @param {CardLevelUpCost} value
   * @param {CardLevelUpCost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardLevelUpCost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasXp() {
    if (this._cachedHasXp === undefined) {
      if (this._value.hasXp) {
        this._cachedHasXp = true;
      } else {
        this._cachedHasXp = this._parent ? this._parent.hasXp : false;
      }
    }
    return this._cachedHasXp;
  }
  get xp() {
    if (this._cachedXp === undefined) {
      if (this._value.hasXp) {
        this._cachedXp = this._value.xp;
      } else {
        this._cachedXp = this._parent ? this._parent.xp : this._value.xp;
      }
    }
    return this._cachedXp;
  }
  update(current, parent) {
    const result = new CardLevelUpCost_WithParent(current, parent);
    return result;
  }
}
CardLevelUpCost_WithParent.default = new CardLevelUpCost_WithParent(CardLevelUpCost.default, null);
CardLevelUpCost.WithParent = CardLevelUpCost_WithParent;
class CardLevelUpCost_Descriptor {
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 1,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get xp() {
    if (!this._xp) {
      this._xp = {
        name: "xp",
        Name: "Xp",
        number: 2,
        protoType: 5,
        protoName: "xp",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xp;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.level,
        this.xp,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXp",
        Name: "DummyOneofForXp",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardLevelUpCost.descriptor = new CardLevelUpCost_Descriptor();
export class CardLevelCap {
  get descriptor() {
    return CardLevelCap.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasStar = false;
    this._star = null;
    this._hasMaxLevel = false;
    this._maxLevel = null;
  }
  isEmpty() {
    if (this._hasStar) return false;
    if (this._hasMaxLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardLevelCap) {
      return value;
    }
    return CardLevelCap.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardLevelCap();
    if (json.star != null) {
      result._hasStar = true;
      result._star = JsonToInt32.fromJson(json.star);
    }
    if (json.maxLevel != null) {
      result._hasMaxLevel = true;
      result._maxLevel = JsonToInt32.fromJson(json.maxLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasStar) {
      result.star = JsonToInt32.toJson(this._star);
    }
    if (this._hasMaxLevel) {
      result.maxLevel = JsonToInt32.toJson(this._maxLevel);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get star() {
    return this._hasStar ? this._star : JsonToInt32.default;
  }
  get hasStar() {
    return this._hasStar;
  }
  setStar(path, value) {
    return {type: 'SET', path: path.concat(['star']), value};
  }
  deleteStar(path) {
    return {type: 'DELETE', path: path.concat(['star'])};
  }
  /**
   * @returns {number}
   */
  get maxLevel() {
    return this._hasMaxLevel ? this._maxLevel : JsonToInt32.default;
  }
  get hasMaxLevel() {
    return this._hasMaxLevel;
  }
  setMaxLevel(path, value) {
    return {type: 'SET', path: path.concat(['maxLevel']), value};
  }
  deleteMaxLevel(path) {
    return {type: 'DELETE', path: path.concat(['maxLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "star": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardLevelCap(this);
              copy._hasStar = true;
              copy._star = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar) {
                return this;
              }
              const copy = new CardLevelCap(this);
              copy._hasStar = false;
              copy._star = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardLevelCap(this);
              copy._hasMaxLevel = true;
              copy._maxLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxLevel) {
                return this;
              }
              const copy = new CardLevelCap(this);
              copy._hasMaxLevel = false;
              copy._maxLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardLevelCap} other
   * @returns {CardLevelCap}
   */
  merge(other) {
    const copy = new CardLevelCap(this);
    if (other._hasStar) {
      copy._hasStar = true;
      copy._star = other._star;
    }
    if (other._hasMaxLevel) {
      copy._hasMaxLevel = true;
      copy._maxLevel = other._maxLevel;
    }
    return copy;
  }
}
CardLevelCap.default = new CardLevelCap();
class CardLevelCap_Builder {
  constructor(value) {
    this._value = new CardLevelCap(value);
  }
  build() {
    return new CardLevelCap(this._value);
  }
  setStar(value) {
    this._value._hasStar = true;
    this._value._star = value;
    return this;
  }
  deleteStar() {
    this._value._hasStar = false;
    this._value._star = null;
    return this;
  }
  setMaxLevel(value) {
    this._value._hasMaxLevel = true;
    this._value._maxLevel = value;
    return this;
  }
  deleteMaxLevel() {
    this._value._hasMaxLevel = false;
    this._value._maxLevel = null;
    return this;
  }
}
CardLevelCap.Builder = CardLevelCap_Builder;
class CardLevelCap_WithParent {
  /**
   * @param {CardLevelCap} value
   * @param {CardLevelCap_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardLevelCap.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasStar() {
    if (this._cachedHasStar === undefined) {
      if (this._value.hasStar) {
        this._cachedHasStar = true;
      } else {
        this._cachedHasStar = this._parent ? this._parent.hasStar : false;
      }
    }
    return this._cachedHasStar;
  }
  get star() {
    if (this._cachedStar === undefined) {
      if (this._value.hasStar) {
        this._cachedStar = this._value.star;
      } else {
        this._cachedStar = this._parent ? this._parent.star : this._value.star;
      }
    }
    return this._cachedStar;
  }
  get hasMaxLevel() {
    if (this._cachedHasMaxLevel === undefined) {
      if (this._value.hasMaxLevel) {
        this._cachedHasMaxLevel = true;
      } else {
        this._cachedHasMaxLevel = this._parent ? this._parent.hasMaxLevel : false;
      }
    }
    return this._cachedHasMaxLevel;
  }
  get maxLevel() {
    if (this._cachedMaxLevel === undefined) {
      if (this._value.hasMaxLevel) {
        this._cachedMaxLevel = this._value.maxLevel;
      } else {
        this._cachedMaxLevel = this._parent ? this._parent.maxLevel : this._value.maxLevel;
      }
    }
    return this._cachedMaxLevel;
  }
  update(current, parent) {
    const result = new CardLevelCap_WithParent(current, parent);
    return result;
  }
}
CardLevelCap_WithParent.default = new CardLevelCap_WithParent(CardLevelCap.default, null);
CardLevelCap.WithParent = CardLevelCap_WithParent;
class CardLevelCap_Descriptor {
  get star() {
    if (!this._star) {
      this._star = {
        name: "star",
        Name: "Star",
        number: 1,
        protoType: 5,
        protoName: "star",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star;
  }
  get maxLevel() {
    if (!this._maxLevel) {
      this._maxLevel = {
        name: "maxLevel",
        Name: "MaxLevel",
        number: 2,
        protoType: 5,
        protoName: "max_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.star,
        this.maxLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForStar",
        Name: "DummyOneofForStar",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxLevel",
        Name: "DummyOneofForMaxLevel",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardLevelCap.descriptor = new CardLevelCap_Descriptor();
export class SkillLevelUpCost {
  get descriptor() {
    return SkillLevelUpCost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasLevel = false;
    this._level = null;
    this._hasSkillPoints = false;
    this._skillPoints = null;
    this._hasGold = false;
    this._gold = null;
  }
  isEmpty() {
    if (this._hasLevel) return false;
    if (this._hasSkillPoints) return false;
    if (this._hasGold) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SkillLevelUpCost) {
      return value;
    }
    return SkillLevelUpCost.fromJson(value);
  }
  static fromJson(json) {
    const result = new SkillLevelUpCost();
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.skillPoints != null) {
      result._hasSkillPoints = true;
      result._skillPoints = JsonToInt32.fromJson(json.skillPoints);
    }
    if (json.gold != null) {
      result._hasGold = true;
      result._gold = JsonToInt32.fromJson(json.gold);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasSkillPoints) {
      result.skillPoints = JsonToInt32.toJson(this._skillPoints);
    }
    if (this._hasGold) {
      result.gold = JsonToInt32.toJson(this._gold);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {number}
   */
  get skillPoints() {
    return this._hasSkillPoints ? this._skillPoints : JsonToInt32.default;
  }
  get hasSkillPoints() {
    return this._hasSkillPoints;
  }
  setSkillPoints(path, value) {
    return {type: 'SET', path: path.concat(['skillPoints']), value};
  }
  deleteSkillPoints(path) {
    return {type: 'DELETE', path: path.concat(['skillPoints'])};
  }
  /**
   * @returns {number}
   */
  get gold() {
    return this._hasGold ? this._gold : JsonToInt32.default;
  }
  get hasGold() {
    return this._hasGold;
  }
  setGold(path, value) {
    return {type: 'SET', path: path.concat(['gold']), value};
  }
  deleteGold(path) {
    return {type: 'DELETE', path: path.concat(['gold'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillLevelUpCost(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new SkillLevelUpCost(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skillPoints": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillLevelUpCost(this);
              copy._hasSkillPoints = true;
              copy._skillPoints = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkillPoints) {
                return this;
              }
              const copy = new SkillLevelUpCost(this);
              copy._hasSkillPoints = false;
              copy._skillPoints = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillLevelUpCost(this);
              copy._hasGold = true;
              copy._gold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGold) {
                return this;
              }
              const copy = new SkillLevelUpCost(this);
              copy._hasGold = false;
              copy._gold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SkillLevelUpCost} other
   * @returns {SkillLevelUpCost}
   */
  merge(other) {
    const copy = new SkillLevelUpCost(this);
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasSkillPoints) {
      copy._hasSkillPoints = true;
      copy._skillPoints = other._skillPoints;
    }
    if (other._hasGold) {
      copy._hasGold = true;
      copy._gold = other._gold;
    }
    return copy;
  }
}
SkillLevelUpCost.default = new SkillLevelUpCost();
class SkillLevelUpCost_Builder {
  constructor(value) {
    this._value = new SkillLevelUpCost(value);
  }
  build() {
    return new SkillLevelUpCost(this._value);
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setSkillPoints(value) {
    this._value._hasSkillPoints = true;
    this._value._skillPoints = value;
    return this;
  }
  deleteSkillPoints() {
    this._value._hasSkillPoints = false;
    this._value._skillPoints = null;
    return this;
  }
  setGold(value) {
    this._value._hasGold = true;
    this._value._gold = value;
    return this;
  }
  deleteGold() {
    this._value._hasGold = false;
    this._value._gold = null;
    return this;
  }
}
SkillLevelUpCost.Builder = SkillLevelUpCost_Builder;
class SkillLevelUpCost_WithParent {
  /**
   * @param {SkillLevelUpCost} value
   * @param {SkillLevelUpCost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SkillLevelUpCost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasSkillPoints() {
    if (this._cachedHasSkillPoints === undefined) {
      if (this._value.hasSkillPoints) {
        this._cachedHasSkillPoints = true;
      } else {
        this._cachedHasSkillPoints = this._parent ? this._parent.hasSkillPoints : false;
      }
    }
    return this._cachedHasSkillPoints;
  }
  get skillPoints() {
    if (this._cachedSkillPoints === undefined) {
      if (this._value.hasSkillPoints) {
        this._cachedSkillPoints = this._value.skillPoints;
      } else {
        this._cachedSkillPoints = this._parent ? this._parent.skillPoints : this._value.skillPoints;
      }
    }
    return this._cachedSkillPoints;
  }
  get hasGold() {
    if (this._cachedHasGold === undefined) {
      if (this._value.hasGold) {
        this._cachedHasGold = true;
      } else {
        this._cachedHasGold = this._parent ? this._parent.hasGold : false;
      }
    }
    return this._cachedHasGold;
  }
  get gold() {
    if (this._cachedGold === undefined) {
      if (this._value.hasGold) {
        this._cachedGold = this._value.gold;
      } else {
        this._cachedGold = this._parent ? this._parent.gold : this._value.gold;
      }
    }
    return this._cachedGold;
  }
  update(current, parent) {
    const result = new SkillLevelUpCost_WithParent(current, parent);
    return result;
  }
}
SkillLevelUpCost_WithParent.default = new SkillLevelUpCost_WithParent(SkillLevelUpCost.default, null);
SkillLevelUpCost.WithParent = SkillLevelUpCost_WithParent;
class SkillLevelUpCost_Descriptor {
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 1,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get skillPoints() {
    if (!this._skillPoints) {
      this._skillPoints = {
        name: "skillPoints",
        Name: "SkillPoints",
        number: 2,
        protoType: 5,
        protoName: "skill_points",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillPoints;
  }
  get gold() {
    if (!this._gold) {
      this._gold = {
        name: "gold",
        Name: "Gold",
        number: 3,
        protoType: 5,
        protoName: "gold",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gold;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.level,
        this.skillPoints,
        this.gold,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkillPoints",
        Name: "DummyOneofForSkillPoints",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGold",
        Name: "DummyOneofForGold",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
SkillLevelUpCost.descriptor = new SkillLevelUpCost_Descriptor();
export class CardEvolveCost {
  get descriptor() {
    return CardEvolveCost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCard = false;
    this._card = null;
    this._hasStar = false;
    this._star = null;
    this._hasGold = false;
    this._gold = null;
    this._hasAffinityCatalystType = false;
    this._affinityCatalystType = null;
    this._hasAffinityCatalystAmount = false;
    this._affinityCatalystAmount = null;
    this._hasClassCatalystType = false;
    this._classCatalystType = null;
    this._hasClassCatalystAmount = false;
    this._classCatalystAmount = null;
    this._hasMainCatalystType = false;
    this._mainCatalystType = null;
    this._hasMainCatalystAmount = false;
    this._mainCatalystAmount = null;
    this._hasUnlockStatus = false;
    this._unlockStatus = null;
    this._hasUnlockDupRequired = false;
    this._unlockDupRequired = null;
  }
  isEmpty() {
    if (this._hasCard) return false;
    if (this._hasStar) return false;
    if (this._hasGold) return false;
    if (this._hasAffinityCatalystType) return false;
    if (this._hasAffinityCatalystAmount) return false;
    if (this._hasClassCatalystType) return false;
    if (this._hasClassCatalystAmount) return false;
    if (this._hasMainCatalystType) return false;
    if (this._hasMainCatalystAmount) return false;
    if (this._hasUnlockStatus) return false;
    if (this._hasUnlockDupRequired) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardEvolveCost) {
      return value;
    }
    return CardEvolveCost.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardEvolveCost();
    if (json.card != null) {
      result._hasCard = true;
      result._card = JsonToString.fromJson(json.card);
    }
    if (json.star != null) {
      result._hasStar = true;
      result._star = JsonToInt32.fromJson(json.star);
    }
    if (json.gold != null) {
      result._hasGold = true;
      result._gold = JsonToInt32.fromJson(json.gold);
    }
    if (json.affinityCatalystType != null) {
      result._hasAffinityCatalystType = true;
      result._affinityCatalystType = JsonToString.fromJson(json.affinityCatalystType);
    }
    if (json.affinityCatalystAmount != null) {
      result._hasAffinityCatalystAmount = true;
      result._affinityCatalystAmount = JsonToInt32.fromJson(json.affinityCatalystAmount);
    }
    if (json.classCatalystType != null) {
      result._hasClassCatalystType = true;
      result._classCatalystType = JsonToString.fromJson(json.classCatalystType);
    }
    if (json.classCatalystAmount != null) {
      result._hasClassCatalystAmount = true;
      result._classCatalystAmount = JsonToInt32.fromJson(json.classCatalystAmount);
    }
    if (json.mainCatalystType != null) {
      result._hasMainCatalystType = true;
      result._mainCatalystType = JsonToString.fromJson(json.mainCatalystType);
    }
    if (json.mainCatalystAmount != null) {
      result._hasMainCatalystAmount = true;
      result._mainCatalystAmount = JsonToInt32.fromJson(json.mainCatalystAmount);
    }
    if (json.unlockStatus != null) {
      result._hasUnlockStatus = true;
      result._unlockStatus = JsonToInt32.fromJson(json.unlockStatus);
    }
    if (json.unlockDupRequired != null) {
      result._hasUnlockDupRequired = true;
      result._unlockDupRequired = JsonToInt32.fromJson(json.unlockDupRequired);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCard) {
      result.card = JsonToString.toJson(this._card);
    }
    if (this._hasStar) {
      result.star = JsonToInt32.toJson(this._star);
    }
    if (this._hasGold) {
      result.gold = JsonToInt32.toJson(this._gold);
    }
    if (this._hasAffinityCatalystType) {
      result.affinityCatalystType = JsonToString.toJson(this._affinityCatalystType);
    }
    if (this._hasAffinityCatalystAmount) {
      result.affinityCatalystAmount = JsonToInt32.toJson(this._affinityCatalystAmount);
    }
    if (this._hasClassCatalystType) {
      result.classCatalystType = JsonToString.toJson(this._classCatalystType);
    }
    if (this._hasClassCatalystAmount) {
      result.classCatalystAmount = JsonToInt32.toJson(this._classCatalystAmount);
    }
    if (this._hasMainCatalystType) {
      result.mainCatalystType = JsonToString.toJson(this._mainCatalystType);
    }
    if (this._hasMainCatalystAmount) {
      result.mainCatalystAmount = JsonToInt32.toJson(this._mainCatalystAmount);
    }
    if (this._hasUnlockStatus) {
      result.unlockStatus = JsonToInt32.toJson(this._unlockStatus);
    }
    if (this._hasUnlockDupRequired) {
      result.unlockDupRequired = JsonToInt32.toJson(this._unlockDupRequired);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get card() {
    return this._hasCard ? this._card : JsonToString.default;
  }
  get hasCard() {
    return this._hasCard;
  }
  setCard(path, value) {
    return {type: 'SET', path: path.concat(['card']), value};
  }
  deleteCard(path) {
    return {type: 'DELETE', path: path.concat(['card'])};
  }
  /**
   * @returns {number}
   */
  get star() {
    return this._hasStar ? this._star : JsonToInt32.default;
  }
  get hasStar() {
    return this._hasStar;
  }
  setStar(path, value) {
    return {type: 'SET', path: path.concat(['star']), value};
  }
  deleteStar(path) {
    return {type: 'DELETE', path: path.concat(['star'])};
  }
  /**
   * @returns {number}
   */
  get gold() {
    return this._hasGold ? this._gold : JsonToInt32.default;
  }
  get hasGold() {
    return this._hasGold;
  }
  setGold(path, value) {
    return {type: 'SET', path: path.concat(['gold']), value};
  }
  deleteGold(path) {
    return {type: 'DELETE', path: path.concat(['gold'])};
  }
  /**
   * @returns {string}
   */
  get affinityCatalystType() {
    return this._hasAffinityCatalystType ? this._affinityCatalystType : JsonToString.default;
  }
  get hasAffinityCatalystType() {
    return this._hasAffinityCatalystType;
  }
  setAffinityCatalystType(path, value) {
    return {type: 'SET', path: path.concat(['affinityCatalystType']), value};
  }
  deleteAffinityCatalystType(path) {
    return {type: 'DELETE', path: path.concat(['affinityCatalystType'])};
  }
  /**
   * @returns {number}
   */
  get affinityCatalystAmount() {
    return this._hasAffinityCatalystAmount ? this._affinityCatalystAmount : JsonToInt32.default;
  }
  get hasAffinityCatalystAmount() {
    return this._hasAffinityCatalystAmount;
  }
  setAffinityCatalystAmount(path, value) {
    return {type: 'SET', path: path.concat(['affinityCatalystAmount']), value};
  }
  deleteAffinityCatalystAmount(path) {
    return {type: 'DELETE', path: path.concat(['affinityCatalystAmount'])};
  }
  /**
   * @returns {string}
   */
  get classCatalystType() {
    return this._hasClassCatalystType ? this._classCatalystType : JsonToString.default;
  }
  get hasClassCatalystType() {
    return this._hasClassCatalystType;
  }
  setClassCatalystType(path, value) {
    return {type: 'SET', path: path.concat(['classCatalystType']), value};
  }
  deleteClassCatalystType(path) {
    return {type: 'DELETE', path: path.concat(['classCatalystType'])};
  }
  /**
   * @returns {number}
   */
  get classCatalystAmount() {
    return this._hasClassCatalystAmount ? this._classCatalystAmount : JsonToInt32.default;
  }
  get hasClassCatalystAmount() {
    return this._hasClassCatalystAmount;
  }
  setClassCatalystAmount(path, value) {
    return {type: 'SET', path: path.concat(['classCatalystAmount']), value};
  }
  deleteClassCatalystAmount(path) {
    return {type: 'DELETE', path: path.concat(['classCatalystAmount'])};
  }
  /**
   * @returns {string}
   */
  get mainCatalystType() {
    return this._hasMainCatalystType ? this._mainCatalystType : JsonToString.default;
  }
  get hasMainCatalystType() {
    return this._hasMainCatalystType;
  }
  setMainCatalystType(path, value) {
    return {type: 'SET', path: path.concat(['mainCatalystType']), value};
  }
  deleteMainCatalystType(path) {
    return {type: 'DELETE', path: path.concat(['mainCatalystType'])};
  }
  /**
   * @returns {number}
   */
  get mainCatalystAmount() {
    return this._hasMainCatalystAmount ? this._mainCatalystAmount : JsonToInt32.default;
  }
  get hasMainCatalystAmount() {
    return this._hasMainCatalystAmount;
  }
  setMainCatalystAmount(path, value) {
    return {type: 'SET', path: path.concat(['mainCatalystAmount']), value};
  }
  deleteMainCatalystAmount(path) {
    return {type: 'DELETE', path: path.concat(['mainCatalystAmount'])};
  }
  /**
   * @returns {number}
   */
  get unlockStatus() {
    return this._hasUnlockStatus ? this._unlockStatus : JsonToInt32.default;
  }
  get hasUnlockStatus() {
    return this._hasUnlockStatus;
  }
  setUnlockStatus(path, value) {
    return {type: 'SET', path: path.concat(['unlockStatus']), value};
  }
  deleteUnlockStatus(path) {
    return {type: 'DELETE', path: path.concat(['unlockStatus'])};
  }
  /**
   * @returns {number}
   */
  get unlockDupRequired() {
    return this._hasUnlockDupRequired ? this._unlockDupRequired : JsonToInt32.default;
  }
  get hasUnlockDupRequired() {
    return this._hasUnlockDupRequired;
  }
  setUnlockDupRequired(path, value) {
    return {type: 'SET', path: path.concat(['unlockDupRequired']), value};
  }
  deleteUnlockDupRequired(path) {
    return {type: 'DELETE', path: path.concat(['unlockDupRequired'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "card": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasCard = true;
              copy._card = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCard) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasCard = false;
              copy._card = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasStar = true;
              copy._star = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasStar = false;
              copy._star = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasGold = true;
              copy._gold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGold) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasGold = false;
              copy._gold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinityCatalystType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasAffinityCatalystType = true;
              copy._affinityCatalystType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinityCatalystType) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasAffinityCatalystType = false;
              copy._affinityCatalystType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinityCatalystAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasAffinityCatalystAmount = true;
              copy._affinityCatalystAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinityCatalystAmount) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasAffinityCatalystAmount = false;
              copy._affinityCatalystAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "classCatalystType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasClassCatalystType = true;
              copy._classCatalystType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClassCatalystType) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasClassCatalystType = false;
              copy._classCatalystType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "classCatalystAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasClassCatalystAmount = true;
              copy._classCatalystAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasClassCatalystAmount) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasClassCatalystAmount = false;
              copy._classCatalystAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mainCatalystType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasMainCatalystType = true;
              copy._mainCatalystType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMainCatalystType) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasMainCatalystType = false;
              copy._mainCatalystType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mainCatalystAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasMainCatalystAmount = true;
              copy._mainCatalystAmount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMainCatalystAmount) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasMainCatalystAmount = false;
              copy._mainCatalystAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unlockStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasUnlockStatus = true;
              copy._unlockStatus = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnlockStatus) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasUnlockStatus = false;
              copy._unlockStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "unlockDupRequired": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardEvolveCost(this);
              copy._hasUnlockDupRequired = true;
              copy._unlockDupRequired = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnlockDupRequired) {
                return this;
              }
              const copy = new CardEvolveCost(this);
              copy._hasUnlockDupRequired = false;
              copy._unlockDupRequired = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardEvolveCost} other
   * @returns {CardEvolveCost}
   */
  merge(other) {
    const copy = new CardEvolveCost(this);
    if (other._hasCard) {
      copy._hasCard = true;
      copy._card = other._card;
    }
    if (other._hasStar) {
      copy._hasStar = true;
      copy._star = other._star;
    }
    if (other._hasGold) {
      copy._hasGold = true;
      copy._gold = other._gold;
    }
    if (other._hasAffinityCatalystType) {
      copy._hasAffinityCatalystType = true;
      copy._affinityCatalystType = other._affinityCatalystType;
    }
    if (other._hasAffinityCatalystAmount) {
      copy._hasAffinityCatalystAmount = true;
      copy._affinityCatalystAmount = other._affinityCatalystAmount;
    }
    if (other._hasClassCatalystType) {
      copy._hasClassCatalystType = true;
      copy._classCatalystType = other._classCatalystType;
    }
    if (other._hasClassCatalystAmount) {
      copy._hasClassCatalystAmount = true;
      copy._classCatalystAmount = other._classCatalystAmount;
    }
    if (other._hasMainCatalystType) {
      copy._hasMainCatalystType = true;
      copy._mainCatalystType = other._mainCatalystType;
    }
    if (other._hasMainCatalystAmount) {
      copy._hasMainCatalystAmount = true;
      copy._mainCatalystAmount = other._mainCatalystAmount;
    }
    if (other._hasUnlockStatus) {
      copy._hasUnlockStatus = true;
      copy._unlockStatus = other._unlockStatus;
    }
    if (other._hasUnlockDupRequired) {
      copy._hasUnlockDupRequired = true;
      copy._unlockDupRequired = other._unlockDupRequired;
    }
    return copy;
  }
}
CardEvolveCost.default = new CardEvolveCost();
class CardEvolveCost_Builder {
  constructor(value) {
    this._value = new CardEvolveCost(value);
  }
  build() {
    return new CardEvolveCost(this._value);
  }
  setCard(value) {
    this._value._hasCard = true;
    this._value._card = value;
    return this;
  }
  deleteCard() {
    this._value._hasCard = false;
    this._value._card = null;
    return this;
  }
  setStar(value) {
    this._value._hasStar = true;
    this._value._star = value;
    return this;
  }
  deleteStar() {
    this._value._hasStar = false;
    this._value._star = null;
    return this;
  }
  setGold(value) {
    this._value._hasGold = true;
    this._value._gold = value;
    return this;
  }
  deleteGold() {
    this._value._hasGold = false;
    this._value._gold = null;
    return this;
  }
  setAffinityCatalystType(value) {
    this._value._hasAffinityCatalystType = true;
    this._value._affinityCatalystType = value;
    return this;
  }
  deleteAffinityCatalystType() {
    this._value._hasAffinityCatalystType = false;
    this._value._affinityCatalystType = null;
    return this;
  }
  setAffinityCatalystAmount(value) {
    this._value._hasAffinityCatalystAmount = true;
    this._value._affinityCatalystAmount = value;
    return this;
  }
  deleteAffinityCatalystAmount() {
    this._value._hasAffinityCatalystAmount = false;
    this._value._affinityCatalystAmount = null;
    return this;
  }
  setClassCatalystType(value) {
    this._value._hasClassCatalystType = true;
    this._value._classCatalystType = value;
    return this;
  }
  deleteClassCatalystType() {
    this._value._hasClassCatalystType = false;
    this._value._classCatalystType = null;
    return this;
  }
  setClassCatalystAmount(value) {
    this._value._hasClassCatalystAmount = true;
    this._value._classCatalystAmount = value;
    return this;
  }
  deleteClassCatalystAmount() {
    this._value._hasClassCatalystAmount = false;
    this._value._classCatalystAmount = null;
    return this;
  }
  setMainCatalystType(value) {
    this._value._hasMainCatalystType = true;
    this._value._mainCatalystType = value;
    return this;
  }
  deleteMainCatalystType() {
    this._value._hasMainCatalystType = false;
    this._value._mainCatalystType = null;
    return this;
  }
  setMainCatalystAmount(value) {
    this._value._hasMainCatalystAmount = true;
    this._value._mainCatalystAmount = value;
    return this;
  }
  deleteMainCatalystAmount() {
    this._value._hasMainCatalystAmount = false;
    this._value._mainCatalystAmount = null;
    return this;
  }
  setUnlockStatus(value) {
    this._value._hasUnlockStatus = true;
    this._value._unlockStatus = value;
    return this;
  }
  deleteUnlockStatus() {
    this._value._hasUnlockStatus = false;
    this._value._unlockStatus = null;
    return this;
  }
  setUnlockDupRequired(value) {
    this._value._hasUnlockDupRequired = true;
    this._value._unlockDupRequired = value;
    return this;
  }
  deleteUnlockDupRequired() {
    this._value._hasUnlockDupRequired = false;
    this._value._unlockDupRequired = null;
    return this;
  }
}
CardEvolveCost.Builder = CardEvolveCost_Builder;
class CardEvolveCost_WithParent {
  /**
   * @param {CardEvolveCost} value
   * @param {CardEvolveCost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardEvolveCost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCard() {
    if (this._cachedHasCard === undefined) {
      if (this._value.hasCard) {
        this._cachedHasCard = true;
      } else {
        this._cachedHasCard = this._parent ? this._parent.hasCard : false;
      }
    }
    return this._cachedHasCard;
  }
  get card() {
    if (this._cachedCard === undefined) {
      if (this._value.hasCard) {
        this._cachedCard = this._value.card;
      } else {
        this._cachedCard = this._parent ? this._parent.card : this._value.card;
      }
    }
    return this._cachedCard;
  }
  get hasStar() {
    if (this._cachedHasStar === undefined) {
      if (this._value.hasStar) {
        this._cachedHasStar = true;
      } else {
        this._cachedHasStar = this._parent ? this._parent.hasStar : false;
      }
    }
    return this._cachedHasStar;
  }
  get star() {
    if (this._cachedStar === undefined) {
      if (this._value.hasStar) {
        this._cachedStar = this._value.star;
      } else {
        this._cachedStar = this._parent ? this._parent.star : this._value.star;
      }
    }
    return this._cachedStar;
  }
  get hasGold() {
    if (this._cachedHasGold === undefined) {
      if (this._value.hasGold) {
        this._cachedHasGold = true;
      } else {
        this._cachedHasGold = this._parent ? this._parent.hasGold : false;
      }
    }
    return this._cachedHasGold;
  }
  get gold() {
    if (this._cachedGold === undefined) {
      if (this._value.hasGold) {
        this._cachedGold = this._value.gold;
      } else {
        this._cachedGold = this._parent ? this._parent.gold : this._value.gold;
      }
    }
    return this._cachedGold;
  }
  get hasAffinityCatalystType() {
    if (this._cachedHasAffinityCatalystType === undefined) {
      if (this._value.hasAffinityCatalystType) {
        this._cachedHasAffinityCatalystType = true;
      } else {
        this._cachedHasAffinityCatalystType = this._parent ? this._parent.hasAffinityCatalystType : false;
      }
    }
    return this._cachedHasAffinityCatalystType;
  }
  get affinityCatalystType() {
    if (this._cachedAffinityCatalystType === undefined) {
      if (this._value.hasAffinityCatalystType) {
        this._cachedAffinityCatalystType = this._value.affinityCatalystType;
      } else {
        this._cachedAffinityCatalystType = this._parent ? this._parent.affinityCatalystType : this._value.affinityCatalystType;
      }
    }
    return this._cachedAffinityCatalystType;
  }
  get hasAffinityCatalystAmount() {
    if (this._cachedHasAffinityCatalystAmount === undefined) {
      if (this._value.hasAffinityCatalystAmount) {
        this._cachedHasAffinityCatalystAmount = true;
      } else {
        this._cachedHasAffinityCatalystAmount = this._parent ? this._parent.hasAffinityCatalystAmount : false;
      }
    }
    return this._cachedHasAffinityCatalystAmount;
  }
  get affinityCatalystAmount() {
    if (this._cachedAffinityCatalystAmount === undefined) {
      if (this._value.hasAffinityCatalystAmount) {
        this._cachedAffinityCatalystAmount = this._value.affinityCatalystAmount;
      } else {
        this._cachedAffinityCatalystAmount = this._parent ? this._parent.affinityCatalystAmount : this._value.affinityCatalystAmount;
      }
    }
    return this._cachedAffinityCatalystAmount;
  }
  get hasClassCatalystType() {
    if (this._cachedHasClassCatalystType === undefined) {
      if (this._value.hasClassCatalystType) {
        this._cachedHasClassCatalystType = true;
      } else {
        this._cachedHasClassCatalystType = this._parent ? this._parent.hasClassCatalystType : false;
      }
    }
    return this._cachedHasClassCatalystType;
  }
  get classCatalystType() {
    if (this._cachedClassCatalystType === undefined) {
      if (this._value.hasClassCatalystType) {
        this._cachedClassCatalystType = this._value.classCatalystType;
      } else {
        this._cachedClassCatalystType = this._parent ? this._parent.classCatalystType : this._value.classCatalystType;
      }
    }
    return this._cachedClassCatalystType;
  }
  get hasClassCatalystAmount() {
    if (this._cachedHasClassCatalystAmount === undefined) {
      if (this._value.hasClassCatalystAmount) {
        this._cachedHasClassCatalystAmount = true;
      } else {
        this._cachedHasClassCatalystAmount = this._parent ? this._parent.hasClassCatalystAmount : false;
      }
    }
    return this._cachedHasClassCatalystAmount;
  }
  get classCatalystAmount() {
    if (this._cachedClassCatalystAmount === undefined) {
      if (this._value.hasClassCatalystAmount) {
        this._cachedClassCatalystAmount = this._value.classCatalystAmount;
      } else {
        this._cachedClassCatalystAmount = this._parent ? this._parent.classCatalystAmount : this._value.classCatalystAmount;
      }
    }
    return this._cachedClassCatalystAmount;
  }
  get hasMainCatalystType() {
    if (this._cachedHasMainCatalystType === undefined) {
      if (this._value.hasMainCatalystType) {
        this._cachedHasMainCatalystType = true;
      } else {
        this._cachedHasMainCatalystType = this._parent ? this._parent.hasMainCatalystType : false;
      }
    }
    return this._cachedHasMainCatalystType;
  }
  get mainCatalystType() {
    if (this._cachedMainCatalystType === undefined) {
      if (this._value.hasMainCatalystType) {
        this._cachedMainCatalystType = this._value.mainCatalystType;
      } else {
        this._cachedMainCatalystType = this._parent ? this._parent.mainCatalystType : this._value.mainCatalystType;
      }
    }
    return this._cachedMainCatalystType;
  }
  get hasMainCatalystAmount() {
    if (this._cachedHasMainCatalystAmount === undefined) {
      if (this._value.hasMainCatalystAmount) {
        this._cachedHasMainCatalystAmount = true;
      } else {
        this._cachedHasMainCatalystAmount = this._parent ? this._parent.hasMainCatalystAmount : false;
      }
    }
    return this._cachedHasMainCatalystAmount;
  }
  get mainCatalystAmount() {
    if (this._cachedMainCatalystAmount === undefined) {
      if (this._value.hasMainCatalystAmount) {
        this._cachedMainCatalystAmount = this._value.mainCatalystAmount;
      } else {
        this._cachedMainCatalystAmount = this._parent ? this._parent.mainCatalystAmount : this._value.mainCatalystAmount;
      }
    }
    return this._cachedMainCatalystAmount;
  }
  get hasUnlockStatus() {
    if (this._cachedHasUnlockStatus === undefined) {
      if (this._value.hasUnlockStatus) {
        this._cachedHasUnlockStatus = true;
      } else {
        this._cachedHasUnlockStatus = this._parent ? this._parent.hasUnlockStatus : false;
      }
    }
    return this._cachedHasUnlockStatus;
  }
  get unlockStatus() {
    if (this._cachedUnlockStatus === undefined) {
      if (this._value.hasUnlockStatus) {
        this._cachedUnlockStatus = this._value.unlockStatus;
      } else {
        this._cachedUnlockStatus = this._parent ? this._parent.unlockStatus : this._value.unlockStatus;
      }
    }
    return this._cachedUnlockStatus;
  }
  get hasUnlockDupRequired() {
    if (this._cachedHasUnlockDupRequired === undefined) {
      if (this._value.hasUnlockDupRequired) {
        this._cachedHasUnlockDupRequired = true;
      } else {
        this._cachedHasUnlockDupRequired = this._parent ? this._parent.hasUnlockDupRequired : false;
      }
    }
    return this._cachedHasUnlockDupRequired;
  }
  get unlockDupRequired() {
    if (this._cachedUnlockDupRequired === undefined) {
      if (this._value.hasUnlockDupRequired) {
        this._cachedUnlockDupRequired = this._value.unlockDupRequired;
      } else {
        this._cachedUnlockDupRequired = this._parent ? this._parent.unlockDupRequired : this._value.unlockDupRequired;
      }
    }
    return this._cachedUnlockDupRequired;
  }
  update(current, parent) {
    const result = new CardEvolveCost_WithParent(current, parent);
    return result;
  }
}
CardEvolveCost_WithParent.default = new CardEvolveCost_WithParent(CardEvolveCost.default, null);
CardEvolveCost.WithParent = CardEvolveCost_WithParent;
class CardEvolveCost_Descriptor {
  get card() {
    if (!this._card) {
      this._card = {
        name: "card",
        Name: "Card",
        number: 1,
        protoType: 9,
        protoName: "card",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._card;
  }
  get star() {
    if (!this._star) {
      this._star = {
        name: "star",
        Name: "Star",
        number: 2,
        protoType: 5,
        protoName: "star",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star;
  }
  get gold() {
    if (!this._gold) {
      this._gold = {
        name: "gold",
        Name: "Gold",
        number: 3,
        protoType: 5,
        protoName: "gold",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gold;
  }
  get affinityCatalystType() {
    if (!this._affinityCatalystType) {
      this._affinityCatalystType = {
        name: "affinityCatalystType",
        Name: "AffinityCatalystType",
        number: 4,
        protoType: 9,
        protoName: "affinity_catalyst_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityCatalystType;
  }
  get affinityCatalystAmount() {
    if (!this._affinityCatalystAmount) {
      this._affinityCatalystAmount = {
        name: "affinityCatalystAmount",
        Name: "AffinityCatalystAmount",
        number: 5,
        protoType: 5,
        protoName: "affinity_catalyst_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityCatalystAmount;
  }
  get classCatalystType() {
    if (!this._classCatalystType) {
      this._classCatalystType = {
        name: "classCatalystType",
        Name: "ClassCatalystType",
        number: 6,
        protoType: 9,
        protoName: "class_catalyst_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._classCatalystType;
  }
  get classCatalystAmount() {
    if (!this._classCatalystAmount) {
      this._classCatalystAmount = {
        name: "classCatalystAmount",
        Name: "ClassCatalystAmount",
        number: 7,
        protoType: 5,
        protoName: "class_catalyst_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._classCatalystAmount;
  }
  get mainCatalystType() {
    if (!this._mainCatalystType) {
      this._mainCatalystType = {
        name: "mainCatalystType",
        Name: "MainCatalystType",
        number: 8,
        protoType: 9,
        protoName: "main_catalyst_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mainCatalystType;
  }
  get mainCatalystAmount() {
    if (!this._mainCatalystAmount) {
      this._mainCatalystAmount = {
        name: "mainCatalystAmount",
        Name: "MainCatalystAmount",
        number: 9,
        protoType: 5,
        protoName: "main_catalyst_amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mainCatalystAmount;
  }
  get unlockStatus() {
    if (!this._unlockStatus) {
      this._unlockStatus = {
        name: "unlockStatus",
        Name: "UnlockStatus",
        number: 10,
        protoType: 5,
        protoName: "unlock_status",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockStatus;
  }
  get unlockDupRequired() {
    if (!this._unlockDupRequired) {
      this._unlockDupRequired = {
        name: "unlockDupRequired",
        Name: "UnlockDupRequired",
        number: 11,
        protoType: 5,
        protoName: "unlock_dup_required",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockDupRequired;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.card,
        this.star,
        this.gold,
        this.affinityCatalystType,
        this.affinityCatalystAmount,
        this.classCatalystType,
        this.classCatalystAmount,
        this.mainCatalystType,
        this.mainCatalystAmount,
        this.unlockStatus,
        this.unlockDupRequired,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCard",
        Name: "DummyOneofForCard",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar",
        Name: "DummyOneofForStar",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGold",
        Name: "DummyOneofForGold",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinityCatalystType",
        Name: "DummyOneofForAffinityCatalystType",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinityCatalystAmount",
        Name: "DummyOneofForAffinityCatalystAmount",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClassCatalystType",
        Name: "DummyOneofForClassCatalystType",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForClassCatalystAmount",
        Name: "DummyOneofForClassCatalystAmount",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMainCatalystType",
        Name: "DummyOneofForMainCatalystType",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMainCatalystAmount",
        Name: "DummyOneofForMainCatalystAmount",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnlockStatus",
        Name: "DummyOneofForUnlockStatus",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUnlockDupRequired",
        Name: "DummyOneofForUnlockDupRequired",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
CardEvolveCost.descriptor = new CardEvolveCost_Descriptor();
export class CardAwakenCost {
  get descriptor() {
    return CardAwakenCost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCard = false;
    this._card = null;
    this._hasLevel = false;
    this._level = null;
    this._hasItem1Type = false;
    this._item1Type = null;
    this._hasItem1Num = false;
    this._item1Num = null;
    this._hasItem2Type = false;
    this._item2Type = null;
    this._hasItem2Num = false;
    this._item2Num = null;
    this._hasItem3Type = false;
    this._item3Type = null;
    this._hasItem3Num = false;
    this._item3Num = null;
    this._hasItem4Type = false;
    this._item4Type = null;
    this._hasItem4Num = false;
    this._item4Num = null;
    this._hasItem5Type = false;
    this._item5Type = null;
    this._hasItem5Num = false;
    this._item5Num = null;
  }
  isEmpty() {
    if (this._hasCard) return false;
    if (this._hasLevel) return false;
    if (this._hasItem1Type) return false;
    if (this._hasItem1Num) return false;
    if (this._hasItem2Type) return false;
    if (this._hasItem2Num) return false;
    if (this._hasItem3Type) return false;
    if (this._hasItem3Num) return false;
    if (this._hasItem4Type) return false;
    if (this._hasItem4Num) return false;
    if (this._hasItem5Type) return false;
    if (this._hasItem5Num) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardAwakenCost) {
      return value;
    }
    return CardAwakenCost.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardAwakenCost();
    if (json.card != null) {
      result._hasCard = true;
      result._card = JsonToString.fromJson(json.card);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.item1Type != null) {
      result._hasItem1Type = true;
      result._item1Type = JsonToString.fromJson(json.item1Type);
    }
    if (json.item1Num != null) {
      result._hasItem1Num = true;
      result._item1Num = JsonToInt32.fromJson(json.item1Num);
    }
    if (json.item2Type != null) {
      result._hasItem2Type = true;
      result._item2Type = JsonToString.fromJson(json.item2Type);
    }
    if (json.item2Num != null) {
      result._hasItem2Num = true;
      result._item2Num = JsonToInt32.fromJson(json.item2Num);
    }
    if (json.item3Type != null) {
      result._hasItem3Type = true;
      result._item3Type = JsonToString.fromJson(json.item3Type);
    }
    if (json.item3Num != null) {
      result._hasItem3Num = true;
      result._item3Num = JsonToInt32.fromJson(json.item3Num);
    }
    if (json.item4Type != null) {
      result._hasItem4Type = true;
      result._item4Type = JsonToString.fromJson(json.item4Type);
    }
    if (json.item4Num != null) {
      result._hasItem4Num = true;
      result._item4Num = JsonToInt32.fromJson(json.item4Num);
    }
    if (json.item5Type != null) {
      result._hasItem5Type = true;
      result._item5Type = JsonToString.fromJson(json.item5Type);
    }
    if (json.item5Num != null) {
      result._hasItem5Num = true;
      result._item5Num = JsonToInt32.fromJson(json.item5Num);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCard) {
      result.card = JsonToString.toJson(this._card);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasItem1Type) {
      result.item1Type = JsonToString.toJson(this._item1Type);
    }
    if (this._hasItem1Num) {
      result.item1Num = JsonToInt32.toJson(this._item1Num);
    }
    if (this._hasItem2Type) {
      result.item2Type = JsonToString.toJson(this._item2Type);
    }
    if (this._hasItem2Num) {
      result.item2Num = JsonToInt32.toJson(this._item2Num);
    }
    if (this._hasItem3Type) {
      result.item3Type = JsonToString.toJson(this._item3Type);
    }
    if (this._hasItem3Num) {
      result.item3Num = JsonToInt32.toJson(this._item3Num);
    }
    if (this._hasItem4Type) {
      result.item4Type = JsonToString.toJson(this._item4Type);
    }
    if (this._hasItem4Num) {
      result.item4Num = JsonToInt32.toJson(this._item4Num);
    }
    if (this._hasItem5Type) {
      result.item5Type = JsonToString.toJson(this._item5Type);
    }
    if (this._hasItem5Num) {
      result.item5Num = JsonToInt32.toJson(this._item5Num);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get card() {
    return this._hasCard ? this._card : JsonToString.default;
  }
  get hasCard() {
    return this._hasCard;
  }
  setCard(path, value) {
    return {type: 'SET', path: path.concat(['card']), value};
  }
  deleteCard(path) {
    return {type: 'DELETE', path: path.concat(['card'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {string}
   */
  get item1Type() {
    return this._hasItem1Type ? this._item1Type : JsonToString.default;
  }
  get hasItem1Type() {
    return this._hasItem1Type;
  }
  setItem1Type(path, value) {
    return {type: 'SET', path: path.concat(['item1Type']), value};
  }
  deleteItem1Type(path) {
    return {type: 'DELETE', path: path.concat(['item1Type'])};
  }
  /**
   * @returns {number}
   */
  get item1Num() {
    return this._hasItem1Num ? this._item1Num : JsonToInt32.default;
  }
  get hasItem1Num() {
    return this._hasItem1Num;
  }
  setItem1Num(path, value) {
    return {type: 'SET', path: path.concat(['item1Num']), value};
  }
  deleteItem1Num(path) {
    return {type: 'DELETE', path: path.concat(['item1Num'])};
  }
  /**
   * @returns {string}
   */
  get item2Type() {
    return this._hasItem2Type ? this._item2Type : JsonToString.default;
  }
  get hasItem2Type() {
    return this._hasItem2Type;
  }
  setItem2Type(path, value) {
    return {type: 'SET', path: path.concat(['item2Type']), value};
  }
  deleteItem2Type(path) {
    return {type: 'DELETE', path: path.concat(['item2Type'])};
  }
  /**
   * @returns {number}
   */
  get item2Num() {
    return this._hasItem2Num ? this._item2Num : JsonToInt32.default;
  }
  get hasItem2Num() {
    return this._hasItem2Num;
  }
  setItem2Num(path, value) {
    return {type: 'SET', path: path.concat(['item2Num']), value};
  }
  deleteItem2Num(path) {
    return {type: 'DELETE', path: path.concat(['item2Num'])};
  }
  /**
   * @returns {string}
   */
  get item3Type() {
    return this._hasItem3Type ? this._item3Type : JsonToString.default;
  }
  get hasItem3Type() {
    return this._hasItem3Type;
  }
  setItem3Type(path, value) {
    return {type: 'SET', path: path.concat(['item3Type']), value};
  }
  deleteItem3Type(path) {
    return {type: 'DELETE', path: path.concat(['item3Type'])};
  }
  /**
   * @returns {number}
   */
  get item3Num() {
    return this._hasItem3Num ? this._item3Num : JsonToInt32.default;
  }
  get hasItem3Num() {
    return this._hasItem3Num;
  }
  setItem3Num(path, value) {
    return {type: 'SET', path: path.concat(['item3Num']), value};
  }
  deleteItem3Num(path) {
    return {type: 'DELETE', path: path.concat(['item3Num'])};
  }
  /**
   * @returns {string}
   */
  get item4Type() {
    return this._hasItem4Type ? this._item4Type : JsonToString.default;
  }
  get hasItem4Type() {
    return this._hasItem4Type;
  }
  setItem4Type(path, value) {
    return {type: 'SET', path: path.concat(['item4Type']), value};
  }
  deleteItem4Type(path) {
    return {type: 'DELETE', path: path.concat(['item4Type'])};
  }
  /**
   * @returns {number}
   */
  get item4Num() {
    return this._hasItem4Num ? this._item4Num : JsonToInt32.default;
  }
  get hasItem4Num() {
    return this._hasItem4Num;
  }
  setItem4Num(path, value) {
    return {type: 'SET', path: path.concat(['item4Num']), value};
  }
  deleteItem4Num(path) {
    return {type: 'DELETE', path: path.concat(['item4Num'])};
  }
  /**
   * @returns {string}
   */
  get item5Type() {
    return this._hasItem5Type ? this._item5Type : JsonToString.default;
  }
  get hasItem5Type() {
    return this._hasItem5Type;
  }
  setItem5Type(path, value) {
    return {type: 'SET', path: path.concat(['item5Type']), value};
  }
  deleteItem5Type(path) {
    return {type: 'DELETE', path: path.concat(['item5Type'])};
  }
  /**
   * @returns {number}
   */
  get item5Num() {
    return this._hasItem5Num ? this._item5Num : JsonToInt32.default;
  }
  get hasItem5Num() {
    return this._hasItem5Num;
  }
  setItem5Num(path, value) {
    return {type: 'SET', path: path.concat(['item5Num']), value};
  }
  deleteItem5Num(path) {
    return {type: 'DELETE', path: path.concat(['item5Num'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "card": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasCard = true;
              copy._card = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCard) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasCard = false;
              copy._card = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item1Type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem1Type = true;
              copy._item1Type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem1Type) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem1Type = false;
              copy._item1Type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item1Num": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem1Num = true;
              copy._item1Num = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem1Num) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem1Num = false;
              copy._item1Num = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item2Type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem2Type = true;
              copy._item2Type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem2Type) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem2Type = false;
              copy._item2Type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item2Num": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem2Num = true;
              copy._item2Num = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem2Num) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem2Num = false;
              copy._item2Num = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item3Type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem3Type = true;
              copy._item3Type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem3Type) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem3Type = false;
              copy._item3Type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item3Num": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem3Num = true;
              copy._item3Num = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem3Num) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem3Num = false;
              copy._item3Num = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item4Type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem4Type = true;
              copy._item4Type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem4Type) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem4Type = false;
              copy._item4Type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item4Num": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem4Num = true;
              copy._item4Num = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem4Num) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem4Num = false;
              copy._item4Num = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item5Type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem5Type = true;
              copy._item5Type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem5Type) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem5Type = false;
              copy._item5Type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "item5Num": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwakenCost(this);
              copy._hasItem5Num = true;
              copy._item5Num = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItem5Num) {
                return this;
              }
              const copy = new CardAwakenCost(this);
              copy._hasItem5Num = false;
              copy._item5Num = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardAwakenCost} other
   * @returns {CardAwakenCost}
   */
  merge(other) {
    const copy = new CardAwakenCost(this);
    if (other._hasCard) {
      copy._hasCard = true;
      copy._card = other._card;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasItem1Type) {
      copy._hasItem1Type = true;
      copy._item1Type = other._item1Type;
    }
    if (other._hasItem1Num) {
      copy._hasItem1Num = true;
      copy._item1Num = other._item1Num;
    }
    if (other._hasItem2Type) {
      copy._hasItem2Type = true;
      copy._item2Type = other._item2Type;
    }
    if (other._hasItem2Num) {
      copy._hasItem2Num = true;
      copy._item2Num = other._item2Num;
    }
    if (other._hasItem3Type) {
      copy._hasItem3Type = true;
      copy._item3Type = other._item3Type;
    }
    if (other._hasItem3Num) {
      copy._hasItem3Num = true;
      copy._item3Num = other._item3Num;
    }
    if (other._hasItem4Type) {
      copy._hasItem4Type = true;
      copy._item4Type = other._item4Type;
    }
    if (other._hasItem4Num) {
      copy._hasItem4Num = true;
      copy._item4Num = other._item4Num;
    }
    if (other._hasItem5Type) {
      copy._hasItem5Type = true;
      copy._item5Type = other._item5Type;
    }
    if (other._hasItem5Num) {
      copy._hasItem5Num = true;
      copy._item5Num = other._item5Num;
    }
    return copy;
  }
}
CardAwakenCost.default = new CardAwakenCost();
class CardAwakenCost_Builder {
  constructor(value) {
    this._value = new CardAwakenCost(value);
  }
  build() {
    return new CardAwakenCost(this._value);
  }
  setCard(value) {
    this._value._hasCard = true;
    this._value._card = value;
    return this;
  }
  deleteCard() {
    this._value._hasCard = false;
    this._value._card = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setItem1Type(value) {
    this._value._hasItem1Type = true;
    this._value._item1Type = value;
    return this;
  }
  deleteItem1Type() {
    this._value._hasItem1Type = false;
    this._value._item1Type = null;
    return this;
  }
  setItem1Num(value) {
    this._value._hasItem1Num = true;
    this._value._item1Num = value;
    return this;
  }
  deleteItem1Num() {
    this._value._hasItem1Num = false;
    this._value._item1Num = null;
    return this;
  }
  setItem2Type(value) {
    this._value._hasItem2Type = true;
    this._value._item2Type = value;
    return this;
  }
  deleteItem2Type() {
    this._value._hasItem2Type = false;
    this._value._item2Type = null;
    return this;
  }
  setItem2Num(value) {
    this._value._hasItem2Num = true;
    this._value._item2Num = value;
    return this;
  }
  deleteItem2Num() {
    this._value._hasItem2Num = false;
    this._value._item2Num = null;
    return this;
  }
  setItem3Type(value) {
    this._value._hasItem3Type = true;
    this._value._item3Type = value;
    return this;
  }
  deleteItem3Type() {
    this._value._hasItem3Type = false;
    this._value._item3Type = null;
    return this;
  }
  setItem3Num(value) {
    this._value._hasItem3Num = true;
    this._value._item3Num = value;
    return this;
  }
  deleteItem3Num() {
    this._value._hasItem3Num = false;
    this._value._item3Num = null;
    return this;
  }
  setItem4Type(value) {
    this._value._hasItem4Type = true;
    this._value._item4Type = value;
    return this;
  }
  deleteItem4Type() {
    this._value._hasItem4Type = false;
    this._value._item4Type = null;
    return this;
  }
  setItem4Num(value) {
    this._value._hasItem4Num = true;
    this._value._item4Num = value;
    return this;
  }
  deleteItem4Num() {
    this._value._hasItem4Num = false;
    this._value._item4Num = null;
    return this;
  }
  setItem5Type(value) {
    this._value._hasItem5Type = true;
    this._value._item5Type = value;
    return this;
  }
  deleteItem5Type() {
    this._value._hasItem5Type = false;
    this._value._item5Type = null;
    return this;
  }
  setItem5Num(value) {
    this._value._hasItem5Num = true;
    this._value._item5Num = value;
    return this;
  }
  deleteItem5Num() {
    this._value._hasItem5Num = false;
    this._value._item5Num = null;
    return this;
  }
}
CardAwakenCost.Builder = CardAwakenCost_Builder;
class CardAwakenCost_WithParent {
  /**
   * @param {CardAwakenCost} value
   * @param {CardAwakenCost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardAwakenCost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCard() {
    if (this._cachedHasCard === undefined) {
      if (this._value.hasCard) {
        this._cachedHasCard = true;
      } else {
        this._cachedHasCard = this._parent ? this._parent.hasCard : false;
      }
    }
    return this._cachedHasCard;
  }
  get card() {
    if (this._cachedCard === undefined) {
      if (this._value.hasCard) {
        this._cachedCard = this._value.card;
      } else {
        this._cachedCard = this._parent ? this._parent.card : this._value.card;
      }
    }
    return this._cachedCard;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasItem1Type() {
    if (this._cachedHasItem1Type === undefined) {
      if (this._value.hasItem1Type) {
        this._cachedHasItem1Type = true;
      } else {
        this._cachedHasItem1Type = this._parent ? this._parent.hasItem1Type : false;
      }
    }
    return this._cachedHasItem1Type;
  }
  get item1Type() {
    if (this._cachedItem1Type === undefined) {
      if (this._value.hasItem1Type) {
        this._cachedItem1Type = this._value.item1Type;
      } else {
        this._cachedItem1Type = this._parent ? this._parent.item1Type : this._value.item1Type;
      }
    }
    return this._cachedItem1Type;
  }
  get hasItem1Num() {
    if (this._cachedHasItem1Num === undefined) {
      if (this._value.hasItem1Num) {
        this._cachedHasItem1Num = true;
      } else {
        this._cachedHasItem1Num = this._parent ? this._parent.hasItem1Num : false;
      }
    }
    return this._cachedHasItem1Num;
  }
  get item1Num() {
    if (this._cachedItem1Num === undefined) {
      if (this._value.hasItem1Num) {
        this._cachedItem1Num = this._value.item1Num;
      } else {
        this._cachedItem1Num = this._parent ? this._parent.item1Num : this._value.item1Num;
      }
    }
    return this._cachedItem1Num;
  }
  get hasItem2Type() {
    if (this._cachedHasItem2Type === undefined) {
      if (this._value.hasItem2Type) {
        this._cachedHasItem2Type = true;
      } else {
        this._cachedHasItem2Type = this._parent ? this._parent.hasItem2Type : false;
      }
    }
    return this._cachedHasItem2Type;
  }
  get item2Type() {
    if (this._cachedItem2Type === undefined) {
      if (this._value.hasItem2Type) {
        this._cachedItem2Type = this._value.item2Type;
      } else {
        this._cachedItem2Type = this._parent ? this._parent.item2Type : this._value.item2Type;
      }
    }
    return this._cachedItem2Type;
  }
  get hasItem2Num() {
    if (this._cachedHasItem2Num === undefined) {
      if (this._value.hasItem2Num) {
        this._cachedHasItem2Num = true;
      } else {
        this._cachedHasItem2Num = this._parent ? this._parent.hasItem2Num : false;
      }
    }
    return this._cachedHasItem2Num;
  }
  get item2Num() {
    if (this._cachedItem2Num === undefined) {
      if (this._value.hasItem2Num) {
        this._cachedItem2Num = this._value.item2Num;
      } else {
        this._cachedItem2Num = this._parent ? this._parent.item2Num : this._value.item2Num;
      }
    }
    return this._cachedItem2Num;
  }
  get hasItem3Type() {
    if (this._cachedHasItem3Type === undefined) {
      if (this._value.hasItem3Type) {
        this._cachedHasItem3Type = true;
      } else {
        this._cachedHasItem3Type = this._parent ? this._parent.hasItem3Type : false;
      }
    }
    return this._cachedHasItem3Type;
  }
  get item3Type() {
    if (this._cachedItem3Type === undefined) {
      if (this._value.hasItem3Type) {
        this._cachedItem3Type = this._value.item3Type;
      } else {
        this._cachedItem3Type = this._parent ? this._parent.item3Type : this._value.item3Type;
      }
    }
    return this._cachedItem3Type;
  }
  get hasItem3Num() {
    if (this._cachedHasItem3Num === undefined) {
      if (this._value.hasItem3Num) {
        this._cachedHasItem3Num = true;
      } else {
        this._cachedHasItem3Num = this._parent ? this._parent.hasItem3Num : false;
      }
    }
    return this._cachedHasItem3Num;
  }
  get item3Num() {
    if (this._cachedItem3Num === undefined) {
      if (this._value.hasItem3Num) {
        this._cachedItem3Num = this._value.item3Num;
      } else {
        this._cachedItem3Num = this._parent ? this._parent.item3Num : this._value.item3Num;
      }
    }
    return this._cachedItem3Num;
  }
  get hasItem4Type() {
    if (this._cachedHasItem4Type === undefined) {
      if (this._value.hasItem4Type) {
        this._cachedHasItem4Type = true;
      } else {
        this._cachedHasItem4Type = this._parent ? this._parent.hasItem4Type : false;
      }
    }
    return this._cachedHasItem4Type;
  }
  get item4Type() {
    if (this._cachedItem4Type === undefined) {
      if (this._value.hasItem4Type) {
        this._cachedItem4Type = this._value.item4Type;
      } else {
        this._cachedItem4Type = this._parent ? this._parent.item4Type : this._value.item4Type;
      }
    }
    return this._cachedItem4Type;
  }
  get hasItem4Num() {
    if (this._cachedHasItem4Num === undefined) {
      if (this._value.hasItem4Num) {
        this._cachedHasItem4Num = true;
      } else {
        this._cachedHasItem4Num = this._parent ? this._parent.hasItem4Num : false;
      }
    }
    return this._cachedHasItem4Num;
  }
  get item4Num() {
    if (this._cachedItem4Num === undefined) {
      if (this._value.hasItem4Num) {
        this._cachedItem4Num = this._value.item4Num;
      } else {
        this._cachedItem4Num = this._parent ? this._parent.item4Num : this._value.item4Num;
      }
    }
    return this._cachedItem4Num;
  }
  get hasItem5Type() {
    if (this._cachedHasItem5Type === undefined) {
      if (this._value.hasItem5Type) {
        this._cachedHasItem5Type = true;
      } else {
        this._cachedHasItem5Type = this._parent ? this._parent.hasItem5Type : false;
      }
    }
    return this._cachedHasItem5Type;
  }
  get item5Type() {
    if (this._cachedItem5Type === undefined) {
      if (this._value.hasItem5Type) {
        this._cachedItem5Type = this._value.item5Type;
      } else {
        this._cachedItem5Type = this._parent ? this._parent.item5Type : this._value.item5Type;
      }
    }
    return this._cachedItem5Type;
  }
  get hasItem5Num() {
    if (this._cachedHasItem5Num === undefined) {
      if (this._value.hasItem5Num) {
        this._cachedHasItem5Num = true;
      } else {
        this._cachedHasItem5Num = this._parent ? this._parent.hasItem5Num : false;
      }
    }
    return this._cachedHasItem5Num;
  }
  get item5Num() {
    if (this._cachedItem5Num === undefined) {
      if (this._value.hasItem5Num) {
        this._cachedItem5Num = this._value.item5Num;
      } else {
        this._cachedItem5Num = this._parent ? this._parent.item5Num : this._value.item5Num;
      }
    }
    return this._cachedItem5Num;
  }
  update(current, parent) {
    const result = new CardAwakenCost_WithParent(current, parent);
    return result;
  }
}
CardAwakenCost_WithParent.default = new CardAwakenCost_WithParent(CardAwakenCost.default, null);
CardAwakenCost.WithParent = CardAwakenCost_WithParent;
class CardAwakenCost_Descriptor {
  get card() {
    if (!this._card) {
      this._card = {
        name: "card",
        Name: "Card",
        number: 4,
        protoType: 9,
        protoName: "card",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._card;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 1,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get item1Type() {
    if (!this._item1Type) {
      this._item1Type = {
        name: "item1Type",
        Name: "Item1Type",
        number: 5,
        protoType: 9,
        protoName: "item1_type",
        type: JsonToString,
        options: {
          comments: "reserved 2; reserved 3;",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item1Type;
  }
  get item1Num() {
    if (!this._item1Num) {
      this._item1Num = {
        name: "item1Num",
        Name: "Item1Num",
        number: 6,
        protoType: 5,
        protoName: "item1_num",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item1Num;
  }
  get item2Type() {
    if (!this._item2Type) {
      this._item2Type = {
        name: "item2Type",
        Name: "Item2Type",
        number: 7,
        protoType: 9,
        protoName: "item2_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item2Type;
  }
  get item2Num() {
    if (!this._item2Num) {
      this._item2Num = {
        name: "item2Num",
        Name: "Item2Num",
        number: 8,
        protoType: 5,
        protoName: "item2_num",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item2Num;
  }
  get item3Type() {
    if (!this._item3Type) {
      this._item3Type = {
        name: "item3Type",
        Name: "Item3Type",
        number: 9,
        protoType: 9,
        protoName: "item3_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item3Type;
  }
  get item3Num() {
    if (!this._item3Num) {
      this._item3Num = {
        name: "item3Num",
        Name: "Item3Num",
        number: 10,
        protoType: 5,
        protoName: "item3_num",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item3Num;
  }
  get item4Type() {
    if (!this._item4Type) {
      this._item4Type = {
        name: "item4Type",
        Name: "Item4Type",
        number: 11,
        protoType: 9,
        protoName: "item4_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item4Type;
  }
  get item4Num() {
    if (!this._item4Num) {
      this._item4Num = {
        name: "item4Num",
        Name: "Item4Num",
        number: 12,
        protoType: 5,
        protoName: "item4_num",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item4Num;
  }
  get item5Type() {
    if (!this._item5Type) {
      this._item5Type = {
        name: "item5Type",
        Name: "Item5Type",
        number: 13,
        protoType: 9,
        protoName: "item5_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item5Type;
  }
  get item5Num() {
    if (!this._item5Num) {
      this._item5Num = {
        name: "item5Num",
        Name: "Item5Num",
        number: 14,
        protoType: 5,
        protoName: "item5_num",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._item5Num;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.card,
        this.level,
        this.item1Type,
        this.item1Num,
        this.item2Type,
        this.item2Num,
        this.item3Type,
        this.item3Num,
        this.item4Type,
        this.item4Num,
        this.item5Type,
        this.item5Num,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCard",
        Name: "DummyOneofForCard",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem1Type",
        Name: "DummyOneofForItem1Type",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem1Num",
        Name: "DummyOneofForItem1Num",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem2Type",
        Name: "DummyOneofForItem2Type",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem2Num",
        Name: "DummyOneofForItem2Num",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem3Type",
        Name: "DummyOneofForItem3Type",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem3Num",
        Name: "DummyOneofForItem3Num",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem4Type",
        Name: "DummyOneofForItem4Type",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem4Num",
        Name: "DummyOneofForItem4Num",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem5Type",
        Name: "DummyOneofForItem5Type",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForItem5Num",
        Name: "DummyOneofForItem5Num",
        fields: [
          this.fields[11],
        ],
      });
    }
    return this._oneofs;
  }
}
CardAwakenCost.descriptor = new CardAwakenCost_Descriptor();
class CardSkin_SkinType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "GENERAL": return 0;
        case "EVENT": return 1;
        case "TOURNAMENT": return 2;
        case "AWAKEN": return 3;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return CardSkin_SkinType.fromJson(value);
  }
  static fromReact(e) {
    return CardSkin_SkinType.fromJson(e);
  }
}
CardSkin_SkinType.GENERAL = 0;
CardSkin_SkinType.EVENT = 1;
CardSkin_SkinType.TOURNAMENT = 2;
CardSkin_SkinType.AWAKEN = 3;
CardSkin_SkinType.default = 0;
CardSkin_SkinType.values = {
  GENERAL: 0,
  EVENT: 1,
  TOURNAMENT: 2,
  AWAKEN: 3,
};
CardSkin_SkinType.names = {
  0: "GENERAL",
  1: "EVENT",
  2: "TOURNAMENT",
  3: "AWAKEN",
};
export class CardSkin {
  get descriptor() {
    return CardSkin.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCard = false;
    this._card = null;
    this._hasSkinName = false;
    this._skinName = null;
    this._hasSkinCost = false;
    this._skinCost = null;
    this._hasSkinType = false;
    this._skinType = null;
  }
  isEmpty() {
    if (this._hasCard) return false;
    if (this._hasSkinName) return false;
    if (this._hasSkinCost && !this._skinCost.isEmpty()) return false;
    if (this._hasSkinType) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkin) {
      return value;
    }
    return CardSkin.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkin();
    if (json.card != null) {
      result._hasCard = true;
      result._card = JsonToString.fromJson(json.card);
    }
    if (json.skinName != null) {
      result._hasSkinName = true;
      result._skinName = JsonToString.fromJson(json.skinName);
    }
    if (json.skinCost != null) {
      result._hasSkinCost = true;
      result._skinCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromJson(json.skinCost);
    }
    if (json.skinType != null) {
      result._hasSkinType = true;
      result._skinType = CardSkin_SkinType.fromJson(json.skinType);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCard) {
      result.card = JsonToString.toJson(this._card);
    }
    if (this._hasSkinName) {
      result.skinName = JsonToString.toJson(this._skinName);
    }
    if (this._hasSkinCost && !this._skinCost.isEmpty()) {
      result.skinCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.toJson(this._skinCost);
    }
    if (this._hasSkinType) {
      result.skinType = CardSkin_SkinType.toJson(this._skinType);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get card() {
    return this._hasCard ? this._card : JsonToString.default;
  }
  get hasCard() {
    return this._hasCard;
  }
  setCard(path, value) {
    return {type: 'SET', path: path.concat(['card']), value};
  }
  deleteCard(path) {
    return {type: 'DELETE', path: path.concat(['card'])};
  }
  /**
   * @returns {string}
   */
  get skinName() {
    return this._hasSkinName ? this._skinName : JsonToString.default;
  }
  get hasSkinName() {
    return this._hasSkinName;
  }
  setSkinName(path, value) {
    return {type: 'SET', path: path.concat(['skinName']), value};
  }
  deleteSkinName(path) {
    return {type: 'DELETE', path: path.concat(['skinName'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair}
   */
  get skinCost() {
    return this._hasSkinCost ? this._skinCost : dcei_wildsky_common_proto.InventoryItemKeyValuePair.default;
  }
  get hasSkinCost() {
    return this._hasSkinCost;
  }
  setSkinCost(path, value) {
    return {type: 'SET', path: path.concat(['skinCost']), value: value.toJson()};
  }
  deleteSkinCost(path) {
    return {type: 'DELETE', path: path.concat(['skinCost'])};
  }
  /**
   * @returns {number}
   */
  get skinType() {
    return this._hasSkinType ? this._skinType : CardSkin_SkinType.default;
  }
  get hasSkinType() {
    return this._hasSkinType;
  }
  setSkinType(path, value) {
    return {type: 'SET', path: path.concat(['skinType']), value};
  }
  deleteSkinType(path) {
    return {type: 'DELETE', path: path.concat(['skinType'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "card": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkin(this);
              copy._hasCard = true;
              copy._card = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCard) {
                return this;
              }
              const copy = new CardSkin(this);
              copy._hasCard = false;
              copy._card = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkin(this);
              copy._hasSkinName = true;
              copy._skinName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinName) {
                return this;
              }
              const copy = new CardSkin(this);
              copy._hasSkinName = false;
              copy._skinName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkin(this);
              copy._hasSkinCost = true;
              copy._skinCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinCost) {
                return this;
              }
              const copy = new CardSkin(this);
              copy._hasSkinCost = false;
              copy._skinCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasSkinCost) {
            const copy = new CardSkin(this);
            copy._hasSkinCost = true;
            copy._skinCost = dcei_wildsky_common_proto.InventoryItemKeyValuePair.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._skinCost.apply(type, path.slice(1), value);
          if (newValue === this._skinCost) {
            return this;
          }
          const copy = new CardSkin(this);
          copy._skinCost = copy._skinCost.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "skinType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkin(this);
              copy._hasSkinType = true;
              copy._skinType = CardSkin_SkinType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinType) {
                return this;
              }
              const copy = new CardSkin(this);
              copy._hasSkinType = false;
              copy._skinType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkin} other
   * @returns {CardSkin}
   */
  merge(other) {
    const copy = new CardSkin(this);
    if (other._hasCard) {
      copy._hasCard = true;
      copy._card = other._card;
    }
    if (other._hasSkinName) {
      copy._hasSkinName = true;
      copy._skinName = other._skinName;
    }
    if (other._hasSkinCost) {
      if (copy._hasSkinCost) {
        copy._skinCost = copy.skinCost.merge(other.skinCost);
      } else {
        copy._skinCost = other._skinCost;
      }
      copy._hasSkinCost = true;
    }
    if (other._hasSkinType) {
      copy._hasSkinType = true;
      copy._skinType = other._skinType;
    }
    return copy;
  }
}
CardSkin.default = new CardSkin();
CardSkin.SkinType = CardSkin_SkinType;
class CardSkin_Builder {
  constructor(value) {
    this._value = new CardSkin(value);
  }
  build() {
    return new CardSkin(this._value);
  }
  setCard(value) {
    this._value._hasCard = true;
    this._value._card = value;
    return this;
  }
  deleteCard() {
    this._value._hasCard = false;
    this._value._card = null;
    return this;
  }
  setSkinName(value) {
    this._value._hasSkinName = true;
    this._value._skinName = value;
    return this;
  }
  deleteSkinName() {
    this._value._hasSkinName = false;
    this._value._skinName = null;
    return this;
  }
  setSkinCost(value) {
    this._value._hasSkinCost = true;
    this._value._skinCost = value;
    return this;
  }
  deleteSkinCost() {
    this._value._hasSkinCost = false;
    this._value._skinCost = null;
    return this;
  }
  setSkinType(value) {
    this._value._hasSkinType = true;
    this._value._skinType = value;
    return this;
  }
  deleteSkinType() {
    this._value._hasSkinType = false;
    this._value._skinType = null;
    return this;
  }
}
CardSkin.Builder = CardSkin_Builder;
class CardSkin_WithParent {
  /**
   * @param {CardSkin} value
   * @param {CardSkin_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkin.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCard() {
    if (this._cachedHasCard === undefined) {
      if (this._value.hasCard) {
        this._cachedHasCard = true;
      } else {
        this._cachedHasCard = this._parent ? this._parent.hasCard : false;
      }
    }
    return this._cachedHasCard;
  }
  get card() {
    if (this._cachedCard === undefined) {
      if (this._value.hasCard) {
        this._cachedCard = this._value.card;
      } else {
        this._cachedCard = this._parent ? this._parent.card : this._value.card;
      }
    }
    return this._cachedCard;
  }
  get hasSkinName() {
    if (this._cachedHasSkinName === undefined) {
      if (this._value.hasSkinName) {
        this._cachedHasSkinName = true;
      } else {
        this._cachedHasSkinName = this._parent ? this._parent.hasSkinName : false;
      }
    }
    return this._cachedHasSkinName;
  }
  get skinName() {
    if (this._cachedSkinName === undefined) {
      if (this._value.hasSkinName) {
        this._cachedSkinName = this._value.skinName;
      } else {
        this._cachedSkinName = this._parent ? this._parent.skinName : this._value.skinName;
      }
    }
    return this._cachedSkinName;
  }
  get hasSkinCost() {
    if (this._cachedHasSkinCost === undefined) {
      if (this._value.hasSkinCost) {
        this._cachedHasSkinCost = true;
      } else {
        this._cachedHasSkinCost = this._parent ? this._parent.hasSkinCost : false;
      }
    }
    return this._cachedHasSkinCost;
  }
  get skinCost() {
    if (!this._cachedSkinCost) {
      if (this._value.hasSkinCost) {
        this._cachedSkinCost = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(this._value.skinCost, this._parent && this._parent.hasSkinCost ? this._parent.skinCost : null);
      } else {
        this._cachedSkinCost = this._parent ? new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(dcei_wildsky_common_proto.InventoryItemKeyValuePair.default, this._parent.skinCost) : dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent.default;
      }
    }
    return this._cachedSkinCost;
  }
  get hasSkinType() {
    if (this._cachedHasSkinType === undefined) {
      if (this._value.hasSkinType) {
        this._cachedHasSkinType = true;
      } else {
        this._cachedHasSkinType = this._parent ? this._parent.hasSkinType : false;
      }
    }
    return this._cachedHasSkinType;
  }
  get skinType() {
    if (this._cachedSkinType === undefined) {
      if (this._value.hasSkinType) {
        this._cachedSkinType = this._value.skinType;
      } else {
        this._cachedSkinType = this._parent ? this._parent.skinType : this._value.skinType;
      }
    }
    return this._cachedSkinType;
  }
  update(current, parent) {
    const result = new CardSkin_WithParent(current, parent);
    if (this._cachedSkinCost && this._value.hasSkinCost && current.hasSkinCost) {
      if (this._value.skinCost === current.skinCost && this._parent === parent) {
        result._cachedSkinCost = this._cachedSkinCost;
      } else {
        result._cachedSkinCost = this._cachedSkinCost.update(current.skinCost, parent && parent.hasSkinCost ? parent.skinCost : null);
      }
    }
    return result;
  }
}
CardSkin_WithParent.default = new CardSkin_WithParent(CardSkin.default, null);
CardSkin.WithParent = CardSkin_WithParent;
class CardSkin_Descriptor {
  get card() {
    if (!this._card) {
      this._card = {
        name: "card",
        Name: "Card",
        number: 1,
        protoType: 9,
        protoName: "card",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._card;
  }
  get skinName() {
    if (!this._skinName) {
      this._skinName = {
        name: "skinName",
        Name: "SkinName",
        number: 2,
        protoType: 9,
        protoName: "skin_name",
        type: JsonToString,
        options: {
          valueDropdown: "SkinNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinName;
  }
  get skinCost() {
    if (!this._skinCost) {
      this._skinCost = {
        name: "skinCost",
        Name: "SkinCost",
        number: 3,
        protoType: 11,
        protoName: "skin_cost",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinCost;
  }
  get skinType() {
    if (!this._skinType) {
      this._skinType = {
        name: "skinType",
        Name: "SkinType",
        number: 4,
        protoType: 14,
        protoName: "skin_type",
        type: CardSkin_SkinType,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinType;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.card,
        this.skinName,
        this.skinCost,
        this.skinType,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCard",
        Name: "DummyOneofForCard",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinName",
        Name: "DummyOneofForSkinName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinCost",
        Name: "DummyOneofForSkinCost",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinType",
        Name: "DummyOneofForSkinType",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkin.descriptor = new CardSkin_Descriptor();
export class XpStoneSetting {
  get descriptor() {
    return XpStoneSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasXpStoneType = false;
    this._xpStoneType = null;
    this._hasXpGains = false;
    this._xpGains = null;
  }
  isEmpty() {
    if (this._hasXpStoneType) return false;
    if (this._hasXpGains) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof XpStoneSetting) {
      return value;
    }
    return XpStoneSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new XpStoneSetting();
    if (json.xpStoneType != null) {
      result._hasXpStoneType = true;
      result._xpStoneType = JsonToString.fromJson(json.xpStoneType);
    }
    if (json.xpGains != null) {
      result._hasXpGains = true;
      result._xpGains = JsonToInt32.fromJson(json.xpGains);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasXpStoneType) {
      result.xpStoneType = JsonToString.toJson(this._xpStoneType);
    }
    if (this._hasXpGains) {
      result.xpGains = JsonToInt32.toJson(this._xpGains);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get xpStoneType() {
    return this._hasXpStoneType ? this._xpStoneType : JsonToString.default;
  }
  get hasXpStoneType() {
    return this._hasXpStoneType;
  }
  setXpStoneType(path, value) {
    return {type: 'SET', path: path.concat(['xpStoneType']), value};
  }
  deleteXpStoneType(path) {
    return {type: 'DELETE', path: path.concat(['xpStoneType'])};
  }
  /**
   * @returns {number}
   */
  get xpGains() {
    return this._hasXpGains ? this._xpGains : JsonToInt32.default;
  }
  get hasXpGains() {
    return this._hasXpGains;
  }
  setXpGains(path, value) {
    return {type: 'SET', path: path.concat(['xpGains']), value};
  }
  deleteXpGains(path) {
    return {type: 'DELETE', path: path.concat(['xpGains'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "xpStoneType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new XpStoneSetting(this);
              copy._hasXpStoneType = true;
              copy._xpStoneType = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXpStoneType) {
                return this;
              }
              const copy = new XpStoneSetting(this);
              copy._hasXpStoneType = false;
              copy._xpStoneType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "xpGains": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new XpStoneSetting(this);
              copy._hasXpGains = true;
              copy._xpGains = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasXpGains) {
                return this;
              }
              const copy = new XpStoneSetting(this);
              copy._hasXpGains = false;
              copy._xpGains = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {XpStoneSetting} other
   * @returns {XpStoneSetting}
   */
  merge(other) {
    const copy = new XpStoneSetting(this);
    if (other._hasXpStoneType) {
      copy._hasXpStoneType = true;
      copy._xpStoneType = other._xpStoneType;
    }
    if (other._hasXpGains) {
      copy._hasXpGains = true;
      copy._xpGains = other._xpGains;
    }
    return copy;
  }
}
XpStoneSetting.default = new XpStoneSetting();
class XpStoneSetting_Builder {
  constructor(value) {
    this._value = new XpStoneSetting(value);
  }
  build() {
    return new XpStoneSetting(this._value);
  }
  setXpStoneType(value) {
    this._value._hasXpStoneType = true;
    this._value._xpStoneType = value;
    return this;
  }
  deleteXpStoneType() {
    this._value._hasXpStoneType = false;
    this._value._xpStoneType = null;
    return this;
  }
  setXpGains(value) {
    this._value._hasXpGains = true;
    this._value._xpGains = value;
    return this;
  }
  deleteXpGains() {
    this._value._hasXpGains = false;
    this._value._xpGains = null;
    return this;
  }
}
XpStoneSetting.Builder = XpStoneSetting_Builder;
class XpStoneSetting_WithParent {
  /**
   * @param {XpStoneSetting} value
   * @param {XpStoneSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return XpStoneSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasXpStoneType() {
    if (this._cachedHasXpStoneType === undefined) {
      if (this._value.hasXpStoneType) {
        this._cachedHasXpStoneType = true;
      } else {
        this._cachedHasXpStoneType = this._parent ? this._parent.hasXpStoneType : false;
      }
    }
    return this._cachedHasXpStoneType;
  }
  get xpStoneType() {
    if (this._cachedXpStoneType === undefined) {
      if (this._value.hasXpStoneType) {
        this._cachedXpStoneType = this._value.xpStoneType;
      } else {
        this._cachedXpStoneType = this._parent ? this._parent.xpStoneType : this._value.xpStoneType;
      }
    }
    return this._cachedXpStoneType;
  }
  get hasXpGains() {
    if (this._cachedHasXpGains === undefined) {
      if (this._value.hasXpGains) {
        this._cachedHasXpGains = true;
      } else {
        this._cachedHasXpGains = this._parent ? this._parent.hasXpGains : false;
      }
    }
    return this._cachedHasXpGains;
  }
  get xpGains() {
    if (this._cachedXpGains === undefined) {
      if (this._value.hasXpGains) {
        this._cachedXpGains = this._value.xpGains;
      } else {
        this._cachedXpGains = this._parent ? this._parent.xpGains : this._value.xpGains;
      }
    }
    return this._cachedXpGains;
  }
  update(current, parent) {
    const result = new XpStoneSetting_WithParent(current, parent);
    return result;
  }
}
XpStoneSetting_WithParent.default = new XpStoneSetting_WithParent(XpStoneSetting.default, null);
XpStoneSetting.WithParent = XpStoneSetting_WithParent;
class XpStoneSetting_Descriptor {
  get xpStoneType() {
    if (!this._xpStoneType) {
      this._xpStoneType = {
        name: "xpStoneType",
        Name: "XpStoneType",
        number: 1,
        protoType: 9,
        protoName: "xp_stone_type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xpStoneType;
  }
  get xpGains() {
    if (!this._xpGains) {
      this._xpGains = {
        name: "xpGains",
        Name: "XpGains",
        number: 2,
        protoType: 5,
        protoName: "xp_gains",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xpGains;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.xpStoneType,
        this.xpGains,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForXpStoneType",
        Name: "DummyOneofForXpStoneType",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForXpGains",
        Name: "DummyOneofForXpGains",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
XpStoneSetting.descriptor = new XpStoneSetting_Descriptor();
export class PlayerGrowthSetting {
  get descriptor() {
    return PlayerGrowthSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPlayerLevel = false;
    this._playerLevel = null;
    this._hasPlayerExp = false;
    this._playerExp = null;
    this._hasSkillPointsCap = false;
    this._skillPointsCap = null;
  }
  isEmpty() {
    if (this._hasPlayerLevel) return false;
    if (this._hasPlayerExp) return false;
    if (this._hasSkillPointsCap) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof PlayerGrowthSetting) {
      return value;
    }
    return PlayerGrowthSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new PlayerGrowthSetting();
    if (json.playerLevel != null) {
      result._hasPlayerLevel = true;
      result._playerLevel = JsonToInt32.fromJson(json.playerLevel);
    }
    if (json.playerExp != null) {
      result._hasPlayerExp = true;
      result._playerExp = JsonToInt32.fromJson(json.playerExp);
    }
    if (json.skillPointsCap != null) {
      result._hasSkillPointsCap = true;
      result._skillPointsCap = JsonToInt32.fromJson(json.skillPointsCap);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPlayerLevel) {
      result.playerLevel = JsonToInt32.toJson(this._playerLevel);
    }
    if (this._hasPlayerExp) {
      result.playerExp = JsonToInt32.toJson(this._playerExp);
    }
    if (this._hasSkillPointsCap) {
      result.skillPointsCap = JsonToInt32.toJson(this._skillPointsCap);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get playerLevel() {
    return this._hasPlayerLevel ? this._playerLevel : JsonToInt32.default;
  }
  get hasPlayerLevel() {
    return this._hasPlayerLevel;
  }
  setPlayerLevel(path, value) {
    return {type: 'SET', path: path.concat(['playerLevel']), value};
  }
  deletePlayerLevel(path) {
    return {type: 'DELETE', path: path.concat(['playerLevel'])};
  }
  /**
   * @returns {number}
   */
  get playerExp() {
    return this._hasPlayerExp ? this._playerExp : JsonToInt32.default;
  }
  get hasPlayerExp() {
    return this._hasPlayerExp;
  }
  setPlayerExp(path, value) {
    return {type: 'SET', path: path.concat(['playerExp']), value};
  }
  deletePlayerExp(path) {
    return {type: 'DELETE', path: path.concat(['playerExp'])};
  }
  /**
   * @returns {number}
   */
  get skillPointsCap() {
    return this._hasSkillPointsCap ? this._skillPointsCap : JsonToInt32.default;
  }
  get hasSkillPointsCap() {
    return this._hasSkillPointsCap;
  }
  setSkillPointsCap(path, value) {
    return {type: 'SET', path: path.concat(['skillPointsCap']), value};
  }
  deleteSkillPointsCap(path) {
    return {type: 'DELETE', path: path.concat(['skillPointsCap'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerGrowthSetting(this);
              copy._hasPlayerLevel = true;
              copy._playerLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerLevel) {
                return this;
              }
              const copy = new PlayerGrowthSetting(this);
              copy._hasPlayerLevel = false;
              copy._playerLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "playerExp": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerGrowthSetting(this);
              copy._hasPlayerExp = true;
              copy._playerExp = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPlayerExp) {
                return this;
              }
              const copy = new PlayerGrowthSetting(this);
              copy._hasPlayerExp = false;
              copy._playerExp = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skillPointsCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new PlayerGrowthSetting(this);
              copy._hasSkillPointsCap = true;
              copy._skillPointsCap = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkillPointsCap) {
                return this;
              }
              const copy = new PlayerGrowthSetting(this);
              copy._hasSkillPointsCap = false;
              copy._skillPointsCap = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {PlayerGrowthSetting} other
   * @returns {PlayerGrowthSetting}
   */
  merge(other) {
    const copy = new PlayerGrowthSetting(this);
    if (other._hasPlayerLevel) {
      copy._hasPlayerLevel = true;
      copy._playerLevel = other._playerLevel;
    }
    if (other._hasPlayerExp) {
      copy._hasPlayerExp = true;
      copy._playerExp = other._playerExp;
    }
    if (other._hasSkillPointsCap) {
      copy._hasSkillPointsCap = true;
      copy._skillPointsCap = other._skillPointsCap;
    }
    return copy;
  }
}
PlayerGrowthSetting.default = new PlayerGrowthSetting();
class PlayerGrowthSetting_Builder {
  constructor(value) {
    this._value = new PlayerGrowthSetting(value);
  }
  build() {
    return new PlayerGrowthSetting(this._value);
  }
  setPlayerLevel(value) {
    this._value._hasPlayerLevel = true;
    this._value._playerLevel = value;
    return this;
  }
  deletePlayerLevel() {
    this._value._hasPlayerLevel = false;
    this._value._playerLevel = null;
    return this;
  }
  setPlayerExp(value) {
    this._value._hasPlayerExp = true;
    this._value._playerExp = value;
    return this;
  }
  deletePlayerExp() {
    this._value._hasPlayerExp = false;
    this._value._playerExp = null;
    return this;
  }
  setSkillPointsCap(value) {
    this._value._hasSkillPointsCap = true;
    this._value._skillPointsCap = value;
    return this;
  }
  deleteSkillPointsCap() {
    this._value._hasSkillPointsCap = false;
    this._value._skillPointsCap = null;
    return this;
  }
}
PlayerGrowthSetting.Builder = PlayerGrowthSetting_Builder;
class PlayerGrowthSetting_WithParent {
  /**
   * @param {PlayerGrowthSetting} value
   * @param {PlayerGrowthSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return PlayerGrowthSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPlayerLevel() {
    if (this._cachedHasPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedHasPlayerLevel = true;
      } else {
        this._cachedHasPlayerLevel = this._parent ? this._parent.hasPlayerLevel : false;
      }
    }
    return this._cachedHasPlayerLevel;
  }
  get playerLevel() {
    if (this._cachedPlayerLevel === undefined) {
      if (this._value.hasPlayerLevel) {
        this._cachedPlayerLevel = this._value.playerLevel;
      } else {
        this._cachedPlayerLevel = this._parent ? this._parent.playerLevel : this._value.playerLevel;
      }
    }
    return this._cachedPlayerLevel;
  }
  get hasPlayerExp() {
    if (this._cachedHasPlayerExp === undefined) {
      if (this._value.hasPlayerExp) {
        this._cachedHasPlayerExp = true;
      } else {
        this._cachedHasPlayerExp = this._parent ? this._parent.hasPlayerExp : false;
      }
    }
    return this._cachedHasPlayerExp;
  }
  get playerExp() {
    if (this._cachedPlayerExp === undefined) {
      if (this._value.hasPlayerExp) {
        this._cachedPlayerExp = this._value.playerExp;
      } else {
        this._cachedPlayerExp = this._parent ? this._parent.playerExp : this._value.playerExp;
      }
    }
    return this._cachedPlayerExp;
  }
  get hasSkillPointsCap() {
    if (this._cachedHasSkillPointsCap === undefined) {
      if (this._value.hasSkillPointsCap) {
        this._cachedHasSkillPointsCap = true;
      } else {
        this._cachedHasSkillPointsCap = this._parent ? this._parent.hasSkillPointsCap : false;
      }
    }
    return this._cachedHasSkillPointsCap;
  }
  get skillPointsCap() {
    if (this._cachedSkillPointsCap === undefined) {
      if (this._value.hasSkillPointsCap) {
        this._cachedSkillPointsCap = this._value.skillPointsCap;
      } else {
        this._cachedSkillPointsCap = this._parent ? this._parent.skillPointsCap : this._value.skillPointsCap;
      }
    }
    return this._cachedSkillPointsCap;
  }
  update(current, parent) {
    const result = new PlayerGrowthSetting_WithParent(current, parent);
    return result;
  }
}
PlayerGrowthSetting_WithParent.default = new PlayerGrowthSetting_WithParent(PlayerGrowthSetting.default, null);
PlayerGrowthSetting.WithParent = PlayerGrowthSetting_WithParent;
class PlayerGrowthSetting_Descriptor {
  get playerLevel() {
    if (!this._playerLevel) {
      this._playerLevel = {
        name: "playerLevel",
        Name: "PlayerLevel",
        number: 1,
        protoType: 5,
        protoName: "player_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerLevel;
  }
  get playerExp() {
    if (!this._playerExp) {
      this._playerExp = {
        name: "playerExp",
        Name: "PlayerExp",
        number: 2,
        protoType: 5,
        protoName: "player_exp",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerExp;
  }
  get skillPointsCap() {
    if (!this._skillPointsCap) {
      this._skillPointsCap = {
        name: "skillPointsCap",
        Name: "SkillPointsCap",
        number: 3,
        protoType: 5,
        protoName: "skill_points_cap",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillPointsCap;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerLevel,
        this.playerExp,
        this.skillPointsCap,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPlayerLevel",
        Name: "DummyOneofForPlayerLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPlayerExp",
        Name: "DummyOneofForPlayerExp",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkillPointsCap",
        Name: "DummyOneofForSkillPointsCap",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
PlayerGrowthSetting.descriptor = new PlayerGrowthSetting_Descriptor();
export class CardGrowthSetting {
  get descriptor() {
    return CardGrowthSetting.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._heroCardLevelupCost = [];
    this._towerCardLevelupCost = [];
    this._spellCardLevelupCost = [];
    this._cardLevelupCap = [];
    this._skillLevelUpCost = [];
    this._cardEvolveCost = [];
    this._cardAwakenCost = [];
    this._xpStoneSetting = [];
    this._playerGrowthSetting = [];
  }
  isEmpty() {
    if (this._heroCardLevelupCost.length > 0) return false;
    if (this._towerCardLevelupCost.length > 0) return false;
    if (this._spellCardLevelupCost.length > 0) return false;
    if (this._cardLevelupCap.length > 0) return false;
    if (this._skillLevelUpCost.length > 0) return false;
    if (this._cardEvolveCost.length > 0) return false;
    if (this._cardAwakenCost.length > 0) return false;
    if (this._xpStoneSetting.length > 0) return false;
    if (this._playerGrowthSetting.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardGrowthSetting) {
      return value;
    }
    return CardGrowthSetting.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardGrowthSetting();
    result._heroCardLevelupCost = JsonToList(json.heroCardLevelupCost, CardLevelUpCost);
    result._towerCardLevelupCost = JsonToList(json.towerCardLevelupCost, CardLevelUpCost);
    result._spellCardLevelupCost = JsonToList(json.spellCardLevelupCost, CardLevelUpCost);
    result._cardLevelupCap = JsonToList(json.cardLevelupCap, CardLevelCap);
    result._skillLevelUpCost = JsonToList(json.skillLevelUpCost, SkillLevelUpCost);
    result._cardEvolveCost = JsonToList(json.cardEvolveCost, CardEvolveCost);
    result._cardAwakenCost = JsonToList(json.cardAwakenCost, CardAwakenCost);
    result._xpStoneSetting = JsonToList(json.xpStoneSetting, XpStoneSetting);
    result._playerGrowthSetting = JsonToList(json.playerGrowthSetting, PlayerGrowthSetting);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._heroCardLevelupCost.length > 0) {
      result.heroCardLevelupCost = ArrayToJson(this._heroCardLevelupCost, CardLevelUpCost);
    }
    if (this._towerCardLevelupCost.length > 0) {
      result.towerCardLevelupCost = ArrayToJson(this._towerCardLevelupCost, CardLevelUpCost);
    }
    if (this._spellCardLevelupCost.length > 0) {
      result.spellCardLevelupCost = ArrayToJson(this._spellCardLevelupCost, CardLevelUpCost);
    }
    if (this._cardLevelupCap.length > 0) {
      result.cardLevelupCap = ArrayToJson(this._cardLevelupCap, CardLevelCap);
    }
    if (this._skillLevelUpCost.length > 0) {
      result.skillLevelUpCost = ArrayToJson(this._skillLevelUpCost, SkillLevelUpCost);
    }
    if (this._cardEvolveCost.length > 0) {
      result.cardEvolveCost = ArrayToJson(this._cardEvolveCost, CardEvolveCost);
    }
    if (this._cardAwakenCost.length > 0) {
      result.cardAwakenCost = ArrayToJson(this._cardAwakenCost, CardAwakenCost);
    }
    if (this._xpStoneSetting.length > 0) {
      result.xpStoneSetting = ArrayToJson(this._xpStoneSetting, XpStoneSetting);
    }
    if (this._playerGrowthSetting.length > 0) {
      result.playerGrowthSetting = ArrayToJson(this._playerGrowthSetting, PlayerGrowthSetting);
    }
    return result;
  }
  /**
   * @returns {CardLevelUpCost[]}
   */
  get heroCardLevelupCost() {
    return this._heroCardLevelupCost;
  }
  addHeroCardLevelupCost(path, value) {
    return {type: 'ADD', path: path.concat(['heroCardLevelupCost']), value: value.toJson()};
  }
  setHeroCardLevelupCost(path, value) {
    return {type: 'SET', path: path.concat(['heroCardLevelupCost']), value: ArrayToJson(value, CardLevelUpCost)};
  }
  setHeroCardLevelupCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['heroCardLevelupCost', key]), value: value.toJson()};
  }
  deleteHeroCardLevelupCost(path) {
    return {type: 'DELETE', path: path.concat(['heroCardLevelupCost'])};
  }
  deleteHeroCardLevelupCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['heroCardLevelupCost', key])};
  }
  /**
   * @returns {CardLevelUpCost[]}
   */
  get towerCardLevelupCost() {
    return this._towerCardLevelupCost;
  }
  addTowerCardLevelupCost(path, value) {
    return {type: 'ADD', path: path.concat(['towerCardLevelupCost']), value: value.toJson()};
  }
  setTowerCardLevelupCost(path, value) {
    return {type: 'SET', path: path.concat(['towerCardLevelupCost']), value: ArrayToJson(value, CardLevelUpCost)};
  }
  setTowerCardLevelupCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['towerCardLevelupCost', key]), value: value.toJson()};
  }
  deleteTowerCardLevelupCost(path) {
    return {type: 'DELETE', path: path.concat(['towerCardLevelupCost'])};
  }
  deleteTowerCardLevelupCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['towerCardLevelupCost', key])};
  }
  /**
   * @returns {CardLevelUpCost[]}
   */
  get spellCardLevelupCost() {
    return this._spellCardLevelupCost;
  }
  addSpellCardLevelupCost(path, value) {
    return {type: 'ADD', path: path.concat(['spellCardLevelupCost']), value: value.toJson()};
  }
  setSpellCardLevelupCost(path, value) {
    return {type: 'SET', path: path.concat(['spellCardLevelupCost']), value: ArrayToJson(value, CardLevelUpCost)};
  }
  setSpellCardLevelupCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['spellCardLevelupCost', key]), value: value.toJson()};
  }
  deleteSpellCardLevelupCost(path) {
    return {type: 'DELETE', path: path.concat(['spellCardLevelupCost'])};
  }
  deleteSpellCardLevelupCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['spellCardLevelupCost', key])};
  }
  /**
   * @returns {CardLevelCap[]}
   */
  get cardLevelupCap() {
    return this._cardLevelupCap;
  }
  addCardLevelupCap(path, value) {
    return {type: 'ADD', path: path.concat(['cardLevelupCap']), value: value.toJson()};
  }
  setCardLevelupCap(path, value) {
    return {type: 'SET', path: path.concat(['cardLevelupCap']), value: ArrayToJson(value, CardLevelCap)};
  }
  setCardLevelupCapByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardLevelupCap', key]), value: value.toJson()};
  }
  deleteCardLevelupCap(path) {
    return {type: 'DELETE', path: path.concat(['cardLevelupCap'])};
  }
  deleteCardLevelupCapByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardLevelupCap', key])};
  }
  /**
   * @returns {SkillLevelUpCost[]}
   */
  get skillLevelUpCost() {
    return this._skillLevelUpCost;
  }
  addSkillLevelUpCost(path, value) {
    return {type: 'ADD', path: path.concat(['skillLevelUpCost']), value: value.toJson()};
  }
  setSkillLevelUpCost(path, value) {
    return {type: 'SET', path: path.concat(['skillLevelUpCost']), value: ArrayToJson(value, SkillLevelUpCost)};
  }
  setSkillLevelUpCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skillLevelUpCost', key]), value: value.toJson()};
  }
  deleteSkillLevelUpCost(path) {
    return {type: 'DELETE', path: path.concat(['skillLevelUpCost'])};
  }
  deleteSkillLevelUpCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skillLevelUpCost', key])};
  }
  /**
   * @returns {CardEvolveCost[]}
   */
  get cardEvolveCost() {
    return this._cardEvolveCost;
  }
  addCardEvolveCost(path, value) {
    return {type: 'ADD', path: path.concat(['cardEvolveCost']), value: value.toJson()};
  }
  setCardEvolveCost(path, value) {
    return {type: 'SET', path: path.concat(['cardEvolveCost']), value: ArrayToJson(value, CardEvolveCost)};
  }
  setCardEvolveCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardEvolveCost', key]), value: value.toJson()};
  }
  deleteCardEvolveCost(path) {
    return {type: 'DELETE', path: path.concat(['cardEvolveCost'])};
  }
  deleteCardEvolveCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardEvolveCost', key])};
  }
  /**
   * @returns {CardAwakenCost[]}
   */
  get cardAwakenCost() {
    return this._cardAwakenCost;
  }
  addCardAwakenCost(path, value) {
    return {type: 'ADD', path: path.concat(['cardAwakenCost']), value: value.toJson()};
  }
  setCardAwakenCost(path, value) {
    return {type: 'SET', path: path.concat(['cardAwakenCost']), value: ArrayToJson(value, CardAwakenCost)};
  }
  setCardAwakenCostByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardAwakenCost', key]), value: value.toJson()};
  }
  deleteCardAwakenCost(path) {
    return {type: 'DELETE', path: path.concat(['cardAwakenCost'])};
  }
  deleteCardAwakenCostByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardAwakenCost', key])};
  }
  /**
   * @returns {XpStoneSetting[]}
   */
  get xpStoneSetting() {
    return this._xpStoneSetting;
  }
  addXpStoneSetting(path, value) {
    return {type: 'ADD', path: path.concat(['xpStoneSetting']), value: value.toJson()};
  }
  setXpStoneSetting(path, value) {
    return {type: 'SET', path: path.concat(['xpStoneSetting']), value: ArrayToJson(value, XpStoneSetting)};
  }
  setXpStoneSettingByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['xpStoneSetting', key]), value: value.toJson()};
  }
  deleteXpStoneSetting(path) {
    return {type: 'DELETE', path: path.concat(['xpStoneSetting'])};
  }
  deleteXpStoneSettingByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['xpStoneSetting', key])};
  }
  /**
   * @returns {PlayerGrowthSetting[]}
   */
  get playerGrowthSetting() {
    return this._playerGrowthSetting;
  }
  addPlayerGrowthSetting(path, value) {
    return {type: 'ADD', path: path.concat(['playerGrowthSetting']), value: value.toJson()};
  }
  setPlayerGrowthSetting(path, value) {
    return {type: 'SET', path: path.concat(['playerGrowthSetting']), value: ArrayToJson(value, PlayerGrowthSetting)};
  }
  setPlayerGrowthSettingByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['playerGrowthSetting', key]), value: value.toJson()};
  }
  deletePlayerGrowthSetting(path) {
    return {type: 'DELETE', path: path.concat(['playerGrowthSetting'])};
  }
  deletePlayerGrowthSettingByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['playerGrowthSetting', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "heroCardLevelupCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._heroCardLevelupCost = [];        for (let i of value) {
                copy._heroCardLevelupCost.push(CardLevelUpCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._heroCardLevelupCost = copy._heroCardLevelupCost.concat([CardLevelUpCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._heroCardLevelupCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._heroCardLevelupCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._heroCardLevelupCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._heroCardLevelupCost = copy._heroCardLevelupCost.slice();
              copy._heroCardLevelupCost[path[1]] = CardLevelUpCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._heroCardLevelupCost = copy._heroCardLevelupCost.slice(0, path[1]).concat(copy._heroCardLevelupCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._heroCardLevelupCost.length) {
            return this;
          }
          const oldValue = this._heroCardLevelupCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._heroCardLevelupCost = copy._heroCardLevelupCost.slice();
          copy._heroCardLevelupCost[key] = newValue;
          return copy;
        }
      }
      case "towerCardLevelupCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._towerCardLevelupCost = [];        for (let i of value) {
                copy._towerCardLevelupCost.push(CardLevelUpCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._towerCardLevelupCost = copy._towerCardLevelupCost.concat([CardLevelUpCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._towerCardLevelupCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._towerCardLevelupCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._towerCardLevelupCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._towerCardLevelupCost = copy._towerCardLevelupCost.slice();
              copy._towerCardLevelupCost[path[1]] = CardLevelUpCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._towerCardLevelupCost = copy._towerCardLevelupCost.slice(0, path[1]).concat(copy._towerCardLevelupCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._towerCardLevelupCost.length) {
            return this;
          }
          const oldValue = this._towerCardLevelupCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._towerCardLevelupCost = copy._towerCardLevelupCost.slice();
          copy._towerCardLevelupCost[key] = newValue;
          return copy;
        }
      }
      case "spellCardLevelupCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._spellCardLevelupCost = [];        for (let i of value) {
                copy._spellCardLevelupCost.push(CardLevelUpCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._spellCardLevelupCost = copy._spellCardLevelupCost.concat([CardLevelUpCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._spellCardLevelupCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._spellCardLevelupCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._spellCardLevelupCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._spellCardLevelupCost = copy._spellCardLevelupCost.slice();
              copy._spellCardLevelupCost[path[1]] = CardLevelUpCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._spellCardLevelupCost = copy._spellCardLevelupCost.slice(0, path[1]).concat(copy._spellCardLevelupCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._spellCardLevelupCost.length) {
            return this;
          }
          const oldValue = this._spellCardLevelupCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._spellCardLevelupCost = copy._spellCardLevelupCost.slice();
          copy._spellCardLevelupCost[key] = newValue;
          return copy;
        }
      }
      case "cardLevelupCap": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardLevelupCap = [];        for (let i of value) {
                copy._cardLevelupCap.push(CardLevelCap.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._cardLevelupCap = copy._cardLevelupCap.concat([CardLevelCap.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardLevelupCap.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._cardLevelupCap = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardLevelupCap.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardLevelupCap = copy._cardLevelupCap.slice();
              copy._cardLevelupCap[path[1]] = CardLevelCap.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._cardLevelupCap = copy._cardLevelupCap.slice(0, path[1]).concat(copy._cardLevelupCap.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardLevelupCap.length) {
            return this;
          }
          const oldValue = this._cardLevelupCap[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._cardLevelupCap = copy._cardLevelupCap.slice();
          copy._cardLevelupCap[key] = newValue;
          return copy;
        }
      }
      case "skillLevelUpCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._skillLevelUpCost = [];        for (let i of value) {
                copy._skillLevelUpCost.push(SkillLevelUpCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._skillLevelUpCost = copy._skillLevelUpCost.concat([SkillLevelUpCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skillLevelUpCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._skillLevelUpCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skillLevelUpCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._skillLevelUpCost = copy._skillLevelUpCost.slice();
              copy._skillLevelUpCost[path[1]] = SkillLevelUpCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._skillLevelUpCost = copy._skillLevelUpCost.slice(0, path[1]).concat(copy._skillLevelUpCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skillLevelUpCost.length) {
            return this;
          }
          const oldValue = this._skillLevelUpCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._skillLevelUpCost = copy._skillLevelUpCost.slice();
          copy._skillLevelUpCost[key] = newValue;
          return copy;
        }
      }
      case "cardEvolveCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardEvolveCost = [];        for (let i of value) {
                copy._cardEvolveCost.push(CardEvolveCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._cardEvolveCost = copy._cardEvolveCost.concat([CardEvolveCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardEvolveCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._cardEvolveCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardEvolveCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardEvolveCost = copy._cardEvolveCost.slice();
              copy._cardEvolveCost[path[1]] = CardEvolveCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._cardEvolveCost = copy._cardEvolveCost.slice(0, path[1]).concat(copy._cardEvolveCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardEvolveCost.length) {
            return this;
          }
          const oldValue = this._cardEvolveCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._cardEvolveCost = copy._cardEvolveCost.slice();
          copy._cardEvolveCost[key] = newValue;
          return copy;
        }
      }
      case "cardAwakenCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardAwakenCost = [];        for (let i of value) {
                copy._cardAwakenCost.push(CardAwakenCost.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._cardAwakenCost = copy._cardAwakenCost.concat([CardAwakenCost.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardAwakenCost.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._cardAwakenCost = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardAwakenCost.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._cardAwakenCost = copy._cardAwakenCost.slice();
              copy._cardAwakenCost[path[1]] = CardAwakenCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._cardAwakenCost = copy._cardAwakenCost.slice(0, path[1]).concat(copy._cardAwakenCost.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardAwakenCost.length) {
            return this;
          }
          const oldValue = this._cardAwakenCost[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._cardAwakenCost = copy._cardAwakenCost.slice();
          copy._cardAwakenCost[key] = newValue;
          return copy;
        }
      }
      case "xpStoneSetting": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._xpStoneSetting = [];        for (let i of value) {
                copy._xpStoneSetting.push(XpStoneSetting.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._xpStoneSetting = copy._xpStoneSetting.concat([XpStoneSetting.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._xpStoneSetting.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._xpStoneSetting = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._xpStoneSetting.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._xpStoneSetting = copy._xpStoneSetting.slice();
              copy._xpStoneSetting[path[1]] = XpStoneSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._xpStoneSetting = copy._xpStoneSetting.slice(0, path[1]).concat(copy._xpStoneSetting.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._xpStoneSetting.length) {
            return this;
          }
          const oldValue = this._xpStoneSetting[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._xpStoneSetting = copy._xpStoneSetting.slice();
          copy._xpStoneSetting[key] = newValue;
          return copy;
        }
      }
      case "playerGrowthSetting": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._playerGrowthSetting = [];        for (let i of value) {
                copy._playerGrowthSetting.push(PlayerGrowthSetting.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardGrowthSetting(this);
              copy._playerGrowthSetting = copy._playerGrowthSetting.concat([PlayerGrowthSetting.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._playerGrowthSetting.length === 0) {
                return this;
              }
              const copy = new CardGrowthSetting(this);
              copy._playerGrowthSetting = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._playerGrowthSetting.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardGrowthSetting(this);
              copy._playerGrowthSetting = copy._playerGrowthSetting.slice();
              copy._playerGrowthSetting[path[1]] = PlayerGrowthSetting.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardGrowthSetting(this);
              copy._playerGrowthSetting = copy._playerGrowthSetting.slice(0, path[1]).concat(copy._playerGrowthSetting.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._playerGrowthSetting.length) {
            return this;
          }
          const oldValue = this._playerGrowthSetting[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardGrowthSetting(this);
          copy._playerGrowthSetting = copy._playerGrowthSetting.slice();
          copy._playerGrowthSetting[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardGrowthSetting} other
   * @returns {CardGrowthSetting}
   */
  merge(other) {
    const copy = new CardGrowthSetting(this);
    copy._heroCardLevelupCost = this._heroCardLevelupCost.concat(other._heroCardLevelupCost);
    copy._towerCardLevelupCost = this._towerCardLevelupCost.concat(other._towerCardLevelupCost);
    copy._spellCardLevelupCost = this._spellCardLevelupCost.concat(other._spellCardLevelupCost);
    copy._cardLevelupCap = this._cardLevelupCap.concat(other._cardLevelupCap);
    copy._skillLevelUpCost = this._skillLevelUpCost.concat(other._skillLevelUpCost);
    copy._cardEvolveCost = this._cardEvolveCost.concat(other._cardEvolveCost);
    copy._cardAwakenCost = this._cardAwakenCost.concat(other._cardAwakenCost);
    copy._xpStoneSetting = this._xpStoneSetting.concat(other._xpStoneSetting);
    copy._playerGrowthSetting = this._playerGrowthSetting.concat(other._playerGrowthSetting);
    return copy;
  }
}
CardGrowthSetting.default = new CardGrowthSetting();
class CardGrowthSetting_Builder {
  constructor(value) {
    this._value = new CardGrowthSetting(value);
  }
  build() {
    return new CardGrowthSetting(this._value);
  }
  addAllHeroCardLevelupCost(values) {
    this._value._heroCardLevelupCost = this._value._heroCardLevelupCost.concat(values);
    return this;
  }
  addHeroCardLevelupCost(value) {
    this._value._heroCardLevelupCost = this._value._heroCardLevelupCost.concat([value]);
    return this;
  }
  setHeroCardLevelupCost(index, value) {
    this._value._heroCardLevelupCost = this._value._heroCardLevelupCost.concat();
    this._value._heroCardLevelupCost[index] = value;
    return this;
  }
  clearHeroCardLevelupCost() {
    this._value._heroCardLevelupCost = [];
    return this;
  }
  addAllTowerCardLevelupCost(values) {
    this._value._towerCardLevelupCost = this._value._towerCardLevelupCost.concat(values);
    return this;
  }
  addTowerCardLevelupCost(value) {
    this._value._towerCardLevelupCost = this._value._towerCardLevelupCost.concat([value]);
    return this;
  }
  setTowerCardLevelupCost(index, value) {
    this._value._towerCardLevelupCost = this._value._towerCardLevelupCost.concat();
    this._value._towerCardLevelupCost[index] = value;
    return this;
  }
  clearTowerCardLevelupCost() {
    this._value._towerCardLevelupCost = [];
    return this;
  }
  addAllSpellCardLevelupCost(values) {
    this._value._spellCardLevelupCost = this._value._spellCardLevelupCost.concat(values);
    return this;
  }
  addSpellCardLevelupCost(value) {
    this._value._spellCardLevelupCost = this._value._spellCardLevelupCost.concat([value]);
    return this;
  }
  setSpellCardLevelupCost(index, value) {
    this._value._spellCardLevelupCost = this._value._spellCardLevelupCost.concat();
    this._value._spellCardLevelupCost[index] = value;
    return this;
  }
  clearSpellCardLevelupCost() {
    this._value._spellCardLevelupCost = [];
    return this;
  }
  addAllCardLevelupCap(values) {
    this._value._cardLevelupCap = this._value._cardLevelupCap.concat(values);
    return this;
  }
  addCardLevelupCap(value) {
    this._value._cardLevelupCap = this._value._cardLevelupCap.concat([value]);
    return this;
  }
  setCardLevelupCap(index, value) {
    this._value._cardLevelupCap = this._value._cardLevelupCap.concat();
    this._value._cardLevelupCap[index] = value;
    return this;
  }
  clearCardLevelupCap() {
    this._value._cardLevelupCap = [];
    return this;
  }
  addAllSkillLevelUpCost(values) {
    this._value._skillLevelUpCost = this._value._skillLevelUpCost.concat(values);
    return this;
  }
  addSkillLevelUpCost(value) {
    this._value._skillLevelUpCost = this._value._skillLevelUpCost.concat([value]);
    return this;
  }
  setSkillLevelUpCost(index, value) {
    this._value._skillLevelUpCost = this._value._skillLevelUpCost.concat();
    this._value._skillLevelUpCost[index] = value;
    return this;
  }
  clearSkillLevelUpCost() {
    this._value._skillLevelUpCost = [];
    return this;
  }
  addAllCardEvolveCost(values) {
    this._value._cardEvolveCost = this._value._cardEvolveCost.concat(values);
    return this;
  }
  addCardEvolveCost(value) {
    this._value._cardEvolveCost = this._value._cardEvolveCost.concat([value]);
    return this;
  }
  setCardEvolveCost(index, value) {
    this._value._cardEvolveCost = this._value._cardEvolveCost.concat();
    this._value._cardEvolveCost[index] = value;
    return this;
  }
  clearCardEvolveCost() {
    this._value._cardEvolveCost = [];
    return this;
  }
  addAllCardAwakenCost(values) {
    this._value._cardAwakenCost = this._value._cardAwakenCost.concat(values);
    return this;
  }
  addCardAwakenCost(value) {
    this._value._cardAwakenCost = this._value._cardAwakenCost.concat([value]);
    return this;
  }
  setCardAwakenCost(index, value) {
    this._value._cardAwakenCost = this._value._cardAwakenCost.concat();
    this._value._cardAwakenCost[index] = value;
    return this;
  }
  clearCardAwakenCost() {
    this._value._cardAwakenCost = [];
    return this;
  }
  addAllXpStoneSetting(values) {
    this._value._xpStoneSetting = this._value._xpStoneSetting.concat(values);
    return this;
  }
  addXpStoneSetting(value) {
    this._value._xpStoneSetting = this._value._xpStoneSetting.concat([value]);
    return this;
  }
  setXpStoneSetting(index, value) {
    this._value._xpStoneSetting = this._value._xpStoneSetting.concat();
    this._value._xpStoneSetting[index] = value;
    return this;
  }
  clearXpStoneSetting() {
    this._value._xpStoneSetting = [];
    return this;
  }
  addAllPlayerGrowthSetting(values) {
    this._value._playerGrowthSetting = this._value._playerGrowthSetting.concat(values);
    return this;
  }
  addPlayerGrowthSetting(value) {
    this._value._playerGrowthSetting = this._value._playerGrowthSetting.concat([value]);
    return this;
  }
  setPlayerGrowthSetting(index, value) {
    this._value._playerGrowthSetting = this._value._playerGrowthSetting.concat();
    this._value._playerGrowthSetting[index] = value;
    return this;
  }
  clearPlayerGrowthSetting() {
    this._value._playerGrowthSetting = [];
    return this;
  }
}
CardGrowthSetting.Builder = CardGrowthSetting_Builder;
class CardGrowthSetting_WithParent {
  /**
   * @param {CardGrowthSetting} value
   * @param {CardGrowthSetting_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardGrowthSetting.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfHeroCardLevelupCost() {
    if (!this._selfHeroCardLevelupCost) {
      this._selfHeroCardLevelupCost = [];
      for (let i of this._value.heroCardLevelupCost) {
        this._selfHeroCardLevelupCost.push(new CardLevelUpCost.WithParent(i, null));
      }
    }
    return this._selfHeroCardLevelupCost;
  }
  get inherentHeroCardLevelupCost() {
    if (!this._inherentHeroCardLevelupCost) {
      this._inherentHeroCardLevelupCost = this._parent ? this._parent.heroCardLevelupCost : [];
    }
    return this._inherentHeroCardLevelupCost;
  }
  get heroCardLevelupCost() {
    if (!this._allHeroCardLevelupCost) {
      this._allHeroCardLevelupCost = this._parent ? this._parent.heroCardLevelupCost.concat(this.selfHeroCardLevelupCost) : this.selfHeroCardLevelupCost;
    }
    return this._allHeroCardLevelupCost;
  }
  get selfTowerCardLevelupCost() {
    if (!this._selfTowerCardLevelupCost) {
      this._selfTowerCardLevelupCost = [];
      for (let i of this._value.towerCardLevelupCost) {
        this._selfTowerCardLevelupCost.push(new CardLevelUpCost.WithParent(i, null));
      }
    }
    return this._selfTowerCardLevelupCost;
  }
  get inherentTowerCardLevelupCost() {
    if (!this._inherentTowerCardLevelupCost) {
      this._inherentTowerCardLevelupCost = this._parent ? this._parent.towerCardLevelupCost : [];
    }
    return this._inherentTowerCardLevelupCost;
  }
  get towerCardLevelupCost() {
    if (!this._allTowerCardLevelupCost) {
      this._allTowerCardLevelupCost = this._parent ? this._parent.towerCardLevelupCost.concat(this.selfTowerCardLevelupCost) : this.selfTowerCardLevelupCost;
    }
    return this._allTowerCardLevelupCost;
  }
  get selfSpellCardLevelupCost() {
    if (!this._selfSpellCardLevelupCost) {
      this._selfSpellCardLevelupCost = [];
      for (let i of this._value.spellCardLevelupCost) {
        this._selfSpellCardLevelupCost.push(new CardLevelUpCost.WithParent(i, null));
      }
    }
    return this._selfSpellCardLevelupCost;
  }
  get inherentSpellCardLevelupCost() {
    if (!this._inherentSpellCardLevelupCost) {
      this._inherentSpellCardLevelupCost = this._parent ? this._parent.spellCardLevelupCost : [];
    }
    return this._inherentSpellCardLevelupCost;
  }
  get spellCardLevelupCost() {
    if (!this._allSpellCardLevelupCost) {
      this._allSpellCardLevelupCost = this._parent ? this._parent.spellCardLevelupCost.concat(this.selfSpellCardLevelupCost) : this.selfSpellCardLevelupCost;
    }
    return this._allSpellCardLevelupCost;
  }
  get selfCardLevelupCap() {
    if (!this._selfCardLevelupCap) {
      this._selfCardLevelupCap = [];
      for (let i of this._value.cardLevelupCap) {
        this._selfCardLevelupCap.push(new CardLevelCap.WithParent(i, null));
      }
    }
    return this._selfCardLevelupCap;
  }
  get inherentCardLevelupCap() {
    if (!this._inherentCardLevelupCap) {
      this._inherentCardLevelupCap = this._parent ? this._parent.cardLevelupCap : [];
    }
    return this._inherentCardLevelupCap;
  }
  get cardLevelupCap() {
    if (!this._allCardLevelupCap) {
      this._allCardLevelupCap = this._parent ? this._parent.cardLevelupCap.concat(this.selfCardLevelupCap) : this.selfCardLevelupCap;
    }
    return this._allCardLevelupCap;
  }
  get selfSkillLevelUpCost() {
    if (!this._selfSkillLevelUpCost) {
      this._selfSkillLevelUpCost = [];
      for (let i of this._value.skillLevelUpCost) {
        this._selfSkillLevelUpCost.push(new SkillLevelUpCost.WithParent(i, null));
      }
    }
    return this._selfSkillLevelUpCost;
  }
  get inherentSkillLevelUpCost() {
    if (!this._inherentSkillLevelUpCost) {
      this._inherentSkillLevelUpCost = this._parent ? this._parent.skillLevelUpCost : [];
    }
    return this._inherentSkillLevelUpCost;
  }
  get skillLevelUpCost() {
    if (!this._allSkillLevelUpCost) {
      this._allSkillLevelUpCost = this._parent ? this._parent.skillLevelUpCost.concat(this.selfSkillLevelUpCost) : this.selfSkillLevelUpCost;
    }
    return this._allSkillLevelUpCost;
  }
  get selfCardEvolveCost() {
    if (!this._selfCardEvolveCost) {
      this._selfCardEvolveCost = [];
      for (let i of this._value.cardEvolveCost) {
        this._selfCardEvolveCost.push(new CardEvolveCost.WithParent(i, null));
      }
    }
    return this._selfCardEvolveCost;
  }
  get inherentCardEvolveCost() {
    if (!this._inherentCardEvolveCost) {
      this._inherentCardEvolveCost = this._parent ? this._parent.cardEvolveCost : [];
    }
    return this._inherentCardEvolveCost;
  }
  get cardEvolveCost() {
    if (!this._allCardEvolveCost) {
      this._allCardEvolveCost = this._parent ? this._parent.cardEvolveCost.concat(this.selfCardEvolveCost) : this.selfCardEvolveCost;
    }
    return this._allCardEvolveCost;
  }
  get selfCardAwakenCost() {
    if (!this._selfCardAwakenCost) {
      this._selfCardAwakenCost = [];
      for (let i of this._value.cardAwakenCost) {
        this._selfCardAwakenCost.push(new CardAwakenCost.WithParent(i, null));
      }
    }
    return this._selfCardAwakenCost;
  }
  get inherentCardAwakenCost() {
    if (!this._inherentCardAwakenCost) {
      this._inherentCardAwakenCost = this._parent ? this._parent.cardAwakenCost : [];
    }
    return this._inherentCardAwakenCost;
  }
  get cardAwakenCost() {
    if (!this._allCardAwakenCost) {
      this._allCardAwakenCost = this._parent ? this._parent.cardAwakenCost.concat(this.selfCardAwakenCost) : this.selfCardAwakenCost;
    }
    return this._allCardAwakenCost;
  }
  get selfXpStoneSetting() {
    if (!this._selfXpStoneSetting) {
      this._selfXpStoneSetting = [];
      for (let i of this._value.xpStoneSetting) {
        this._selfXpStoneSetting.push(new XpStoneSetting.WithParent(i, null));
      }
    }
    return this._selfXpStoneSetting;
  }
  get inherentXpStoneSetting() {
    if (!this._inherentXpStoneSetting) {
      this._inherentXpStoneSetting = this._parent ? this._parent.xpStoneSetting : [];
    }
    return this._inherentXpStoneSetting;
  }
  get xpStoneSetting() {
    if (!this._allXpStoneSetting) {
      this._allXpStoneSetting = this._parent ? this._parent.xpStoneSetting.concat(this.selfXpStoneSetting) : this.selfXpStoneSetting;
    }
    return this._allXpStoneSetting;
  }
  get selfPlayerGrowthSetting() {
    if (!this._selfPlayerGrowthSetting) {
      this._selfPlayerGrowthSetting = [];
      for (let i of this._value.playerGrowthSetting) {
        this._selfPlayerGrowthSetting.push(new PlayerGrowthSetting.WithParent(i, null));
      }
    }
    return this._selfPlayerGrowthSetting;
  }
  get inherentPlayerGrowthSetting() {
    if (!this._inherentPlayerGrowthSetting) {
      this._inherentPlayerGrowthSetting = this._parent ? this._parent.playerGrowthSetting : [];
    }
    return this._inherentPlayerGrowthSetting;
  }
  get playerGrowthSetting() {
    if (!this._allPlayerGrowthSetting) {
      this._allPlayerGrowthSetting = this._parent ? this._parent.playerGrowthSetting.concat(this.selfPlayerGrowthSetting) : this.selfPlayerGrowthSetting;
    }
    return this._allPlayerGrowthSetting;
  }
  update(current, parent) {
    const result = new CardGrowthSetting_WithParent(current, parent);
    if (this._selfHeroCardLevelupCost) {
      if (this._value.heroCardLevelupCost === current.heroCardLevelupCost) {
        result._selfHeroCardLevelupCost = this._selfHeroCardLevelupCost;
      } else {
        result._selfHeroCardLevelupCost = [];
        for (let i = 0; i < current.heroCardLevelupCost.length; i++) {
          const oldValue = this._value.heroCardLevelupCost[i];
          if (oldValue) {
            const oldCache = this._selfHeroCardLevelupCost[i];
            if (oldValue === current.heroCardLevelupCost[i]) {
              result._selfHeroCardLevelupCost[i] = oldCache;
            } else {
              result._selfHeroCardLevelupCost[i] = oldCache.update(current.heroCardLevelupCost[i], null);
            }
          } else {
            result._selfHeroCardLevelupCost[i] = new CardLevelUpCost.WithParent(current.heroCardLevelupCost[i], null);
          }
        }
      }
    }
    if (this._selfTowerCardLevelupCost) {
      if (this._value.towerCardLevelupCost === current.towerCardLevelupCost) {
        result._selfTowerCardLevelupCost = this._selfTowerCardLevelupCost;
      } else {
        result._selfTowerCardLevelupCost = [];
        for (let i = 0; i < current.towerCardLevelupCost.length; i++) {
          const oldValue = this._value.towerCardLevelupCost[i];
          if (oldValue) {
            const oldCache = this._selfTowerCardLevelupCost[i];
            if (oldValue === current.towerCardLevelupCost[i]) {
              result._selfTowerCardLevelupCost[i] = oldCache;
            } else {
              result._selfTowerCardLevelupCost[i] = oldCache.update(current.towerCardLevelupCost[i], null);
            }
          } else {
            result._selfTowerCardLevelupCost[i] = new CardLevelUpCost.WithParent(current.towerCardLevelupCost[i], null);
          }
        }
      }
    }
    if (this._selfSpellCardLevelupCost) {
      if (this._value.spellCardLevelupCost === current.spellCardLevelupCost) {
        result._selfSpellCardLevelupCost = this._selfSpellCardLevelupCost;
      } else {
        result._selfSpellCardLevelupCost = [];
        for (let i = 0; i < current.spellCardLevelupCost.length; i++) {
          const oldValue = this._value.spellCardLevelupCost[i];
          if (oldValue) {
            const oldCache = this._selfSpellCardLevelupCost[i];
            if (oldValue === current.spellCardLevelupCost[i]) {
              result._selfSpellCardLevelupCost[i] = oldCache;
            } else {
              result._selfSpellCardLevelupCost[i] = oldCache.update(current.spellCardLevelupCost[i], null);
            }
          } else {
            result._selfSpellCardLevelupCost[i] = new CardLevelUpCost.WithParent(current.spellCardLevelupCost[i], null);
          }
        }
      }
    }
    if (this._selfCardLevelupCap) {
      if (this._value.cardLevelupCap === current.cardLevelupCap) {
        result._selfCardLevelupCap = this._selfCardLevelupCap;
      } else {
        result._selfCardLevelupCap = [];
        for (let i = 0; i < current.cardLevelupCap.length; i++) {
          const oldValue = this._value.cardLevelupCap[i];
          if (oldValue) {
            const oldCache = this._selfCardLevelupCap[i];
            if (oldValue === current.cardLevelupCap[i]) {
              result._selfCardLevelupCap[i] = oldCache;
            } else {
              result._selfCardLevelupCap[i] = oldCache.update(current.cardLevelupCap[i], null);
            }
          } else {
            result._selfCardLevelupCap[i] = new CardLevelCap.WithParent(current.cardLevelupCap[i], null);
          }
        }
      }
    }
    if (this._selfSkillLevelUpCost) {
      if (this._value.skillLevelUpCost === current.skillLevelUpCost) {
        result._selfSkillLevelUpCost = this._selfSkillLevelUpCost;
      } else {
        result._selfSkillLevelUpCost = [];
        for (let i = 0; i < current.skillLevelUpCost.length; i++) {
          const oldValue = this._value.skillLevelUpCost[i];
          if (oldValue) {
            const oldCache = this._selfSkillLevelUpCost[i];
            if (oldValue === current.skillLevelUpCost[i]) {
              result._selfSkillLevelUpCost[i] = oldCache;
            } else {
              result._selfSkillLevelUpCost[i] = oldCache.update(current.skillLevelUpCost[i], null);
            }
          } else {
            result._selfSkillLevelUpCost[i] = new SkillLevelUpCost.WithParent(current.skillLevelUpCost[i], null);
          }
        }
      }
    }
    if (this._selfCardEvolveCost) {
      if (this._value.cardEvolveCost === current.cardEvolveCost) {
        result._selfCardEvolveCost = this._selfCardEvolveCost;
      } else {
        result._selfCardEvolveCost = [];
        for (let i = 0; i < current.cardEvolveCost.length; i++) {
          const oldValue = this._value.cardEvolveCost[i];
          if (oldValue) {
            const oldCache = this._selfCardEvolveCost[i];
            if (oldValue === current.cardEvolveCost[i]) {
              result._selfCardEvolveCost[i] = oldCache;
            } else {
              result._selfCardEvolveCost[i] = oldCache.update(current.cardEvolveCost[i], null);
            }
          } else {
            result._selfCardEvolveCost[i] = new CardEvolveCost.WithParent(current.cardEvolveCost[i], null);
          }
        }
      }
    }
    if (this._selfCardAwakenCost) {
      if (this._value.cardAwakenCost === current.cardAwakenCost) {
        result._selfCardAwakenCost = this._selfCardAwakenCost;
      } else {
        result._selfCardAwakenCost = [];
        for (let i = 0; i < current.cardAwakenCost.length; i++) {
          const oldValue = this._value.cardAwakenCost[i];
          if (oldValue) {
            const oldCache = this._selfCardAwakenCost[i];
            if (oldValue === current.cardAwakenCost[i]) {
              result._selfCardAwakenCost[i] = oldCache;
            } else {
              result._selfCardAwakenCost[i] = oldCache.update(current.cardAwakenCost[i], null);
            }
          } else {
            result._selfCardAwakenCost[i] = new CardAwakenCost.WithParent(current.cardAwakenCost[i], null);
          }
        }
      }
    }
    if (this._selfXpStoneSetting) {
      if (this._value.xpStoneSetting === current.xpStoneSetting) {
        result._selfXpStoneSetting = this._selfXpStoneSetting;
      } else {
        result._selfXpStoneSetting = [];
        for (let i = 0; i < current.xpStoneSetting.length; i++) {
          const oldValue = this._value.xpStoneSetting[i];
          if (oldValue) {
            const oldCache = this._selfXpStoneSetting[i];
            if (oldValue === current.xpStoneSetting[i]) {
              result._selfXpStoneSetting[i] = oldCache;
            } else {
              result._selfXpStoneSetting[i] = oldCache.update(current.xpStoneSetting[i], null);
            }
          } else {
            result._selfXpStoneSetting[i] = new XpStoneSetting.WithParent(current.xpStoneSetting[i], null);
          }
        }
      }
    }
    if (this._selfPlayerGrowthSetting) {
      if (this._value.playerGrowthSetting === current.playerGrowthSetting) {
        result._selfPlayerGrowthSetting = this._selfPlayerGrowthSetting;
      } else {
        result._selfPlayerGrowthSetting = [];
        for (let i = 0; i < current.playerGrowthSetting.length; i++) {
          const oldValue = this._value.playerGrowthSetting[i];
          if (oldValue) {
            const oldCache = this._selfPlayerGrowthSetting[i];
            if (oldValue === current.playerGrowthSetting[i]) {
              result._selfPlayerGrowthSetting[i] = oldCache;
            } else {
              result._selfPlayerGrowthSetting[i] = oldCache.update(current.playerGrowthSetting[i], null);
            }
          } else {
            result._selfPlayerGrowthSetting[i] = new PlayerGrowthSetting.WithParent(current.playerGrowthSetting[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardGrowthSetting_WithParent.default = new CardGrowthSetting_WithParent(CardGrowthSetting.default, null);
CardGrowthSetting.WithParent = CardGrowthSetting_WithParent;
class CardGrowthSetting_Descriptor {
  get heroCardLevelupCost() {
    if (!this._heroCardLevelupCost) {
      this._heroCardLevelupCost = {
        name: "heroCardLevelupCost",
        Name: "HeroCardLevelupCost",
        number: 1,
        protoType: 11,
        protoName: "hero_card_levelup_cost",
        type: CardLevelUpCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heroCardLevelupCost;
  }
  get towerCardLevelupCost() {
    if (!this._towerCardLevelupCost) {
      this._towerCardLevelupCost = {
        name: "towerCardLevelupCost",
        Name: "TowerCardLevelupCost",
        number: 2,
        protoType: 11,
        protoName: "tower_card_levelup_cost",
        type: CardLevelUpCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerCardLevelupCost;
  }
  get spellCardLevelupCost() {
    if (!this._spellCardLevelupCost) {
      this._spellCardLevelupCost = {
        name: "spellCardLevelupCost",
        Name: "SpellCardLevelupCost",
        number: 3,
        protoType: 11,
        protoName: "spell_card_levelup_cost",
        type: CardLevelUpCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellCardLevelupCost;
  }
  get cardLevelupCap() {
    if (!this._cardLevelupCap) {
      this._cardLevelupCap = {
        name: "cardLevelupCap",
        Name: "CardLevelupCap",
        number: 4,
        protoType: 11,
        protoName: "card_levelup_cap",
        type: CardLevelCap,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardLevelupCap;
  }
  get skillLevelUpCost() {
    if (!this._skillLevelUpCost) {
      this._skillLevelUpCost = {
        name: "skillLevelUpCost",
        Name: "SkillLevelUpCost",
        number: 5,
        protoType: 11,
        protoName: "skill_level_up_cost",
        type: SkillLevelUpCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillLevelUpCost;
  }
  get cardEvolveCost() {
    if (!this._cardEvolveCost) {
      this._cardEvolveCost = {
        name: "cardEvolveCost",
        Name: "CardEvolveCost",
        number: 6,
        protoType: 11,
        protoName: "card_evolve_cost",
        type: CardEvolveCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardEvolveCost;
  }
  get cardAwakenCost() {
    if (!this._cardAwakenCost) {
      this._cardAwakenCost = {
        name: "cardAwakenCost",
        Name: "CardAwakenCost",
        number: 7,
        protoType: 11,
        protoName: "card_awaken_cost",
        type: CardAwakenCost,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardAwakenCost;
  }
  get xpStoneSetting() {
    if (!this._xpStoneSetting) {
      this._xpStoneSetting = {
        name: "xpStoneSetting",
        Name: "XpStoneSetting",
        number: 8,
        protoType: 11,
        protoName: "xp_stone_setting",
        type: XpStoneSetting,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._xpStoneSetting;
  }
  get playerGrowthSetting() {
    if (!this._playerGrowthSetting) {
      this._playerGrowthSetting = {
        name: "playerGrowthSetting",
        Name: "PlayerGrowthSetting",
        number: 9,
        protoType: 11,
        protoName: "player_growth_setting",
        type: PlayerGrowthSetting,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerGrowthSetting;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.heroCardLevelupCost,
        this.towerCardLevelupCost,
        this.spellCardLevelupCost,
        this.cardLevelupCap,
        this.skillLevelUpCost,
        this.cardEvolveCost,
        this.cardAwakenCost,
        this.xpStoneSetting,
        this.playerGrowthSetting,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CardGrowthSetting.descriptor = new CardGrowthSetting_Descriptor();
export class UnitUpgrade {
  get descriptor() {
    return UnitUpgrade.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHealth = false;
    this._health = null;
    this._hasDamage = false;
    this._damage = null;
  }
  isEmpty() {
    if (this._hasHealth) return false;
    if (this._hasDamage) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof UnitUpgrade) {
      return value;
    }
    return UnitUpgrade.fromJson(value);
  }
  static fromJson(json) {
    const result = new UnitUpgrade();
    if (json.health != null) {
      result._hasHealth = true;
      result._health = JsonToDouble.fromJson(json.health);
    }
    if (json.damage != null) {
      result._hasDamage = true;
      result._damage = JsonToDouble.fromJson(json.damage);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHealth) {
      result.health = JsonToDouble.toJson(this._health);
    }
    if (this._hasDamage) {
      result.damage = JsonToDouble.toJson(this._damage);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get health() {
    return this._hasHealth ? this._health : JsonToDouble.default;
  }
  get hasHealth() {
    return this._hasHealth;
  }
  setHealth(path, value) {
    return {type: 'SET', path: path.concat(['health']), value};
  }
  deleteHealth(path) {
    return {type: 'DELETE', path: path.concat(['health'])};
  }
  /**
   * @returns {number}
   */
  get damage() {
    return this._hasDamage ? this._damage : JsonToDouble.default;
  }
  get hasDamage() {
    return this._hasDamage;
  }
  setDamage(path, value) {
    return {type: 'SET', path: path.concat(['damage']), value};
  }
  deleteDamage(path) {
    return {type: 'DELETE', path: path.concat(['damage'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "health": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitUpgrade(this);
              copy._hasHealth = true;
              copy._health = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealth) {
                return this;
              }
              const copy = new UnitUpgrade(this);
              copy._hasHealth = false;
              copy._health = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "damage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new UnitUpgrade(this);
              copy._hasDamage = true;
              copy._damage = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamage) {
                return this;
              }
              const copy = new UnitUpgrade(this);
              copy._hasDamage = false;
              copy._damage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {UnitUpgrade} other
   * @returns {UnitUpgrade}
   */
  merge(other) {
    const copy = new UnitUpgrade(this);
    if (other._hasHealth) {
      copy._hasHealth = true;
      copy._health = other._health;
    }
    if (other._hasDamage) {
      copy._hasDamage = true;
      copy._damage = other._damage;
    }
    return copy;
  }
}
UnitUpgrade.default = new UnitUpgrade();
class UnitUpgrade_Builder {
  constructor(value) {
    this._value = new UnitUpgrade(value);
  }
  build() {
    return new UnitUpgrade(this._value);
  }
  setHealth(value) {
    this._value._hasHealth = true;
    this._value._health = value;
    return this;
  }
  deleteHealth() {
    this._value._hasHealth = false;
    this._value._health = null;
    return this;
  }
  setDamage(value) {
    this._value._hasDamage = true;
    this._value._damage = value;
    return this;
  }
  deleteDamage() {
    this._value._hasDamage = false;
    this._value._damage = null;
    return this;
  }
}
UnitUpgrade.Builder = UnitUpgrade_Builder;
class UnitUpgrade_WithParent {
  /**
   * @param {UnitUpgrade} value
   * @param {UnitUpgrade_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return UnitUpgrade.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHealth() {
    if (this._cachedHasHealth === undefined) {
      if (this._value.hasHealth) {
        this._cachedHasHealth = true;
      } else {
        this._cachedHasHealth = this._parent ? this._parent.hasHealth : false;
      }
    }
    return this._cachedHasHealth;
  }
  get health() {
    if (this._cachedHealth === undefined) {
      if (this._value.hasHealth) {
        this._cachedHealth = this._value.health;
      } else {
        this._cachedHealth = this._parent ? this._parent.health : this._value.health;
      }
    }
    return this._cachedHealth;
  }
  get hasDamage() {
    if (this._cachedHasDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedHasDamage = true;
      } else {
        this._cachedHasDamage = this._parent ? this._parent.hasDamage : false;
      }
    }
    return this._cachedHasDamage;
  }
  get damage() {
    if (this._cachedDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedDamage = this._value.damage;
      } else {
        this._cachedDamage = this._parent ? this._parent.damage : this._value.damage;
      }
    }
    return this._cachedDamage;
  }
  update(current, parent) {
    const result = new UnitUpgrade_WithParent(current, parent);
    return result;
  }
}
UnitUpgrade_WithParent.default = new UnitUpgrade_WithParent(UnitUpgrade.default, null);
UnitUpgrade.WithParent = UnitUpgrade_WithParent;
class UnitUpgrade_Descriptor {
  get health() {
    if (!this._health) {
      this._health = {
        name: "health",
        Name: "Health",
        number: 1,
        protoType: 2,
        protoName: "health",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._health;
  }
  get damage() {
    if (!this._damage) {
      this._damage = {
        name: "damage",
        Name: "Damage",
        number: 2,
        protoType: 2,
        protoName: "damage",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damage;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.health,
        this.damage,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHealth",
        Name: "DummyOneofForHealth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDamage",
        Name: "DummyOneofForDamage",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
UnitUpgrade.descriptor = new UnitUpgrade_Descriptor();
export class CardSkill {
  get descriptor() {
    return CardSkill.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDescription = false;
    this._description = null;
    this._hasIcon = false;
    this._icon = null;
    this._hasCardStarRequirement = false;
    this._cardStarRequirement = null;
    this._skillUpgrades = [];
    this._unlockedAbilities = [];
    this._unlockedWeapons = [];
    this._unlockedBehaviors = [];
    this._hasLevelUpPopupMsg = false;
    this._levelUpPopupMsg = null;
    this._hasBasePowerIndex = false;
    this._basePowerIndex = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDescription) return false;
    if (this._hasIcon) return false;
    if (this._hasCardStarRequirement) return false;
    if (this._skillUpgrades.length > 0) return false;
    if (this._unlockedAbilities.length > 0) return false;
    if (this._unlockedWeapons.length > 0) return false;
    if (this._unlockedBehaviors.length > 0) return false;
    if (this._hasLevelUpPopupMsg) return false;
    if (this._hasBasePowerIndex) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkill) {
      return value;
    }
    return CardSkill.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkill();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.cardStarRequirement != null) {
      result._hasCardStarRequirement = true;
      result._cardStarRequirement = JsonToInt32.fromJson(json.cardStarRequirement);
    }
    result._skillUpgrades = JsonToList(json.skillUpgrades, JsonToString);
    result._unlockedAbilities = JsonToList(json.unlockedAbilities, JsonToString);
    result._unlockedWeapons = JsonToList(json.unlockedWeapons, JsonToString);
    result._unlockedBehaviors = JsonToList(json.unlockedBehaviors, JsonToString);
    if (json.levelUpPopupMsg != null) {
      result._hasLevelUpPopupMsg = true;
      result._levelUpPopupMsg = JsonToString.fromJson(json.levelUpPopupMsg);
    }
    if (json.basePowerIndex != null) {
      result._hasBasePowerIndex = true;
      result._basePowerIndex = JsonToInt32.fromJson(json.basePowerIndex);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasCardStarRequirement) {
      result.cardStarRequirement = JsonToInt32.toJson(this._cardStarRequirement);
    }
    if (this._skillUpgrades.length > 0) {
      result.skillUpgrades = ArrayToJson(this._skillUpgrades, JsonToString);
    }
    if (this._unlockedAbilities.length > 0) {
      result.unlockedAbilities = ArrayToJson(this._unlockedAbilities, JsonToString);
    }
    if (this._unlockedWeapons.length > 0) {
      result.unlockedWeapons = ArrayToJson(this._unlockedWeapons, JsonToString);
    }
    if (this._unlockedBehaviors.length > 0) {
      result.unlockedBehaviors = ArrayToJson(this._unlockedBehaviors, JsonToString);
    }
    if (this._hasLevelUpPopupMsg) {
      result.levelUpPopupMsg = JsonToString.toJson(this._levelUpPopupMsg);
    }
    if (this._hasBasePowerIndex) {
      result.basePowerIndex = JsonToInt32.toJson(this._basePowerIndex);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {number}
   */
  get cardStarRequirement() {
    return this._hasCardStarRequirement ? this._cardStarRequirement : JsonToInt32.default;
  }
  get hasCardStarRequirement() {
    return this._hasCardStarRequirement;
  }
  setCardStarRequirement(path, value) {
    return {type: 'SET', path: path.concat(['cardStarRequirement']), value};
  }
  deleteCardStarRequirement(path) {
    return {type: 'DELETE', path: path.concat(['cardStarRequirement'])};
  }
  /**
   * @returns {string[]}
   */
  get skillUpgrades() {
    return this._skillUpgrades;
  }
  addSkillUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['skillUpgrades']), value};
  }
  setSkillUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['skillUpgrades']), value: ArrayToJson(value, JsonToString)};
  }
  setSkillUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skillUpgrades', key]), value};
  }
  deleteSkillUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['skillUpgrades'])};
  }
  deleteSkillUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skillUpgrades', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedAbilities() {
    return this._unlockedAbilities;
  }
  addUnlockedAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedAbilities']), value};
  }
  setUnlockedAbilities(path, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities', key]), value};
  }
  deleteUnlockedAbilities(path) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities'])};
  }
  deleteUnlockedAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedWeapons() {
    return this._unlockedWeapons;
  }
  addUnlockedWeapons(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedWeapons']), value};
  }
  setUnlockedWeapons(path, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedWeaponsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons', key]), value};
  }
  deleteUnlockedWeapons(path) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons'])};
  }
  deleteUnlockedWeaponsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedBehaviors() {
    return this._unlockedBehaviors;
  }
  addUnlockedBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedBehaviors']), value};
  }
  setUnlockedBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors', key]), value};
  }
  deleteUnlockedBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors'])};
  }
  deleteUnlockedBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors', key])};
  }
  /**
   * @returns {string}
   */
  get levelUpPopupMsg() {
    return this._hasLevelUpPopupMsg ? this._levelUpPopupMsg : JsonToString.default;
  }
  get hasLevelUpPopupMsg() {
    return this._hasLevelUpPopupMsg;
  }
  setLevelUpPopupMsg(path, value) {
    return {type: 'SET', path: path.concat(['levelUpPopupMsg']), value};
  }
  deleteLevelUpPopupMsg(path) {
    return {type: 'DELETE', path: path.concat(['levelUpPopupMsg'])};
  }
  /**
   * @returns {number}
   */
  get basePowerIndex() {
    return this._hasBasePowerIndex ? this._basePowerIndex : JsonToInt32.default;
  }
  get hasBasePowerIndex() {
    return this._hasBasePowerIndex;
  }
  setBasePowerIndex(path, value) {
    return {type: 'SET', path: path.concat(['basePowerIndex']), value};
  }
  deleteBasePowerIndex(path) {
    return {type: 'DELETE', path: path.concat(['basePowerIndex'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardStarRequirement": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasCardStarRequirement = true;
              copy._cardStarRequirement = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardStarRequirement) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasCardStarRequirement = false;
              copy._cardStarRequirement = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skillUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._skillUpgrades = [];        for (let i of value) {
                copy._skillUpgrades.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkill(this);
              copy._skillUpgrades = copy._skillUpgrades.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skillUpgrades.length === 0) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._skillUpgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skillUpgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._skillUpgrades = copy._skillUpgrades.slice();
              copy._skillUpgrades[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkill(this);
              copy._skillUpgrades = copy._skillUpgrades.slice(0, path[1]).concat(copy._skillUpgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skillUpgrades.length) {
            return this;
          }
          const oldValue = this._skillUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkill(this);
          copy._skillUpgrades = copy._skillUpgrades.slice();
          copy._skillUpgrades[key] = newValue;
          return copy;
        }
      }
      case "unlockedAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedAbilities = [];        for (let i of value) {
                copy._unlockedAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkill(this);
              copy._unlockedAbilities = copy._unlockedAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedAbilities.length === 0) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._unlockedAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice();
              copy._unlockedAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkill(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice(0, path[1]).concat(copy._unlockedAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          const oldValue = this._unlockedAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkill(this);
          copy._unlockedAbilities = copy._unlockedAbilities.slice();
          copy._unlockedAbilities[key] = newValue;
          return copy;
        }
      }
      case "unlockedWeapons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedWeapons = [];        for (let i of value) {
                copy._unlockedWeapons.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkill(this);
              copy._unlockedWeapons = copy._unlockedWeapons.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedWeapons.length === 0) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._unlockedWeapons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice();
              copy._unlockedWeapons[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkill(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice(0, path[1]).concat(copy._unlockedWeapons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          const oldValue = this._unlockedWeapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkill(this);
          copy._unlockedWeapons = copy._unlockedWeapons.slice();
          copy._unlockedWeapons[key] = newValue;
          return copy;
        }
      }
      case "unlockedBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedBehaviors = [];        for (let i of value) {
                copy._unlockedBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkill(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedBehaviors.length === 0) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._unlockedBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
              copy._unlockedBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkill(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice(0, path[1]).concat(copy._unlockedBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          const oldValue = this._unlockedBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkill(this);
          copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
          copy._unlockedBehaviors[key] = newValue;
          return copy;
        }
      }
      case "levelUpPopupMsg": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasLevelUpPopupMsg = true;
              copy._levelUpPopupMsg = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelUpPopupMsg) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasLevelUpPopupMsg = false;
              copy._levelUpPopupMsg = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "basePowerIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkill(this);
              copy._hasBasePowerIndex = true;
              copy._basePowerIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasBasePowerIndex) {
                return this;
              }
              const copy = new CardSkill(this);
              copy._hasBasePowerIndex = false;
              copy._basePowerIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkill} other
   * @returns {CardSkill}
   */
  merge(other) {
    const copy = new CardSkill(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasCardStarRequirement) {
      copy._hasCardStarRequirement = true;
      copy._cardStarRequirement = other._cardStarRequirement;
    }
    copy._skillUpgrades = this._skillUpgrades.concat(other._skillUpgrades);
    copy._unlockedAbilities = this._unlockedAbilities.concat(other._unlockedAbilities);
    copy._unlockedWeapons = this._unlockedWeapons.concat(other._unlockedWeapons);
    copy._unlockedBehaviors = this._unlockedBehaviors.concat(other._unlockedBehaviors);
    if (other._hasLevelUpPopupMsg) {
      copy._hasLevelUpPopupMsg = true;
      copy._levelUpPopupMsg = other._levelUpPopupMsg;
    }
    if (other._hasBasePowerIndex) {
      copy._hasBasePowerIndex = true;
      copy._basePowerIndex = other._basePowerIndex;
    }
    return copy;
  }
}
CardSkill.default = new CardSkill();
class CardSkill_Builder {
  constructor(value) {
    this._value = new CardSkill(value);
  }
  build() {
    return new CardSkill(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setCardStarRequirement(value) {
    this._value._hasCardStarRequirement = true;
    this._value._cardStarRequirement = value;
    return this;
  }
  deleteCardStarRequirement() {
    this._value._hasCardStarRequirement = false;
    this._value._cardStarRequirement = null;
    return this;
  }
  addAllSkillUpgrades(values) {
    this._value._skillUpgrades = this._value._skillUpgrades.concat(values);
    return this;
  }
  addSkillUpgrades(value) {
    this._value._skillUpgrades = this._value._skillUpgrades.concat([value]);
    return this;
  }
  setSkillUpgrades(index, value) {
    this._value._skillUpgrades = this._value._skillUpgrades.concat();
    this._value._skillUpgrades[index] = value;
    return this;
  }
  clearSkillUpgrades() {
    this._value._skillUpgrades = [];
    return this;
  }
  addAllUnlockedAbilities(values) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat(values);
    return this;
  }
  addUnlockedAbilities(value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat([value]);
    return this;
  }
  setUnlockedAbilities(index, value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat();
    this._value._unlockedAbilities[index] = value;
    return this;
  }
  clearUnlockedAbilities() {
    this._value._unlockedAbilities = [];
    return this;
  }
  addAllUnlockedWeapons(values) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat(values);
    return this;
  }
  addUnlockedWeapons(value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat([value]);
    return this;
  }
  setUnlockedWeapons(index, value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat();
    this._value._unlockedWeapons[index] = value;
    return this;
  }
  clearUnlockedWeapons() {
    this._value._unlockedWeapons = [];
    return this;
  }
  addAllUnlockedBehaviors(values) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat(values);
    return this;
  }
  addUnlockedBehaviors(value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat([value]);
    return this;
  }
  setUnlockedBehaviors(index, value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat();
    this._value._unlockedBehaviors[index] = value;
    return this;
  }
  clearUnlockedBehaviors() {
    this._value._unlockedBehaviors = [];
    return this;
  }
  setLevelUpPopupMsg(value) {
    this._value._hasLevelUpPopupMsg = true;
    this._value._levelUpPopupMsg = value;
    return this;
  }
  deleteLevelUpPopupMsg() {
    this._value._hasLevelUpPopupMsg = false;
    this._value._levelUpPopupMsg = null;
    return this;
  }
  setBasePowerIndex(value) {
    this._value._hasBasePowerIndex = true;
    this._value._basePowerIndex = value;
    return this;
  }
  deleteBasePowerIndex() {
    this._value._hasBasePowerIndex = false;
    this._value._basePowerIndex = null;
    return this;
  }
}
CardSkill.Builder = CardSkill_Builder;
class CardSkill_WithParent {
  /**
   * @param {CardSkill} value
   * @param {CardSkill_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkill.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasCardStarRequirement() {
    if (this._cachedHasCardStarRequirement === undefined) {
      if (this._value.hasCardStarRequirement) {
        this._cachedHasCardStarRequirement = true;
      } else {
        this._cachedHasCardStarRequirement = this._parent ? this._parent.hasCardStarRequirement : false;
      }
    }
    return this._cachedHasCardStarRequirement;
  }
  get cardStarRequirement() {
    if (this._cachedCardStarRequirement === undefined) {
      if (this._value.hasCardStarRequirement) {
        this._cachedCardStarRequirement = this._value.cardStarRequirement;
      } else {
        this._cachedCardStarRequirement = this._parent ? this._parent.cardStarRequirement : this._value.cardStarRequirement;
      }
    }
    return this._cachedCardStarRequirement;
  }
  get selfSkillUpgrades() {
    return this._value.skillUpgrades;
  }
  get inherentSkillUpgrades() {
    if (!this._inherentSkillUpgrades) {
      this._inherentSkillUpgrades = this._parent ? this._parent.skillUpgrades : [];
    }
    return this._inherentSkillUpgrades;
  }
  get skillUpgrades() {
    if (!this._allSkillUpgrades) {
      this._allSkillUpgrades = this._parent ? this._parent.skillUpgrades.concat(this.selfSkillUpgrades) : this.selfSkillUpgrades;
    }
    return this._allSkillUpgrades;
  }
  get selfUnlockedAbilities() {
    return this._value.unlockedAbilities;
  }
  get inherentUnlockedAbilities() {
    if (!this._inherentUnlockedAbilities) {
      this._inherentUnlockedAbilities = this._parent ? this._parent.unlockedAbilities : [];
    }
    return this._inherentUnlockedAbilities;
  }
  get unlockedAbilities() {
    if (!this._allUnlockedAbilities) {
      this._allUnlockedAbilities = this._parent ? this._parent.unlockedAbilities.concat(this.selfUnlockedAbilities) : this.selfUnlockedAbilities;
    }
    return this._allUnlockedAbilities;
  }
  get selfUnlockedWeapons() {
    return this._value.unlockedWeapons;
  }
  get inherentUnlockedWeapons() {
    if (!this._inherentUnlockedWeapons) {
      this._inherentUnlockedWeapons = this._parent ? this._parent.unlockedWeapons : [];
    }
    return this._inherentUnlockedWeapons;
  }
  get unlockedWeapons() {
    if (!this._allUnlockedWeapons) {
      this._allUnlockedWeapons = this._parent ? this._parent.unlockedWeapons.concat(this.selfUnlockedWeapons) : this.selfUnlockedWeapons;
    }
    return this._allUnlockedWeapons;
  }
  get selfUnlockedBehaviors() {
    return this._value.unlockedBehaviors;
  }
  get inherentUnlockedBehaviors() {
    if (!this._inherentUnlockedBehaviors) {
      this._inherentUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors : [];
    }
    return this._inherentUnlockedBehaviors;
  }
  get unlockedBehaviors() {
    if (!this._allUnlockedBehaviors) {
      this._allUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors.concat(this.selfUnlockedBehaviors) : this.selfUnlockedBehaviors;
    }
    return this._allUnlockedBehaviors;
  }
  get hasLevelUpPopupMsg() {
    if (this._cachedHasLevelUpPopupMsg === undefined) {
      if (this._value.hasLevelUpPopupMsg) {
        this._cachedHasLevelUpPopupMsg = true;
      } else {
        this._cachedHasLevelUpPopupMsg = this._parent ? this._parent.hasLevelUpPopupMsg : false;
      }
    }
    return this._cachedHasLevelUpPopupMsg;
  }
  get levelUpPopupMsg() {
    if (this._cachedLevelUpPopupMsg === undefined) {
      if (this._value.hasLevelUpPopupMsg) {
        this._cachedLevelUpPopupMsg = this._value.levelUpPopupMsg;
      } else {
        this._cachedLevelUpPopupMsg = this._parent ? this._parent.levelUpPopupMsg : this._value.levelUpPopupMsg;
      }
    }
    return this._cachedLevelUpPopupMsg;
  }
  get hasBasePowerIndex() {
    if (this._cachedHasBasePowerIndex === undefined) {
      if (this._value.hasBasePowerIndex) {
        this._cachedHasBasePowerIndex = true;
      } else {
        this._cachedHasBasePowerIndex = this._parent ? this._parent.hasBasePowerIndex : false;
      }
    }
    return this._cachedHasBasePowerIndex;
  }
  get basePowerIndex() {
    if (this._cachedBasePowerIndex === undefined) {
      if (this._value.hasBasePowerIndex) {
        this._cachedBasePowerIndex = this._value.basePowerIndex;
      } else {
        this._cachedBasePowerIndex = this._parent ? this._parent.basePowerIndex : this._value.basePowerIndex;
      }
    }
    return this._cachedBasePowerIndex;
  }
  update(current, parent) {
    const result = new CardSkill_WithParent(current, parent);
    return result;
  }
}
CardSkill_WithParent.default = new CardSkill_WithParent(CardSkill.default, null);
CardSkill.WithParent = CardSkill_WithParent;
class CardSkill_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 3,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 4,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "SkillIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get cardStarRequirement() {
    if (!this._cardStarRequirement) {
      this._cardStarRequirement = {
        name: "cardStarRequirement",
        Name: "CardStarRequirement",
        number: 5,
        protoType: 5,
        protoName: "card_star_requirement",
        type: JsonToInt32,
        options: {
          comments: "unlocked when card star reaches this number",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardStarRequirement;
  }
  get skillUpgrades() {
    if (!this._skillUpgrades) {
      this._skillUpgrades = {
        name: "skillUpgrades",
        Name: "SkillUpgrades",
        number: 6,
        protoType: 9,
        protoName: "skill_upgrades",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillUpgrades;
  }
  get unlockedAbilities() {
    if (!this._unlockedAbilities) {
      this._unlockedAbilities = {
        name: "unlockedAbilities",
        Name: "UnlockedAbilities",
        number: 7,
        protoType: 9,
        protoName: "unlocked_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "abilities unlocked when the skill is bought",
          valueDropdown: "AbilityNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedAbilities;
  }
  get unlockedWeapons() {
    if (!this._unlockedWeapons) {
      this._unlockedWeapons = {
        name: "unlockedWeapons",
        Name: "UnlockedWeapons",
        number: 8,
        protoType: 9,
        protoName: "unlocked_weapons",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "WeaponNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedWeapons;
  }
  get unlockedBehaviors() {
    if (!this._unlockedBehaviors) {
      this._unlockedBehaviors = {
        name: "unlockedBehaviors",
        Name: "UnlockedBehaviors",
        number: 9,
        protoType: 9,
        protoName: "unlocked_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "BehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedBehaviors;
  }
  get levelUpPopupMsg() {
    if (!this._levelUpPopupMsg) {
      this._levelUpPopupMsg = {
        name: "levelUpPopupMsg",
        Name: "LevelUpPopupMsg",
        number: 10,
        protoType: 9,
        protoName: "level_up_popup_msg",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelUpPopupMsg;
  }
  get basePowerIndex() {
    if (!this._basePowerIndex) {
      this._basePowerIndex = {
        name: "basePowerIndex",
        Name: "BasePowerIndex",
        number: 20,
        protoType: 5,
        protoName: "base_power_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._basePowerIndex;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.displayName,
        this.description,
        this.icon,
        this.cardStarRequirement,
        this.skillUpgrades,
        this.unlockedAbilities,
        this.unlockedWeapons,
        this.unlockedBehaviors,
        this.levelUpPopupMsg,
        this.basePowerIndex,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardStarRequirement",
        Name: "DummyOneofForCardStarRequirement",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelUpPopupMsg",
        Name: "DummyOneofForLevelUpPopupMsg",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForBasePowerIndex",
        Name: "DummyOneofForBasePowerIndex",
        fields: [
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkill.descriptor = new CardSkill_Descriptor();
class CardAwaken_AwakenUpgrade {
  get descriptor() {
    return CardAwaken_AwakenUpgrade.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasAddedLevel = false;
    this._addedLevel = null;
    this._hasUpgrade = false;
    this._upgrade = null;
  }
  isEmpty() {
    if (this._hasAddedLevel) return false;
    if (this._hasUpgrade) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardAwaken_AwakenUpgrade) {
      return value;
    }
    return CardAwaken_AwakenUpgrade.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardAwaken_AwakenUpgrade();
    if (json.addedLevel != null) {
      result._hasAddedLevel = true;
      result._addedLevel = JsonToInt32.fromJson(json.addedLevel);
    }
    if (json.upgrade != null) {
      result._hasUpgrade = true;
      result._upgrade = JsonToString.fromJson(json.upgrade);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasAddedLevel) {
      result.addedLevel = JsonToInt32.toJson(this._addedLevel);
    }
    if (this._hasUpgrade) {
      result.upgrade = JsonToString.toJson(this._upgrade);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get addedLevel() {
    return this._hasAddedLevel ? this._addedLevel : JsonToInt32.default;
  }
  get hasAddedLevel() {
    return this._hasAddedLevel;
  }
  setAddedLevel(path, value) {
    return {type: 'SET', path: path.concat(['addedLevel']), value};
  }
  deleteAddedLevel(path) {
    return {type: 'DELETE', path: path.concat(['addedLevel'])};
  }
  /**
   * @returns {string}
   */
  get upgrade() {
    return this._hasUpgrade ? this._upgrade : JsonToString.default;
  }
  get hasUpgrade() {
    return this._hasUpgrade;
  }
  setUpgrade(path, value) {
    return {type: 'SET', path: path.concat(['upgrade']), value};
  }
  deleteUpgrade(path) {
    return {type: 'DELETE', path: path.concat(['upgrade'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "addedLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken_AwakenUpgrade(this);
              copy._hasAddedLevel = true;
              copy._addedLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAddedLevel) {
                return this;
              }
              const copy = new CardAwaken_AwakenUpgrade(this);
              copy._hasAddedLevel = false;
              copy._addedLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "upgrade": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken_AwakenUpgrade(this);
              copy._hasUpgrade = true;
              copy._upgrade = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUpgrade) {
                return this;
              }
              const copy = new CardAwaken_AwakenUpgrade(this);
              copy._hasUpgrade = false;
              copy._upgrade = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardAwaken_AwakenUpgrade} other
   * @returns {CardAwaken_AwakenUpgrade}
   */
  merge(other) {
    const copy = new CardAwaken_AwakenUpgrade(this);
    if (other._hasAddedLevel) {
      copy._hasAddedLevel = true;
      copy._addedLevel = other._addedLevel;
    }
    if (other._hasUpgrade) {
      copy._hasUpgrade = true;
      copy._upgrade = other._upgrade;
    }
    return copy;
  }
}
CardAwaken_AwakenUpgrade.default = new CardAwaken_AwakenUpgrade();
class CardAwaken_AwakenUpgrade_Builder {
  constructor(value) {
    this._value = new CardAwaken_AwakenUpgrade(value);
  }
  build() {
    return new CardAwaken_AwakenUpgrade(this._value);
  }
  setAddedLevel(value) {
    this._value._hasAddedLevel = true;
    this._value._addedLevel = value;
    return this;
  }
  deleteAddedLevel() {
    this._value._hasAddedLevel = false;
    this._value._addedLevel = null;
    return this;
  }
  setUpgrade(value) {
    this._value._hasUpgrade = true;
    this._value._upgrade = value;
    return this;
  }
  deleteUpgrade() {
    this._value._hasUpgrade = false;
    this._value._upgrade = null;
    return this;
  }
}
CardAwaken_AwakenUpgrade.Builder = CardAwaken_AwakenUpgrade_Builder;
class CardAwaken_AwakenUpgrade_WithParent {
  /**
   * @param {CardAwaken_AwakenUpgrade} value
   * @param {CardAwaken_AwakenUpgrade_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardAwaken_AwakenUpgrade.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasAddedLevel() {
    if (this._cachedHasAddedLevel === undefined) {
      if (this._value.hasAddedLevel) {
        this._cachedHasAddedLevel = true;
      } else {
        this._cachedHasAddedLevel = this._parent ? this._parent.hasAddedLevel : false;
      }
    }
    return this._cachedHasAddedLevel;
  }
  get addedLevel() {
    if (this._cachedAddedLevel === undefined) {
      if (this._value.hasAddedLevel) {
        this._cachedAddedLevel = this._value.addedLevel;
      } else {
        this._cachedAddedLevel = this._parent ? this._parent.addedLevel : this._value.addedLevel;
      }
    }
    return this._cachedAddedLevel;
  }
  get hasUpgrade() {
    if (this._cachedHasUpgrade === undefined) {
      if (this._value.hasUpgrade) {
        this._cachedHasUpgrade = true;
      } else {
        this._cachedHasUpgrade = this._parent ? this._parent.hasUpgrade : false;
      }
    }
    return this._cachedHasUpgrade;
  }
  get upgrade() {
    if (this._cachedUpgrade === undefined) {
      if (this._value.hasUpgrade) {
        this._cachedUpgrade = this._value.upgrade;
      } else {
        this._cachedUpgrade = this._parent ? this._parent.upgrade : this._value.upgrade;
      }
    }
    return this._cachedUpgrade;
  }
  update(current, parent) {
    const result = new CardAwaken_AwakenUpgrade_WithParent(current, parent);
    return result;
  }
}
CardAwaken_AwakenUpgrade_WithParent.default = new CardAwaken_AwakenUpgrade_WithParent(CardAwaken_AwakenUpgrade.default, null);
CardAwaken_AwakenUpgrade.WithParent = CardAwaken_AwakenUpgrade_WithParent;
class CardAwaken_AwakenUpgrade_Descriptor {
  get addedLevel() {
    if (!this._addedLevel) {
      this._addedLevel = {
        name: "addedLevel",
        Name: "AddedLevel",
        number: 1,
        protoType: 5,
        protoName: "added_level",
        type: JsonToInt32,
        options: {
          comments: "value added to upgrade",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addedLevel;
  }
  get upgrade() {
    if (!this._upgrade) {
      this._upgrade = {
        name: "upgrade",
        Name: "Upgrade",
        number: 2,
        protoType: 9,
        protoName: "upgrade",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._upgrade;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.addedLevel,
        this.upgrade,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForAddedLevel",
        Name: "DummyOneofForAddedLevel",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUpgrade",
        Name: "DummyOneofForUpgrade",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardAwaken_AwakenUpgrade.descriptor = new CardAwaken_AwakenUpgrade_Descriptor();
export class CardAwaken {
  get descriptor() {
    return CardAwaken.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDescription = false;
    this._description = null;
    this._awakenUpgrades = [];
    this._hasSkillLevelBonus = false;
    this._skillLevelBonus = null;
  }
  isEmpty() {
    if (this._hasDescription) return false;
    if (this._awakenUpgrades.length > 0) return false;
    if (this._hasSkillLevelBonus) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardAwaken) {
      return value;
    }
    return CardAwaken.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardAwaken();
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    result._awakenUpgrades = JsonToList(json.awakenUpgrades, CardAwaken_AwakenUpgrade);
    if (json.skillLevelBonus != null) {
      result._hasSkillLevelBonus = true;
      result._skillLevelBonus = JsonToInt32.fromJson(json.skillLevelBonus);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._awakenUpgrades.length > 0) {
      result.awakenUpgrades = ArrayToJson(this._awakenUpgrades, CardAwaken_AwakenUpgrade);
    }
    if (this._hasSkillLevelBonus) {
      result.skillLevelBonus = JsonToInt32.toJson(this._skillLevelBonus);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {CardAwaken_AwakenUpgrade[]}
   */
  get awakenUpgrades() {
    return this._awakenUpgrades;
  }
  addAwakenUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['awakenUpgrades']), value: value.toJson()};
  }
  setAwakenUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['awakenUpgrades']), value: ArrayToJson(value, CardAwaken_AwakenUpgrade)};
  }
  setAwakenUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['awakenUpgrades', key]), value: value.toJson()};
  }
  deleteAwakenUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['awakenUpgrades'])};
  }
  deleteAwakenUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['awakenUpgrades', key])};
  }
  /**
   * @returns {number}
   */
  get skillLevelBonus() {
    return this._hasSkillLevelBonus ? this._skillLevelBonus : JsonToInt32.default;
  }
  get hasSkillLevelBonus() {
    return this._hasSkillLevelBonus;
  }
  setSkillLevelBonus(path, value) {
    return {type: 'SET', path: path.concat(['skillLevelBonus']), value};
  }
  deleteSkillLevelBonus(path) {
    return {type: 'DELETE', path: path.concat(['skillLevelBonus'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new CardAwaken(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awakenUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken(this);
              copy._awakenUpgrades = [];        for (let i of value) {
                copy._awakenUpgrades.push(CardAwaken_AwakenUpgrade.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardAwaken(this);
              copy._awakenUpgrades = copy._awakenUpgrades.concat([CardAwaken_AwakenUpgrade.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._awakenUpgrades.length === 0) {
                return this;
              }
              const copy = new CardAwaken(this);
              copy._awakenUpgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._awakenUpgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken(this);
              copy._awakenUpgrades = copy._awakenUpgrades.slice();
              copy._awakenUpgrades[path[1]] = CardAwaken_AwakenUpgrade.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardAwaken(this);
              copy._awakenUpgrades = copy._awakenUpgrades.slice(0, path[1]).concat(copy._awakenUpgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._awakenUpgrades.length) {
            return this;
          }
          const oldValue = this._awakenUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardAwaken(this);
          copy._awakenUpgrades = copy._awakenUpgrades.slice();
          copy._awakenUpgrades[key] = newValue;
          return copy;
        }
      }
      case "skillLevelBonus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardAwaken(this);
              copy._hasSkillLevelBonus = true;
              copy._skillLevelBonus = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkillLevelBonus) {
                return this;
              }
              const copy = new CardAwaken(this);
              copy._hasSkillLevelBonus = false;
              copy._skillLevelBonus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardAwaken} other
   * @returns {CardAwaken}
   */
  merge(other) {
    const copy = new CardAwaken(this);
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    copy._awakenUpgrades = this._awakenUpgrades.concat(other._awakenUpgrades);
    if (other._hasSkillLevelBonus) {
      copy._hasSkillLevelBonus = true;
      copy._skillLevelBonus = other._skillLevelBonus;
    }
    return copy;
  }
}
CardAwaken.default = new CardAwaken();
CardAwaken.AwakenUpgrade = CardAwaken_AwakenUpgrade;
class CardAwaken_Builder {
  constructor(value) {
    this._value = new CardAwaken(value);
  }
  build() {
    return new CardAwaken(this._value);
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  addAllAwakenUpgrades(values) {
    this._value._awakenUpgrades = this._value._awakenUpgrades.concat(values);
    return this;
  }
  addAwakenUpgrades(value) {
    this._value._awakenUpgrades = this._value._awakenUpgrades.concat([value]);
    return this;
  }
  setAwakenUpgrades(index, value) {
    this._value._awakenUpgrades = this._value._awakenUpgrades.concat();
    this._value._awakenUpgrades[index] = value;
    return this;
  }
  clearAwakenUpgrades() {
    this._value._awakenUpgrades = [];
    return this;
  }
  setSkillLevelBonus(value) {
    this._value._hasSkillLevelBonus = true;
    this._value._skillLevelBonus = value;
    return this;
  }
  deleteSkillLevelBonus() {
    this._value._hasSkillLevelBonus = false;
    this._value._skillLevelBonus = null;
    return this;
  }
}
CardAwaken.Builder = CardAwaken_Builder;
class CardAwaken_WithParent {
  /**
   * @param {CardAwaken} value
   * @param {CardAwaken_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardAwaken.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get selfAwakenUpgrades() {
    if (!this._selfAwakenUpgrades) {
      this._selfAwakenUpgrades = [];
      for (let i of this._value.awakenUpgrades) {
        this._selfAwakenUpgrades.push(new CardAwaken_AwakenUpgrade.WithParent(i, null));
      }
    }
    return this._selfAwakenUpgrades;
  }
  get inherentAwakenUpgrades() {
    if (!this._inherentAwakenUpgrades) {
      this._inherentAwakenUpgrades = this._parent ? this._parent.awakenUpgrades : [];
    }
    return this._inherentAwakenUpgrades;
  }
  get awakenUpgrades() {
    if (!this._allAwakenUpgrades) {
      this._allAwakenUpgrades = this._parent ? this._parent.awakenUpgrades.concat(this.selfAwakenUpgrades) : this.selfAwakenUpgrades;
    }
    return this._allAwakenUpgrades;
  }
  get hasSkillLevelBonus() {
    if (this._cachedHasSkillLevelBonus === undefined) {
      if (this._value.hasSkillLevelBonus) {
        this._cachedHasSkillLevelBonus = true;
      } else {
        this._cachedHasSkillLevelBonus = this._parent ? this._parent.hasSkillLevelBonus : false;
      }
    }
    return this._cachedHasSkillLevelBonus;
  }
  get skillLevelBonus() {
    if (this._cachedSkillLevelBonus === undefined) {
      if (this._value.hasSkillLevelBonus) {
        this._cachedSkillLevelBonus = this._value.skillLevelBonus;
      } else {
        this._cachedSkillLevelBonus = this._parent ? this._parent.skillLevelBonus : this._value.skillLevelBonus;
      }
    }
    return this._cachedSkillLevelBonus;
  }
  update(current, parent) {
    const result = new CardAwaken_WithParent(current, parent);
    if (this._selfAwakenUpgrades) {
      if (this._value.awakenUpgrades === current.awakenUpgrades) {
        result._selfAwakenUpgrades = this._selfAwakenUpgrades;
      } else {
        result._selfAwakenUpgrades = [];
        for (let i = 0; i < current.awakenUpgrades.length; i++) {
          const oldValue = this._value.awakenUpgrades[i];
          if (oldValue) {
            const oldCache = this._selfAwakenUpgrades[i];
            if (oldValue === current.awakenUpgrades[i]) {
              result._selfAwakenUpgrades[i] = oldCache;
            } else {
              result._selfAwakenUpgrades[i] = oldCache.update(current.awakenUpgrades[i], null);
            }
          } else {
            result._selfAwakenUpgrades[i] = new CardAwaken_AwakenUpgrade.WithParent(current.awakenUpgrades[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardAwaken_WithParent.default = new CardAwaken_WithParent(CardAwaken.default, null);
CardAwaken.WithParent = CardAwaken_WithParent;
class CardAwaken_Descriptor {
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 1,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get awakenUpgrades() {
    if (!this._awakenUpgrades) {
      this._awakenUpgrades = {
        name: "awakenUpgrades",
        Name: "AwakenUpgrades",
        number: 2,
        protoType: 11,
        protoName: "awaken_upgrades",
        type: CardAwaken_AwakenUpgrade,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awakenUpgrades;
  }
  get skillLevelBonus() {
    if (!this._skillLevelBonus) {
      this._skillLevelBonus = {
        name: "skillLevelBonus",
        Name: "SkillLevelBonus",
        number: 3,
        protoType: 5,
        protoName: "skill_level_bonus",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skillLevelBonus;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.description,
        this.awakenUpgrades,
        this.skillLevelBonus,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkillLevelBonus",
        Name: "DummyOneofForSkillLevelBonus",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
CardAwaken.descriptor = new CardAwaken_Descriptor();
export class SkillRechargeConfig {
  get descriptor() {
    return SkillRechargeConfig.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCurrency = false;
    this._currency = null;
    this._hasCost = false;
    this._cost = null;
    this._hasChancePerDay = false;
    this._chancePerDay = null;
    this._hasDailyRefreshTime = false;
    this._dailyRefreshTime = null;
  }
  isEmpty() {
    if (this._hasCurrency) return false;
    if (this._hasCost) return false;
    if (this._hasChancePerDay) return false;
    if (this._hasDailyRefreshTime) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof SkillRechargeConfig) {
      return value;
    }
    return SkillRechargeConfig.fromJson(value);
  }
  static fromJson(json) {
    const result = new SkillRechargeConfig();
    if (json.currency != null) {
      result._hasCurrency = true;
      result._currency = JsonToString.fromJson(json.currency);
    }
    if (json.cost != null) {
      result._hasCost = true;
      result._cost = JsonToInt32.fromJson(json.cost);
    }
    if (json.chancePerDay != null) {
      result._hasChancePerDay = true;
      result._chancePerDay = JsonToInt32.fromJson(json.chancePerDay);
    }
    if (json.dailyRefreshTime != null) {
      result._hasDailyRefreshTime = true;
      result._dailyRefreshTime = JsonToInt32.fromJson(json.dailyRefreshTime);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCurrency) {
      result.currency = JsonToString.toJson(this._currency);
    }
    if (this._hasCost) {
      result.cost = JsonToInt32.toJson(this._cost);
    }
    if (this._hasChancePerDay) {
      result.chancePerDay = JsonToInt32.toJson(this._chancePerDay);
    }
    if (this._hasDailyRefreshTime) {
      result.dailyRefreshTime = JsonToInt32.toJson(this._dailyRefreshTime);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get currency() {
    return this._hasCurrency ? this._currency : JsonToString.default;
  }
  get hasCurrency() {
    return this._hasCurrency;
  }
  setCurrency(path, value) {
    return {type: 'SET', path: path.concat(['currency']), value};
  }
  deleteCurrency(path) {
    return {type: 'DELETE', path: path.concat(['currency'])};
  }
  /**
   * @returns {number}
   */
  get cost() {
    return this._hasCost ? this._cost : JsonToInt32.default;
  }
  get hasCost() {
    return this._hasCost;
  }
  setCost(path, value) {
    return {type: 'SET', path: path.concat(['cost']), value};
  }
  deleteCost(path) {
    return {type: 'DELETE', path: path.concat(['cost'])};
  }
  /**
   * @returns {number}
   */
  get chancePerDay() {
    return this._hasChancePerDay ? this._chancePerDay : JsonToInt32.default;
  }
  get hasChancePerDay() {
    return this._hasChancePerDay;
  }
  setChancePerDay(path, value) {
    return {type: 'SET', path: path.concat(['chancePerDay']), value};
  }
  deleteChancePerDay(path) {
    return {type: 'DELETE', path: path.concat(['chancePerDay'])};
  }
  /**
   * @returns {number}
   */
  get dailyRefreshTime() {
    return this._hasDailyRefreshTime ? this._dailyRefreshTime : JsonToInt32.default;
  }
  get hasDailyRefreshTime() {
    return this._hasDailyRefreshTime;
  }
  setDailyRefreshTime(path, value) {
    return {type: 'SET', path: path.concat(['dailyRefreshTime']), value};
  }
  deleteDailyRefreshTime(path) {
    return {type: 'DELETE', path: path.concat(['dailyRefreshTime'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "currency": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillRechargeConfig(this);
              copy._hasCurrency = true;
              copy._currency = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCurrency) {
                return this;
              }
              const copy = new SkillRechargeConfig(this);
              copy._hasCurrency = false;
              copy._currency = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillRechargeConfig(this);
              copy._hasCost = true;
              copy._cost = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCost) {
                return this;
              }
              const copy = new SkillRechargeConfig(this);
              copy._hasCost = false;
              copy._cost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chancePerDay": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillRechargeConfig(this);
              copy._hasChancePerDay = true;
              copy._chancePerDay = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChancePerDay) {
                return this;
              }
              const copy = new SkillRechargeConfig(this);
              copy._hasChancePerDay = false;
              copy._chancePerDay = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dailyRefreshTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new SkillRechargeConfig(this);
              copy._hasDailyRefreshTime = true;
              copy._dailyRefreshTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDailyRefreshTime) {
                return this;
              }
              const copy = new SkillRechargeConfig(this);
              copy._hasDailyRefreshTime = false;
              copy._dailyRefreshTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {SkillRechargeConfig} other
   * @returns {SkillRechargeConfig}
   */
  merge(other) {
    const copy = new SkillRechargeConfig(this);
    if (other._hasCurrency) {
      copy._hasCurrency = true;
      copy._currency = other._currency;
    }
    if (other._hasCost) {
      copy._hasCost = true;
      copy._cost = other._cost;
    }
    if (other._hasChancePerDay) {
      copy._hasChancePerDay = true;
      copy._chancePerDay = other._chancePerDay;
    }
    if (other._hasDailyRefreshTime) {
      copy._hasDailyRefreshTime = true;
      copy._dailyRefreshTime = other._dailyRefreshTime;
    }
    return copy;
  }
}
SkillRechargeConfig.default = new SkillRechargeConfig();
class SkillRechargeConfig_Builder {
  constructor(value) {
    this._value = new SkillRechargeConfig(value);
  }
  build() {
    return new SkillRechargeConfig(this._value);
  }
  setCurrency(value) {
    this._value._hasCurrency = true;
    this._value._currency = value;
    return this;
  }
  deleteCurrency() {
    this._value._hasCurrency = false;
    this._value._currency = null;
    return this;
  }
  setCost(value) {
    this._value._hasCost = true;
    this._value._cost = value;
    return this;
  }
  deleteCost() {
    this._value._hasCost = false;
    this._value._cost = null;
    return this;
  }
  setChancePerDay(value) {
    this._value._hasChancePerDay = true;
    this._value._chancePerDay = value;
    return this;
  }
  deleteChancePerDay() {
    this._value._hasChancePerDay = false;
    this._value._chancePerDay = null;
    return this;
  }
  setDailyRefreshTime(value) {
    this._value._hasDailyRefreshTime = true;
    this._value._dailyRefreshTime = value;
    return this;
  }
  deleteDailyRefreshTime() {
    this._value._hasDailyRefreshTime = false;
    this._value._dailyRefreshTime = null;
    return this;
  }
}
SkillRechargeConfig.Builder = SkillRechargeConfig_Builder;
class SkillRechargeConfig_WithParent {
  /**
   * @param {SkillRechargeConfig} value
   * @param {SkillRechargeConfig_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return SkillRechargeConfig.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCurrency() {
    if (this._cachedHasCurrency === undefined) {
      if (this._value.hasCurrency) {
        this._cachedHasCurrency = true;
      } else {
        this._cachedHasCurrency = this._parent ? this._parent.hasCurrency : false;
      }
    }
    return this._cachedHasCurrency;
  }
  get currency() {
    if (this._cachedCurrency === undefined) {
      if (this._value.hasCurrency) {
        this._cachedCurrency = this._value.currency;
      } else {
        this._cachedCurrency = this._parent ? this._parent.currency : this._value.currency;
      }
    }
    return this._cachedCurrency;
  }
  get hasCost() {
    if (this._cachedHasCost === undefined) {
      if (this._value.hasCost) {
        this._cachedHasCost = true;
      } else {
        this._cachedHasCost = this._parent ? this._parent.hasCost : false;
      }
    }
    return this._cachedHasCost;
  }
  get cost() {
    if (this._cachedCost === undefined) {
      if (this._value.hasCost) {
        this._cachedCost = this._value.cost;
      } else {
        this._cachedCost = this._parent ? this._parent.cost : this._value.cost;
      }
    }
    return this._cachedCost;
  }
  get hasChancePerDay() {
    if (this._cachedHasChancePerDay === undefined) {
      if (this._value.hasChancePerDay) {
        this._cachedHasChancePerDay = true;
      } else {
        this._cachedHasChancePerDay = this._parent ? this._parent.hasChancePerDay : false;
      }
    }
    return this._cachedHasChancePerDay;
  }
  get chancePerDay() {
    if (this._cachedChancePerDay === undefined) {
      if (this._value.hasChancePerDay) {
        this._cachedChancePerDay = this._value.chancePerDay;
      } else {
        this._cachedChancePerDay = this._parent ? this._parent.chancePerDay : this._value.chancePerDay;
      }
    }
    return this._cachedChancePerDay;
  }
  get hasDailyRefreshTime() {
    if (this._cachedHasDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedHasDailyRefreshTime = true;
      } else {
        this._cachedHasDailyRefreshTime = this._parent ? this._parent.hasDailyRefreshTime : false;
      }
    }
    return this._cachedHasDailyRefreshTime;
  }
  get dailyRefreshTime() {
    if (this._cachedDailyRefreshTime === undefined) {
      if (this._value.hasDailyRefreshTime) {
        this._cachedDailyRefreshTime = this._value.dailyRefreshTime;
      } else {
        this._cachedDailyRefreshTime = this._parent ? this._parent.dailyRefreshTime : this._value.dailyRefreshTime;
      }
    }
    return this._cachedDailyRefreshTime;
  }
  update(current, parent) {
    const result = new SkillRechargeConfig_WithParent(current, parent);
    return result;
  }
}
SkillRechargeConfig_WithParent.default = new SkillRechargeConfig_WithParent(SkillRechargeConfig.default, null);
SkillRechargeConfig.WithParent = SkillRechargeConfig_WithParent;
class SkillRechargeConfig_Descriptor {
  get currency() {
    if (!this._currency) {
      this._currency = {
        name: "currency",
        Name: "Currency",
        number: 1,
        protoType: 9,
        protoName: "currency",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._currency;
  }
  get cost() {
    if (!this._cost) {
      this._cost = {
        name: "cost",
        Name: "Cost",
        number: 2,
        protoType: 5,
        protoName: "cost",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cost;
  }
  get chancePerDay() {
    if (!this._chancePerDay) {
      this._chancePerDay = {
        name: "chancePerDay",
        Name: "ChancePerDay",
        number: 3,
        protoType: 5,
        protoName: "chance_per_day",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chancePerDay;
  }
  get dailyRefreshTime() {
    if (!this._dailyRefreshTime) {
      this._dailyRefreshTime = {
        name: "dailyRefreshTime",
        Name: "DailyRefreshTime",
        number: 4,
        protoType: 5,
        protoName: "daily_refresh_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dailyRefreshTime;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.currency,
        this.cost,
        this.chancePerDay,
        this.dailyRefreshTime,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCurrency",
        Name: "DummyOneofForCurrency",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCost",
        Name: "DummyOneofForCost",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChancePerDay",
        Name: "DummyOneofForChancePerDay",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDailyRefreshTime",
        Name: "DummyOneofForDailyRefreshTime",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
SkillRechargeConfig.descriptor = new SkillRechargeConfig_Descriptor();
class CardInfo_StatsBar {
  get descriptor() {
    return CardInfo_StatsBar.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasIcon = false;
    this._icon = null;
    this._hasFillAmount = false;
    this._fillAmount = null;
  }
  isEmpty() {
    if (this._hasIcon) return false;
    if (this._hasFillAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo_StatsBar) {
      return value;
    }
    return CardInfo_StatsBar.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo_StatsBar();
    if (json.icon != null) {
      result._hasIcon = true;
      result._icon = JsonToString.fromJson(json.icon);
    }
    if (json.fillAmount != null) {
      result._hasFillAmount = true;
      result._fillAmount = JsonToDouble.fromJson(json.fillAmount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasIcon) {
      result.icon = JsonToString.toJson(this._icon);
    }
    if (this._hasFillAmount) {
      result.fillAmount = JsonToDouble.toJson(this._fillAmount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get icon() {
    return this._hasIcon ? this._icon : JsonToString.default;
  }
  get hasIcon() {
    return this._hasIcon;
  }
  setIcon(path, value) {
    return {type: 'SET', path: path.concat(['icon']), value};
  }
  deleteIcon(path) {
    return {type: 'DELETE', path: path.concat(['icon'])};
  }
  /**
   * @returns {number}
   */
  get fillAmount() {
    return this._hasFillAmount ? this._fillAmount : JsonToDouble.default;
  }
  get hasFillAmount() {
    return this._hasFillAmount;
  }
  setFillAmount(path, value) {
    return {type: 'SET', path: path.concat(['fillAmount']), value};
  }
  deleteFillAmount(path) {
    return {type: 'DELETE', path: path.concat(['fillAmount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "icon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_StatsBar(this);
              copy._hasIcon = true;
              copy._icon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIcon) {
                return this;
              }
              const copy = new CardInfo_StatsBar(this);
              copy._hasIcon = false;
              copy._icon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "fillAmount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_StatsBar(this);
              copy._hasFillAmount = true;
              copy._fillAmount = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFillAmount) {
                return this;
              }
              const copy = new CardInfo_StatsBar(this);
              copy._hasFillAmount = false;
              copy._fillAmount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo_StatsBar} other
   * @returns {CardInfo_StatsBar}
   */
  merge(other) {
    const copy = new CardInfo_StatsBar(this);
    if (other._hasIcon) {
      copy._hasIcon = true;
      copy._icon = other._icon;
    }
    if (other._hasFillAmount) {
      copy._hasFillAmount = true;
      copy._fillAmount = other._fillAmount;
    }
    return copy;
  }
}
CardInfo_StatsBar.default = new CardInfo_StatsBar();
class CardInfo_StatsBar_Builder {
  constructor(value) {
    this._value = new CardInfo_StatsBar(value);
  }
  build() {
    return new CardInfo_StatsBar(this._value);
  }
  setIcon(value) {
    this._value._hasIcon = true;
    this._value._icon = value;
    return this;
  }
  deleteIcon() {
    this._value._hasIcon = false;
    this._value._icon = null;
    return this;
  }
  setFillAmount(value) {
    this._value._hasFillAmount = true;
    this._value._fillAmount = value;
    return this;
  }
  deleteFillAmount() {
    this._value._hasFillAmount = false;
    this._value._fillAmount = null;
    return this;
  }
}
CardInfo_StatsBar.Builder = CardInfo_StatsBar_Builder;
class CardInfo_StatsBar_WithParent {
  /**
   * @param {CardInfo_StatsBar} value
   * @param {CardInfo_StatsBar_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo_StatsBar.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasIcon() {
    if (this._cachedHasIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedHasIcon = true;
      } else {
        this._cachedHasIcon = this._parent ? this._parent.hasIcon : false;
      }
    }
    return this._cachedHasIcon;
  }
  get icon() {
    if (this._cachedIcon === undefined) {
      if (this._value.hasIcon) {
        this._cachedIcon = this._value.icon;
      } else {
        this._cachedIcon = this._parent ? this._parent.icon : this._value.icon;
      }
    }
    return this._cachedIcon;
  }
  get hasFillAmount() {
    if (this._cachedHasFillAmount === undefined) {
      if (this._value.hasFillAmount) {
        this._cachedHasFillAmount = true;
      } else {
        this._cachedHasFillAmount = this._parent ? this._parent.hasFillAmount : false;
      }
    }
    return this._cachedHasFillAmount;
  }
  get fillAmount() {
    if (this._cachedFillAmount === undefined) {
      if (this._value.hasFillAmount) {
        this._cachedFillAmount = this._value.fillAmount;
      } else {
        this._cachedFillAmount = this._parent ? this._parent.fillAmount : this._value.fillAmount;
      }
    }
    return this._cachedFillAmount;
  }
  update(current, parent) {
    const result = new CardInfo_StatsBar_WithParent(current, parent);
    return result;
  }
}
CardInfo_StatsBar_WithParent.default = new CardInfo_StatsBar_WithParent(CardInfo_StatsBar.default, null);
CardInfo_StatsBar.WithParent = CardInfo_StatsBar_WithParent;
class CardInfo_StatsBar_Descriptor {
  get icon() {
    if (!this._icon) {
      this._icon = {
        name: "icon",
        Name: "Icon",
        number: 1,
        protoType: 9,
        protoName: "icon",
        type: JsonToString,
        options: {
          valueDropdown: "CardInfoStatsIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._icon;
  }
  get fillAmount() {
    if (!this._fillAmount) {
      this._fillAmount = {
        name: "fillAmount",
        Name: "FillAmount",
        number: 2,
        protoType: 1,
        protoName: "fill_amount",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._fillAmount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.icon,
        this.fillAmount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForIcon",
        Name: "DummyOneofForIcon",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFillAmount",
        Name: "DummyOneofForFillAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo_StatsBar.descriptor = new CardInfo_StatsBar_Descriptor();
class CardInfo_Story {
  get descriptor() {
    return CardInfo_Story.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTitle = false;
    this._title = null;
    this._hasContent = false;
    this._content = null;
  }
  isEmpty() {
    if (this._hasTitle) return false;
    if (this._hasContent) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo_Story) {
      return value;
    }
    return CardInfo_Story.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo_Story();
    if (json.title != null) {
      result._hasTitle = true;
      result._title = JsonToString.fromJson(json.title);
    }
    if (json.content != null) {
      result._hasContent = true;
      result._content = JsonToString.fromJson(json.content);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTitle) {
      result.title = JsonToString.toJson(this._title);
    }
    if (this._hasContent) {
      result.content = JsonToString.toJson(this._content);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get title() {
    return this._hasTitle ? this._title : JsonToString.default;
  }
  get hasTitle() {
    return this._hasTitle;
  }
  setTitle(path, value) {
    return {type: 'SET', path: path.concat(['title']), value};
  }
  deleteTitle(path) {
    return {type: 'DELETE', path: path.concat(['title'])};
  }
  /**
   * @returns {string}
   */
  get content() {
    return this._hasContent ? this._content : JsonToString.default;
  }
  get hasContent() {
    return this._hasContent;
  }
  setContent(path, value) {
    return {type: 'SET', path: path.concat(['content']), value};
  }
  deleteContent(path) {
    return {type: 'DELETE', path: path.concat(['content'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "title": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_Story(this);
              copy._hasTitle = true;
              copy._title = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTitle) {
                return this;
              }
              const copy = new CardInfo_Story(this);
              copy._hasTitle = false;
              copy._title = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "content": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_Story(this);
              copy._hasContent = true;
              copy._content = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasContent) {
                return this;
              }
              const copy = new CardInfo_Story(this);
              copy._hasContent = false;
              copy._content = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo_Story} other
   * @returns {CardInfo_Story}
   */
  merge(other) {
    const copy = new CardInfo_Story(this);
    if (other._hasTitle) {
      copy._hasTitle = true;
      copy._title = other._title;
    }
    if (other._hasContent) {
      copy._hasContent = true;
      copy._content = other._content;
    }
    return copy;
  }
}
CardInfo_Story.default = new CardInfo_Story();
class CardInfo_Story_Builder {
  constructor(value) {
    this._value = new CardInfo_Story(value);
  }
  build() {
    return new CardInfo_Story(this._value);
  }
  setTitle(value) {
    this._value._hasTitle = true;
    this._value._title = value;
    return this;
  }
  deleteTitle() {
    this._value._hasTitle = false;
    this._value._title = null;
    return this;
  }
  setContent(value) {
    this._value._hasContent = true;
    this._value._content = value;
    return this;
  }
  deleteContent() {
    this._value._hasContent = false;
    this._value._content = null;
    return this;
  }
}
CardInfo_Story.Builder = CardInfo_Story_Builder;
class CardInfo_Story_WithParent {
  /**
   * @param {CardInfo_Story} value
   * @param {CardInfo_Story_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo_Story.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTitle() {
    if (this._cachedHasTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedHasTitle = true;
      } else {
        this._cachedHasTitle = this._parent ? this._parent.hasTitle : false;
      }
    }
    return this._cachedHasTitle;
  }
  get title() {
    if (this._cachedTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedTitle = this._value.title;
      } else {
        this._cachedTitle = this._parent ? this._parent.title : this._value.title;
      }
    }
    return this._cachedTitle;
  }
  get hasContent() {
    if (this._cachedHasContent === undefined) {
      if (this._value.hasContent) {
        this._cachedHasContent = true;
      } else {
        this._cachedHasContent = this._parent ? this._parent.hasContent : false;
      }
    }
    return this._cachedHasContent;
  }
  get content() {
    if (this._cachedContent === undefined) {
      if (this._value.hasContent) {
        this._cachedContent = this._value.content;
      } else {
        this._cachedContent = this._parent ? this._parent.content : this._value.content;
      }
    }
    return this._cachedContent;
  }
  update(current, parent) {
    const result = new CardInfo_Story_WithParent(current, parent);
    return result;
  }
}
CardInfo_Story_WithParent.default = new CardInfo_Story_WithParent(CardInfo_Story.default, null);
CardInfo_Story.WithParent = CardInfo_Story_WithParent;
class CardInfo_Story_Descriptor {
  get title() {
    if (!this._title) {
      this._title = {
        name: "title",
        Name: "Title",
        number: 1,
        protoType: 9,
        protoName: "title",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._title;
  }
  get content() {
    if (!this._content) {
      this._content = {
        name: "content",
        Name: "Content",
        number: 2,
        protoType: 9,
        protoName: "content",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._content;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.title,
        this.content,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTitle",
        Name: "DummyOneofForTitle",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForContent",
        Name: "DummyOneofForContent",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo_Story.descriptor = new CardInfo_Story_Descriptor();
class CardInfo_HeroCardStats {
  get descriptor() {
    return CardInfo_HeroCardStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasOffensive = false;
    this._offensive = null;
    this._hasDefensive = false;
    this._defensive = null;
    this._hasControl = false;
    this._control = null;
    this._hasSupportive = false;
    this._supportive = null;
    this._hasSpeed = false;
    this._speed = null;
  }
  isEmpty() {
    if (this._hasOffensive) return false;
    if (this._hasDefensive) return false;
    if (this._hasControl) return false;
    if (this._hasSupportive) return false;
    if (this._hasSpeed) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo_HeroCardStats) {
      return value;
    }
    return CardInfo_HeroCardStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo_HeroCardStats();
    if (json.offensive != null) {
      result._hasOffensive = true;
      result._offensive = JsonToDouble.fromJson(json.offensive);
    }
    if (json.defensive != null) {
      result._hasDefensive = true;
      result._defensive = JsonToDouble.fromJson(json.defensive);
    }
    if (json.control != null) {
      result._hasControl = true;
      result._control = JsonToDouble.fromJson(json.control);
    }
    if (json.supportive != null) {
      result._hasSupportive = true;
      result._supportive = JsonToDouble.fromJson(json.supportive);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasOffensive) {
      result.offensive = JsonToDouble.toJson(this._offensive);
    }
    if (this._hasDefensive) {
      result.defensive = JsonToDouble.toJson(this._defensive);
    }
    if (this._hasControl) {
      result.control = JsonToDouble.toJson(this._control);
    }
    if (this._hasSupportive) {
      result.supportive = JsonToDouble.toJson(this._supportive);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get offensive() {
    return this._hasOffensive ? this._offensive : JsonToDouble.default;
  }
  get hasOffensive() {
    return this._hasOffensive;
  }
  setOffensive(path, value) {
    return {type: 'SET', path: path.concat(['offensive']), value};
  }
  deleteOffensive(path) {
    return {type: 'DELETE', path: path.concat(['offensive'])};
  }
  /**
   * @returns {number}
   */
  get defensive() {
    return this._hasDefensive ? this._defensive : JsonToDouble.default;
  }
  get hasDefensive() {
    return this._hasDefensive;
  }
  setDefensive(path, value) {
    return {type: 'SET', path: path.concat(['defensive']), value};
  }
  deleteDefensive(path) {
    return {type: 'DELETE', path: path.concat(['defensive'])};
  }
  /**
   * @returns {number}
   */
  get control() {
    return this._hasControl ? this._control : JsonToDouble.default;
  }
  get hasControl() {
    return this._hasControl;
  }
  setControl(path, value) {
    return {type: 'SET', path: path.concat(['control']), value};
  }
  deleteControl(path) {
    return {type: 'DELETE', path: path.concat(['control'])};
  }
  /**
   * @returns {number}
   */
  get supportive() {
    return this._hasSupportive ? this._supportive : JsonToDouble.default;
  }
  get hasSupportive() {
    return this._hasSupportive;
  }
  setSupportive(path, value) {
    return {type: 'SET', path: path.concat(['supportive']), value};
  }
  deleteSupportive(path) {
    return {type: 'DELETE', path: path.concat(['supportive'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "offensive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasOffensive = true;
              copy._offensive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffensive) {
                return this;
              }
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasOffensive = false;
              copy._offensive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "defensive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasDefensive = true;
              copy._defensive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefensive) {
                return this;
              }
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasDefensive = false;
              copy._defensive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "control": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasControl = true;
              copy._control = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasControl) {
                return this;
              }
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasControl = false;
              copy._control = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "supportive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasSupportive = true;
              copy._supportive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSupportive) {
                return this;
              }
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasSupportive = false;
              copy._supportive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new CardInfo_HeroCardStats(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo_HeroCardStats} other
   * @returns {CardInfo_HeroCardStats}
   */
  merge(other) {
    const copy = new CardInfo_HeroCardStats(this);
    if (other._hasOffensive) {
      copy._hasOffensive = true;
      copy._offensive = other._offensive;
    }
    if (other._hasDefensive) {
      copy._hasDefensive = true;
      copy._defensive = other._defensive;
    }
    if (other._hasControl) {
      copy._hasControl = true;
      copy._control = other._control;
    }
    if (other._hasSupportive) {
      copy._hasSupportive = true;
      copy._supportive = other._supportive;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    return copy;
  }
}
CardInfo_HeroCardStats.default = new CardInfo_HeroCardStats();
class CardInfo_HeroCardStats_Builder {
  constructor(value) {
    this._value = new CardInfo_HeroCardStats(value);
  }
  build() {
    return new CardInfo_HeroCardStats(this._value);
  }
  setOffensive(value) {
    this._value._hasOffensive = true;
    this._value._offensive = value;
    return this;
  }
  deleteOffensive() {
    this._value._hasOffensive = false;
    this._value._offensive = null;
    return this;
  }
  setDefensive(value) {
    this._value._hasDefensive = true;
    this._value._defensive = value;
    return this;
  }
  deleteDefensive() {
    this._value._hasDefensive = false;
    this._value._defensive = null;
    return this;
  }
  setControl(value) {
    this._value._hasControl = true;
    this._value._control = value;
    return this;
  }
  deleteControl() {
    this._value._hasControl = false;
    this._value._control = null;
    return this;
  }
  setSupportive(value) {
    this._value._hasSupportive = true;
    this._value._supportive = value;
    return this;
  }
  deleteSupportive() {
    this._value._hasSupportive = false;
    this._value._supportive = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
}
CardInfo_HeroCardStats.Builder = CardInfo_HeroCardStats_Builder;
class CardInfo_HeroCardStats_WithParent {
  /**
   * @param {CardInfo_HeroCardStats} value
   * @param {CardInfo_HeroCardStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo_HeroCardStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasOffensive() {
    if (this._cachedHasOffensive === undefined) {
      if (this._value.hasOffensive) {
        this._cachedHasOffensive = true;
      } else {
        this._cachedHasOffensive = this._parent ? this._parent.hasOffensive : false;
      }
    }
    return this._cachedHasOffensive;
  }
  get offensive() {
    if (this._cachedOffensive === undefined) {
      if (this._value.hasOffensive) {
        this._cachedOffensive = this._value.offensive;
      } else {
        this._cachedOffensive = this._parent ? this._parent.offensive : this._value.offensive;
      }
    }
    return this._cachedOffensive;
  }
  get hasDefensive() {
    if (this._cachedHasDefensive === undefined) {
      if (this._value.hasDefensive) {
        this._cachedHasDefensive = true;
      } else {
        this._cachedHasDefensive = this._parent ? this._parent.hasDefensive : false;
      }
    }
    return this._cachedHasDefensive;
  }
  get defensive() {
    if (this._cachedDefensive === undefined) {
      if (this._value.hasDefensive) {
        this._cachedDefensive = this._value.defensive;
      } else {
        this._cachedDefensive = this._parent ? this._parent.defensive : this._value.defensive;
      }
    }
    return this._cachedDefensive;
  }
  get hasControl() {
    if (this._cachedHasControl === undefined) {
      if (this._value.hasControl) {
        this._cachedHasControl = true;
      } else {
        this._cachedHasControl = this._parent ? this._parent.hasControl : false;
      }
    }
    return this._cachedHasControl;
  }
  get control() {
    if (this._cachedControl === undefined) {
      if (this._value.hasControl) {
        this._cachedControl = this._value.control;
      } else {
        this._cachedControl = this._parent ? this._parent.control : this._value.control;
      }
    }
    return this._cachedControl;
  }
  get hasSupportive() {
    if (this._cachedHasSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedHasSupportive = true;
      } else {
        this._cachedHasSupportive = this._parent ? this._parent.hasSupportive : false;
      }
    }
    return this._cachedHasSupportive;
  }
  get supportive() {
    if (this._cachedSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedSupportive = this._value.supportive;
      } else {
        this._cachedSupportive = this._parent ? this._parent.supportive : this._value.supportive;
      }
    }
    return this._cachedSupportive;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  update(current, parent) {
    const result = new CardInfo_HeroCardStats_WithParent(current, parent);
    return result;
  }
}
CardInfo_HeroCardStats_WithParent.default = new CardInfo_HeroCardStats_WithParent(CardInfo_HeroCardStats.default, null);
CardInfo_HeroCardStats.WithParent = CardInfo_HeroCardStats_WithParent;
class CardInfo_HeroCardStats_Descriptor {
  get offensive() {
    if (!this._offensive) {
      this._offensive = {
        name: "offensive",
        Name: "Offensive",
        number: 1,
        protoType: 1,
        protoName: "offensive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offensive;
  }
  get defensive() {
    if (!this._defensive) {
      this._defensive = {
        name: "defensive",
        Name: "Defensive",
        number: 2,
        protoType: 1,
        protoName: "defensive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defensive;
  }
  get control() {
    if (!this._control) {
      this._control = {
        name: "control",
        Name: "Control",
        number: 3,
        protoType: 1,
        protoName: "control",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._control;
  }
  get supportive() {
    if (!this._supportive) {
      this._supportive = {
        name: "supportive",
        Name: "Supportive",
        number: 4,
        protoType: 1,
        protoName: "supportive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._supportive;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 5,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.offensive,
        this.defensive,
        this.control,
        this.supportive,
        this.speed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOffensive",
        Name: "DummyOneofForOffensive",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDefensive",
        Name: "DummyOneofForDefensive",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForControl",
        Name: "DummyOneofForControl",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSupportive",
        Name: "DummyOneofForSupportive",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo_HeroCardStats.descriptor = new CardInfo_HeroCardStats_Descriptor();
class CardInfo_TowerCardStats {
  get descriptor() {
    return CardInfo_TowerCardStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDamage = false;
    this._damage = null;
    this._hasControl = false;
    this._control = null;
    this._hasSupportive = false;
    this._supportive = null;
    this._hasPrice = false;
    this._price = null;
    this._hasTroopHealth = false;
    this._troopHealth = null;
  }
  isEmpty() {
    if (this._hasDamage) return false;
    if (this._hasControl) return false;
    if (this._hasSupportive) return false;
    if (this._hasPrice) return false;
    if (this._hasTroopHealth) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo_TowerCardStats) {
      return value;
    }
    return CardInfo_TowerCardStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo_TowerCardStats();
    if (json.damage != null) {
      result._hasDamage = true;
      result._damage = JsonToDouble.fromJson(json.damage);
    }
    if (json.control != null) {
      result._hasControl = true;
      result._control = JsonToDouble.fromJson(json.control);
    }
    if (json.supportive != null) {
      result._hasSupportive = true;
      result._supportive = JsonToDouble.fromJson(json.supportive);
    }
    if (json.price != null) {
      result._hasPrice = true;
      result._price = JsonToDouble.fromJson(json.price);
    }
    if (json.troopHealth != null) {
      result._hasTroopHealth = true;
      result._troopHealth = JsonToDouble.fromJson(json.troopHealth);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDamage) {
      result.damage = JsonToDouble.toJson(this._damage);
    }
    if (this._hasControl) {
      result.control = JsonToDouble.toJson(this._control);
    }
    if (this._hasSupportive) {
      result.supportive = JsonToDouble.toJson(this._supportive);
    }
    if (this._hasPrice) {
      result.price = JsonToDouble.toJson(this._price);
    }
    if (this._hasTroopHealth) {
      result.troopHealth = JsonToDouble.toJson(this._troopHealth);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get damage() {
    return this._hasDamage ? this._damage : JsonToDouble.default;
  }
  get hasDamage() {
    return this._hasDamage;
  }
  setDamage(path, value) {
    return {type: 'SET', path: path.concat(['damage']), value};
  }
  deleteDamage(path) {
    return {type: 'DELETE', path: path.concat(['damage'])};
  }
  /**
   * @returns {number}
   */
  get control() {
    return this._hasControl ? this._control : JsonToDouble.default;
  }
  get hasControl() {
    return this._hasControl;
  }
  setControl(path, value) {
    return {type: 'SET', path: path.concat(['control']), value};
  }
  deleteControl(path) {
    return {type: 'DELETE', path: path.concat(['control'])};
  }
  /**
   * @returns {number}
   */
  get supportive() {
    return this._hasSupportive ? this._supportive : JsonToDouble.default;
  }
  get hasSupportive() {
    return this._hasSupportive;
  }
  setSupportive(path, value) {
    return {type: 'SET', path: path.concat(['supportive']), value};
  }
  deleteSupportive(path) {
    return {type: 'DELETE', path: path.concat(['supportive'])};
  }
  /**
   * @returns {number}
   */
  get price() {
    return this._hasPrice ? this._price : JsonToDouble.default;
  }
  get hasPrice() {
    return this._hasPrice;
  }
  setPrice(path, value) {
    return {type: 'SET', path: path.concat(['price']), value};
  }
  deletePrice(path) {
    return {type: 'DELETE', path: path.concat(['price'])};
  }
  /**
   * @returns {number}
   */
  get troopHealth() {
    return this._hasTroopHealth ? this._troopHealth : JsonToDouble.default;
  }
  get hasTroopHealth() {
    return this._hasTroopHealth;
  }
  setTroopHealth(path, value) {
    return {type: 'SET', path: path.concat(['troopHealth']), value};
  }
  deleteTroopHealth(path) {
    return {type: 'DELETE', path: path.concat(['troopHealth'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "damage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasDamage = true;
              copy._damage = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamage) {
                return this;
              }
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasDamage = false;
              copy._damage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "control": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasControl = true;
              copy._control = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasControl) {
                return this;
              }
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasControl = false;
              copy._control = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "supportive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasSupportive = true;
              copy._supportive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSupportive) {
                return this;
              }
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasSupportive = false;
              copy._supportive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "price": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasPrice = true;
              copy._price = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrice) {
                return this;
              }
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasPrice = false;
              copy._price = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "troopHealth": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasTroopHealth = true;
              copy._troopHealth = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTroopHealth) {
                return this;
              }
              const copy = new CardInfo_TowerCardStats(this);
              copy._hasTroopHealth = false;
              copy._troopHealth = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo_TowerCardStats} other
   * @returns {CardInfo_TowerCardStats}
   */
  merge(other) {
    const copy = new CardInfo_TowerCardStats(this);
    if (other._hasDamage) {
      copy._hasDamage = true;
      copy._damage = other._damage;
    }
    if (other._hasControl) {
      copy._hasControl = true;
      copy._control = other._control;
    }
    if (other._hasSupportive) {
      copy._hasSupportive = true;
      copy._supportive = other._supportive;
    }
    if (other._hasPrice) {
      copy._hasPrice = true;
      copy._price = other._price;
    }
    if (other._hasTroopHealth) {
      copy._hasTroopHealth = true;
      copy._troopHealth = other._troopHealth;
    }
    return copy;
  }
}
CardInfo_TowerCardStats.default = new CardInfo_TowerCardStats();
class CardInfo_TowerCardStats_Builder {
  constructor(value) {
    this._value = new CardInfo_TowerCardStats(value);
  }
  build() {
    return new CardInfo_TowerCardStats(this._value);
  }
  setDamage(value) {
    this._value._hasDamage = true;
    this._value._damage = value;
    return this;
  }
  deleteDamage() {
    this._value._hasDamage = false;
    this._value._damage = null;
    return this;
  }
  setControl(value) {
    this._value._hasControl = true;
    this._value._control = value;
    return this;
  }
  deleteControl() {
    this._value._hasControl = false;
    this._value._control = null;
    return this;
  }
  setSupportive(value) {
    this._value._hasSupportive = true;
    this._value._supportive = value;
    return this;
  }
  deleteSupportive() {
    this._value._hasSupportive = false;
    this._value._supportive = null;
    return this;
  }
  setPrice(value) {
    this._value._hasPrice = true;
    this._value._price = value;
    return this;
  }
  deletePrice() {
    this._value._hasPrice = false;
    this._value._price = null;
    return this;
  }
  setTroopHealth(value) {
    this._value._hasTroopHealth = true;
    this._value._troopHealth = value;
    return this;
  }
  deleteTroopHealth() {
    this._value._hasTroopHealth = false;
    this._value._troopHealth = null;
    return this;
  }
}
CardInfo_TowerCardStats.Builder = CardInfo_TowerCardStats_Builder;
class CardInfo_TowerCardStats_WithParent {
  /**
   * @param {CardInfo_TowerCardStats} value
   * @param {CardInfo_TowerCardStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo_TowerCardStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDamage() {
    if (this._cachedHasDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedHasDamage = true;
      } else {
        this._cachedHasDamage = this._parent ? this._parent.hasDamage : false;
      }
    }
    return this._cachedHasDamage;
  }
  get damage() {
    if (this._cachedDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedDamage = this._value.damage;
      } else {
        this._cachedDamage = this._parent ? this._parent.damage : this._value.damage;
      }
    }
    return this._cachedDamage;
  }
  get hasControl() {
    if (this._cachedHasControl === undefined) {
      if (this._value.hasControl) {
        this._cachedHasControl = true;
      } else {
        this._cachedHasControl = this._parent ? this._parent.hasControl : false;
      }
    }
    return this._cachedHasControl;
  }
  get control() {
    if (this._cachedControl === undefined) {
      if (this._value.hasControl) {
        this._cachedControl = this._value.control;
      } else {
        this._cachedControl = this._parent ? this._parent.control : this._value.control;
      }
    }
    return this._cachedControl;
  }
  get hasSupportive() {
    if (this._cachedHasSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedHasSupportive = true;
      } else {
        this._cachedHasSupportive = this._parent ? this._parent.hasSupportive : false;
      }
    }
    return this._cachedHasSupportive;
  }
  get supportive() {
    if (this._cachedSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedSupportive = this._value.supportive;
      } else {
        this._cachedSupportive = this._parent ? this._parent.supportive : this._value.supportive;
      }
    }
    return this._cachedSupportive;
  }
  get hasPrice() {
    if (this._cachedHasPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedHasPrice = true;
      } else {
        this._cachedHasPrice = this._parent ? this._parent.hasPrice : false;
      }
    }
    return this._cachedHasPrice;
  }
  get price() {
    if (this._cachedPrice === undefined) {
      if (this._value.hasPrice) {
        this._cachedPrice = this._value.price;
      } else {
        this._cachedPrice = this._parent ? this._parent.price : this._value.price;
      }
    }
    return this._cachedPrice;
  }
  get hasTroopHealth() {
    if (this._cachedHasTroopHealth === undefined) {
      if (this._value.hasTroopHealth) {
        this._cachedHasTroopHealth = true;
      } else {
        this._cachedHasTroopHealth = this._parent ? this._parent.hasTroopHealth : false;
      }
    }
    return this._cachedHasTroopHealth;
  }
  get troopHealth() {
    if (this._cachedTroopHealth === undefined) {
      if (this._value.hasTroopHealth) {
        this._cachedTroopHealth = this._value.troopHealth;
      } else {
        this._cachedTroopHealth = this._parent ? this._parent.troopHealth : this._value.troopHealth;
      }
    }
    return this._cachedTroopHealth;
  }
  update(current, parent) {
    const result = new CardInfo_TowerCardStats_WithParent(current, parent);
    return result;
  }
}
CardInfo_TowerCardStats_WithParent.default = new CardInfo_TowerCardStats_WithParent(CardInfo_TowerCardStats.default, null);
CardInfo_TowerCardStats.WithParent = CardInfo_TowerCardStats_WithParent;
class CardInfo_TowerCardStats_Descriptor {
  get damage() {
    if (!this._damage) {
      this._damage = {
        name: "damage",
        Name: "Damage",
        number: 1,
        protoType: 1,
        protoName: "damage",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damage;
  }
  get control() {
    if (!this._control) {
      this._control = {
        name: "control",
        Name: "Control",
        number: 2,
        protoType: 1,
        protoName: "control",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._control;
  }
  get supportive() {
    if (!this._supportive) {
      this._supportive = {
        name: "supportive",
        Name: "Supportive",
        number: 3,
        protoType: 1,
        protoName: "supportive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._supportive;
  }
  get price() {
    if (!this._price) {
      this._price = {
        name: "price",
        Name: "Price",
        number: 4,
        protoType: 1,
        protoName: "price",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._price;
  }
  get troopHealth() {
    if (!this._troopHealth) {
      this._troopHealth = {
        name: "troopHealth",
        Name: "TroopHealth",
        number: 5,
        protoType: 1,
        protoName: "troop_health",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._troopHealth;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.damage,
        this.control,
        this.supportive,
        this.price,
        this.troopHealth,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDamage",
        Name: "DummyOneofForDamage",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForControl",
        Name: "DummyOneofForControl",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSupportive",
        Name: "DummyOneofForSupportive",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPrice",
        Name: "DummyOneofForPrice",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTroopHealth",
        Name: "DummyOneofForTroopHealth",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo_TowerCardStats.descriptor = new CardInfo_TowerCardStats_Descriptor();
class CardInfo_SpellCardStats {
  get descriptor() {
    return CardInfo_SpellCardStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDamage = false;
    this._damage = null;
    this._hasControl = false;
    this._control = null;
    this._hasSupportive = false;
    this._supportive = null;
    this._hasManaCost = false;
    this._manaCost = null;
    this._hasCoolDown = false;
    this._coolDown = null;
  }
  isEmpty() {
    if (this._hasDamage) return false;
    if (this._hasControl) return false;
    if (this._hasSupportive) return false;
    if (this._hasManaCost) return false;
    if (this._hasCoolDown) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo_SpellCardStats) {
      return value;
    }
    return CardInfo_SpellCardStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo_SpellCardStats();
    if (json.damage != null) {
      result._hasDamage = true;
      result._damage = JsonToDouble.fromJson(json.damage);
    }
    if (json.control != null) {
      result._hasControl = true;
      result._control = JsonToDouble.fromJson(json.control);
    }
    if (json.supportive != null) {
      result._hasSupportive = true;
      result._supportive = JsonToDouble.fromJson(json.supportive);
    }
    if (json.manaCost != null) {
      result._hasManaCost = true;
      result._manaCost = JsonToDouble.fromJson(json.manaCost);
    }
    if (json.coolDown != null) {
      result._hasCoolDown = true;
      result._coolDown = JsonToDouble.fromJson(json.coolDown);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDamage) {
      result.damage = JsonToDouble.toJson(this._damage);
    }
    if (this._hasControl) {
      result.control = JsonToDouble.toJson(this._control);
    }
    if (this._hasSupportive) {
      result.supportive = JsonToDouble.toJson(this._supportive);
    }
    if (this._hasManaCost) {
      result.manaCost = JsonToDouble.toJson(this._manaCost);
    }
    if (this._hasCoolDown) {
      result.coolDown = JsonToDouble.toJson(this._coolDown);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get damage() {
    return this._hasDamage ? this._damage : JsonToDouble.default;
  }
  get hasDamage() {
    return this._hasDamage;
  }
  setDamage(path, value) {
    return {type: 'SET', path: path.concat(['damage']), value};
  }
  deleteDamage(path) {
    return {type: 'DELETE', path: path.concat(['damage'])};
  }
  /**
   * @returns {number}
   */
  get control() {
    return this._hasControl ? this._control : JsonToDouble.default;
  }
  get hasControl() {
    return this._hasControl;
  }
  setControl(path, value) {
    return {type: 'SET', path: path.concat(['control']), value};
  }
  deleteControl(path) {
    return {type: 'DELETE', path: path.concat(['control'])};
  }
  /**
   * @returns {number}
   */
  get supportive() {
    return this._hasSupportive ? this._supportive : JsonToDouble.default;
  }
  get hasSupportive() {
    return this._hasSupportive;
  }
  setSupportive(path, value) {
    return {type: 'SET', path: path.concat(['supportive']), value};
  }
  deleteSupportive(path) {
    return {type: 'DELETE', path: path.concat(['supportive'])};
  }
  /**
   * @returns {number}
   */
  get manaCost() {
    return this._hasManaCost ? this._manaCost : JsonToDouble.default;
  }
  get hasManaCost() {
    return this._hasManaCost;
  }
  setManaCost(path, value) {
    return {type: 'SET', path: path.concat(['manaCost']), value};
  }
  deleteManaCost(path) {
    return {type: 'DELETE', path: path.concat(['manaCost'])};
  }
  /**
   * @returns {number}
   */
  get coolDown() {
    return this._hasCoolDown ? this._coolDown : JsonToDouble.default;
  }
  get hasCoolDown() {
    return this._hasCoolDown;
  }
  setCoolDown(path, value) {
    return {type: 'SET', path: path.concat(['coolDown']), value};
  }
  deleteCoolDown(path) {
    return {type: 'DELETE', path: path.concat(['coolDown'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "damage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasDamage = true;
              copy._damage = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDamage) {
                return this;
              }
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasDamage = false;
              copy._damage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "control": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasControl = true;
              copy._control = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasControl) {
                return this;
              }
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasControl = false;
              copy._control = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "supportive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasSupportive = true;
              copy._supportive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSupportive) {
                return this;
              }
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasSupportive = false;
              copy._supportive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "manaCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasManaCost = true;
              copy._manaCost = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasManaCost) {
                return this;
              }
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasManaCost = false;
              copy._manaCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "coolDown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasCoolDown = true;
              copy._coolDown = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCoolDown) {
                return this;
              }
              const copy = new CardInfo_SpellCardStats(this);
              copy._hasCoolDown = false;
              copy._coolDown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo_SpellCardStats} other
   * @returns {CardInfo_SpellCardStats}
   */
  merge(other) {
    const copy = new CardInfo_SpellCardStats(this);
    if (other._hasDamage) {
      copy._hasDamage = true;
      copy._damage = other._damage;
    }
    if (other._hasControl) {
      copy._hasControl = true;
      copy._control = other._control;
    }
    if (other._hasSupportive) {
      copy._hasSupportive = true;
      copy._supportive = other._supportive;
    }
    if (other._hasManaCost) {
      copy._hasManaCost = true;
      copy._manaCost = other._manaCost;
    }
    if (other._hasCoolDown) {
      copy._hasCoolDown = true;
      copy._coolDown = other._coolDown;
    }
    return copy;
  }
}
CardInfo_SpellCardStats.default = new CardInfo_SpellCardStats();
class CardInfo_SpellCardStats_Builder {
  constructor(value) {
    this._value = new CardInfo_SpellCardStats(value);
  }
  build() {
    return new CardInfo_SpellCardStats(this._value);
  }
  setDamage(value) {
    this._value._hasDamage = true;
    this._value._damage = value;
    return this;
  }
  deleteDamage() {
    this._value._hasDamage = false;
    this._value._damage = null;
    return this;
  }
  setControl(value) {
    this._value._hasControl = true;
    this._value._control = value;
    return this;
  }
  deleteControl() {
    this._value._hasControl = false;
    this._value._control = null;
    return this;
  }
  setSupportive(value) {
    this._value._hasSupportive = true;
    this._value._supportive = value;
    return this;
  }
  deleteSupportive() {
    this._value._hasSupportive = false;
    this._value._supportive = null;
    return this;
  }
  setManaCost(value) {
    this._value._hasManaCost = true;
    this._value._manaCost = value;
    return this;
  }
  deleteManaCost() {
    this._value._hasManaCost = false;
    this._value._manaCost = null;
    return this;
  }
  setCoolDown(value) {
    this._value._hasCoolDown = true;
    this._value._coolDown = value;
    return this;
  }
  deleteCoolDown() {
    this._value._hasCoolDown = false;
    this._value._coolDown = null;
    return this;
  }
}
CardInfo_SpellCardStats.Builder = CardInfo_SpellCardStats_Builder;
class CardInfo_SpellCardStats_WithParent {
  /**
   * @param {CardInfo_SpellCardStats} value
   * @param {CardInfo_SpellCardStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo_SpellCardStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDamage() {
    if (this._cachedHasDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedHasDamage = true;
      } else {
        this._cachedHasDamage = this._parent ? this._parent.hasDamage : false;
      }
    }
    return this._cachedHasDamage;
  }
  get damage() {
    if (this._cachedDamage === undefined) {
      if (this._value.hasDamage) {
        this._cachedDamage = this._value.damage;
      } else {
        this._cachedDamage = this._parent ? this._parent.damage : this._value.damage;
      }
    }
    return this._cachedDamage;
  }
  get hasControl() {
    if (this._cachedHasControl === undefined) {
      if (this._value.hasControl) {
        this._cachedHasControl = true;
      } else {
        this._cachedHasControl = this._parent ? this._parent.hasControl : false;
      }
    }
    return this._cachedHasControl;
  }
  get control() {
    if (this._cachedControl === undefined) {
      if (this._value.hasControl) {
        this._cachedControl = this._value.control;
      } else {
        this._cachedControl = this._parent ? this._parent.control : this._value.control;
      }
    }
    return this._cachedControl;
  }
  get hasSupportive() {
    if (this._cachedHasSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedHasSupportive = true;
      } else {
        this._cachedHasSupportive = this._parent ? this._parent.hasSupportive : false;
      }
    }
    return this._cachedHasSupportive;
  }
  get supportive() {
    if (this._cachedSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedSupportive = this._value.supportive;
      } else {
        this._cachedSupportive = this._parent ? this._parent.supportive : this._value.supportive;
      }
    }
    return this._cachedSupportive;
  }
  get hasManaCost() {
    if (this._cachedHasManaCost === undefined) {
      if (this._value.hasManaCost) {
        this._cachedHasManaCost = true;
      } else {
        this._cachedHasManaCost = this._parent ? this._parent.hasManaCost : false;
      }
    }
    return this._cachedHasManaCost;
  }
  get manaCost() {
    if (this._cachedManaCost === undefined) {
      if (this._value.hasManaCost) {
        this._cachedManaCost = this._value.manaCost;
      } else {
        this._cachedManaCost = this._parent ? this._parent.manaCost : this._value.manaCost;
      }
    }
    return this._cachedManaCost;
  }
  get hasCoolDown() {
    if (this._cachedHasCoolDown === undefined) {
      if (this._value.hasCoolDown) {
        this._cachedHasCoolDown = true;
      } else {
        this._cachedHasCoolDown = this._parent ? this._parent.hasCoolDown : false;
      }
    }
    return this._cachedHasCoolDown;
  }
  get coolDown() {
    if (this._cachedCoolDown === undefined) {
      if (this._value.hasCoolDown) {
        this._cachedCoolDown = this._value.coolDown;
      } else {
        this._cachedCoolDown = this._parent ? this._parent.coolDown : this._value.coolDown;
      }
    }
    return this._cachedCoolDown;
  }
  update(current, parent) {
    const result = new CardInfo_SpellCardStats_WithParent(current, parent);
    return result;
  }
}
CardInfo_SpellCardStats_WithParent.default = new CardInfo_SpellCardStats_WithParent(CardInfo_SpellCardStats.default, null);
CardInfo_SpellCardStats.WithParent = CardInfo_SpellCardStats_WithParent;
class CardInfo_SpellCardStats_Descriptor {
  get damage() {
    if (!this._damage) {
      this._damage = {
        name: "damage",
        Name: "Damage",
        number: 1,
        protoType: 1,
        protoName: "damage",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._damage;
  }
  get control() {
    if (!this._control) {
      this._control = {
        name: "control",
        Name: "Control",
        number: 2,
        protoType: 1,
        protoName: "control",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._control;
  }
  get supportive() {
    if (!this._supportive) {
      this._supportive = {
        name: "supportive",
        Name: "Supportive",
        number: 3,
        protoType: 1,
        protoName: "supportive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._supportive;
  }
  get manaCost() {
    if (!this._manaCost) {
      this._manaCost = {
        name: "manaCost",
        Name: "ManaCost",
        number: 4,
        protoType: 1,
        protoName: "mana_cost",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._manaCost;
  }
  get coolDown() {
    if (!this._coolDown) {
      this._coolDown = {
        name: "coolDown",
        Name: "CoolDown",
        number: 5,
        protoType: 1,
        protoName: "cool_down",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._coolDown;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.damage,
        this.control,
        this.supportive,
        this.manaCost,
        this.coolDown,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDamage",
        Name: "DummyOneofForDamage",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForControl",
        Name: "DummyOneofForControl",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSupportive",
        Name: "DummyOneofForSupportive",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForManaCost",
        Name: "DummyOneofForManaCost",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCoolDown",
        Name: "DummyOneofForCoolDown",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo_SpellCardStats.descriptor = new CardInfo_SpellCardStats_Descriptor();
export class CardInfo {
  get descriptor() {
    return CardInfo.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._tagNames = [];
    this._startsBars = [];
    this._stories = [];
    this._hasOffensive = false;
    this._offensive = null;
    this._hasDefensive = false;
    this._defensive = null;
    this._hasControl = false;
    this._control = null;
    this._hasSupportive = false;
    this._supportive = null;
    this._hasSpeed = false;
    this._speed = null;
    this._cardTypeCase = 0;
    this._cardTypeValue = null;
  }
  isEmpty() {
    if (this._tagNames.length > 0) return false;
    if (this._startsBars.length > 0) return false;
    if (this._stories.length > 0) return false;
    if (this._hasOffensive) return false;
    if (this._hasDefensive) return false;
    if (this._hasControl) return false;
    if (this._hasSupportive) return false;
    if (this._hasSpeed) return false;
    if (this._cardTypeCase !== 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardInfo) {
      return value;
    }
    return CardInfo.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardInfo();
    result._tagNames = JsonToList(json.tagNames, JsonToString);
    result._startsBars = JsonToList(json.startsBars, CardInfo_StatsBar);
    result._stories = JsonToList(json.stories, CardInfo_Story);
    if (json.offensive != null) {
      result._hasOffensive = true;
      result._offensive = JsonToDouble.fromJson(json.offensive);
    }
    if (json.defensive != null) {
      result._hasDefensive = true;
      result._defensive = JsonToDouble.fromJson(json.defensive);
    }
    if (json.control != null) {
      result._hasControl = true;
      result._control = JsonToDouble.fromJson(json.control);
    }
    if (json.supportive != null) {
      result._hasSupportive = true;
      result._supportive = JsonToDouble.fromJson(json.supportive);
    }
    if (json.speed != null) {
      result._hasSpeed = true;
      result._speed = JsonToDouble.fromJson(json.speed);
    }
    if (json.heroCardStats != null) {
      result._cardTypeCase = 21;
      result._cardTypeValue = CardInfo_HeroCardStats.fromJson(json.heroCardStats);
    }
    if (json.towerCardStats != null) {
      result._cardTypeCase = 22;
      result._cardTypeValue = CardInfo_TowerCardStats.fromJson(json.towerCardStats);
    }
    if (json.spellCardStats != null) {
      result._cardTypeCase = 23;
      result._cardTypeValue = CardInfo_SpellCardStats.fromJson(json.spellCardStats);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._tagNames.length > 0) {
      result.tagNames = ArrayToJson(this._tagNames, JsonToString);
    }
    if (this._startsBars.length > 0) {
      result.startsBars = ArrayToJson(this._startsBars, CardInfo_StatsBar);
    }
    if (this._stories.length > 0) {
      result.stories = ArrayToJson(this._stories, CardInfo_Story);
    }
    if (this._hasOffensive) {
      result.offensive = JsonToDouble.toJson(this._offensive);
    }
    if (this._hasDefensive) {
      result.defensive = JsonToDouble.toJson(this._defensive);
    }
    if (this._hasControl) {
      result.control = JsonToDouble.toJson(this._control);
    }
    if (this._hasSupportive) {
      result.supportive = JsonToDouble.toJson(this._supportive);
    }
    if (this._hasSpeed) {
      result.speed = JsonToDouble.toJson(this._speed);
    }
    switch (this._cardTypeCase) {
      case 21:
        result.heroCardStats = CardInfo_HeroCardStats.toJson(this._cardTypeValue);
        break;
      case 22:
        result.towerCardStats = CardInfo_TowerCardStats.toJson(this._cardTypeValue);
        break;
      case 23:
        result.spellCardStats = CardInfo_SpellCardStats.toJson(this._cardTypeValue);
        break;
      default:
        break;
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get tagNames() {
    return this._tagNames;
  }
  addTagNames(path, value) {
    return {type: 'ADD', path: path.concat(['tagNames']), value};
  }
  setTagNames(path, value) {
    return {type: 'SET', path: path.concat(['tagNames']), value: ArrayToJson(value, JsonToString)};
  }
  setTagNamesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['tagNames', key]), value};
  }
  deleteTagNames(path) {
    return {type: 'DELETE', path: path.concat(['tagNames'])};
  }
  deleteTagNamesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['tagNames', key])};
  }
  /**
   * @returns {CardInfo_StatsBar[]}
   */
  get startsBars() {
    return this._startsBars;
  }
  addStartsBars(path, value) {
    return {type: 'ADD', path: path.concat(['startsBars']), value: value.toJson()};
  }
  setStartsBars(path, value) {
    return {type: 'SET', path: path.concat(['startsBars']), value: ArrayToJson(value, CardInfo_StatsBar)};
  }
  setStartsBarsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['startsBars', key]), value: value.toJson()};
  }
  deleteStartsBars(path) {
    return {type: 'DELETE', path: path.concat(['startsBars'])};
  }
  deleteStartsBarsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['startsBars', key])};
  }
  /**
   * @returns {CardInfo_Story[]}
   */
  get stories() {
    return this._stories;
  }
  addStories(path, value) {
    return {type: 'ADD', path: path.concat(['stories']), value: value.toJson()};
  }
  setStories(path, value) {
    return {type: 'SET', path: path.concat(['stories']), value: ArrayToJson(value, CardInfo_Story)};
  }
  setStoriesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['stories', key]), value: value.toJson()};
  }
  deleteStories(path) {
    return {type: 'DELETE', path: path.concat(['stories'])};
  }
  deleteStoriesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['stories', key])};
  }
  /**
   * @returns {number}
   */
  get offensive() {
    return this._hasOffensive ? this._offensive : JsonToDouble.default;
  }
  get hasOffensive() {
    return this._hasOffensive;
  }
  setOffensive(path, value) {
    return {type: 'SET', path: path.concat(['offensive']), value};
  }
  deleteOffensive(path) {
    return {type: 'DELETE', path: path.concat(['offensive'])};
  }
  /**
   * @returns {number}
   */
  get defensive() {
    return this._hasDefensive ? this._defensive : JsonToDouble.default;
  }
  get hasDefensive() {
    return this._hasDefensive;
  }
  setDefensive(path, value) {
    return {type: 'SET', path: path.concat(['defensive']), value};
  }
  deleteDefensive(path) {
    return {type: 'DELETE', path: path.concat(['defensive'])};
  }
  /**
   * @returns {number}
   */
  get control() {
    return this._hasControl ? this._control : JsonToDouble.default;
  }
  get hasControl() {
    return this._hasControl;
  }
  setControl(path, value) {
    return {type: 'SET', path: path.concat(['control']), value};
  }
  deleteControl(path) {
    return {type: 'DELETE', path: path.concat(['control'])};
  }
  /**
   * @returns {number}
   */
  get supportive() {
    return this._hasSupportive ? this._supportive : JsonToDouble.default;
  }
  get hasSupportive() {
    return this._hasSupportive;
  }
  setSupportive(path, value) {
    return {type: 'SET', path: path.concat(['supportive']), value};
  }
  deleteSupportive(path) {
    return {type: 'DELETE', path: path.concat(['supportive'])};
  }
  /**
   * @returns {number}
   */
  get speed() {
    return this._hasSpeed ? this._speed : JsonToDouble.default;
  }
  get hasSpeed() {
    return this._hasSpeed;
  }
  setSpeed(path, value) {
    return {type: 'SET', path: path.concat(['speed']), value};
  }
  deleteSpeed(path) {
    return {type: 'DELETE', path: path.concat(['speed'])};
  }
  get cardTypeCase() {
    return this._cardTypeCase;
  }
  deleteCardType(path) {
    switch (this._cardTypeCase) {
      default:
      case 21: {
        return {type: 'DELETE', path: path.concat(['heroCardStats'])};
      }
      case 22: {
        return {type: 'DELETE', path: path.concat(['towerCardStats'])};
      }
      case 23: {
        return {type: 'DELETE', path: path.concat(['spellCardStats'])};
      }
    }
  }
  /**
   * @returns {CardInfo_HeroCardStats}
   */
  get heroCardStats() {
    return this._cardTypeCase === 21 ? this._cardTypeValue : CardInfo_HeroCardStats.default;
  }
  setHeroCardStats(path, value) {
    return {type: 'SET', path: path.concat(['heroCardStats']), value: value.toJson()};
  }
  deleteHeroCardStats(path) {
    return {type: 'DELETE', path: path.concat(['heroCardStats'])};
  }
  /**
   * @returns {CardInfo_TowerCardStats}
   */
  get towerCardStats() {
    return this._cardTypeCase === 22 ? this._cardTypeValue : CardInfo_TowerCardStats.default;
  }
  setTowerCardStats(path, value) {
    return {type: 'SET', path: path.concat(['towerCardStats']), value: value.toJson()};
  }
  deleteTowerCardStats(path) {
    return {type: 'DELETE', path: path.concat(['towerCardStats'])};
  }
  /**
   * @returns {CardInfo_SpellCardStats}
   */
  get spellCardStats() {
    return this._cardTypeCase === 23 ? this._cardTypeValue : CardInfo_SpellCardStats.default;
  }
  setSpellCardStats(path, value) {
    return {type: 'SET', path: path.concat(['spellCardStats']), value: value.toJson()};
  }
  deleteSpellCardStats(path) {
    return {type: 'DELETE', path: path.concat(['spellCardStats'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tagNames": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._tagNames = [];        for (let i of value) {
                copy._tagNames.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardInfo(this);
              copy._tagNames = copy._tagNames.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._tagNames.length === 0) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._tagNames = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._tagNames.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._tagNames = copy._tagNames.slice();
              copy._tagNames[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardInfo(this);
              copy._tagNames = copy._tagNames.slice(0, path[1]).concat(copy._tagNames.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._tagNames.length) {
            return this;
          }
          const oldValue = this._tagNames[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._tagNames = copy._tagNames.slice();
          copy._tagNames[key] = newValue;
          return copy;
        }
      }
      case "startsBars": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._startsBars = [];        for (let i of value) {
                copy._startsBars.push(CardInfo_StatsBar.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardInfo(this);
              copy._startsBars = copy._startsBars.concat([CardInfo_StatsBar.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._startsBars.length === 0) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._startsBars = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._startsBars.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._startsBars = copy._startsBars.slice();
              copy._startsBars[path[1]] = CardInfo_StatsBar.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardInfo(this);
              copy._startsBars = copy._startsBars.slice(0, path[1]).concat(copy._startsBars.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._startsBars.length) {
            return this;
          }
          const oldValue = this._startsBars[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._startsBars = copy._startsBars.slice();
          copy._startsBars[key] = newValue;
          return copy;
        }
      }
      case "stories": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._stories = [];        for (let i of value) {
                copy._stories.push(CardInfo_Story.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardInfo(this);
              copy._stories = copy._stories.concat([CardInfo_Story.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._stories.length === 0) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._stories = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._stories.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._stories = copy._stories.slice();
              copy._stories[path[1]] = CardInfo_Story.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardInfo(this);
              copy._stories = copy._stories.slice(0, path[1]).concat(copy._stories.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._stories.length) {
            return this;
          }
          const oldValue = this._stories[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._stories = copy._stories.slice();
          copy._stories[key] = newValue;
          return copy;
        }
      }
      case "offensive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._hasOffensive = true;
              copy._offensive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasOffensive) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._hasOffensive = false;
              copy._offensive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "defensive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._hasDefensive = true;
              copy._defensive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDefensive) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._hasDefensive = false;
              copy._defensive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "control": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._hasControl = true;
              copy._control = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasControl) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._hasControl = false;
              copy._control = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "supportive": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._hasSupportive = true;
              copy._supportive = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSupportive) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._hasSupportive = false;
              copy._supportive = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "speed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._hasSpeed = true;
              copy._speed = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSpeed) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._hasSpeed = false;
              copy._speed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "heroCardStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._cardTypeCase = 21;
              copy._cardTypeValue = CardInfo_HeroCardStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 21) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 21) {
            const copy = new CardInfo(this);
            copy._cardTypeCase = 21;
            copy._cardTypeValue = CardInfo_HeroCardStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.heroCardStats.apply(type, path.slice(1), value);
          if (newValue === this.heroCardStats) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._cardTypeCase = 21;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "towerCardStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._cardTypeCase = 22;
              copy._cardTypeValue = CardInfo_TowerCardStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 22) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 22) {
            const copy = new CardInfo(this);
            copy._cardTypeCase = 22;
            copy._cardTypeValue = CardInfo_TowerCardStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.towerCardStats.apply(type, path.slice(1), value);
          if (newValue === this.towerCardStats) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._cardTypeCase = 22;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "spellCardStats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardInfo(this);
              copy._cardTypeCase = 23;
              copy._cardTypeValue = CardInfo_SpellCardStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 23) {
                return this;
              }
              const copy = new CardInfo(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 23) {
            const copy = new CardInfo(this);
            copy._cardTypeCase = 23;
            copy._cardTypeValue = CardInfo_SpellCardStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.spellCardStats.apply(type, path.slice(1), value);
          if (newValue === this.spellCardStats) {
            return this;
          }
          const copy = new CardInfo(this);
          copy._cardTypeCase = 23;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardInfo} other
   * @returns {CardInfo}
   */
  merge(other) {
    const copy = new CardInfo(this);
    copy._tagNames = this._tagNames.concat(other._tagNames);
    copy._startsBars = this._startsBars.concat(other._startsBars);
    copy._stories = this._stories.concat(other._stories);
    if (other._hasOffensive) {
      copy._hasOffensive = true;
      copy._offensive = other._offensive;
    }
    if (other._hasDefensive) {
      copy._hasDefensive = true;
      copy._defensive = other._defensive;
    }
    if (other._hasControl) {
      copy._hasControl = true;
      copy._control = other._control;
    }
    if (other._hasSupportive) {
      copy._hasSupportive = true;
      copy._supportive = other._supportive;
    }
    if (other._hasSpeed) {
      copy._hasSpeed = true;
      copy._speed = other._speed;
    }
    if (other._cardTypeCase === 21) {
      if (this._cardTypeCase === 21) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 21;
    }
    if (other._cardTypeCase === 21) {
      if (this._cardTypeCase === 21) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 21;
    }
    if (other._cardTypeCase === 21) {
      if (this._cardTypeCase === 21) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 21;
    }
    return copy;
  }
}
CardInfo.default = new CardInfo();
CardInfo.StatsBar = CardInfo_StatsBar;
CardInfo.Story = CardInfo_Story;
CardInfo.HeroCardStats = CardInfo_HeroCardStats;
CardInfo.TowerCardStats = CardInfo_TowerCardStats;
CardInfo.SpellCardStats = CardInfo_SpellCardStats;
class CardInfo_Builder {
  constructor(value) {
    this._value = new CardInfo(value);
  }
  build() {
    return new CardInfo(this._value);
  }
  addAllTagNames(values) {
    this._value._tagNames = this._value._tagNames.concat(values);
    return this;
  }
  addTagNames(value) {
    this._value._tagNames = this._value._tagNames.concat([value]);
    return this;
  }
  setTagNames(index, value) {
    this._value._tagNames = this._value._tagNames.concat();
    this._value._tagNames[index] = value;
    return this;
  }
  clearTagNames() {
    this._value._tagNames = [];
    return this;
  }
  addAllStartsBars(values) {
    this._value._startsBars = this._value._startsBars.concat(values);
    return this;
  }
  addStartsBars(value) {
    this._value._startsBars = this._value._startsBars.concat([value]);
    return this;
  }
  setStartsBars(index, value) {
    this._value._startsBars = this._value._startsBars.concat();
    this._value._startsBars[index] = value;
    return this;
  }
  clearStartsBars() {
    this._value._startsBars = [];
    return this;
  }
  addAllStories(values) {
    this._value._stories = this._value._stories.concat(values);
    return this;
  }
  addStories(value) {
    this._value._stories = this._value._stories.concat([value]);
    return this;
  }
  setStories(index, value) {
    this._value._stories = this._value._stories.concat();
    this._value._stories[index] = value;
    return this;
  }
  clearStories() {
    this._value._stories = [];
    return this;
  }
  setOffensive(value) {
    this._value._hasOffensive = true;
    this._value._offensive = value;
    return this;
  }
  deleteOffensive() {
    this._value._hasOffensive = false;
    this._value._offensive = null;
    return this;
  }
  setDefensive(value) {
    this._value._hasDefensive = true;
    this._value._defensive = value;
    return this;
  }
  deleteDefensive() {
    this._value._hasDefensive = false;
    this._value._defensive = null;
    return this;
  }
  setControl(value) {
    this._value._hasControl = true;
    this._value._control = value;
    return this;
  }
  deleteControl() {
    this._value._hasControl = false;
    this._value._control = null;
    return this;
  }
  setSupportive(value) {
    this._value._hasSupportive = true;
    this._value._supportive = value;
    return this;
  }
  deleteSupportive() {
    this._value._hasSupportive = false;
    this._value._supportive = null;
    return this;
  }
  setSpeed(value) {
    this._value._hasSpeed = true;
    this._value._speed = value;
    return this;
  }
  deleteSpeed() {
    this._value._hasSpeed = false;
    this._value._speed = null;
    return this;
  }
  clearcardType() {
    this._value._cardTypeCase = 0;
    this._value._cardTypeValue = null;
    return this;
  }
  setHeroCardStats(value) {
    this._value._cardTypeCase = 21;
    this._value._cardTypeValue = value;
    return this;
  }
  setTowerCardStats(value) {
    this._value._cardTypeCase = 22;
    this._value._cardTypeValue = value;
    return this;
  }
  setSpellCardStats(value) {
    this._value._cardTypeCase = 23;
    this._value._cardTypeValue = value;
    return this;
  }
}
CardInfo.Builder = CardInfo_Builder;
class CardInfo_WithParent {
  /**
   * @param {CardInfo} value
   * @param {CardInfo_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardInfo.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfTagNames() {
    return this._value.tagNames;
  }
  get inherentTagNames() {
    if (!this._inherentTagNames) {
      this._inherentTagNames = this._parent ? this._parent.tagNames : [];
    }
    return this._inherentTagNames;
  }
  get tagNames() {
    if (!this._allTagNames) {
      this._allTagNames = this._parent ? this._parent.tagNames.concat(this.selfTagNames) : this.selfTagNames;
    }
    return this._allTagNames;
  }
  get selfStartsBars() {
    if (!this._selfStartsBars) {
      this._selfStartsBars = [];
      for (let i of this._value.startsBars) {
        this._selfStartsBars.push(new CardInfo_StatsBar.WithParent(i, null));
      }
    }
    return this._selfStartsBars;
  }
  get inherentStartsBars() {
    if (!this._inherentStartsBars) {
      this._inherentStartsBars = this._parent ? this._parent.startsBars : [];
    }
    return this._inherentStartsBars;
  }
  get startsBars() {
    if (!this._allStartsBars) {
      this._allStartsBars = this._parent ? this._parent.startsBars.concat(this.selfStartsBars) : this.selfStartsBars;
    }
    return this._allStartsBars;
  }
  get selfStories() {
    if (!this._selfStories) {
      this._selfStories = [];
      for (let i of this._value.stories) {
        this._selfStories.push(new CardInfo_Story.WithParent(i, null));
      }
    }
    return this._selfStories;
  }
  get inherentStories() {
    if (!this._inherentStories) {
      this._inherentStories = this._parent ? this._parent.stories : [];
    }
    return this._inherentStories;
  }
  get stories() {
    if (!this._allStories) {
      this._allStories = this._parent ? this._parent.stories.concat(this.selfStories) : this.selfStories;
    }
    return this._allStories;
  }
  get hasOffensive() {
    if (this._cachedHasOffensive === undefined) {
      if (this._value.hasOffensive) {
        this._cachedHasOffensive = true;
      } else {
        this._cachedHasOffensive = this._parent ? this._parent.hasOffensive : false;
      }
    }
    return this._cachedHasOffensive;
  }
  get offensive() {
    if (this._cachedOffensive === undefined) {
      if (this._value.hasOffensive) {
        this._cachedOffensive = this._value.offensive;
      } else {
        this._cachedOffensive = this._parent ? this._parent.offensive : this._value.offensive;
      }
    }
    return this._cachedOffensive;
  }
  get hasDefensive() {
    if (this._cachedHasDefensive === undefined) {
      if (this._value.hasDefensive) {
        this._cachedHasDefensive = true;
      } else {
        this._cachedHasDefensive = this._parent ? this._parent.hasDefensive : false;
      }
    }
    return this._cachedHasDefensive;
  }
  get defensive() {
    if (this._cachedDefensive === undefined) {
      if (this._value.hasDefensive) {
        this._cachedDefensive = this._value.defensive;
      } else {
        this._cachedDefensive = this._parent ? this._parent.defensive : this._value.defensive;
      }
    }
    return this._cachedDefensive;
  }
  get hasControl() {
    if (this._cachedHasControl === undefined) {
      if (this._value.hasControl) {
        this._cachedHasControl = true;
      } else {
        this._cachedHasControl = this._parent ? this._parent.hasControl : false;
      }
    }
    return this._cachedHasControl;
  }
  get control() {
    if (this._cachedControl === undefined) {
      if (this._value.hasControl) {
        this._cachedControl = this._value.control;
      } else {
        this._cachedControl = this._parent ? this._parent.control : this._value.control;
      }
    }
    return this._cachedControl;
  }
  get hasSupportive() {
    if (this._cachedHasSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedHasSupportive = true;
      } else {
        this._cachedHasSupportive = this._parent ? this._parent.hasSupportive : false;
      }
    }
    return this._cachedHasSupportive;
  }
  get supportive() {
    if (this._cachedSupportive === undefined) {
      if (this._value.hasSupportive) {
        this._cachedSupportive = this._value.supportive;
      } else {
        this._cachedSupportive = this._parent ? this._parent.supportive : this._value.supportive;
      }
    }
    return this._cachedSupportive;
  }
  get hasSpeed() {
    if (this._cachedHasSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedHasSpeed = true;
      } else {
        this._cachedHasSpeed = this._parent ? this._parent.hasSpeed : false;
      }
    }
    return this._cachedHasSpeed;
  }
  get speed() {
    if (this._cachedSpeed === undefined) {
      if (this._value.hasSpeed) {
        this._cachedSpeed = this._value.speed;
      } else {
        this._cachedSpeed = this._parent ? this._parent.speed : this._value.speed;
      }
    }
    return this._cachedSpeed;
  }
  get cardTypeCase() {
    if (this._cachedcardTypeCase === undefined) {
      if (this._value._cardTypeCase === 0) {
        this._cachedcardTypeCase = this._parent ? this._parent.cardTypeCase : 0;
      } else {
        this._cachedcardTypeCase = this._value._cardTypeCase;
      }
    }
    return this._cachedcardTypeCase;
  }
  get heroCardStats() {
    if (!this._cachedHeroCardStats) {
      if (this._value._cardTypeCase === 0) {
        this._cachedHeroCardStats = this._parent ? new CardInfo_HeroCardStats.WithParent(CardInfo_HeroCardStats.default, this._parent.heroCardStats) : this._value.heroCardStats;
      } else if (this._value._cardTypeCase === 21) {
        this._cachedHeroCardStats = new CardInfo_HeroCardStats.WithParent(this._value.heroCardStats, this._parent && this._parent.cardTypeCase === 21 ? this._parent.heroCardStats : null);
      } else {
        this._cachedHeroCardStats = CardInfo_HeroCardStats.WithParent.default;
      }
    }
    return this._cachedHeroCardStats;
  }
  get towerCardStats() {
    if (!this._cachedTowerCardStats) {
      if (this._value._cardTypeCase === 0) {
        this._cachedTowerCardStats = this._parent ? new CardInfo_TowerCardStats.WithParent(CardInfo_TowerCardStats.default, this._parent.towerCardStats) : this._value.towerCardStats;
      } else if (this._value._cardTypeCase === 22) {
        this._cachedTowerCardStats = new CardInfo_TowerCardStats.WithParent(this._value.towerCardStats, this._parent && this._parent.cardTypeCase === 22 ? this._parent.towerCardStats : null);
      } else {
        this._cachedTowerCardStats = CardInfo_TowerCardStats.WithParent.default;
      }
    }
    return this._cachedTowerCardStats;
  }
  get spellCardStats() {
    if (!this._cachedSpellCardStats) {
      if (this._value._cardTypeCase === 0) {
        this._cachedSpellCardStats = this._parent ? new CardInfo_SpellCardStats.WithParent(CardInfo_SpellCardStats.default, this._parent.spellCardStats) : this._value.spellCardStats;
      } else if (this._value._cardTypeCase === 23) {
        this._cachedSpellCardStats = new CardInfo_SpellCardStats.WithParent(this._value.spellCardStats, this._parent && this._parent.cardTypeCase === 23 ? this._parent.spellCardStats : null);
      } else {
        this._cachedSpellCardStats = CardInfo_SpellCardStats.WithParent.default;
      }
    }
    return this._cachedSpellCardStats;
  }
  update(current, parent) {
    const result = new CardInfo_WithParent(current, parent);
    if (this._selfStartsBars) {
      if (this._value.startsBars === current.startsBars) {
        result._selfStartsBars = this._selfStartsBars;
      } else {
        result._selfStartsBars = [];
        for (let i = 0; i < current.startsBars.length; i++) {
          const oldValue = this._value.startsBars[i];
          if (oldValue) {
            const oldCache = this._selfStartsBars[i];
            if (oldValue === current.startsBars[i]) {
              result._selfStartsBars[i] = oldCache;
            } else {
              result._selfStartsBars[i] = oldCache.update(current.startsBars[i], null);
            }
          } else {
            result._selfStartsBars[i] = new CardInfo_StatsBar.WithParent(current.startsBars[i], null);
          }
        }
      }
    }
    if (this._selfStories) {
      if (this._value.stories === current.stories) {
        result._selfStories = this._selfStories;
      } else {
        result._selfStories = [];
        for (let i = 0; i < current.stories.length; i++) {
          const oldValue = this._value.stories[i];
          if (oldValue) {
            const oldCache = this._selfStories[i];
            if (oldValue === current.stories[i]) {
              result._selfStories[i] = oldCache;
            } else {
              result._selfStories[i] = oldCache.update(current.stories[i], null);
            }
          } else {
            result._selfStories[i] = new CardInfo_Story.WithParent(current.stories[i], null);
          }
        }
      }
    }
    if (this._cachedHeroCardStats && this._value._cardTypeCase === 21 && current._cardTypeCase === 21) {
      if (this._value.heroCardStats === current.heroCardStats && this._parent === parent) {
        result._cachedHeroCardStats = this._cachedHeroCardStats;
      } else {
        result._cachedHeroCardStats = this._cachedHeroCardStats.update(current.heroCardStats, parent && parent.cardTypeCase === 21 ? parent.heroCardStats : null);
      }
    }
    if (this._cachedTowerCardStats && this._value._cardTypeCase === 22 && current._cardTypeCase === 22) {
      if (this._value.towerCardStats === current.towerCardStats && this._parent === parent) {
        result._cachedTowerCardStats = this._cachedTowerCardStats;
      } else {
        result._cachedTowerCardStats = this._cachedTowerCardStats.update(current.towerCardStats, parent && parent.cardTypeCase === 22 ? parent.towerCardStats : null);
      }
    }
    if (this._cachedSpellCardStats && this._value._cardTypeCase === 23 && current._cardTypeCase === 23) {
      if (this._value.spellCardStats === current.spellCardStats && this._parent === parent) {
        result._cachedSpellCardStats = this._cachedSpellCardStats;
      } else {
        result._cachedSpellCardStats = this._cachedSpellCardStats.update(current.spellCardStats, parent && parent.cardTypeCase === 23 ? parent.spellCardStats : null);
      }
    }
    return result;
  }
}
CardInfo_WithParent.default = new CardInfo_WithParent(CardInfo.default, null);
CardInfo.WithParent = CardInfo_WithParent;
class CardInfo_Descriptor {
  get tagNames() {
    if (!this._tagNames) {
      this._tagNames = {
        name: "tagNames",
        Name: "TagNames",
        number: 1,
        protoType: 9,
        protoName: "tag_names",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "CardTags",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagNames;
  }
  get startsBars() {
    if (!this._startsBars) {
      this._startsBars = {
        name: "startsBars",
        Name: "StartsBars",
        number: 2,
        protoType: 11,
        protoName: "starts_bars",
        type: CardInfo_StatsBar,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._startsBars;
  }
  get stories() {
    if (!this._stories) {
      this._stories = {
        name: "stories",
        Name: "Stories",
        number: 3,
        protoType: 11,
        protoName: "stories",
        type: CardInfo_Story,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stories;
  }
  get offensive() {
    if (!this._offensive) {
      this._offensive = {
        name: "offensive",
        Name: "Offensive",
        number: 11,
        protoType: 1,
        protoName: "offensive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._offensive;
  }
  get defensive() {
    if (!this._defensive) {
      this._defensive = {
        name: "defensive",
        Name: "Defensive",
        number: 12,
        protoType: 1,
        protoName: "defensive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._defensive;
  }
  get control() {
    if (!this._control) {
      this._control = {
        name: "control",
        Name: "Control",
        number: 13,
        protoType: 1,
        protoName: "control",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._control;
  }
  get supportive() {
    if (!this._supportive) {
      this._supportive = {
        name: "supportive",
        Name: "Supportive",
        number: 14,
        protoType: 1,
        protoName: "supportive",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._supportive;
  }
  get speed() {
    if (!this._speed) {
      this._speed = {
        name: "speed",
        Name: "Speed",
        number: 15,
        protoType: 1,
        protoName: "speed",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._speed;
  }
  get heroCardStats() {
    if (!this._heroCardStats) {
      this._heroCardStats = {
        name: "heroCardStats",
        Name: "HeroCardStats",
        number: 21,
        protoType: 11,
        protoName: "hero_card_stats",
        oneofIndex: 5,
        type: CardInfo_HeroCardStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._heroCardStats;
  }
  get towerCardStats() {
    if (!this._towerCardStats) {
      this._towerCardStats = {
        name: "towerCardStats",
        Name: "TowerCardStats",
        number: 22,
        protoType: 11,
        protoName: "tower_card_stats",
        oneofIndex: 5,
        type: CardInfo_TowerCardStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._towerCardStats;
  }
  get spellCardStats() {
    if (!this._spellCardStats) {
      this._spellCardStats = {
        name: "spellCardStats",
        Name: "SpellCardStats",
        number: 23,
        protoType: 11,
        protoName: "spell_card_stats",
        oneofIndex: 5,
        type: CardInfo_SpellCardStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._spellCardStats;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tagNames,
        this.startsBars,
        this.stories,
        this.offensive,
        this.defensive,
        this.control,
        this.supportive,
        this.speed,
        this.heroCardStats,
        this.towerCardStats,
        this.spellCardStats,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForOffensive",
        Name: "DummyOneofForOffensive",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDefensive",
        Name: "DummyOneofForDefensive",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForControl",
        Name: "DummyOneofForControl",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSupportive",
        Name: "DummyOneofForSupportive",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSpeed",
        Name: "DummyOneofForSpeed",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "cardType",
        Name: "CardType",
        fields: [
          this.fields[8],
          this.fields[9],
          this.fields[10],
        ],
      });
    }
    return this._oneofs;
  }
}
CardInfo.descriptor = new CardInfo_Descriptor();
export class CardTag {
  get descriptor() {
    return CardTag.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTagName = false;
    this._tagName = null;
    this._hasTagDisplayName = false;
    this._tagDisplayName = null;
    this._hasTagIcon = false;
    this._tagIcon = null;
    this._hasTagDescription = false;
    this._tagDescription = null;
  }
  isEmpty() {
    if (this._hasTagName) return false;
    if (this._hasTagDisplayName) return false;
    if (this._hasTagIcon) return false;
    if (this._hasTagDescription) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardTag) {
      return value;
    }
    return CardTag.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardTag();
    if (json.tagName != null) {
      result._hasTagName = true;
      result._tagName = JsonToString.fromJson(json.tagName);
    }
    if (json.tagDisplayName != null) {
      result._hasTagDisplayName = true;
      result._tagDisplayName = JsonToString.fromJson(json.tagDisplayName);
    }
    if (json.tagIcon != null) {
      result._hasTagIcon = true;
      result._tagIcon = JsonToString.fromJson(json.tagIcon);
    }
    if (json.tagDescription != null) {
      result._hasTagDescription = true;
      result._tagDescription = JsonToString.fromJson(json.tagDescription);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTagName) {
      result.tagName = JsonToString.toJson(this._tagName);
    }
    if (this._hasTagDisplayName) {
      result.tagDisplayName = JsonToString.toJson(this._tagDisplayName);
    }
    if (this._hasTagIcon) {
      result.tagIcon = JsonToString.toJson(this._tagIcon);
    }
    if (this._hasTagDescription) {
      result.tagDescription = JsonToString.toJson(this._tagDescription);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get tagName() {
    return this._hasTagName ? this._tagName : JsonToString.default;
  }
  get hasTagName() {
    return this._hasTagName;
  }
  setTagName(path, value) {
    return {type: 'SET', path: path.concat(['tagName']), value};
  }
  deleteTagName(path) {
    return {type: 'DELETE', path: path.concat(['tagName'])};
  }
  /**
   * @returns {string}
   */
  get tagDisplayName() {
    return this._hasTagDisplayName ? this._tagDisplayName : JsonToString.default;
  }
  get hasTagDisplayName() {
    return this._hasTagDisplayName;
  }
  setTagDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['tagDisplayName']), value};
  }
  deleteTagDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['tagDisplayName'])};
  }
  /**
   * @returns {string}
   */
  get tagIcon() {
    return this._hasTagIcon ? this._tagIcon : JsonToString.default;
  }
  get hasTagIcon() {
    return this._hasTagIcon;
  }
  setTagIcon(path, value) {
    return {type: 'SET', path: path.concat(['tagIcon']), value};
  }
  deleteTagIcon(path) {
    return {type: 'DELETE', path: path.concat(['tagIcon'])};
  }
  /**
   * @returns {string}
   */
  get tagDescription() {
    return this._hasTagDescription ? this._tagDescription : JsonToString.default;
  }
  get hasTagDescription() {
    return this._hasTagDescription;
  }
  setTagDescription(path, value) {
    return {type: 'SET', path: path.concat(['tagDescription']), value};
  }
  deleteTagDescription(path) {
    return {type: 'DELETE', path: path.concat(['tagDescription'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "tagName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardTag(this);
              copy._hasTagName = true;
              copy._tagName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagName) {
                return this;
              }
              const copy = new CardTag(this);
              copy._hasTagName = false;
              copy._tagName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagDisplayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardTag(this);
              copy._hasTagDisplayName = true;
              copy._tagDisplayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagDisplayName) {
                return this;
              }
              const copy = new CardTag(this);
              copy._hasTagDisplayName = false;
              copy._tagDisplayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardTag(this);
              copy._hasTagIcon = true;
              copy._tagIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagIcon) {
                return this;
              }
              const copy = new CardTag(this);
              copy._hasTagIcon = false;
              copy._tagIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "tagDescription": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardTag(this);
              copy._hasTagDescription = true;
              copy._tagDescription = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTagDescription) {
                return this;
              }
              const copy = new CardTag(this);
              copy._hasTagDescription = false;
              copy._tagDescription = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardTag} other
   * @returns {CardTag}
   */
  merge(other) {
    const copy = new CardTag(this);
    if (other._hasTagName) {
      copy._hasTagName = true;
      copy._tagName = other._tagName;
    }
    if (other._hasTagDisplayName) {
      copy._hasTagDisplayName = true;
      copy._tagDisplayName = other._tagDisplayName;
    }
    if (other._hasTagIcon) {
      copy._hasTagIcon = true;
      copy._tagIcon = other._tagIcon;
    }
    if (other._hasTagDescription) {
      copy._hasTagDescription = true;
      copy._tagDescription = other._tagDescription;
    }
    return copy;
  }
}
CardTag.default = new CardTag();
class CardTag_Builder {
  constructor(value) {
    this._value = new CardTag(value);
  }
  build() {
    return new CardTag(this._value);
  }
  setTagName(value) {
    this._value._hasTagName = true;
    this._value._tagName = value;
    return this;
  }
  deleteTagName() {
    this._value._hasTagName = false;
    this._value._tagName = null;
    return this;
  }
  setTagDisplayName(value) {
    this._value._hasTagDisplayName = true;
    this._value._tagDisplayName = value;
    return this;
  }
  deleteTagDisplayName() {
    this._value._hasTagDisplayName = false;
    this._value._tagDisplayName = null;
    return this;
  }
  setTagIcon(value) {
    this._value._hasTagIcon = true;
    this._value._tagIcon = value;
    return this;
  }
  deleteTagIcon() {
    this._value._hasTagIcon = false;
    this._value._tagIcon = null;
    return this;
  }
  setTagDescription(value) {
    this._value._hasTagDescription = true;
    this._value._tagDescription = value;
    return this;
  }
  deleteTagDescription() {
    this._value._hasTagDescription = false;
    this._value._tagDescription = null;
    return this;
  }
}
CardTag.Builder = CardTag_Builder;
class CardTag_WithParent {
  /**
   * @param {CardTag} value
   * @param {CardTag_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardTag.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTagName() {
    if (this._cachedHasTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedHasTagName = true;
      } else {
        this._cachedHasTagName = this._parent ? this._parent.hasTagName : false;
      }
    }
    return this._cachedHasTagName;
  }
  get tagName() {
    if (this._cachedTagName === undefined) {
      if (this._value.hasTagName) {
        this._cachedTagName = this._value.tagName;
      } else {
        this._cachedTagName = this._parent ? this._parent.tagName : this._value.tagName;
      }
    }
    return this._cachedTagName;
  }
  get hasTagDisplayName() {
    if (this._cachedHasTagDisplayName === undefined) {
      if (this._value.hasTagDisplayName) {
        this._cachedHasTagDisplayName = true;
      } else {
        this._cachedHasTagDisplayName = this._parent ? this._parent.hasTagDisplayName : false;
      }
    }
    return this._cachedHasTagDisplayName;
  }
  get tagDisplayName() {
    if (this._cachedTagDisplayName === undefined) {
      if (this._value.hasTagDisplayName) {
        this._cachedTagDisplayName = this._value.tagDisplayName;
      } else {
        this._cachedTagDisplayName = this._parent ? this._parent.tagDisplayName : this._value.tagDisplayName;
      }
    }
    return this._cachedTagDisplayName;
  }
  get hasTagIcon() {
    if (this._cachedHasTagIcon === undefined) {
      if (this._value.hasTagIcon) {
        this._cachedHasTagIcon = true;
      } else {
        this._cachedHasTagIcon = this._parent ? this._parent.hasTagIcon : false;
      }
    }
    return this._cachedHasTagIcon;
  }
  get tagIcon() {
    if (this._cachedTagIcon === undefined) {
      if (this._value.hasTagIcon) {
        this._cachedTagIcon = this._value.tagIcon;
      } else {
        this._cachedTagIcon = this._parent ? this._parent.tagIcon : this._value.tagIcon;
      }
    }
    return this._cachedTagIcon;
  }
  get hasTagDescription() {
    if (this._cachedHasTagDescription === undefined) {
      if (this._value.hasTagDescription) {
        this._cachedHasTagDescription = true;
      } else {
        this._cachedHasTagDescription = this._parent ? this._parent.hasTagDescription : false;
      }
    }
    return this._cachedHasTagDescription;
  }
  get tagDescription() {
    if (this._cachedTagDescription === undefined) {
      if (this._value.hasTagDescription) {
        this._cachedTagDescription = this._value.tagDescription;
      } else {
        this._cachedTagDescription = this._parent ? this._parent.tagDescription : this._value.tagDescription;
      }
    }
    return this._cachedTagDescription;
  }
  update(current, parent) {
    const result = new CardTag_WithParent(current, parent);
    return result;
  }
}
CardTag_WithParent.default = new CardTag_WithParent(CardTag.default, null);
CardTag.WithParent = CardTag_WithParent;
class CardTag_Descriptor {
  get tagName() {
    if (!this._tagName) {
      this._tagName = {
        name: "tagName",
        Name: "TagName",
        number: 1,
        protoType: 9,
        protoName: "tag_name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagName;
  }
  get tagDisplayName() {
    if (!this._tagDisplayName) {
      this._tagDisplayName = {
        name: "tagDisplayName",
        Name: "TagDisplayName",
        number: 2,
        protoType: 9,
        protoName: "tag_display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagDisplayName;
  }
  get tagIcon() {
    if (!this._tagIcon) {
      this._tagIcon = {
        name: "tagIcon",
        Name: "TagIcon",
        number: 3,
        protoType: 9,
        protoName: "tag_icon",
        type: JsonToString,
        options: {
          valueDropdown: "SkillIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagIcon;
  }
  get tagDescription() {
    if (!this._tagDescription) {
      this._tagDescription = {
        name: "tagDescription",
        Name: "TagDescription",
        number: 4,
        protoType: 9,
        protoName: "tag_description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tagDescription;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.tagName,
        this.tagDisplayName,
        this.tagIcon,
        this.tagDescription,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTagName",
        Name: "DummyOneofForTagName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTagDisplayName",
        Name: "DummyOneofForTagDisplayName",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTagIcon",
        Name: "DummyOneofForTagIcon",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTagDescription",
        Name: "DummyOneofForTagDescription",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
CardTag.descriptor = new CardTag_Descriptor();
export class CardSkinDefinitions {
  get descriptor() {
    return CardSkinDefinitions.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardSkinDefinitions = [];
  }
  isEmpty() {
    if (this._cardSkinDefinitions.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinDefinitions) {
      return value;
    }
    return CardSkinDefinitions.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinDefinitions();
    result._cardSkinDefinitions = JsonToList(json.cardSkinDefinitions, CardSkinDefinition);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardSkinDefinitions.length > 0) {
      result.cardSkinDefinitions = ArrayToJson(this._cardSkinDefinitions, CardSkinDefinition);
    }
    return result;
  }
  /**
   * @returns {CardSkinDefinition[]}
   */
  get cardSkinDefinitions() {
    return this._cardSkinDefinitions;
  }
  addCardSkinDefinitions_(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkinDefinitions']), value: value.toJson()};
  }
  setCardSkinDefinitions_(path, value) {
    return {type: 'SET', path: path.concat(['cardSkinDefinitions']), value: ArrayToJson(value, CardSkinDefinition)};
  }
  setCardSkinDefinitions_ByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkinDefinitions', key]), value: value.toJson()};
  }
  deleteCardSkinDefinitions_(path) {
    return {type: 'DELETE', path: path.concat(['cardSkinDefinitions'])};
  }
  deleteCardSkinDefinitions_ByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkinDefinitions', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardSkinDefinitions": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinitions(this);
              copy._cardSkinDefinitions = [];        for (let i of value) {
                copy._cardSkinDefinitions.push(CardSkinDefinition.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinitions(this);
              copy._cardSkinDefinitions = copy._cardSkinDefinitions.concat([CardSkinDefinition.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkinDefinitions.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinitions(this);
              copy._cardSkinDefinitions = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkinDefinitions.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinitions(this);
              copy._cardSkinDefinitions = copy._cardSkinDefinitions.slice();
              copy._cardSkinDefinitions[path[1]] = CardSkinDefinition.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinitions(this);
              copy._cardSkinDefinitions = copy._cardSkinDefinitions.slice(0, path[1]).concat(copy._cardSkinDefinitions.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkinDefinitions.length) {
            return this;
          }
          const oldValue = this._cardSkinDefinitions[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinitions(this);
          copy._cardSkinDefinitions = copy._cardSkinDefinitions.slice();
          copy._cardSkinDefinitions[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinDefinitions} other
   * @returns {CardSkinDefinitions}
   */
  merge(other) {
    const copy = new CardSkinDefinitions(this);
    copy._cardSkinDefinitions = this._cardSkinDefinitions.concat(other._cardSkinDefinitions);
    return copy;
  }
}
CardSkinDefinitions.default = new CardSkinDefinitions();
class CardSkinDefinitions_Builder {
  constructor(value) {
    this._value = new CardSkinDefinitions(value);
  }
  build() {
    return new CardSkinDefinitions(this._value);
  }
  addAllCardSkinDefinitions_(values) {
    this._value._cardSkinDefinitions = this._value._cardSkinDefinitions.concat(values);
    return this;
  }
  addCardSkinDefinitions_(value) {
    this._value._cardSkinDefinitions = this._value._cardSkinDefinitions.concat([value]);
    return this;
  }
  setCardSkinDefinitions_(index, value) {
    this._value._cardSkinDefinitions = this._value._cardSkinDefinitions.concat();
    this._value._cardSkinDefinitions[index] = value;
    return this;
  }
  clearCardSkinDefinitions_() {
    this._value._cardSkinDefinitions = [];
    return this;
  }
}
CardSkinDefinitions.Builder = CardSkinDefinitions_Builder;
class CardSkinDefinitions_WithParent {
  /**
   * @param {CardSkinDefinitions} value
   * @param {CardSkinDefinitions_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinDefinitions.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardSkinDefinitions_() {
    if (!this._selfCardSkinDefinitions_) {
      this._selfCardSkinDefinitions_ = [];
      for (let i of this._value.cardSkinDefinitions) {
        this._selfCardSkinDefinitions_.push(new CardSkinDefinition.WithParent(i, null));
      }
    }
    return this._selfCardSkinDefinitions_;
  }
  get inherentCardSkinDefinitions_() {
    if (!this._inherentCardSkinDefinitions_) {
      this._inherentCardSkinDefinitions_ = this._parent ? this._parent.cardSkinDefinitions : [];
    }
    return this._inherentCardSkinDefinitions_;
  }
  get cardSkinDefinitions() {
    if (!this._allCardSkinDefinitions_) {
      this._allCardSkinDefinitions_ = this._parent ? this._parent.cardSkinDefinitions.concat(this.selfCardSkinDefinitions_) : this.selfCardSkinDefinitions_;
    }
    return this._allCardSkinDefinitions_;
  }
  update(current, parent) {
    const result = new CardSkinDefinitions_WithParent(current, parent);
    if (this._selfCardSkinDefinitions_) {
      if (this._value.cardSkinDefinitions === current.cardSkinDefinitions) {
        result._selfCardSkinDefinitions_ = this._selfCardSkinDefinitions_;
      } else {
        result._selfCardSkinDefinitions_ = [];
        for (let i = 0; i < current.cardSkinDefinitions.length; i++) {
          const oldValue = this._value.cardSkinDefinitions[i];
          if (oldValue) {
            const oldCache = this._selfCardSkinDefinitions_[i];
            if (oldValue === current.cardSkinDefinitions[i]) {
              result._selfCardSkinDefinitions_[i] = oldCache;
            } else {
              result._selfCardSkinDefinitions_[i] = oldCache.update(current.cardSkinDefinitions[i], null);
            }
          } else {
            result._selfCardSkinDefinitions_[i] = new CardSkinDefinition.WithParent(current.cardSkinDefinitions[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardSkinDefinitions_WithParent.default = new CardSkinDefinitions_WithParent(CardSkinDefinitions.default, null);
CardSkinDefinitions.WithParent = CardSkinDefinitions_WithParent;
class CardSkinDefinitions_Descriptor {
  get cardSkinDefinitions() {
    if (!this._cardSkinDefinitions) {
      this._cardSkinDefinitions = {
        name: "cardSkinDefinitions",
        Name: "CardSkinDefinitions_",
        number: 1,
        protoType: 11,
        protoName: "card_skin_definitions",
        type: CardSkinDefinition,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkinDefinitions;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardSkinDefinitions,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CardSkinDefinitions.descriptor = new CardSkinDefinitions_Descriptor();
export class CardSkinData {
  get descriptor() {
    return CardSkinData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._cardSkins = [];
  }
  isEmpty() {
    if (this._cardSkins.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinData) {
      return value;
    }
    return CardSkinData.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinData();
    result._cardSkins = JsonToList(json.cardSkins, CardSkin);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._cardSkins.length > 0) {
      result.cardSkins = ArrayToJson(this._cardSkins, CardSkin);
    }
    return result;
  }
  /**
   * @returns {CardSkin[]}
   */
  get cardSkins() {
    return this._cardSkins;
  }
  addCardSkins(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkins']), value: value.toJson()};
  }
  setCardSkins(path, value) {
    return {type: 'SET', path: path.concat(['cardSkins']), value: ArrayToJson(value, CardSkin)};
  }
  setCardSkinsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkins', key]), value: value.toJson()};
  }
  deleteCardSkins(path) {
    return {type: 'DELETE', path: path.concat(['cardSkins'])};
  }
  deleteCardSkinsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkins', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cardSkins": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinData(this);
              copy._cardSkins = [];        for (let i of value) {
                copy._cardSkins.push(CardSkin.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinData(this);
              copy._cardSkins = copy._cardSkins.concat([CardSkin.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkins.length === 0) {
                return this;
              }
              const copy = new CardSkinData(this);
              copy._cardSkins = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkins.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinData(this);
              copy._cardSkins = copy._cardSkins.slice();
              copy._cardSkins[path[1]] = CardSkin.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinData(this);
              copy._cardSkins = copy._cardSkins.slice(0, path[1]).concat(copy._cardSkins.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkins.length) {
            return this;
          }
          const oldValue = this._cardSkins[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinData(this);
          copy._cardSkins = copy._cardSkins.slice();
          copy._cardSkins[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinData} other
   * @returns {CardSkinData}
   */
  merge(other) {
    const copy = new CardSkinData(this);
    copy._cardSkins = this._cardSkins.concat(other._cardSkins);
    return copy;
  }
}
CardSkinData.default = new CardSkinData();
class CardSkinData_Builder {
  constructor(value) {
    this._value = new CardSkinData(value);
  }
  build() {
    return new CardSkinData(this._value);
  }
  addAllCardSkins(values) {
    this._value._cardSkins = this._value._cardSkins.concat(values);
    return this;
  }
  addCardSkins(value) {
    this._value._cardSkins = this._value._cardSkins.concat([value]);
    return this;
  }
  setCardSkins(index, value) {
    this._value._cardSkins = this._value._cardSkins.concat();
    this._value._cardSkins[index] = value;
    return this;
  }
  clearCardSkins() {
    this._value._cardSkins = [];
    return this;
  }
}
CardSkinData.Builder = CardSkinData_Builder;
class CardSkinData_WithParent {
  /**
   * @param {CardSkinData} value
   * @param {CardSkinData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCardSkins() {
    if (!this._selfCardSkins) {
      this._selfCardSkins = [];
      for (let i of this._value.cardSkins) {
        this._selfCardSkins.push(new CardSkin.WithParent(i, null));
      }
    }
    return this._selfCardSkins;
  }
  get inherentCardSkins() {
    if (!this._inherentCardSkins) {
      this._inherentCardSkins = this._parent ? this._parent.cardSkins : [];
    }
    return this._inherentCardSkins;
  }
  get cardSkins() {
    if (!this._allCardSkins) {
      this._allCardSkins = this._parent ? this._parent.cardSkins.concat(this.selfCardSkins) : this.selfCardSkins;
    }
    return this._allCardSkins;
  }
  update(current, parent) {
    const result = new CardSkinData_WithParent(current, parent);
    if (this._selfCardSkins) {
      if (this._value.cardSkins === current.cardSkins) {
        result._selfCardSkins = this._selfCardSkins;
      } else {
        result._selfCardSkins = [];
        for (let i = 0; i < current.cardSkins.length; i++) {
          const oldValue = this._value.cardSkins[i];
          if (oldValue) {
            const oldCache = this._selfCardSkins[i];
            if (oldValue === current.cardSkins[i]) {
              result._selfCardSkins[i] = oldCache;
            } else {
              result._selfCardSkins[i] = oldCache.update(current.cardSkins[i], null);
            }
          } else {
            result._selfCardSkins[i] = new CardSkin.WithParent(current.cardSkins[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardSkinData_WithParent.default = new CardSkinData_WithParent(CardSkinData.default, null);
CardSkinData.WithParent = CardSkinData_WithParent;
class CardSkinData_Descriptor {
  get cardSkins() {
    if (!this._cardSkins) {
      this._cardSkins = {
        name: "cardSkins",
        Name: "CardSkins",
        number: 1,
        protoType: 11,
        protoName: "card_skins",
        type: CardSkin,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkins;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cardSkins,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CardSkinData.descriptor = new CardSkinData_Descriptor();
class CardSkinDefinition_Skin {
  get descriptor() {
    return CardSkinDefinition_Skin.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._skinResources = [];
    this._hasSkinIcon = false;
    this._skinIcon = null;
    this._hasSkinPortraitImage = false;
    this._skinPortraitImage = null;
    this._skinUpgrades = [];
    this._unlockedAbilities = [];
    this._unlockedWeapons = [];
    this._unlockedBehaviors = [];
    this._hasDisplayName = false;
    this._displayName = null;
    this._hasDescription = false;
    this._description = null;
    this._hasDescriptionTitle = false;
    this._descriptionTitle = null;
    this._hasSkinUnlockTime = false;
    this._skinUnlockTime = null;
    this._hasIngameIcon = false;
    this._ingameIcon = null;
    this._hasHide = false;
    this._hide = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._skinResources.length > 0) return false;
    if (this._hasSkinIcon) return false;
    if (this._hasSkinPortraitImage) return false;
    if (this._skinUpgrades.length > 0) return false;
    if (this._unlockedAbilities.length > 0) return false;
    if (this._unlockedWeapons.length > 0) return false;
    if (this._unlockedBehaviors.length > 0) return false;
    if (this._hasDisplayName) return false;
    if (this._hasDescription) return false;
    if (this._hasDescriptionTitle) return false;
    if (this._hasSkinUnlockTime) return false;
    if (this._hasIngameIcon) return false;
    if (this._hasHide) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinDefinition_Skin) {
      return value;
    }
    return CardSkinDefinition_Skin.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinDefinition_Skin();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    result._skinResources = JsonToList(json.skinResources, JsonToString);
    if (json.skinIcon != null) {
      result._hasSkinIcon = true;
      result._skinIcon = JsonToString.fromJson(json.skinIcon);
    }
    if (json.skinPortraitImage != null) {
      result._hasSkinPortraitImage = true;
      result._skinPortraitImage = JsonToString.fromJson(json.skinPortraitImage);
    }
    result._skinUpgrades = JsonToList(json.skinUpgrades, JsonToString);
    result._unlockedAbilities = JsonToList(json.unlockedAbilities, JsonToString);
    result._unlockedWeapons = JsonToList(json.unlockedWeapons, JsonToString);
    result._unlockedBehaviors = JsonToList(json.unlockedBehaviors, JsonToString);
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.descriptionTitle != null) {
      result._hasDescriptionTitle = true;
      result._descriptionTitle = JsonToString.fromJson(json.descriptionTitle);
    }
    if (json.skinUnlockTime != null) {
      result._hasSkinUnlockTime = true;
      result._skinUnlockTime = JsonToInt32.fromJson(json.skinUnlockTime);
    }
    if (json.ingameIcon != null) {
      result._hasIngameIcon = true;
      result._ingameIcon = JsonToString.fromJson(json.ingameIcon);
    }
    if (json.hide != null) {
      result._hasHide = true;
      result._hide = JsonToBoolean.fromJson(json.hide);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._skinResources.length > 0) {
      result.skinResources = ArrayToJson(this._skinResources, JsonToString);
    }
    if (this._hasSkinIcon) {
      result.skinIcon = JsonToString.toJson(this._skinIcon);
    }
    if (this._hasSkinPortraitImage) {
      result.skinPortraitImage = JsonToString.toJson(this._skinPortraitImage);
    }
    if (this._skinUpgrades.length > 0) {
      result.skinUpgrades = ArrayToJson(this._skinUpgrades, JsonToString);
    }
    if (this._unlockedAbilities.length > 0) {
      result.unlockedAbilities = ArrayToJson(this._unlockedAbilities, JsonToString);
    }
    if (this._unlockedWeapons.length > 0) {
      result.unlockedWeapons = ArrayToJson(this._unlockedWeapons, JsonToString);
    }
    if (this._unlockedBehaviors.length > 0) {
      result.unlockedBehaviors = ArrayToJson(this._unlockedBehaviors, JsonToString);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasDescriptionTitle) {
      result.descriptionTitle = JsonToString.toJson(this._descriptionTitle);
    }
    if (this._hasSkinUnlockTime) {
      result.skinUnlockTime = JsonToInt32.toJson(this._skinUnlockTime);
    }
    if (this._hasIngameIcon) {
      result.ingameIcon = JsonToString.toJson(this._ingameIcon);
    }
    if (this._hasHide) {
      result.hide = JsonToBoolean.toJson(this._hide);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string[]}
   */
  get skinResources() {
    return this._skinResources;
  }
  addSkinResources(path, value) {
    return {type: 'ADD', path: path.concat(['skinResources']), value};
  }
  setSkinResources(path, value) {
    return {type: 'SET', path: path.concat(['skinResources']), value: ArrayToJson(value, JsonToString)};
  }
  setSkinResourcesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skinResources', key]), value};
  }
  deleteSkinResources(path) {
    return {type: 'DELETE', path: path.concat(['skinResources'])};
  }
  deleteSkinResourcesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skinResources', key])};
  }
  /**
   * @returns {string}
   */
  get skinIcon() {
    return this._hasSkinIcon ? this._skinIcon : JsonToString.default;
  }
  get hasSkinIcon() {
    return this._hasSkinIcon;
  }
  setSkinIcon(path, value) {
    return {type: 'SET', path: path.concat(['skinIcon']), value};
  }
  deleteSkinIcon(path) {
    return {type: 'DELETE', path: path.concat(['skinIcon'])};
  }
  /**
   * @returns {string}
   */
  get skinPortraitImage() {
    return this._hasSkinPortraitImage ? this._skinPortraitImage : JsonToString.default;
  }
  get hasSkinPortraitImage() {
    return this._hasSkinPortraitImage;
  }
  setSkinPortraitImage(path, value) {
    return {type: 'SET', path: path.concat(['skinPortraitImage']), value};
  }
  deleteSkinPortraitImage(path) {
    return {type: 'DELETE', path: path.concat(['skinPortraitImage'])};
  }
  /**
   * @returns {string[]}
   */
  get skinUpgrades() {
    return this._skinUpgrades;
  }
  addSkinUpgrades(path, value) {
    return {type: 'ADD', path: path.concat(['skinUpgrades']), value};
  }
  setSkinUpgrades(path, value) {
    return {type: 'SET', path: path.concat(['skinUpgrades']), value: ArrayToJson(value, JsonToString)};
  }
  setSkinUpgradesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['skinUpgrades', key]), value};
  }
  deleteSkinUpgrades(path) {
    return {type: 'DELETE', path: path.concat(['skinUpgrades'])};
  }
  deleteSkinUpgradesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['skinUpgrades', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedAbilities() {
    return this._unlockedAbilities;
  }
  addUnlockedAbilities(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedAbilities']), value};
  }
  setUnlockedAbilities(path, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedAbilitiesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedAbilities', key]), value};
  }
  deleteUnlockedAbilities(path) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities'])};
  }
  deleteUnlockedAbilitiesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedAbilities', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedWeapons() {
    return this._unlockedWeapons;
  }
  addUnlockedWeapons(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedWeapons']), value};
  }
  setUnlockedWeapons(path, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedWeaponsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedWeapons', key]), value};
  }
  deleteUnlockedWeapons(path) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons'])};
  }
  deleteUnlockedWeaponsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedWeapons', key])};
  }
  /**
   * @returns {string[]}
   */
  get unlockedBehaviors() {
    return this._unlockedBehaviors;
  }
  addUnlockedBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['unlockedBehaviors']), value};
  }
  setUnlockedBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setUnlockedBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unlockedBehaviors', key]), value};
  }
  deleteUnlockedBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors'])};
  }
  deleteUnlockedBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unlockedBehaviors', key])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {string}
   */
  get descriptionTitle() {
    return this._hasDescriptionTitle ? this._descriptionTitle : JsonToString.default;
  }
  get hasDescriptionTitle() {
    return this._hasDescriptionTitle;
  }
  setDescriptionTitle(path, value) {
    return {type: 'SET', path: path.concat(['descriptionTitle']), value};
  }
  deleteDescriptionTitle(path) {
    return {type: 'DELETE', path: path.concat(['descriptionTitle'])};
  }
  /**
   * @returns {number}
   */
  get skinUnlockTime() {
    return this._hasSkinUnlockTime ? this._skinUnlockTime : JsonToInt32.default;
  }
  get hasSkinUnlockTime() {
    return this._hasSkinUnlockTime;
  }
  setSkinUnlockTime(path, value) {
    return {type: 'SET', path: path.concat(['skinUnlockTime']), value};
  }
  deleteSkinUnlockTime(path) {
    return {type: 'DELETE', path: path.concat(['skinUnlockTime'])};
  }
  /**
   * @returns {string}
   */
  get ingameIcon() {
    return this._hasIngameIcon ? this._ingameIcon : JsonToString.default;
  }
  get hasIngameIcon() {
    return this._hasIngameIcon;
  }
  setIngameIcon(path, value) {
    return {type: 'SET', path: path.concat(['ingameIcon']), value};
  }
  deleteIngameIcon(path) {
    return {type: 'DELETE', path: path.concat(['ingameIcon'])};
  }
  /**
   * @returns {boolean}
   */
  get hide() {
    return this._hasHide ? this._hide : JsonToBoolean.default;
  }
  get hasHide() {
    return this._hasHide;
  }
  setHide(path, value) {
    return {type: 'SET', path: path.concat(['hide']), value};
  }
  deleteHide(path) {
    return {type: 'DELETE', path: path.concat(['hide'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinResources": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinResources = [];        for (let i of value) {
                copy._skinResources.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinResources = copy._skinResources.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skinResources.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinResources = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skinResources.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinResources = copy._skinResources.slice();
              copy._skinResources[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinResources = copy._skinResources.slice(0, path[1]).concat(copy._skinResources.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skinResources.length) {
            return this;
          }
          const oldValue = this._skinResources[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_Skin(this);
          copy._skinResources = copy._skinResources.slice();
          copy._skinResources[key] = newValue;
          return copy;
        }
      }
      case "skinIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinIcon = true;
              copy._skinIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinIcon) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinIcon = false;
              copy._skinIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinPortraitImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinPortraitImage = true;
              copy._skinPortraitImage = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinPortraitImage) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinPortraitImage = false;
              copy._skinPortraitImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinUpgrades": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinUpgrades = [];        for (let i of value) {
                copy._skinUpgrades.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinUpgrades = copy._skinUpgrades.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._skinUpgrades.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinUpgrades = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._skinUpgrades.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinUpgrades = copy._skinUpgrades.slice();
              copy._skinUpgrades[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._skinUpgrades = copy._skinUpgrades.slice(0, path[1]).concat(copy._skinUpgrades.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._skinUpgrades.length) {
            return this;
          }
          const oldValue = this._skinUpgrades[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_Skin(this);
          copy._skinUpgrades = copy._skinUpgrades.slice();
          copy._skinUpgrades[key] = newValue;
          return copy;
        }
      }
      case "unlockedAbilities": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedAbilities = [];        for (let i of value) {
                copy._unlockedAbilities.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedAbilities = copy._unlockedAbilities.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedAbilities.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedAbilities = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice();
              copy._unlockedAbilities[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedAbilities = copy._unlockedAbilities.slice(0, path[1]).concat(copy._unlockedAbilities.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedAbilities.length) {
            return this;
          }
          const oldValue = this._unlockedAbilities[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_Skin(this);
          copy._unlockedAbilities = copy._unlockedAbilities.slice();
          copy._unlockedAbilities[key] = newValue;
          return copy;
        }
      }
      case "unlockedWeapons": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedWeapons = [];        for (let i of value) {
                copy._unlockedWeapons.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedWeapons = copy._unlockedWeapons.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedWeapons.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedWeapons = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice();
              copy._unlockedWeapons[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedWeapons = copy._unlockedWeapons.slice(0, path[1]).concat(copy._unlockedWeapons.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedWeapons.length) {
            return this;
          }
          const oldValue = this._unlockedWeapons[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_Skin(this);
          copy._unlockedWeapons = copy._unlockedWeapons.slice();
          copy._unlockedWeapons[key] = newValue;
          return copy;
        }
      }
      case "unlockedBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedBehaviors = [];        for (let i of value) {
                copy._unlockedBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unlockedBehaviors.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
              copy._unlockedBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._unlockedBehaviors = copy._unlockedBehaviors.slice(0, path[1]).concat(copy._unlockedBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unlockedBehaviors.length) {
            return this;
          }
          const oldValue = this._unlockedBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_Skin(this);
          copy._unlockedBehaviors = copy._unlockedBehaviors.slice();
          copy._unlockedBehaviors[key] = newValue;
          return copy;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "descriptionTitle": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDescriptionTitle = true;
              copy._descriptionTitle = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescriptionTitle) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasDescriptionTitle = false;
              copy._descriptionTitle = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "skinUnlockTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinUnlockTime = true;
              copy._skinUnlockTime = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasSkinUnlockTime) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasSkinUnlockTime = false;
              copy._skinUnlockTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "ingameIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasIngameIcon = true;
              copy._ingameIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIngameIcon) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasIngameIcon = false;
              copy._ingameIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasHide = true;
              copy._hide = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHide) {
                return this;
              }
              const copy = new CardSkinDefinition_Skin(this);
              copy._hasHide = false;
              copy._hide = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinDefinition_Skin} other
   * @returns {CardSkinDefinition_Skin}
   */
  merge(other) {
    const copy = new CardSkinDefinition_Skin(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    copy._skinResources = this._skinResources.concat(other._skinResources);
    if (other._hasSkinIcon) {
      copy._hasSkinIcon = true;
      copy._skinIcon = other._skinIcon;
    }
    if (other._hasSkinPortraitImage) {
      copy._hasSkinPortraitImage = true;
      copy._skinPortraitImage = other._skinPortraitImage;
    }
    copy._skinUpgrades = this._skinUpgrades.concat(other._skinUpgrades);
    copy._unlockedAbilities = this._unlockedAbilities.concat(other._unlockedAbilities);
    copy._unlockedWeapons = this._unlockedWeapons.concat(other._unlockedWeapons);
    copy._unlockedBehaviors = this._unlockedBehaviors.concat(other._unlockedBehaviors);
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasDescriptionTitle) {
      copy._hasDescriptionTitle = true;
      copy._descriptionTitle = other._descriptionTitle;
    }
    if (other._hasSkinUnlockTime) {
      copy._hasSkinUnlockTime = true;
      copy._skinUnlockTime = other._skinUnlockTime;
    }
    if (other._hasIngameIcon) {
      copy._hasIngameIcon = true;
      copy._ingameIcon = other._ingameIcon;
    }
    if (other._hasHide) {
      copy._hasHide = true;
      copy._hide = other._hide;
    }
    return copy;
  }
}
CardSkinDefinition_Skin.default = new CardSkinDefinition_Skin();
class CardSkinDefinition_Skin_Builder {
  constructor(value) {
    this._value = new CardSkinDefinition_Skin(value);
  }
  build() {
    return new CardSkinDefinition_Skin(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  addAllSkinResources(values) {
    this._value._skinResources = this._value._skinResources.concat(values);
    return this;
  }
  addSkinResources(value) {
    this._value._skinResources = this._value._skinResources.concat([value]);
    return this;
  }
  setSkinResources(index, value) {
    this._value._skinResources = this._value._skinResources.concat();
    this._value._skinResources[index] = value;
    return this;
  }
  clearSkinResources() {
    this._value._skinResources = [];
    return this;
  }
  setSkinIcon(value) {
    this._value._hasSkinIcon = true;
    this._value._skinIcon = value;
    return this;
  }
  deleteSkinIcon() {
    this._value._hasSkinIcon = false;
    this._value._skinIcon = null;
    return this;
  }
  setSkinPortraitImage(value) {
    this._value._hasSkinPortraitImage = true;
    this._value._skinPortraitImage = value;
    return this;
  }
  deleteSkinPortraitImage() {
    this._value._hasSkinPortraitImage = false;
    this._value._skinPortraitImage = null;
    return this;
  }
  addAllSkinUpgrades(values) {
    this._value._skinUpgrades = this._value._skinUpgrades.concat(values);
    return this;
  }
  addSkinUpgrades(value) {
    this._value._skinUpgrades = this._value._skinUpgrades.concat([value]);
    return this;
  }
  setSkinUpgrades(index, value) {
    this._value._skinUpgrades = this._value._skinUpgrades.concat();
    this._value._skinUpgrades[index] = value;
    return this;
  }
  clearSkinUpgrades() {
    this._value._skinUpgrades = [];
    return this;
  }
  addAllUnlockedAbilities(values) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat(values);
    return this;
  }
  addUnlockedAbilities(value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat([value]);
    return this;
  }
  setUnlockedAbilities(index, value) {
    this._value._unlockedAbilities = this._value._unlockedAbilities.concat();
    this._value._unlockedAbilities[index] = value;
    return this;
  }
  clearUnlockedAbilities() {
    this._value._unlockedAbilities = [];
    return this;
  }
  addAllUnlockedWeapons(values) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat(values);
    return this;
  }
  addUnlockedWeapons(value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat([value]);
    return this;
  }
  setUnlockedWeapons(index, value) {
    this._value._unlockedWeapons = this._value._unlockedWeapons.concat();
    this._value._unlockedWeapons[index] = value;
    return this;
  }
  clearUnlockedWeapons() {
    this._value._unlockedWeapons = [];
    return this;
  }
  addAllUnlockedBehaviors(values) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat(values);
    return this;
  }
  addUnlockedBehaviors(value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat([value]);
    return this;
  }
  setUnlockedBehaviors(index, value) {
    this._value._unlockedBehaviors = this._value._unlockedBehaviors.concat();
    this._value._unlockedBehaviors[index] = value;
    return this;
  }
  clearUnlockedBehaviors() {
    this._value._unlockedBehaviors = [];
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setDescriptionTitle(value) {
    this._value._hasDescriptionTitle = true;
    this._value._descriptionTitle = value;
    return this;
  }
  deleteDescriptionTitle() {
    this._value._hasDescriptionTitle = false;
    this._value._descriptionTitle = null;
    return this;
  }
  setSkinUnlockTime(value) {
    this._value._hasSkinUnlockTime = true;
    this._value._skinUnlockTime = value;
    return this;
  }
  deleteSkinUnlockTime() {
    this._value._hasSkinUnlockTime = false;
    this._value._skinUnlockTime = null;
    return this;
  }
  setIngameIcon(value) {
    this._value._hasIngameIcon = true;
    this._value._ingameIcon = value;
    return this;
  }
  deleteIngameIcon() {
    this._value._hasIngameIcon = false;
    this._value._ingameIcon = null;
    return this;
  }
  setHide(value) {
    this._value._hasHide = true;
    this._value._hide = value;
    return this;
  }
  deleteHide() {
    this._value._hasHide = false;
    this._value._hide = null;
    return this;
  }
}
CardSkinDefinition_Skin.Builder = CardSkinDefinition_Skin_Builder;
class CardSkinDefinition_Skin_WithParent {
  /**
   * @param {CardSkinDefinition_Skin} value
   * @param {CardSkinDefinition_Skin_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinDefinition_Skin.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get selfSkinResources() {
    return this._value.skinResources;
  }
  get inherentSkinResources() {
    if (!this._inherentSkinResources) {
      this._inherentSkinResources = this._parent ? this._parent.skinResources : [];
    }
    return this._inherentSkinResources;
  }
  get skinResources() {
    if (!this._allSkinResources) {
      this._allSkinResources = this._parent ? this._parent.skinResources.concat(this.selfSkinResources) : this.selfSkinResources;
    }
    return this._allSkinResources;
  }
  get hasSkinIcon() {
    if (this._cachedHasSkinIcon === undefined) {
      if (this._value.hasSkinIcon) {
        this._cachedHasSkinIcon = true;
      } else {
        this._cachedHasSkinIcon = this._parent ? this._parent.hasSkinIcon : false;
      }
    }
    return this._cachedHasSkinIcon;
  }
  get skinIcon() {
    if (this._cachedSkinIcon === undefined) {
      if (this._value.hasSkinIcon) {
        this._cachedSkinIcon = this._value.skinIcon;
      } else {
        this._cachedSkinIcon = this._parent ? this._parent.skinIcon : this._value.skinIcon;
      }
    }
    return this._cachedSkinIcon;
  }
  get hasSkinPortraitImage() {
    if (this._cachedHasSkinPortraitImage === undefined) {
      if (this._value.hasSkinPortraitImage) {
        this._cachedHasSkinPortraitImage = true;
      } else {
        this._cachedHasSkinPortraitImage = this._parent ? this._parent.hasSkinPortraitImage : false;
      }
    }
    return this._cachedHasSkinPortraitImage;
  }
  get skinPortraitImage() {
    if (this._cachedSkinPortraitImage === undefined) {
      if (this._value.hasSkinPortraitImage) {
        this._cachedSkinPortraitImage = this._value.skinPortraitImage;
      } else {
        this._cachedSkinPortraitImage = this._parent ? this._parent.skinPortraitImage : this._value.skinPortraitImage;
      }
    }
    return this._cachedSkinPortraitImage;
  }
  get selfSkinUpgrades() {
    return this._value.skinUpgrades;
  }
  get inherentSkinUpgrades() {
    if (!this._inherentSkinUpgrades) {
      this._inherentSkinUpgrades = this._parent ? this._parent.skinUpgrades : [];
    }
    return this._inherentSkinUpgrades;
  }
  get skinUpgrades() {
    if (!this._allSkinUpgrades) {
      this._allSkinUpgrades = this._parent ? this._parent.skinUpgrades.concat(this.selfSkinUpgrades) : this.selfSkinUpgrades;
    }
    return this._allSkinUpgrades;
  }
  get selfUnlockedAbilities() {
    return this._value.unlockedAbilities;
  }
  get inherentUnlockedAbilities() {
    if (!this._inherentUnlockedAbilities) {
      this._inherentUnlockedAbilities = this._parent ? this._parent.unlockedAbilities : [];
    }
    return this._inherentUnlockedAbilities;
  }
  get unlockedAbilities() {
    if (!this._allUnlockedAbilities) {
      this._allUnlockedAbilities = this._parent ? this._parent.unlockedAbilities.concat(this.selfUnlockedAbilities) : this.selfUnlockedAbilities;
    }
    return this._allUnlockedAbilities;
  }
  get selfUnlockedWeapons() {
    return this._value.unlockedWeapons;
  }
  get inherentUnlockedWeapons() {
    if (!this._inherentUnlockedWeapons) {
      this._inherentUnlockedWeapons = this._parent ? this._parent.unlockedWeapons : [];
    }
    return this._inherentUnlockedWeapons;
  }
  get unlockedWeapons() {
    if (!this._allUnlockedWeapons) {
      this._allUnlockedWeapons = this._parent ? this._parent.unlockedWeapons.concat(this.selfUnlockedWeapons) : this.selfUnlockedWeapons;
    }
    return this._allUnlockedWeapons;
  }
  get selfUnlockedBehaviors() {
    return this._value.unlockedBehaviors;
  }
  get inherentUnlockedBehaviors() {
    if (!this._inherentUnlockedBehaviors) {
      this._inherentUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors : [];
    }
    return this._inherentUnlockedBehaviors;
  }
  get unlockedBehaviors() {
    if (!this._allUnlockedBehaviors) {
      this._allUnlockedBehaviors = this._parent ? this._parent.unlockedBehaviors.concat(this.selfUnlockedBehaviors) : this.selfUnlockedBehaviors;
    }
    return this._allUnlockedBehaviors;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasDescriptionTitle() {
    if (this._cachedHasDescriptionTitle === undefined) {
      if (this._value.hasDescriptionTitle) {
        this._cachedHasDescriptionTitle = true;
      } else {
        this._cachedHasDescriptionTitle = this._parent ? this._parent.hasDescriptionTitle : false;
      }
    }
    return this._cachedHasDescriptionTitle;
  }
  get descriptionTitle() {
    if (this._cachedDescriptionTitle === undefined) {
      if (this._value.hasDescriptionTitle) {
        this._cachedDescriptionTitle = this._value.descriptionTitle;
      } else {
        this._cachedDescriptionTitle = this._parent ? this._parent.descriptionTitle : this._value.descriptionTitle;
      }
    }
    return this._cachedDescriptionTitle;
  }
  get hasSkinUnlockTime() {
    if (this._cachedHasSkinUnlockTime === undefined) {
      if (this._value.hasSkinUnlockTime) {
        this._cachedHasSkinUnlockTime = true;
      } else {
        this._cachedHasSkinUnlockTime = this._parent ? this._parent.hasSkinUnlockTime : false;
      }
    }
    return this._cachedHasSkinUnlockTime;
  }
  get skinUnlockTime() {
    if (this._cachedSkinUnlockTime === undefined) {
      if (this._value.hasSkinUnlockTime) {
        this._cachedSkinUnlockTime = this._value.skinUnlockTime;
      } else {
        this._cachedSkinUnlockTime = this._parent ? this._parent.skinUnlockTime : this._value.skinUnlockTime;
      }
    }
    return this._cachedSkinUnlockTime;
  }
  get hasIngameIcon() {
    if (this._cachedHasIngameIcon === undefined) {
      if (this._value.hasIngameIcon) {
        this._cachedHasIngameIcon = true;
      } else {
        this._cachedHasIngameIcon = this._parent ? this._parent.hasIngameIcon : false;
      }
    }
    return this._cachedHasIngameIcon;
  }
  get ingameIcon() {
    if (this._cachedIngameIcon === undefined) {
      if (this._value.hasIngameIcon) {
        this._cachedIngameIcon = this._value.ingameIcon;
      } else {
        this._cachedIngameIcon = this._parent ? this._parent.ingameIcon : this._value.ingameIcon;
      }
    }
    return this._cachedIngameIcon;
  }
  get hasHide() {
    if (this._cachedHasHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHasHide = true;
      } else {
        this._cachedHasHide = this._parent ? this._parent.hasHide : false;
      }
    }
    return this._cachedHasHide;
  }
  get hide() {
    if (this._cachedHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHide = this._value.hide;
      } else {
        this._cachedHide = this._parent ? this._parent.hide : this._value.hide;
      }
    }
    return this._cachedHide;
  }
  update(current, parent) {
    const result = new CardSkinDefinition_Skin_WithParent(current, parent);
    return result;
  }
}
CardSkinDefinition_Skin_WithParent.default = new CardSkinDefinition_Skin_WithParent(CardSkinDefinition_Skin.default, null);
CardSkinDefinition_Skin.WithParent = CardSkinDefinition_Skin_WithParent;
class CardSkinDefinition_Skin_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get skinResources() {
    if (!this._skinResources) {
      this._skinResources = {
        name: "skinResources",
        Name: "SkinResources",
        number: 2,
        protoType: 9,
        protoName: "skin_resources",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinResources;
  }
  get skinIcon() {
    if (!this._skinIcon) {
      this._skinIcon = {
        name: "skinIcon",
        Name: "SkinIcon",
        number: 3,
        protoType: 9,
        protoName: "skin_icon",
        type: JsonToString,
        options: {
          valueDropdown: "CardIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinIcon;
  }
  get skinPortraitImage() {
    if (!this._skinPortraitImage) {
      this._skinPortraitImage = {
        name: "skinPortraitImage",
        Name: "SkinPortraitImage",
        number: 4,
        protoType: 9,
        protoName: "skin_portrait_image",
        type: JsonToString,
        options: {
          valueDropdown: "CardPortraits",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinPortraitImage;
  }
  get skinUpgrades() {
    if (!this._skinUpgrades) {
      this._skinUpgrades = {
        name: "skinUpgrades",
        Name: "SkinUpgrades",
        number: 6,
        protoType: 9,
        protoName: "skin_upgrades",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "SupportedDataUpgrades",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinUpgrades;
  }
  get unlockedAbilities() {
    if (!this._unlockedAbilities) {
      this._unlockedAbilities = {
        name: "unlockedAbilities",
        Name: "UnlockedAbilities",
        number: 7,
        protoType: 9,
        protoName: "unlocked_abilities",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "AbilityNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedAbilities;
  }
  get unlockedWeapons() {
    if (!this._unlockedWeapons) {
      this._unlockedWeapons = {
        name: "unlockedWeapons",
        Name: "UnlockedWeapons",
        number: 8,
        protoType: 9,
        protoName: "unlocked_weapons",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "WeaponNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedWeapons;
  }
  get unlockedBehaviors() {
    if (!this._unlockedBehaviors) {
      this._unlockedBehaviors = {
        name: "unlockedBehaviors",
        Name: "UnlockedBehaviors",
        number: 9,
        protoType: 9,
        protoName: "unlocked_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "BehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unlockedBehaviors;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 10,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 11,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get descriptionTitle() {
    if (!this._descriptionTitle) {
      this._descriptionTitle = {
        name: "descriptionTitle",
        Name: "DescriptionTitle",
        number: 12,
        protoType: 9,
        protoName: "description_title",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._descriptionTitle;
  }
  get skinUnlockTime() {
    if (!this._skinUnlockTime) {
      this._skinUnlockTime = {
        name: "skinUnlockTime",
        Name: "SkinUnlockTime",
        number: 21,
        protoType: 5,
        protoName: "skin_unlock_time",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._skinUnlockTime;
  }
  get ingameIcon() {
    if (!this._ingameIcon) {
      this._ingameIcon = {
        name: "ingameIcon",
        Name: "IngameIcon",
        number: 31,
        protoType: 9,
        protoName: "ingame_icon",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedInGameIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._ingameIcon;
  }
  get hide() {
    if (!this._hide) {
      this._hide = {
        name: "hide",
        Name: "Hide",
        number: 99,
        protoType: 8,
        protoName: "hide",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hide;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.skinResources,
        this.skinIcon,
        this.skinPortraitImage,
        this.skinUpgrades,
        this.unlockedAbilities,
        this.unlockedWeapons,
        this.unlockedBehaviors,
        this.displayName,
        this.description,
        this.descriptionTitle,
        this.skinUnlockTime,
        this.ingameIcon,
        this.hide,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinIcon",
        Name: "DummyOneofForSkinIcon",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinPortraitImage",
        Name: "DummyOneofForSkinPortraitImage",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescriptionTitle",
        Name: "DummyOneofForDescriptionTitle",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForSkinUnlockTime",
        Name: "DummyOneofForSkinUnlockTime",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIngameIcon",
        Name: "DummyOneofForIngameIcon",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHide",
        Name: "DummyOneofForHide",
        fields: [
          this.fields[13],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkinDefinition_Skin.descriptor = new CardSkinDefinition_Skin_Descriptor();
class CardSkinDefinition_HeroActor {
  get descriptor() {
    return CardSkinDefinition_HeroActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasUnitActor = false;
    this._unitActor = null;
  }
  isEmpty() {
    if (this._hasUnitActor) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinDefinition_HeroActor) {
      return value;
    }
    return CardSkinDefinition_HeroActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinDefinition_HeroActor();
    if (json.unitActor != null) {
      result._hasUnitActor = true;
      result._unitActor = JsonToString.fromJson(json.unitActor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasUnitActor) {
      result.unitActor = JsonToString.toJson(this._unitActor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get unitActor() {
    return this._hasUnitActor ? this._unitActor : JsonToString.default;
  }
  get hasUnitActor() {
    return this._hasUnitActor;
  }
  setUnitActor(path, value) {
    return {type: 'SET', path: path.concat(['unitActor']), value};
  }
  deleteUnitActor(path) {
    return {type: 'DELETE', path: path.concat(['unitActor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_HeroActor(this);
              copy._hasUnitActor = true;
              copy._unitActor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUnitActor) {
                return this;
              }
              const copy = new CardSkinDefinition_HeroActor(this);
              copy._hasUnitActor = false;
              copy._unitActor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinDefinition_HeroActor} other
   * @returns {CardSkinDefinition_HeroActor}
   */
  merge(other) {
    const copy = new CardSkinDefinition_HeroActor(this);
    if (other._hasUnitActor) {
      copy._hasUnitActor = true;
      copy._unitActor = other._unitActor;
    }
    return copy;
  }
}
CardSkinDefinition_HeroActor.default = new CardSkinDefinition_HeroActor();
class CardSkinDefinition_HeroActor_Builder {
  constructor(value) {
    this._value = new CardSkinDefinition_HeroActor(value);
  }
  build() {
    return new CardSkinDefinition_HeroActor(this._value);
  }
  setUnitActor(value) {
    this._value._hasUnitActor = true;
    this._value._unitActor = value;
    return this;
  }
  deleteUnitActor() {
    this._value._hasUnitActor = false;
    this._value._unitActor = null;
    return this;
  }
}
CardSkinDefinition_HeroActor.Builder = CardSkinDefinition_HeroActor_Builder;
class CardSkinDefinition_HeroActor_WithParent {
  /**
   * @param {CardSkinDefinition_HeroActor} value
   * @param {CardSkinDefinition_HeroActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinDefinition_HeroActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasUnitActor() {
    if (this._cachedHasUnitActor === undefined) {
      if (this._value.hasUnitActor) {
        this._cachedHasUnitActor = true;
      } else {
        this._cachedHasUnitActor = this._parent ? this._parent.hasUnitActor : false;
      }
    }
    return this._cachedHasUnitActor;
  }
  get unitActor() {
    if (this._cachedUnitActor === undefined) {
      if (this._value.hasUnitActor) {
        this._cachedUnitActor = this._value.unitActor;
      } else {
        this._cachedUnitActor = this._parent ? this._parent.unitActor : this._value.unitActor;
      }
    }
    return this._cachedUnitActor;
  }
  update(current, parent) {
    const result = new CardSkinDefinition_HeroActor_WithParent(current, parent);
    return result;
  }
}
CardSkinDefinition_HeroActor_WithParent.default = new CardSkinDefinition_HeroActor_WithParent(CardSkinDefinition_HeroActor.default, null);
CardSkinDefinition_HeroActor.WithParent = CardSkinDefinition_HeroActor_WithParent;
class CardSkinDefinition_HeroActor_Descriptor {
  get unitActor() {
    if (!this._unitActor) {
      this._unitActor = {
        name: "unitActor",
        Name: "UnitActor",
        number: 1,
        protoType: 9,
        protoName: "unit_actor",
        type: JsonToString,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitActor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitActor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForUnitActor",
        Name: "DummyOneofForUnitActor",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkinDefinition_HeroActor.descriptor = new CardSkinDefinition_HeroActor_Descriptor();
class CardSkinDefinition_TowerActor {
  get descriptor() {
    return CardSkinDefinition_TowerActor.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._unitActors = [];
  }
  isEmpty() {
    if (this._unitActors.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinDefinition_TowerActor) {
      return value;
    }
    return CardSkinDefinition_TowerActor.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinDefinition_TowerActor();
    result._unitActors = JsonToList(json.unitActors, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._unitActors.length > 0) {
      result.unitActors = ArrayToJson(this._unitActors, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string[]}
   */
  get unitActors() {
    return this._unitActors;
  }
  addUnitActors(path, value) {
    return {type: 'ADD', path: path.concat(['unitActors']), value};
  }
  setUnitActors(path, value) {
    return {type: 'SET', path: path.concat(['unitActors']), value: ArrayToJson(value, JsonToString)};
  }
  setUnitActorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['unitActors', key]), value};
  }
  deleteUnitActors(path) {
    return {type: 'DELETE', path: path.concat(['unitActors'])};
  }
  deleteUnitActorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['unitActors', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "unitActors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_TowerActor(this);
              copy._unitActors = [];        for (let i of value) {
                copy._unitActors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition_TowerActor(this);
              copy._unitActors = copy._unitActors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._unitActors.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition_TowerActor(this);
              copy._unitActors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._unitActors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition_TowerActor(this);
              copy._unitActors = copy._unitActors.slice();
              copy._unitActors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition_TowerActor(this);
              copy._unitActors = copy._unitActors.slice(0, path[1]).concat(copy._unitActors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._unitActors.length) {
            return this;
          }
          const oldValue = this._unitActors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition_TowerActor(this);
          copy._unitActors = copy._unitActors.slice();
          copy._unitActors[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinDefinition_TowerActor} other
   * @returns {CardSkinDefinition_TowerActor}
   */
  merge(other) {
    const copy = new CardSkinDefinition_TowerActor(this);
    copy._unitActors = this._unitActors.concat(other._unitActors);
    return copy;
  }
}
CardSkinDefinition_TowerActor.default = new CardSkinDefinition_TowerActor();
class CardSkinDefinition_TowerActor_Builder {
  constructor(value) {
    this._value = new CardSkinDefinition_TowerActor(value);
  }
  build() {
    return new CardSkinDefinition_TowerActor(this._value);
  }
  addAllUnitActors(values) {
    this._value._unitActors = this._value._unitActors.concat(values);
    return this;
  }
  addUnitActors(value) {
    this._value._unitActors = this._value._unitActors.concat([value]);
    return this;
  }
  setUnitActors(index, value) {
    this._value._unitActors = this._value._unitActors.concat();
    this._value._unitActors[index] = value;
    return this;
  }
  clearUnitActors() {
    this._value._unitActors = [];
    return this;
  }
}
CardSkinDefinition_TowerActor.Builder = CardSkinDefinition_TowerActor_Builder;
class CardSkinDefinition_TowerActor_WithParent {
  /**
   * @param {CardSkinDefinition_TowerActor} value
   * @param {CardSkinDefinition_TowerActor_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinDefinition_TowerActor.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfUnitActors() {
    return this._value.unitActors;
  }
  get inherentUnitActors() {
    if (!this._inherentUnitActors) {
      this._inherentUnitActors = this._parent ? this._parent.unitActors : [];
    }
    return this._inherentUnitActors;
  }
  get unitActors() {
    if (!this._allUnitActors) {
      this._allUnitActors = this._parent ? this._parent.unitActors.concat(this.selfUnitActors) : this.selfUnitActors;
    }
    return this._allUnitActors;
  }
  update(current, parent) {
    const result = new CardSkinDefinition_TowerActor_WithParent(current, parent);
    return result;
  }
}
CardSkinDefinition_TowerActor_WithParent.default = new CardSkinDefinition_TowerActor_WithParent(CardSkinDefinition_TowerActor.default, null);
CardSkinDefinition_TowerActor.WithParent = CardSkinDefinition_TowerActor_WithParent;
class CardSkinDefinition_TowerActor_Descriptor {
  get unitActors() {
    if (!this._unitActors) {
      this._unitActors = {
        name: "unitActors",
        Name: "UnitActors",
        number: 1,
        protoType: 9,
        protoName: "unit_actors",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "UnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._unitActors;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.unitActors,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CardSkinDefinition_TowerActor.descriptor = new CardSkinDefinition_TowerActor_Descriptor();
export class CardSkinDefinition {
  get descriptor() {
    return CardSkinDefinition.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasHide = false;
    this._hide = null;
    this._cardTypeCase = 0;
    this._cardTypeValue = null;
    this._cardSkin = [];
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasHide) return false;
    if (this._cardTypeCase !== 0) return false;
    if (this._cardSkin.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinDefinition) {
      return value;
    }
    return CardSkinDefinition.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinDefinition();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.hide != null) {
      result._hasHide = true;
      result._hide = JsonToBoolean.fromJson(json.hide);
    }
    if (json.hero != null) {
      result._cardTypeCase = 11;
      result._cardTypeValue = CardSkinDefinition_HeroActor.fromJson(json.hero);
    }
    if (json.tower != null) {
      result._cardTypeCase = 12;
      result._cardTypeValue = CardSkinDefinition_TowerActor.fromJson(json.tower);
    }
    result._cardSkin = JsonToList(json.cardSkin, CardSkinDefinition_Skin);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasHide) {
      result.hide = JsonToBoolean.toJson(this._hide);
    }
    switch (this._cardTypeCase) {
      case 11:
        result.hero = CardSkinDefinition_HeroActor.toJson(this._cardTypeValue);
        break;
      case 12:
        result.tower = CardSkinDefinition_TowerActor.toJson(this._cardTypeValue);
        break;
      default:
        break;
    }
    if (this._cardSkin.length > 0) {
      result.cardSkin = ArrayToJson(this._cardSkin, CardSkinDefinition_Skin);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {boolean}
   */
  get hide() {
    return this._hasHide ? this._hide : JsonToBoolean.default;
  }
  get hasHide() {
    return this._hasHide;
  }
  setHide(path, value) {
    return {type: 'SET', path: path.concat(['hide']), value};
  }
  deleteHide(path) {
    return {type: 'DELETE', path: path.concat(['hide'])};
  }
  get cardTypeCase() {
    return this._cardTypeCase;
  }
  deleteCardType(path) {
    switch (this._cardTypeCase) {
      default:
      case 11: {
        return {type: 'DELETE', path: path.concat(['hero'])};
      }
      case 12: {
        return {type: 'DELETE', path: path.concat(['tower'])};
      }
    }
  }
  /**
   * @returns {CardSkinDefinition_HeroActor}
   */
  get hero() {
    return this._cardTypeCase === 11 ? this._cardTypeValue : CardSkinDefinition_HeroActor.default;
  }
  setHero(path, value) {
    return {type: 'SET', path: path.concat(['hero']), value: value.toJson()};
  }
  deleteHero(path) {
    return {type: 'DELETE', path: path.concat(['hero'])};
  }
  /**
   * @returns {CardSkinDefinition_TowerActor}
   */
  get tower() {
    return this._cardTypeCase === 12 ? this._cardTypeValue : CardSkinDefinition_TowerActor.default;
  }
  setTower(path, value) {
    return {type: 'SET', path: path.concat(['tower']), value: value.toJson()};
  }
  deleteTower(path) {
    return {type: 'DELETE', path: path.concat(['tower'])};
  }
  /**
   * @returns {CardSkinDefinition_Skin[]}
   */
  get cardSkin() {
    return this._cardSkin;
  }
  addCardSkin(path, value) {
    return {type: 'ADD', path: path.concat(['cardSkin']), value: value.toJson()};
  }
  setCardSkin(path, value) {
    return {type: 'SET', path: path.concat(['cardSkin']), value: ArrayToJson(value, CardSkinDefinition_Skin)};
  }
  setCardSkinByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['cardSkin', key]), value: value.toJson()};
  }
  deleteCardSkin(path) {
    return {type: 'DELETE', path: path.concat(['cardSkin'])};
  }
  deleteCardSkinByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['cardSkin', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardSkinDefinition(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._hasHide = true;
              copy._hide = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHide) {
                return this;
              }
              const copy = new CardSkinDefinition(this);
              copy._hasHide = false;
              copy._hide = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hero": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._cardTypeCase = 11;
              copy._cardTypeValue = CardSkinDefinition_HeroActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 11) {
                return this;
              }
              const copy = new CardSkinDefinition(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 11) {
            const copy = new CardSkinDefinition(this);
            copy._cardTypeCase = 11;
            copy._cardTypeValue = CardSkinDefinition_HeroActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.hero.apply(type, path.slice(1), value);
          if (newValue === this.hero) {
            return this;
          }
          const copy = new CardSkinDefinition(this);
          copy._cardTypeCase = 11;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "tower": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._cardTypeCase = 12;
              copy._cardTypeValue = CardSkinDefinition_TowerActor.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (this._cardTypeCase !== 12) {
                return this;
              }
              const copy = new CardSkinDefinition(this);
              copy._cardTypeCase = 0;
              copy._cardTypeValue = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (this._cardTypeCase !== 12) {
            const copy = new CardSkinDefinition(this);
            copy._cardTypeCase = 12;
            copy._cardTypeValue = CardSkinDefinition_TowerActor.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this.tower.apply(type, path.slice(1), value);
          if (newValue === this.tower) {
            return this;
          }
          const copy = new CardSkinDefinition(this);
          copy._cardTypeCase = 12;
          copy._cardTypeValue = newValue;
          return copy;
        }
      }
      case "cardSkin": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._cardSkin = [];        for (let i of value) {
                copy._cardSkin.push(CardSkinDefinition_Skin.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CardSkinDefinition(this);
              copy._cardSkin = copy._cardSkin.concat([CardSkinDefinition_Skin.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._cardSkin.length === 0) {
                return this;
              }
              const copy = new CardSkinDefinition(this);
              copy._cardSkin = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._cardSkin.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CardSkinDefinition(this);
              copy._cardSkin = copy._cardSkin.slice();
              copy._cardSkin[path[1]] = CardSkinDefinition_Skin.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CardSkinDefinition(this);
              copy._cardSkin = copy._cardSkin.slice(0, path[1]).concat(copy._cardSkin.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._cardSkin.length) {
            return this;
          }
          const oldValue = this._cardSkin[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CardSkinDefinition(this);
          copy._cardSkin = copy._cardSkin.slice();
          copy._cardSkin[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinDefinition} other
   * @returns {CardSkinDefinition}
   */
  merge(other) {
    const copy = new CardSkinDefinition(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasHide) {
      copy._hasHide = true;
      copy._hide = other._hide;
    }
    if (other._cardTypeCase === 11) {
      if (this._cardTypeCase === 11) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 11;
    }
    if (other._cardTypeCase === 11) {
      if (this._cardTypeCase === 11) {
        copy._cardTypeValue = copy._cardTypeValue.merge(other._cardTypeValue);
      } else {
        copy._cardTypeValue = other._cardTypeValue;
      }
      copy._cardTypeCase = 11;
    }
    copy._cardSkin = this._cardSkin.concat(other._cardSkin);
    return copy;
  }
}
CardSkinDefinition.default = new CardSkinDefinition();
CardSkinDefinition.Skin = CardSkinDefinition_Skin;
CardSkinDefinition.HeroActor = CardSkinDefinition_HeroActor;
CardSkinDefinition.TowerActor = CardSkinDefinition_TowerActor;
class CardSkinDefinition_Builder {
  constructor(value) {
    this._value = new CardSkinDefinition(value);
  }
  build() {
    return new CardSkinDefinition(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setHide(value) {
    this._value._hasHide = true;
    this._value._hide = value;
    return this;
  }
  deleteHide() {
    this._value._hasHide = false;
    this._value._hide = null;
    return this;
  }
  clearcardType() {
    this._value._cardTypeCase = 0;
    this._value._cardTypeValue = null;
    return this;
  }
  setHero(value) {
    this._value._cardTypeCase = 11;
    this._value._cardTypeValue = value;
    return this;
  }
  setTower(value) {
    this._value._cardTypeCase = 12;
    this._value._cardTypeValue = value;
    return this;
  }
  addAllCardSkin(values) {
    this._value._cardSkin = this._value._cardSkin.concat(values);
    return this;
  }
  addCardSkin(value) {
    this._value._cardSkin = this._value._cardSkin.concat([value]);
    return this;
  }
  setCardSkin(index, value) {
    this._value._cardSkin = this._value._cardSkin.concat();
    this._value._cardSkin[index] = value;
    return this;
  }
  clearCardSkin() {
    this._value._cardSkin = [];
    return this;
  }
}
CardSkinDefinition.Builder = CardSkinDefinition_Builder;
class CardSkinDefinition_WithParent {
  /**
   * @param {CardSkinDefinition} value
   * @param {CardSkinDefinition_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinDefinition.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasHide() {
    if (this._cachedHasHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHasHide = true;
      } else {
        this._cachedHasHide = this._parent ? this._parent.hasHide : false;
      }
    }
    return this._cachedHasHide;
  }
  get hide() {
    if (this._cachedHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHide = this._value.hide;
      } else {
        this._cachedHide = this._parent ? this._parent.hide : this._value.hide;
      }
    }
    return this._cachedHide;
  }
  get cardTypeCase() {
    if (this._cachedcardTypeCase === undefined) {
      if (this._value._cardTypeCase === 0) {
        this._cachedcardTypeCase = this._parent ? this._parent.cardTypeCase : 0;
      } else {
        this._cachedcardTypeCase = this._value._cardTypeCase;
      }
    }
    return this._cachedcardTypeCase;
  }
  get hero() {
    if (!this._cachedHero) {
      if (this._value._cardTypeCase === 0) {
        this._cachedHero = this._parent ? new CardSkinDefinition_HeroActor.WithParent(CardSkinDefinition_HeroActor.default, this._parent.hero) : this._value.hero;
      } else if (this._value._cardTypeCase === 11) {
        this._cachedHero = new CardSkinDefinition_HeroActor.WithParent(this._value.hero, this._parent && this._parent.cardTypeCase === 11 ? this._parent.hero : null);
      } else {
        this._cachedHero = CardSkinDefinition_HeroActor.WithParent.default;
      }
    }
    return this._cachedHero;
  }
  get tower() {
    if (!this._cachedTower) {
      if (this._value._cardTypeCase === 0) {
        this._cachedTower = this._parent ? new CardSkinDefinition_TowerActor.WithParent(CardSkinDefinition_TowerActor.default, this._parent.tower) : this._value.tower;
      } else if (this._value._cardTypeCase === 12) {
        this._cachedTower = new CardSkinDefinition_TowerActor.WithParent(this._value.tower, this._parent && this._parent.cardTypeCase === 12 ? this._parent.tower : null);
      } else {
        this._cachedTower = CardSkinDefinition_TowerActor.WithParent.default;
      }
    }
    return this._cachedTower;
  }
  get selfCardSkin() {
    if (!this._selfCardSkin) {
      this._selfCardSkin = [];
      for (let i of this._value.cardSkin) {
        this._selfCardSkin.push(new CardSkinDefinition_Skin.WithParent(i, null));
      }
    }
    return this._selfCardSkin;
  }
  get inherentCardSkin() {
    if (!this._inherentCardSkin) {
      this._inherentCardSkin = this._parent ? this._parent.cardSkin : [];
    }
    return this._inherentCardSkin;
  }
  get cardSkin() {
    if (!this._allCardSkin) {
      this._allCardSkin = this._parent ? this._parent.cardSkin.concat(this.selfCardSkin) : this.selfCardSkin;
    }
    return this._allCardSkin;
  }
  update(current, parent) {
    const result = new CardSkinDefinition_WithParent(current, parent);
    if (this._cachedHero && this._value._cardTypeCase === 11 && current._cardTypeCase === 11) {
      if (this._value.hero === current.hero && this._parent === parent) {
        result._cachedHero = this._cachedHero;
      } else {
        result._cachedHero = this._cachedHero.update(current.hero, parent && parent.cardTypeCase === 11 ? parent.hero : null);
      }
    }
    if (this._cachedTower && this._value._cardTypeCase === 12 && current._cardTypeCase === 12) {
      if (this._value.tower === current.tower && this._parent === parent) {
        result._cachedTower = this._cachedTower;
      } else {
        result._cachedTower = this._cachedTower.update(current.tower, parent && parent.cardTypeCase === 12 ? parent.tower : null);
      }
    }
    if (this._selfCardSkin) {
      if (this._value.cardSkin === current.cardSkin) {
        result._selfCardSkin = this._selfCardSkin;
      } else {
        result._selfCardSkin = [];
        for (let i = 0; i < current.cardSkin.length; i++) {
          const oldValue = this._value.cardSkin[i];
          if (oldValue) {
            const oldCache = this._selfCardSkin[i];
            if (oldValue === current.cardSkin[i]) {
              result._selfCardSkin[i] = oldCache;
            } else {
              result._selfCardSkin[i] = oldCache.update(current.cardSkin[i], null);
            }
          } else {
            result._selfCardSkin[i] = new CardSkinDefinition_Skin.WithParent(current.cardSkin[i], null);
          }
        }
      }
    }
    return result;
  }
}
CardSkinDefinition_WithParent.default = new CardSkinDefinition_WithParent(CardSkinDefinition.default, null);
CardSkinDefinition.WithParent = CardSkinDefinition_WithParent;
class CardSkinDefinition_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get hide() {
    if (!this._hide) {
      this._hide = {
        name: "hide",
        Name: "Hide",
        number: 99,
        protoType: 8,
        protoName: "hide",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hide;
  }
  get hero() {
    if (!this._hero) {
      this._hero = {
        name: "hero",
        Name: "Hero",
        number: 11,
        protoType: 11,
        protoName: "hero",
        oneofIndex: 2,
        type: CardSkinDefinition_HeroActor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hero;
  }
  get tower() {
    if (!this._tower) {
      this._tower = {
        name: "tower",
        Name: "Tower",
        number: 12,
        protoType: 11,
        protoName: "tower",
        oneofIndex: 2,
        type: CardSkinDefinition_TowerActor,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._tower;
  }
  get cardSkin() {
    if (!this._cardSkin) {
      this._cardSkin = {
        name: "cardSkin",
        Name: "CardSkin",
        number: 13,
        protoType: 11,
        protoName: "card_skin",
        type: CardSkinDefinition_Skin,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardSkin;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.hide,
        this.hero,
        this.tower,
        this.cardSkin,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHide",
        Name: "DummyOneofForHide",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "cardType",
        Name: "CardType",
        fields: [
          this.fields[2],
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkinDefinition.descriptor = new CardSkinDefinition_Descriptor();
export class CardSkinProgression {
  get descriptor() {
    return CardSkinProgression.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CardSkinProgression) {
      return value;
    }
    return CardSkinProgression.fromJson(value);
  }
  static fromJson(json) {
    const result = new CardSkinProgression();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CardSkinProgression(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new CardSkinProgression(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CardSkinProgression} other
   * @returns {CardSkinProgression}
   */
  merge(other) {
    const copy = new CardSkinProgression(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    return copy;
  }
}
CardSkinProgression.default = new CardSkinProgression();
class CardSkinProgression_Builder {
  constructor(value) {
    this._value = new CardSkinProgression(value);
  }
  build() {
    return new CardSkinProgression(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
}
CardSkinProgression.Builder = CardSkinProgression_Builder;
class CardSkinProgression_WithParent {
  /**
   * @param {CardSkinProgression} value
   * @param {CardSkinProgression_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CardSkinProgression.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  update(current, parent) {
    const result = new CardSkinProgression_WithParent(current, parent);
    return result;
  }
}
CardSkinProgression_WithParent.default = new CardSkinProgression_WithParent(CardSkinProgression.default, null);
CardSkinProgression.WithParent = CardSkinProgression_WithParent;
class CardSkinProgression_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CardSkinProgression.descriptor = new CardSkinProgression_Descriptor();
class InGamePlayerDeck_PlayerCard {
  get descriptor() {
    return InGamePlayerDeck_PlayerCard.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasName = false;
    this._name = null;
    this._hasType = false;
    this._type = null;
    this._hasFeatured = false;
    this._featured = null;
    this._hasLevel = false;
    this._level = null;
    this._hasStar = false;
    this._star = null;
    this._hasAwaken = false;
    this._awaken = null;
    this._hasAffinity = false;
    this._affinity = null;
  }
  isEmpty() {
    if (this._hasName) return false;
    if (this._hasType) return false;
    if (this._hasFeatured) return false;
    if (this._hasLevel) return false;
    if (this._hasStar) return false;
    if (this._hasAwaken) return false;
    if (this._hasAffinity) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InGamePlayerDeck_PlayerCard) {
      return value;
    }
    return InGamePlayerDeck_PlayerCard.fromJson(value);
  }
  static fromJson(json) {
    const result = new InGamePlayerDeck_PlayerCard();
    if (json.name != null) {
      result._hasName = true;
      result._name = JsonToString.fromJson(json.name);
    }
    if (json.type != null) {
      result._hasType = true;
      result._type = JsonToString.fromJson(json.type);
    }
    if (json.featured != null) {
      result._hasFeatured = true;
      result._featured = JsonToBoolean.fromJson(json.featured);
    }
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.star != null) {
      result._hasStar = true;
      result._star = JsonToInt32.fromJson(json.star);
    }
    if (json.awaken != null) {
      result._hasAwaken = true;
      result._awaken = JsonToInt32.fromJson(json.awaken);
    }
    if (json.affinity != null) {
      result._hasAffinity = true;
      result._affinity = JsonToInt32.fromJson(json.affinity);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasName) {
      result.name = JsonToString.toJson(this._name);
    }
    if (this._hasType) {
      result.type = JsonToString.toJson(this._type);
    }
    if (this._hasFeatured) {
      result.featured = JsonToBoolean.toJson(this._featured);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasStar) {
      result.star = JsonToInt32.toJson(this._star);
    }
    if (this._hasAwaken) {
      result.awaken = JsonToInt32.toJson(this._awaken);
    }
    if (this._hasAffinity) {
      result.affinity = JsonToInt32.toJson(this._affinity);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get name() {
    return this._hasName ? this._name : JsonToString.default;
  }
  get hasName() {
    return this._hasName;
  }
  setName(path, value) {
    return {type: 'SET', path: path.concat(['name']), value};
  }
  deleteName(path) {
    return {type: 'DELETE', path: path.concat(['name'])};
  }
  /**
   * @returns {string}
   */
  get type() {
    return this._hasType ? this._type : JsonToString.default;
  }
  get hasType() {
    return this._hasType;
  }
  setType(path, value) {
    return {type: 'SET', path: path.concat(['type']), value};
  }
  deleteType(path) {
    return {type: 'DELETE', path: path.concat(['type'])};
  }
  /**
   * @returns {boolean}
   */
  get featured() {
    return this._hasFeatured ? this._featured : JsonToBoolean.default;
  }
  get hasFeatured() {
    return this._hasFeatured;
  }
  setFeatured(path, value) {
    return {type: 'SET', path: path.concat(['featured']), value};
  }
  deleteFeatured(path) {
    return {type: 'DELETE', path: path.concat(['featured'])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {number}
   */
  get star() {
    return this._hasStar ? this._star : JsonToInt32.default;
  }
  get hasStar() {
    return this._hasStar;
  }
  setStar(path, value) {
    return {type: 'SET', path: path.concat(['star']), value};
  }
  deleteStar(path) {
    return {type: 'DELETE', path: path.concat(['star'])};
  }
  /**
   * @returns {number}
   */
  get awaken() {
    return this._hasAwaken ? this._awaken : JsonToInt32.default;
  }
  get hasAwaken() {
    return this._hasAwaken;
  }
  setAwaken(path, value) {
    return {type: 'SET', path: path.concat(['awaken']), value};
  }
  deleteAwaken(path) {
    return {type: 'DELETE', path: path.concat(['awaken'])};
  }
  /**
   * @returns {number}
   */
  get affinity() {
    return this._hasAffinity ? this._affinity : JsonToInt32.default;
  }
  get hasAffinity() {
    return this._hasAffinity;
  }
  setAffinity(path, value) {
    return {type: 'SET', path: path.concat(['affinity']), value};
  }
  deleteAffinity(path) {
    return {type: 'DELETE', path: path.concat(['affinity'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "name": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasName = true;
              copy._name = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasName) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasName = false;
              copy._name = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "type": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasType = true;
              copy._type = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasType) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasType = false;
              copy._type = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "featured": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasFeatured = true;
              copy._featured = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFeatured) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasFeatured = false;
              copy._featured = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "star": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasStar = true;
              copy._star = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStar) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasStar = false;
              copy._star = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "awaken": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasAwaken = true;
              copy._awaken = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAwaken) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasAwaken = false;
              copy._awaken = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinity": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasAffinity = true;
              copy._affinity = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinity) {
                return this;
              }
              const copy = new InGamePlayerDeck_PlayerCard(this);
              copy._hasAffinity = false;
              copy._affinity = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InGamePlayerDeck_PlayerCard} other
   * @returns {InGamePlayerDeck_PlayerCard}
   */
  merge(other) {
    const copy = new InGamePlayerDeck_PlayerCard(this);
    if (other._hasName) {
      copy._hasName = true;
      copy._name = other._name;
    }
    if (other._hasType) {
      copy._hasType = true;
      copy._type = other._type;
    }
    if (other._hasFeatured) {
      copy._hasFeatured = true;
      copy._featured = other._featured;
    }
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasStar) {
      copy._hasStar = true;
      copy._star = other._star;
    }
    if (other._hasAwaken) {
      copy._hasAwaken = true;
      copy._awaken = other._awaken;
    }
    if (other._hasAffinity) {
      copy._hasAffinity = true;
      copy._affinity = other._affinity;
    }
    return copy;
  }
}
InGamePlayerDeck_PlayerCard.default = new InGamePlayerDeck_PlayerCard();
class InGamePlayerDeck_PlayerCard_Builder {
  constructor(value) {
    this._value = new InGamePlayerDeck_PlayerCard(value);
  }
  build() {
    return new InGamePlayerDeck_PlayerCard(this._value);
  }
  setName(value) {
    this._value._hasName = true;
    this._value._name = value;
    return this;
  }
  deleteName() {
    this._value._hasName = false;
    this._value._name = null;
    return this;
  }
  setType(value) {
    this._value._hasType = true;
    this._value._type = value;
    return this;
  }
  deleteType() {
    this._value._hasType = false;
    this._value._type = null;
    return this;
  }
  setFeatured(value) {
    this._value._hasFeatured = true;
    this._value._featured = value;
    return this;
  }
  deleteFeatured() {
    this._value._hasFeatured = false;
    this._value._featured = null;
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setStar(value) {
    this._value._hasStar = true;
    this._value._star = value;
    return this;
  }
  deleteStar() {
    this._value._hasStar = false;
    this._value._star = null;
    return this;
  }
  setAwaken(value) {
    this._value._hasAwaken = true;
    this._value._awaken = value;
    return this;
  }
  deleteAwaken() {
    this._value._hasAwaken = false;
    this._value._awaken = null;
    return this;
  }
  setAffinity(value) {
    this._value._hasAffinity = true;
    this._value._affinity = value;
    return this;
  }
  deleteAffinity() {
    this._value._hasAffinity = false;
    this._value._affinity = null;
    return this;
  }
}
InGamePlayerDeck_PlayerCard.Builder = InGamePlayerDeck_PlayerCard_Builder;
class InGamePlayerDeck_PlayerCard_WithParent {
  /**
   * @param {InGamePlayerDeck_PlayerCard} value
   * @param {InGamePlayerDeck_PlayerCard_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InGamePlayerDeck_PlayerCard.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasName() {
    if (this._cachedHasName === undefined) {
      if (this._value.hasName) {
        this._cachedHasName = true;
      } else {
        this._cachedHasName = this._parent ? this._parent.hasName : false;
      }
    }
    return this._cachedHasName;
  }
  get name() {
    if (this._cachedName === undefined) {
      if (this._value.hasName) {
        this._cachedName = this._value.name;
      } else {
        this._cachedName = this._parent ? this._parent.name : this._value.name;
      }
    }
    return this._cachedName;
  }
  get hasType() {
    if (this._cachedHasType === undefined) {
      if (this._value.hasType) {
        this._cachedHasType = true;
      } else {
        this._cachedHasType = this._parent ? this._parent.hasType : false;
      }
    }
    return this._cachedHasType;
  }
  get type() {
    if (this._cachedType === undefined) {
      if (this._value.hasType) {
        this._cachedType = this._value.type;
      } else {
        this._cachedType = this._parent ? this._parent.type : this._value.type;
      }
    }
    return this._cachedType;
  }
  get hasFeatured() {
    if (this._cachedHasFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedHasFeatured = true;
      } else {
        this._cachedHasFeatured = this._parent ? this._parent.hasFeatured : false;
      }
    }
    return this._cachedHasFeatured;
  }
  get featured() {
    if (this._cachedFeatured === undefined) {
      if (this._value.hasFeatured) {
        this._cachedFeatured = this._value.featured;
      } else {
        this._cachedFeatured = this._parent ? this._parent.featured : this._value.featured;
      }
    }
    return this._cachedFeatured;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasStar() {
    if (this._cachedHasStar === undefined) {
      if (this._value.hasStar) {
        this._cachedHasStar = true;
      } else {
        this._cachedHasStar = this._parent ? this._parent.hasStar : false;
      }
    }
    return this._cachedHasStar;
  }
  get star() {
    if (this._cachedStar === undefined) {
      if (this._value.hasStar) {
        this._cachedStar = this._value.star;
      } else {
        this._cachedStar = this._parent ? this._parent.star : this._value.star;
      }
    }
    return this._cachedStar;
  }
  get hasAwaken() {
    if (this._cachedHasAwaken === undefined) {
      if (this._value.hasAwaken) {
        this._cachedHasAwaken = true;
      } else {
        this._cachedHasAwaken = this._parent ? this._parent.hasAwaken : false;
      }
    }
    return this._cachedHasAwaken;
  }
  get awaken() {
    if (this._cachedAwaken === undefined) {
      if (this._value.hasAwaken) {
        this._cachedAwaken = this._value.awaken;
      } else {
        this._cachedAwaken = this._parent ? this._parent.awaken : this._value.awaken;
      }
    }
    return this._cachedAwaken;
  }
  get hasAffinity() {
    if (this._cachedHasAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedHasAffinity = true;
      } else {
        this._cachedHasAffinity = this._parent ? this._parent.hasAffinity : false;
      }
    }
    return this._cachedHasAffinity;
  }
  get affinity() {
    if (this._cachedAffinity === undefined) {
      if (this._value.hasAffinity) {
        this._cachedAffinity = this._value.affinity;
      } else {
        this._cachedAffinity = this._parent ? this._parent.affinity : this._value.affinity;
      }
    }
    return this._cachedAffinity;
  }
  update(current, parent) {
    const result = new InGamePlayerDeck_PlayerCard_WithParent(current, parent);
    return result;
  }
}
InGamePlayerDeck_PlayerCard_WithParent.default = new InGamePlayerDeck_PlayerCard_WithParent(InGamePlayerDeck_PlayerCard.default, null);
InGamePlayerDeck_PlayerCard.WithParent = InGamePlayerDeck_PlayerCard_WithParent;
class InGamePlayerDeck_PlayerCard_Descriptor {
  get name() {
    if (!this._name) {
      this._name = {
        name: "name",
        Name: "Name",
        number: 1,
        protoType: 9,
        protoName: "name",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._name;
  }
  get type() {
    if (!this._type) {
      this._type = {
        name: "type",
        Name: "Type",
        number: 2,
        protoType: 9,
        protoName: "type",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._type;
  }
  get featured() {
    if (!this._featured) {
      this._featured = {
        name: "featured",
        Name: "Featured",
        number: 3,
        protoType: 8,
        protoName: "featured",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._featured;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 4,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get star() {
    if (!this._star) {
      this._star = {
        name: "star",
        Name: "Star",
        number: 5,
        protoType: 5,
        protoName: "star",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._star;
  }
  get awaken() {
    if (!this._awaken) {
      this._awaken = {
        name: "awaken",
        Name: "Awaken",
        number: 6,
        protoType: 5,
        protoName: "awaken",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._awaken;
  }
  get affinity() {
    if (!this._affinity) {
      this._affinity = {
        name: "affinity",
        Name: "Affinity",
        number: 7,
        protoType: 5,
        protoName: "affinity",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinity;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.name,
        this.type,
        this.featured,
        this.level,
        this.star,
        this.awaken,
        this.affinity,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForName",
        Name: "DummyOneofForName",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForType",
        Name: "DummyOneofForType",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFeatured",
        Name: "DummyOneofForFeatured",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStar",
        Name: "DummyOneofForStar",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAwaken",
        Name: "DummyOneofForAwaken",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinity",
        Name: "DummyOneofForAffinity",
        fields: [
          this.fields[6],
        ],
      });
    }
    return this._oneofs;
  }
}
InGamePlayerDeck_PlayerCard.descriptor = new InGamePlayerDeck_PlayerCard_Descriptor();
export class InGamePlayerDeck {
  get descriptor() {
    return InGamePlayerDeck.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._playerCards = [];
  }
  isEmpty() {
    if (this._playerCards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof InGamePlayerDeck) {
      return value;
    }
    return InGamePlayerDeck.fromJson(value);
  }
  static fromJson(json) {
    const result = new InGamePlayerDeck();
    result._playerCards = JsonToList(json.playerCards, InGamePlayerDeck_PlayerCard);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._playerCards.length > 0) {
      result.playerCards = ArrayToJson(this._playerCards, InGamePlayerDeck_PlayerCard);
    }
    return result;
  }
  /**
   * @returns {InGamePlayerDeck_PlayerCard[]}
   */
  get playerCards() {
    return this._playerCards;
  }
  addPlayerCards(path, value) {
    return {type: 'ADD', path: path.concat(['playerCards']), value: value.toJson()};
  }
  setPlayerCards(path, value) {
    return {type: 'SET', path: path.concat(['playerCards']), value: ArrayToJson(value, InGamePlayerDeck_PlayerCard)};
  }
  setPlayerCardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['playerCards', key]), value: value.toJson()};
  }
  deletePlayerCards(path) {
    return {type: 'DELETE', path: path.concat(['playerCards'])};
  }
  deletePlayerCardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['playerCards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "playerCards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck(this);
              copy._playerCards = [];        for (let i of value) {
                copy._playerCards.push(InGamePlayerDeck_PlayerCard.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new InGamePlayerDeck(this);
              copy._playerCards = copy._playerCards.concat([InGamePlayerDeck_PlayerCard.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._playerCards.length === 0) {
                return this;
              }
              const copy = new InGamePlayerDeck(this);
              copy._playerCards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._playerCards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new InGamePlayerDeck(this);
              copy._playerCards = copy._playerCards.slice();
              copy._playerCards[path[1]] = InGamePlayerDeck_PlayerCard.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new InGamePlayerDeck(this);
              copy._playerCards = copy._playerCards.slice(0, path[1]).concat(copy._playerCards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._playerCards.length) {
            return this;
          }
          const oldValue = this._playerCards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new InGamePlayerDeck(this);
          copy._playerCards = copy._playerCards.slice();
          copy._playerCards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {InGamePlayerDeck} other
   * @returns {InGamePlayerDeck}
   */
  merge(other) {
    const copy = new InGamePlayerDeck(this);
    copy._playerCards = this._playerCards.concat(other._playerCards);
    return copy;
  }
}
InGamePlayerDeck.default = new InGamePlayerDeck();
InGamePlayerDeck.PlayerCard = InGamePlayerDeck_PlayerCard;
class InGamePlayerDeck_Builder {
  constructor(value) {
    this._value = new InGamePlayerDeck(value);
  }
  build() {
    return new InGamePlayerDeck(this._value);
  }
  addAllPlayerCards(values) {
    this._value._playerCards = this._value._playerCards.concat(values);
    return this;
  }
  addPlayerCards(value) {
    this._value._playerCards = this._value._playerCards.concat([value]);
    return this;
  }
  setPlayerCards(index, value) {
    this._value._playerCards = this._value._playerCards.concat();
    this._value._playerCards[index] = value;
    return this;
  }
  clearPlayerCards() {
    this._value._playerCards = [];
    return this;
  }
}
InGamePlayerDeck.Builder = InGamePlayerDeck_Builder;
class InGamePlayerDeck_WithParent {
  /**
   * @param {InGamePlayerDeck} value
   * @param {InGamePlayerDeck_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return InGamePlayerDeck.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfPlayerCards() {
    if (!this._selfPlayerCards) {
      this._selfPlayerCards = [];
      for (let i of this._value.playerCards) {
        this._selfPlayerCards.push(new InGamePlayerDeck_PlayerCard.WithParent(i, null));
      }
    }
    return this._selfPlayerCards;
  }
  get inherentPlayerCards() {
    if (!this._inherentPlayerCards) {
      this._inherentPlayerCards = this._parent ? this._parent.playerCards : [];
    }
    return this._inherentPlayerCards;
  }
  get playerCards() {
    if (!this._allPlayerCards) {
      this._allPlayerCards = this._parent ? this._parent.playerCards.concat(this.selfPlayerCards) : this.selfPlayerCards;
    }
    return this._allPlayerCards;
  }
  update(current, parent) {
    const result = new InGamePlayerDeck_WithParent(current, parent);
    if (this._selfPlayerCards) {
      if (this._value.playerCards === current.playerCards) {
        result._selfPlayerCards = this._selfPlayerCards;
      } else {
        result._selfPlayerCards = [];
        for (let i = 0; i < current.playerCards.length; i++) {
          const oldValue = this._value.playerCards[i];
          if (oldValue) {
            const oldCache = this._selfPlayerCards[i];
            if (oldValue === current.playerCards[i]) {
              result._selfPlayerCards[i] = oldCache;
            } else {
              result._selfPlayerCards[i] = oldCache.update(current.playerCards[i], null);
            }
          } else {
            result._selfPlayerCards[i] = new InGamePlayerDeck_PlayerCard.WithParent(current.playerCards[i], null);
          }
        }
      }
    }
    return result;
  }
}
InGamePlayerDeck_WithParent.default = new InGamePlayerDeck_WithParent(InGamePlayerDeck.default, null);
InGamePlayerDeck.WithParent = InGamePlayerDeck_WithParent;
class InGamePlayerDeck_Descriptor {
  get playerCards() {
    if (!this._playerCards) {
      this._playerCards = {
        name: "playerCards",
        Name: "PlayerCards",
        number: 1,
        protoType: 11,
        protoName: "player_cards",
        type: InGamePlayerDeck_PlayerCard,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._playerCards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.playerCards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
InGamePlayerDeck.descriptor = new InGamePlayerDeck_Descriptor();
